var _Ta, _Da;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { C as e, f as n, d as t, _ as o, c as r, h as a, i as l, a as i, e as c, g as s } from "./polyfills-377d7928.js";
import u from "@amzn/awsui-components-react/polaris/top-navigation";
import { D as d } from "./UnauthenticatedClientProvider-39a7be39.js";
import f, { useMemo as p, useContext as g, useState as m, useCallback as h, useRef as b, Fragment as y, useEffect as k, useLayoutEffect as v, createContext as w, createRef as x } from "react";
import A from "@amzn/awsui-components-react/polaris/badge";
import S from "@amzn/awsui-components-react/polaris/link";
import E from "@amzn/awsui-components-react/polaris/popover";
import C from "@amzn/awsui-components-react/polaris/box";
import z from "@amzn/awsui-components-react/polaris/button";
import T from "@amzn/awsui-components-react/polaris/modal";
import M from "@amzn/awsui-components-react/polaris/space-between";
import O from "@amzn/awsui-components-react/polaris/alert";
import D from "@amzn/awsui-components-react/polaris/tabs";
import F from "@amzn/awsui-components-react/polaris/segmented-control";
import { v as P } from "./v4-ecc7a3fb.js";
import L from "@amzn/awsui-components-react/polaris/icon";
import B from "@amzn/awsui-components-react/polaris/column-layout";
import R from "@amzn/awsui-components-react/polaris/container";
import H from "@amzn/awsui-components-react/polaris/header";
import N from "@amzn/awsui-components-react/polaris/status-indicator";
import I from "@amzn/awsui-components-react/polaris/checkbox";
import j from "@amzn/awsui-components-react/polaris/text-content";
import { a as W, b as q } from "./PollEngine-f1b02379.js";
import { e as U, W as V, S as J, a as K } from "./StoragePartition-9c35ff49.js";
import { g as Q } from "./app-version-5f619b8d.js";
import { c as Y, i as G, j as X, k as _, F as Z, I as $, T as ee, e as ne, h as te, f as oe, l as re, q as ae } from "./use-url-parse-642a7ef2.js";
import { useHistory as le, useLocation as ie } from "react-router-dom";
import "lodash.isequal";
import ce from "@amzn/awsui-components-react/polaris/grid";
import se from "@amzn/awsui-components-react/polaris/spinner";
import ue from "@amzn/awsui-components-react/polaris/expandable-section";
import { c as de, a as fe } from "./_commonjsHelpers-9f0380ce.js";
import pe from "process";
import { fileURLToPath as ge } from "url";
import me from "path";
import he from "@amzn/awsui-components-react/polaris/collection-preferences";
import be from "@amzn/awsui-components-react/polaris/pagination";
import ye from "@amzn/awsui-components-react/polaris/table";
import ke from "@amzn/awsui-components-react/polaris/text-filter";
import ve from "@amzn/awsui-components-react/polaris/form";
import { useFormik as we, FormikProvider as xe } from "formik";
import { f as Ae, t as Se, s as Ee, c as Ce } from "./index-d4c2da51.js";
import * as ze from "yup";
import { i as Te } from "./exclusion-error-filter-18959131.js";
import "@amzn/awsui-components-react/polaris/form-field";
import { colorBackgroundLayoutMain as Me, colorBorderDividerDefault as Oe } from "@amzn/awsui-design-tokens/polaris";
import { Helmet as De } from "react-helmet-async";
import { Hub as Fe } from "aws-amplify";
import { w as Pe } from "./with-retry-b12cc9ac.js";
var Le,
    Be = {
  notFound: {
    title: "Page not found",
    message: "The page you are looking for does not exist. You might have typed the address incorrectly or you might have used an outdated link. Please check the link and try again."
  }
},
    Re = "data:image/png;base64,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",
    He = "AppTopNavigation-module_topNavigation__1hDwW",
    Ne = "AppTopNavigation-module_customLogoContainer__3bgMq",
    Ie = "AppTopNavigation-module_badge__3V6Yp",
    je = "AppTopNavigation-module_sticky__kgaSh",
    We = {
  topNavigation: {
    searchIconAriaLabel: "Search",
    searchDismissIconAriaLabel: "Close search",
    overflowMenuTriggerText: "More",
    overflowMenuTitleText: "Menu"
  },
  darkMode: "Dark mode 🌙",
  lightMode: "Light mode ☀️",
  logoAlt: "Workshop Studio",
  utilities: {
    settings: "Settings"
  },
  badges: {
    publicPreview: "Public preview"
  },
  popovers: {
    publicPreview: {
      content: "Event delivery feature is in public preview.",
      readMoreLink: "Read more"
    }
  }
};
(Le || (Le = {})).DarkMode = "system-dark-mode-toggle";

var qe,
    Ue = "PublicPreviewBadge-module_container__1eJl_",
    Ve = "PublicPreviewBadge-module_trigger__2ewmh",
    Je = function Je() {
  return f.createElement("div", {
    className: Ue
  }, f.createElement(E, {
    content: f.createElement(f.Fragment, null, We.popovers.publicPreview.content, " ", f.createElement(S, {
      href: e.ExternalLinks.eventDeliveryLaunch,
      external: !0
    }, We.popovers.publicPreview.readMoreLink)),
    triggerType: "custom",
    size: "small",
    position: "bottom"
  }, f.createElement("span", {
    className: Ve
  }, f.createElement(A, {
    color: "blue"
  }, We.badges.publicPreview))));
},
    Ke = We,
    Qe = Le,
    Ye = function Ye(e) {
  var o = e.identity,
      r = e.id,
      a = e.className,
      l = e.sticky,
      i = e.utilities,
      c = void 0 === i ? [] : i,
      s = e.publicPreview,
      m = p(function () {
    var e = [He];
    return a && e.push(a.trim()), l && e.push(je), e.join(" ");
  }, [a, l]),
      h = g(d),
      b = h.enabled,
      y = h.setEnabled,
      k = p(function () {
    var e = [];
    return y && e.push({
      type: "menu-dropdown",
      iconName: "settings",
      ariaLabel: Ke.utilities.settings,
      title: Ke.utilities.settings,
      onItemClick: function onItemClick(e) {
        switch (e.detail.id) {
          case Qe.DarkMode:
            y(!b);
        }
      },
      items: [{
        id: Qe.DarkMode,
        text: b ? Ke.lightMode : Ke.darkMode
      }]
    }), n(n([], e), c);
  }, [c, b, y]),
      v = p(function () {
    return s ? {
      href: void 0,
      title: f.createElement("span", {
        className: Ne
      }, f.createElement("a", {
        href: o.href,
        onClick: function onClick(e) {
          var n;
          return null === (n = o.onFollow) || void 0 === n ? void 0 : n.call(o, e);
        }
      }, f.createElement("img", {
        src: Re,
        alt: Ke.logoAlt
      })), f.createElement("span", {
        className: Ie
      }, f.createElement(Je, null)))
    } : t(t({}, o), {
      logo: {
        src: Re,
        alt: Ke.logoAlt
      }
    });
  }, [s, o]);
  return f.createElement(u, {
    id: r,
    className: m,
    identity: v,
    utilities: k,
    i18nStrings: Ke.topNavigation
  });
},
    Ge = {
  NetworkError: {
    header: "A Network Change was Detected",
    body: "Check your network connection and refresh the page."
  },
  AmazonCorporateSSOToken: {
    header: "Amazon Corporate SSO token expired",
    body: "Your Amazon Corporate SSO token token has expired. Please refresh the page and re-authenticate to use the console application."
  }
},
    Xe = function Xe(e) {
  var n = e.type,
      t = e.onDismiss,
      o = m(!0),
      r = o[0],
      a = o[1],
      l = h(function () {
    window.location.reload();
  }, []),
      i = Ge[n],
      c = i.header,
      s = i.body;
  return f.createElement(T, {
    onDismiss: function onDismiss() {
      null == t || t(), a(!1);
    },
    visible: r,
    closeAriaLabel: "Close modal",
    size: "medium",
    footer: f.createElement(C, {
      "float": "right"
    }, f.createElement(M, {
      direction: "horizontal",
      size: "xs"
    }, f.createElement(z, {
      onClick: l,
      variant: "primary"
    }, "Refresh"))),
    header: c
  }, s);
},
    _e = "CopyButton-module_styledButton__1Jq7M";

!function (e) {
  e.CopyButton = "copy-button";
}(qe || (qe = {}));

var Ze,
    $e = {
  copied: "Copied!",
  loading: "Loading...",
  error: "Could not copy content"
},
    en = function en(e) {
  var a = e.elementId,
      l = e.children,
      i = e.content,
      c = e.deferredContent,
      s = e.className,
      u = e.i18n,
      d = e.variant,
      g = m(!1),
      h = g[0],
      b = g[1],
      y = m(!1),
      k = y[0],
      v = y[1],
      w = p(function () {
    return u = t(t({}, $e), u || {}), h ? f.createElement(N, {
      type: "loading"
    }, u.loading) : k ? f.createElement(N, {
      type: "error"
    }, u.error) : f.createElement(N, {
      type: "success"
    }, u.copied);
  }, [h, k]),
      x = Y({
    elementId: a
  }),
      A = x.copyToClipboard,
      S = x.copyContentToClipboard,
      C = n([], "inline-icon" === d || l ? [] : [_e]);
  return f.createElement(E, {
    className: s,
    size: "small",
    position: "top",
    triggerType: "custom",
    dismissButton: !1,
    content: w
  }, f.createElement(z, {
    className: C.join(" "),
    disabled: h,
    variant: d,
    onClick: function onClick() {
      return o(void 0, void 0, void 0, function () {
        var e;
        return r(this, function (n) {
          switch (n.label) {
            case 0:
              return v(!1), b(!1), a ? (A(), [3, 4]) : [3, 1];

            case 1:
              return i ? (S(i), [3, 4]) : [3, 2];

            case 2:
              return c ? (b(!0), [4, c()["catch"](function () {
                v(!0);
              })]) : [3, 4];

            case 3:
              if (e = n.sent(), b(!1), !e) return v(!0), [2];
              S(e), n.label = 4;

            case 4:
              return [2];
          }
        });
      });
    },
    "data-testid": qe.CopyButton,
    iconName: "copy",
    ariaLabel: "Copy content"
  }, l));
},
    nn = "CodeBlock-module_container__wNFjc",
    tn = "CodeBlock-module_codeBlock__2ejpU",
    on = "CodeBlock-module_hasCopyAction__3U3hm",
    rn = "CodeBlock-module_wrapLines__3uSTp",
    an = "CodeBlock-module_copyAction__3F2NS",
    ln = function ln(e) {
  var n = e.children,
      o = e.margin,
      r = void 0 === o ? "n" : o,
      l = e.padding,
      i = void 0 === l ? "n" : l,
      c = e.showCopyAction,
      s = e.wrapLines,
      u = a(e, ["children", "margin", "padding", "showCopyAction", "wrapLines"]),
      d = b(P()).current,
      p = [tn];
  return c && p.push(on), s && p.push(rn), f.createElement(C, t({}, u, {
    className: nn,
    margin: r,
    padding: i,
    variant: "pre"
  }), f.createElement(C, {
    className: p.join(" "),
    id: d,
    variant: "code",
    padding: "l"
  }, n), c && f.createElement("div", {
    className: an
  }, f.createElement(en, {
    elementId: d
  })));
},
    cn = "AWSCliCredentials-module_segmentedControl__2U03E",
    sn = function sn(e) {
  var n = e.credentials,
      t = e.defaultEnv,
      o = void 0 === t ? l.Bash : t,
      r = e.defaultRegion,
      a = e.showCopyAction,
      c = e.tabsVariant,
      s = e.variant,
      u = void 0 === s ? "tabs" : s,
      d = m(o),
      g = d[0],
      h = d[1],
      b = p(function () {
    return i(n, r);
  }, [n, r]),
      y = p(function () {
    return b.find(function (e) {
      return e.env === g;
    });
  }, [b, g]);
  return f.createElement(f.Fragment, null, "segmented-control" === u && f.createElement("div", null, f.createElement(C, {
    margin: {
      bottom: "xs"
    }
  }, f.createElement(F, {
    className: cn,
    selectedId: g,
    onChange: function onChange(e) {
      var n = e.detail.selectedId;
      return h(n);
    },
    options: b.map(function (e) {
      return {
        id: e.env,
        text: e.getName()
      };
    })
  })), y && f.createElement(ln, {
    showCopyAction: a
  }, y.toString())), !u || "tabs" === u && f.createElement(D, {
    variant: c,
    disableContentPaddings: "container" !== c,
    activeTabId: g,
    onChange: function onChange(e) {
      var n = e.detail.activeTabId;
      return h(n);
    },
    tabs: b.map(function (e) {
      return {
        id: e.env,
        label: e.getName(),
        content: f.createElement(C, {
          padding: {
            top: "container" !== c ? "m" : void 0
          }
        }, f.createElement(ln, {
          showCopyAction: a
        }, e.toString()))
      };
    })
  }));
},
    un = "AWS account access",
    dn = "Close",
    fn = "AWS account login",
    pn = "AWS CLI credentials",
    gn = "Open AWS console",
    mn = "Copy login URL",
    hn = "message",
    bn = "section-console-login",
    yn = "section-cli-credentials",
    kn = "button-console-login",
    vn = "button-copy-login",
    wn = "close-button",
    xn = "AWSAccountAccessModal-module_modal__1Ed5o",
    An = "AWSAccountAccessModal-module_tabs__22_mj",
    Sn = "AWSAccountAccessModal-module_textContent___6tPv",
    En = "SectionHeader-module_title__1kTM_",
    Cn = function Cn(e) {
  var n = e.children,
      t = e.iconName;
  return f.createElement(C, {
    className: En,
    variant: "h5",
    margin: {
      bottom: "s"
    }
  }, t && f.createElement(C, {
    margin: {
      right: "xs"
    }
  }, f.createElement(L, {
    name: t,
    variant: "disabled"
  })), n);
},
    zn = function zn(e) {
  var n = e.header,
      t = void 0 === n ? un : n,
      o = e.roleConfigs,
      r = e.size,
      a = e.visible,
      l = e.allowedRegions,
      i = e.defaultRegion,
      c = e.onDismiss,
      s = h(function () {
    c && c();
  }, [c]),
      u = p(function () {
    return o.map(function (e, n) {
      var t = e.id,
          r = e.name,
          a = e.federatedLoginUrl,
          i = e.consoleLoginUrl,
          c = e.message,
          s = [];
      return i && s.push(f.createElement(z, {
        key: kn,
        "data-testid": kn,
        href: i,
        variant: "primary",
        iconAlign: "right",
        iconName: "external",
        target: "_blank"
      }, gn)), a && s.push(f.createElement(en, {
        key: vn,
        content: a
      }, mn)), {
        id: t,
        label: r,
        content: f.createElement(C, {
          padding: {
            horizontal: o.length > 1 ? "l" : void 0
          }
        }, f.createElement(M, {
          direction: "vertical",
          size: "m"
        }, c ? f.createElement("div", {
          "data-testid": hn
        }, c) : null, s.length ? f.createElement("section", {
          "data-testid": bn
        }, f.createElement(Cn, {
          iconName: "lock-private"
        }, fn), f.createElement(M, {
          direction: "horizontal",
          size: "xs"
        }, s.map(function (e) {
          return e;
        }))) : null, f.createElement("section", {
          "data-testid": yn
        }, f.createElement(Cn, {
          iconName: "key"
        }, pn), f.createElement(sn, {
          credentials: o[n].credentials,
          variant: "segmented-control",
          showCopyAction: !0
        }), (null == l ? void 0 : l.length) && f.createElement(C, {
          margin: {
            top: "m"
          }
        }, f.createElement(O, {
          className: Sn,
          type: "info"
        }, "Only use", " ", l.map(function (e, n) {
          return f.createElement(y, {
            key: n
          }, f.createElement(C, {
            variant: "code"
          }, e), l.length > 2 && n < l.length - 1 ? ", " : n < l.length - 1 ? " " : "", l.length > 1 && n === l.length - 2 && "and ");
        }), " ", "as your region, unless otherwise directed by the event operator. You can optionally set the", " ", f.createElement(C, {
          variant: "code"
        }, "AWS_DEFAULT_REGION"), " ", "environment variable to one of the allowed regions to set the default region for CLI commands. This value can be overridden with the", " ", f.createElement(C, {
          variant: "code"
        }, "--region"), " command line parameter.")))))
      };
    });
  }, [o, i, l]);
  return f.createElement(T, {
    className: u.length > 1 ? xn : void 0,
    header: t,
    onDismiss: s,
    size: r,
    visible: a,
    footer: f.createElement(C, {
      "float": "right"
    }, f.createElement(M, {
      direction: "horizontal",
      size: "xs"
    }, f.createElement(z, {
      "data-testid": wn,
      onClick: s,
      variant: "link"
    }, dn))),
    disableContentPaddings: u.length > 1
  }, u.length > 1 && f.createElement(C, {
    padding: {
      bottom: "xxs"
    }
  }, f.createElement(D, {
    className: An,
    tabs: u
  })), 1 === u.length && u[0].content);
},
    Tn = "ValueWithLabel-module_breakSpaces__3pffU",
    Mn = function Mn(e) {
  var n = e.label,
      t = e.breakSpaces,
      o = e.children;
  return f.createElement("div", null, f.createElement(C, {
    variant: "awsui-key-label"
  }, n), f.createElement(C, null, f.createElement("span", {
    className: t ? Tn : void 0
  }, o)));
},
    On = "AWS console login",
    Dn = "Status",
    Fn = "Account number",
    Pn = "IAM role",
    Ln = "Destination",
    Bn = "Logging in...",
    Rn = "AWSConsoleLogin-module_iframe__176yb",
    Hn = function Hn(e) {
  var n = e.delay,
      t = void 0 === n ? 0 : n,
      o = e.details,
      r = e.header,
      a = void 0 === r ? On : r,
      l = e.onLogin,
      i = e.url,
      c = b(),
      s = m(!1),
      u = s[0],
      d = s[1],
      p = m(!1),
      g = p[0],
      y = p[1],
      v = h(function () {
    d(!0);
  }, [d]);
  return k(function () {
    return function () {
      window.clearTimeout(c.current);
    };
  }), k(function () {
    u && (window.clearTimeout(c.current), c.current = window.setTimeout(function () {
      return y(!0);
    }, t));
  }, [u, t]), k(function () {
    g && (l && l(i), i && (window.location.href = i));
  }, [g, i, l]), f.createElement(f.Fragment, null, f.createElement(R, {
    header: f.createElement(H, {
      variant: "h2"
    }, a)
  }, f.createElement(B, {
    columns: 4,
    variant: "text-grid"
  }, f.createElement(Mn, {
    label: Dn
  }, f.createElement(N, {
    type: "loading"
  }, Bn)), (null == o ? void 0 : o.account) ? f.createElement(Mn, {
    label: Fn
  }, o.account) : null, (null == o ? void 0 : o.role) ? f.createElement(Mn, {
    label: Pn
  }, o.role) : null, (null == o ? void 0 : o.destination) ? f.createElement(Mn, {
    label: Ln
  }, o.destination) : null)), f.createElement("iframe", {
    className: Rn,
    src: "https://signin.aws.amazon.com/oauth?Action=logout",
    onLoad: v
  }));
},
    Nn = ze.string().trim(),
    In = new RegExp(e.REGULAR_EXPRESSIONS.uuidV4),
    jn = "Required",
    Wn = "Enter a valid URL",
    qn = "Enter a valid workshop ID",
    Un = "This is an invalid URL for the current workshop",
    Vn = ze.object({
  workshopTitle: Nn.required(jn),
  workshopPage: Nn.url(Wn).test({
    message: "",
    test: function test(e, n) {
      void 0 === e && (e = "");
      var t = (null == n ? void 0 : n.parent) || {},
          o = t.contentId,
          r = void 0 === o ? "" : o,
          a = t.quickLinkId,
          l = void 0 === a ? "" : a;
      return e ? -1 !== e.indexOf(r) || !!(l && e.indexOf(l) > 0) || n.createError({
        message: Un
      }) : n.createError({
        message: jn
      });
    }
  }).required(),
  issue: Nn.min(3).max(250).required(jn),
  proposedSolution: Nn.max(250),
  impactLevel: ze.mixed().oneOf([1, 2, 3, 4, 5]).required(jn),
  assignee: Nn.required(jn),
  contentId: Nn.matches(In, qn).required(jn),
  quickLinkId: Nn
}),
    Jn = t(t({}, U), {
  primaryActionText: "Open in SIM",
  secondaryActionText: "Cancel",
  optionalText: "optional",
  maxUrlLengthErr: "The issue has exceeded a max length. Please limit your responses from {0} to {1} characters. You will be able to modify the issue prior to final submission."
}),
    Kn = "workshopPage",
    Qn = "issue",
    Yn = "proposedSolution",
    Gn = {
  invalid: !1,
  issueLength: -1,
  maxLength: -1
},
    Xn = function Xn(n) {
  var t = n.isVisible,
      a = n.onModalClosed,
      l = n.providedFormValues,
      i = n.onComplete,
      c = G("ContentIssueModal")[0],
      s = X().addCounterMetric,
      u = m(Gn),
      d = u[0],
      p = u[1],
      g = l.assignee,
      b = l.contentId,
      y = l.impactLevel,
      v = l.workshopTitle,
      w = l.quickLinkId,
      x = m(!1),
      A = x[0],
      S = x[1],
      E = we({
    validationSchema: Vn,
    validateOnChange: A,
    validateOnBlur: !1,
    initialValues: {
      workshopPage: "",
      issue: "",
      proposedSolution: "",
      workshopTitle: v,
      impactLevel: y,
      assignee: g,
      contentId: b,
      quickLinkId: w
    },
    onSubmit: function onSubmit(n) {
      return o(void 0, void 0, void 0, function () {
        var t, o;
        return r(this, function (r) {
          return t = new V(), o = t.addTitle(Ae(Jn.contentIssueTitle, v)).addDescription(t.formatDescription({
            pageOfWorkshop: n.workshopPage,
            issue: n.issue,
            proposedSolution: n.proposedSolution ? n.proposedSolution : ""
          })).addAssignedUser(n.assignee).addImpactLevel(n.impactLevel).addCustomField({
            id: "contentid",
            type: "string",
            value: n.contentId
          }).createIssueTemplate(), t.validateIssueTemplateLength(o) ? (d.invalid && p(Gn), s(e.CloudWatchMetric.CONTENT_ISSUE_TEMPLATE_CREATED), c.info("Opening issue in a new tab", o), t.open(o), null == i || i(o), [2]) : (p({
            invalid: !0,
            issueLength: o.length,
            maxLength: t.getMaxUrlLength()
          }), [2]);
        });
      });
    }
  }),
      C = h(function () {
    E.handleSubmit();
  }, []),
      z = h(function () {
    D(), a();
  }, []);
  k(function () {
    1 === E.submitCount && S(!0);
  }, [E.submitCount]), k(function () {
    t || E.resetForm();
  }, [t]);

  var T = _({
    isVisible: t,
    onDismiss: a,
    modalHeader: Ae(Jn.contentIssueTitle, v),
    actions: {
      primary: {
        text: Jn.primaryActionText,
        onClick: C,
        disabled: !E.dirty || !E.isValid,
        iconAlign: "right",
        iconName: "external"
      },
      tertiary: {
        text: Jn.secondaryActionText,
        onClick: z
      }
    },
    content: f.createElement(xe, {
      value: E
    }, f.createElement(ve, {
      errorText: d.invalid ? Ae(Jn.maxUrlLengthErr, d.issueLength, d.maxLength) : ""
    }, f.createElement(M, {
      size: "l"
    }, f.createElement(Z, {
      name: "workshopPage",
      dataTestId: Kn,
      formFieldProps: {
        label: Jn.linkPromptText,
        stretch: !0,
        children: f.createElement($, {
          name: "workshopPage",
          placeholder: "Published content or build preview URL",
          inputProps: {
            type: "text"
          }
        })
      }
    }), f.createElement(Z, {
      name: "issue",
      dataTestId: Qn,
      formFieldProps: {
        label: Jn.issuePromptText,
        stretch: !0,
        children: f.createElement(ee, {
          name: "issue",
          placeholder: "Issue details",
          textFieldProps: {}
        })
      }
    }), f.createElement(Z, {
      name: "proposedSolution",
      dataTestId: Yn,
      formFieldProps: {
        label: f.createElement(f.Fragment, null, Jn.proposedSolutionPromptText, " -", " ", f.createElement("i", null, Jn.optionalText)),
        stretch: !0,
        children: f.createElement(ee, {
          name: "proposedSolution",
          placeholder: "Proposed solution",
          textFieldProps: {}
        })
      }
    }))))
  }),
      O = T.modalComponent,
      D = T.hideModal;

  return O;
},
    _n = e.ConsoleLogLocalStorageId,
    Zn = function Zn(e) {
  var n = e.children,
      t = e.gitInformation || {},
      o = t.sha,
      r = t.branch,
      a = te(),
      l = a.getItem,
      i = a.setItem,
      c = a.removeItem,
      s = f.useState(!!l(_n)),
      u = s[0],
      d = s[1],
      p = m(""),
      g = p[0],
      b = p[1],
      y = m(!1),
      w = y[0],
      x = y[1],
      A = m(!1),
      S = A[0],
      E = A[1],
      z = m(2),
      O = z[0],
      D = z[1],
      F = m(1),
      P = F[0],
      L = F[1];
  ne(function () {
    if (O <= 0) return E(!1), L(1), void D(2);
    D(O - 1);
  }, S ? 1e3 : null);
  var B = h(function (e) {
    var n = !1;
    "keyup" === e.type && (n = !!("ControlLeft" === e.code));

    if (n) {
      if (P < 10) return S || E(!0), void L(P + 1);
      L(1), E(!1), x(!0);
    }
  }, [S, P]);
  return k(function () {
    return window.addEventListener("keyup", B), function () {
      return window.removeEventListener("keyup", B);
    };
  }, [P, B]), v(function () {
    var e = Q();
    e && b(e);
  }, []), f.createElement("div", {
    "data-testid": "debug-menu"
  }, n, f.createElement(T, {
    "data-testid": "debug-modal",
    onDismiss: function onDismiss() {
      return x(!1);
    },
    visible: w,
    closeAriaLabel: "Close modal",
    size: "medium",
    header: "Event Engine Debug Menu"
  }, f.createElement(f.Fragment, null, (o || r || g) && f.createElement(C, {
    margin: {
      bottom: "m"
    }
  }, f.createElement(M, {
    size: "m",
    direction: "vertical"
  }, f.createElement(j, null, f.createElement("h4", null, "Build Information"), r && f.createElement("p", null, f.createElement("b", null, "Branch"), " ", r), o && f.createElement("p", null, f.createElement("b", null, "Commit SHA"), " ", o), g && f.createElement("p", null, f.createElement("b", null, "Build Version"), " ", g)))), f.createElement(I, {
    onChange: function onChange(e) {
      var n = e.detail;
      n.checked ? i(_n, "true") : c(_n), d(n.checked);
    },
    checked: u
  }, "Enable ConsoleLogSink"))));
},
    $n = function (n) {
  function t() {
    var t = null !== n && n.apply(this, arguments) || this;
    return t.state = {
      error: null,
      info: null,
      hasError: !1
    }, t.componentDidMount = function () {
      var e = t.props.logger;
      window.addEventListener("error", function (n) {
        Te(n) || e.critical("Uncaught global error", n);
      });
    }, t.componentDidUpdate = function () {
      var n = t.state,
          o = n.error,
          r = n.info,
          a = t.props,
          l = a.logger,
          i = a.addCounterMetric;
      o && r && !Te(o) && !Te(r) && (l.critical("ErrorBoundary Catastrophic error!", o, r), i && i(e.CloudWatchMetric.ERROR_BOUNDARY_EXCEPTION));
    }, t.componentDidCatch = function (e, n) {
      var o = t.props.onError;
      if (o) try {
        o.call(t, e, n.componentStack);
      } catch (e) {}
      t.setState({
        error: e,
        info: n
      });
    }, t;
  }

  return c(t, n), t.getDerivedStateFromError = function () {
    return {
      hasError: !0
    };
  }, t.prototype.render = function () {
    var e = this.props,
        n = e.children,
        t = e.fallback,
        o = void 0 === t ? null : t;
    return this.state.hasError ? o : n;
  }, t.defaultProps = {
    logger: W.getLogger("ErrorBoundary", q.CRITICAL)
  }, t;
}(f.Component),
    et = {
  404: {
    imgSrc: "data:image/png;base64,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",
    title: Be.notFound.title,
    message: Be.notFound.message
  }
},
    nt = "ErrorPage-module_container__1PtO7",
    tt = "ErrorPage-module_graphic__1Ptuv";

!function (e) {
  e.Image = "error-page-image", e.Title = "error-page-title", e.Message = "error-page-message", e.Actions = "error-page-actions";
}(Ze || (Ze = {}));

var ot = function ot(e) {
  var n = e.type,
      t = void 0 === n ? "404" : n,
      o = e.imgSrc,
      r = e.title,
      a = e.message,
      l = e.actions,
      i = le(),
      c = et[t];
  return o = o || c.imgSrc, r = r || c.title, a = a || c.message, f.createElement(C, {
    className: nt,
    padding: {
      vertical: "xl"
    },
    "data-testid": "error-page-component"
  }, f.createElement(C, null, f.createElement("img", {
    "data-testid": Ze.Image,
    className: tt,
    src: o,
    alt: "Error page graphic"
  })), f.createElement(C, {
    "data-testid": Ze.Title,
    margin: {
      top: "m",
      bottom: "xs"
    },
    variant: "h2",
    fontSize: "heading-xl",
    fontWeight: "normal"
  }, r), f.createElement(C, {
    "data-testid": Ze.Message,
    variant: "p"
  }, a), (null == l ? void 0 : l.length) ? f.createElement(C, {
    margin: {
      top: "m"
    },
    padding: {
      right: "xxxl"
    }
  }, f.createElement(B, {
    "data-testid": Ze.Actions,
    columns: 4,
    disableGutters: !0
  }, l.map(function (e) {
    var n = e.text,
        t = e.href,
        o = e.external;
    return f.createElement(S, {
      key: t,
      href: t,
      external: o,
      onFollow: function onFollow(e) {
        !o && e.preventDefault(), i.push(t);
      }
    }, n);
  }))) : null);
};

f.createElement(ot, {
  type: "404"
});

var rt,
    at = "Footer-module_consoleNavFooter__Sosou",
    lt = "Footer-module_footerContainerRight__pNXd0",
    it = "Footer-module_footerLink__1PSjb",
    ct = "Footer-module_copyrightNotice__2oL27",
    st = "Footer-module_sticky__19UQd",
    ut = function ut(e) {
  return f.createElement(S, t({}, e, {
    className: it,
    variant: "info"
  }));
},
    dt = function dt(n) {
  var o = n.className;
  n.hideReportABug;
  var r = n.setReportWSBugModalOpenState,
      l = n.sticky,
      i = a(n, ["className", "hideReportABug", "setReportWSBugModalOpenState", "sticky"]),
      c = p(function () {
    var e = [at];
    return o && e.push(o.trim()), l && e.push(st), e.join(" ");
  }, [o, l]),
      s = new Date().getFullYear(),
      u = h(function () {
    r && r(!0);
  }, [r]);
  return f.createElement("footer", t({}, i, {
    className: c
  }), f.createElement("div", null, !(null == n ? void 0 : n.hideReportABug) && r && f.createElement(ut, {
    onFollow: u
  }, "Report Workshop Studio bug")), f.createElement("div", {
    className: lt
  }, f.createElement(C, {
    variant: "small",
    className: ct
  }, "© 2008 - ", s, ", Amazon Web Services, Inc. or its affiliates. All rights reserved."), f.createElement(ut, {
    href: e.ExternalLinks.privacy,
    target: "_blank"
  }, "Privacy policy"), f.createElement(ut, {
    href: e.ExternalLinks.terms,
    target: "_blank"
  }, "Terms of use")));
},
    ft = {
  "custom-banner-container__text": "LandingPageOverview-module_custom-banner-container__text__3_H7m",
  darkBannerText: "LandingPageOverview-module_darkBannerText__C13_z",
  lightBannerText: "LandingPageOverview-module_lightBannerText__122Kz",
  "custom-banner-container__item": "LandingPageOverview-module_custom-banner-container__item__2pxeV",
  "custom-banner-container__image": "LandingPageOverview-module_custom-banner-container__image__22WhI",
  "custom-banner-container__emphasizedText": "LandingPageOverview-module_custom-banner-container__emphasizedText__3ZvdA",
  a: "LandingPageOverview-module_a__2Re4i"
},
    pt = function pt(e) {
  return ft[e];
},
    gt = [pt("custom-banner-container__text"), pt("darkBannerText"), pt("lightBannerText"), pt("custom-banner-container__item"), pt("custom-banner-container__image"), pt("custom-banner-container__emphasizedText"), pt("a")],
    mt = gt[0],
    ht = gt[1],
    bt = gt[2],
    yt = gt[3],
    kt = gt[4],
    vt = gt[5],
    wt = gt[6],
    xt = function xt(e) {
  var n = e.item,
      t = e.isDarkMode,
      o = e.bannerIndex,
      r = [mt, t ? ht : bt];
  return f.createElement("div", {
    className: yt
  }, f.createElement("img", {
    className: kt,
    src: t ? n.darkIcon : n.lightIcon,
    alt: n.iconAltText
  }), f.createElement(C, {
    variant: "p",
    fontWeight: "light",
    key: n.emphasisText
  }, o ? o + ". " : "", " ", f.createElement("b", {
    className: ft[vt]
  }, n.emphasisText), " ", f.createElement("span", {
    className: r.join(" ")
  }, n.text)));
},
    At = function At(e) {
  var n = e.target,
      t = e.config,
      o = e.gridContainer,
      r = void 0 === o ? {} : o,
      a = e.gridItemContainer,
      l = void 0 === a ? {} : a,
      i = e.enableNumbering,
      c = void 0 !== i && i,
      s = oe(n);
  return f.createElement(ce, {
    className: r.isWebConsoleLandingPageOverview ? wt : "",
    gridDefinition: r.gridDefinition
  }, f.createElement(ce, {
    gridDefinition: l.gridDefinition
  }, t.map(function (e, n) {
    return f.createElement(xt, {
      key: e.emphasisText,
      item: e,
      isDarkMode: s,
      bannerIndex: c ? n + 1 : void 0
    });
  })));
},
    St = "LoadingComponent-module_styledContainer__2NmZ5",
    Et = function Et(e) {
  return f.createElement("div", {
    className: St
  }, f.createElement(C, {
    variant: e.boxVariant
  }, f.createElement(se, {
    variant: e.variant,
    size: e.size
  })), e.children && f.createElement(C, {
    margin: {
      left: "s"
    },
    variant: e.textVariant
  }, e.children));
},
    Ct = function Ct(e) {
  var n = e.containerProps,
      o = void 0 === n ? {
    margin: "l"
  } : n,
      r = e.spinnerWithLabelProps,
      a = void 0 === r ? {
    boxVariant: "h1",
    size: "big",
    children: "Loading...",
    textVariant: "h5"
  } : r;
  return f.createElement(C, t({}, o), f.createElement(Et, t({}, a)));
},
    zt = "Login-module_buttonContainer__2KfBS",
    Tt = function Tt(e) {
  var n = e.id,
      t = e.header,
      o = t.title,
      r = t.description,
      a = e.identityProviders,
      l = e.loginWithIdentityProvider,
      i = e.getHelpSigningInUrl,
      c = e.getHelpSigningInText;
  return f.createElement(R, {
    "data-testid": n,
    header: f.createElement(H, {
      variant: "h2",
      description: r,
      info: i && f.createElement(S, {
        href: i,
        variant: "info",
        target: "_blank"
      }, c)
    }, o)
  }, f.createElement(M, {
    direction: "vertical",
    size: "m"
  }, a.map(function (e) {
    return f.createElement("div", {
      className: zt,
      key: e.name
    }, f.createElement(z, {
      variant: e.isPrimaryButton ? "primary" : "normal",
      ariaLabel: e.ariaLabel,
      onClick: function onClick() {
        return l(e.provider);
      }
    }, e.name), e.description && f.createElement(C, {
      margin: {
        top: "xs"
      },
      variant: "small"
    }, e.description));
  })));
},
    Mt = "LoginFAQ-module_styledSections__2zof2",
    Ot = "LoginFAQ-module_styledListItem__rHI1g",
    Dt = "LoginFAQ-module_styledContent__14RXr",
    Ft = function Ft(e) {
  var n = e.headerTitle,
      t = e.helpContent;
  return f.createElement(R, {
    header: f.createElement(H, {
      variant: "h2"
    }, f.createElement("strong", null, n))
  }, t.sections.map(function (e) {
    var n = e.id,
        t = e.heading,
        o = e.topics;
    return f.createElement("section", {
      key: n
    }, f.createElement(j, null, f.createElement("h3", null, t)), f.createElement("ul", {
      className: Mt,
      "data-testid": n
    }, o.map(function (e) {
      var n = e.id,
          t = e.heading,
          o = e.content;
      return f.createElement("li", {
        className: Ot,
        key: n
      }, f.createElement(ue, {
        header: t
      }, f.createElement(j, null, f.createElement("article", {
        className: Dt,
        "data-testid": n
      }, o))));
    })));
  }));
},
    Pt = w({}),
    Lt = function Lt(e) {
  var n = m({}),
      o = n[0],
      r = n[1];
  return f.createElement(Pt.Provider, {
    value: {
      getTabsGroupActiveTab: function getTabsGroupActiveTab(e) {
        return o[e];
      },
      setTabsGroupActiveTab: function setTabsGroupActiveTab(e, n) {
        var a;
        return r(t(t({}, o), ((a = {})[e] = n, a)));
      },
      tabsGroupActiveTabs: o
    }
  }, e.children);
},
    Bt = w({}),
    Rt = "",
    Ht = function Ht(e, n) {
  if ("string" != typeof e) throw new TypeError("expected a string");
  if (1 === n) return e;
  if (2 === n) return e + e;
  var t = e.length * n;
  if (rt !== e || void 0 === rt) rt = e, Rt = "";else if (Rt.length >= t) return Rt.substr(0, t);

  for (; t > Rt.length && n > 1;) {
    1 & n && (Rt += e), n >>= 1, e += e;
  }

  return Rt = (Rt += e).substr(0, t);
};

var Nt = function Nt(e, n) {
  if (e = e.replace(n.subset ? function (e) {
    var n = [],
        t = -1;

    for (; ++t < e.length;) {
      n.push(e[t].replace(/[|\\{}()[\]^$+*?.]/g, "\\$&"));
    }

    return new RegExp("(?:" + n.join("|") + ")", "g");
  }(n.subset) : /["&'<>`]/g, t), n.subset || n.escapeOnly) return e;
  return e.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, function (e, t, o) {
    return n.format(1024 * (e.charCodeAt(0) - 55296) + e.charCodeAt(1) - 56320 + 65536, o.charCodeAt(t + 2), n);
  }).replace(/[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g, t);

  function t(e, t, o) {
    return n.format(e.charCodeAt(0), o.charCodeAt(t + 1), n);
  }
};

var It = Object.assign,
    jt = function jt(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
};

var Wt = function Wt(e, n) {
  return Nt(e, It({
    format: jt
  }, n));
},
    qt = Ut;

function Ut(e) {
  if (null == e) return Vt;
  if ("string" == typeof e) return function (e) {
    return n;

    function n(n) {
      return Boolean(n && n.type === e);
    }
  }(e);
  if ("object" == _typeof(e)) return "length" in e ? function (e) {
    var n = [],
        t = -1;

    for (; ++t < e.length;) {
      n[t] = Ut(e[t]);
    }

    return o;

    function o() {
      for (var e = -1; ++e < n.length;) {
        if (n[e].apply(this, arguments)) return !0;
      }

      return !1;
    }
  }(e) : function (e) {
    return n;

    function n(n) {
      var t;

      for (t in e) {
        if (n[t] !== e[t]) return !1;
      }

      return !0;
    }
  }(e);
  if ("function" == typeof e) return e;
  throw new Error("Expected function, string, or object as test");
}

function Vt() {
  return !0;
}

var Jt = function Jt(e) {
  return "[33m" + e + "[39m";
};

var Kt = Qt;

function Qt(e, n, t, o) {
  var r, a;
  "function" == typeof n && "function" != typeof t && (o = t, t = n, n = null), a = qt(n), r = o ? -1 : 1, function e(l, i, c) {
    var s,
        u = "object" == _typeof(l) && null !== l ? l : {};
    "string" == typeof u.type && (s = "string" == typeof u.tagName ? u.tagName : "string" == typeof u.name ? u.name : void 0, d.displayName = "node (" + Jt(u.type + (s ? "<" + s + ">" : "")) + ")");
    return d;

    function d() {
      var s,
          u,
          d = c.concat(l),
          f = [];
      if ((!n || a(l, i, c[c.length - 1] || null)) && false === (f = function (e) {
        if (null !== e && "object" == _typeof(e) && "length" in e) return e;
        if ("number" == typeof e) return [true, e];
        return [e];
      }(t(l, c)))[0]) return f;
      if (l.children && "skip" !== f[0]) for (u = (o ? l.children.length : -1) + r; u > -1 && u < l.children.length;) {
        if (false === (s = e(l.children[u], u, d)())[0]) return s;
        u = "number" == typeof s[1] ? s[1] : u + r;
      }
      return f;
    }
  }(e, null, [])();
}

Qt.CONTINUE = true, Qt.SKIP = "skip", Qt.EXIT = false;

var Yt = function Yt(e, n) {
  var t,
      o = e.children || [],
      r = [],
      a = -1;

  for (; ++a < o.length;) {
    t = o[a], r.push(n.handle(t, e, n, {
      before: "\n",
      after: "\n"
    })), a + 1 < o.length && r.push(l(t, o[a + 1]));
  }

  return r.join("");

  function l(t, o) {
    for (var r, a = -1; ++a < n.join.length && !0 !== (r = n.join[a](t, o, e, n)) && 1 !== r;) {
      if ("number" == typeof r) return Ht("\n", 1 + Number(r));
      if (!1 === r) return "\n\n\x3c!----\x3e\n\n";
    }

    return "\n\n";
  }
};

var Gt = function Gt(e, n, t) {
  var o,
      r,
      a,
      l = e.children || [],
      i = [],
      c = -1,
      s = t.before;

  for (; ++c < l.length;) {
    a = l[c], c + 1 < l.length ? ((r = n.handle.handlers[l[c + 1].type]) && r.peek && (r = r.peek), o = r ? r(l[c + 1], e, n, {
      before: "",
      after: ""
    }).charAt(0) : "") : o = t.after, i.length > 0 && ("\r" === s || "\n" === s) && "html" === a.type && (i[i.length - 1] = i[i.length - 1].replace(/(\r?\n|\r)$/, " "), s = " "), i.push(n.handle(a, e, n, {
      before: s,
      after: o
    })), s = i[i.length - 1].slice(-1);
  }

  return i.join("");
};

var Xt = function Xt(e) {
  var n = e.options.quote || '"';
  if ('"' !== n && "'" !== n) throw new Error("Cannot serialize title with `" + n + "` for `options.quote`, expected `\"`, or `'`");
  return n;
};

var _t = {
  containerDirective: eo,
  leafDirective: eo,
  textDirective: eo
};

eo.peek = function () {
  return ":";
};

var Zt = {}.hasOwnProperty,
    $t = /^[^\t\n\r "#'.<=>`}]+$/;

function eo(e, n, t) {
  var o,
      r = function (e) {
    var n = 0;
    "containerDirective" === e.type ? (Kt(e, "containerDirective", t), n += 3) : n = "leafDirective" === e.type ? 2 : 1;
    return Ht(":", n);

    function t(e, t) {
      for (var o = t.length, r = 0; o--;) {
        "containerDirective" === t[o].type && r++;
      }

      r > n && (n = r);
    }
  }(e),
      a = t.enter(e.type),
      l = r + (e.name || "") + function (e, n) {
    var t,
        o,
        r,
        a = e;

    if ("containerDirective" === e.type) {
      if (!no(e)) return "";
      a = e.children[0];
    }

    return t = n.enter("label"), o = n.enter(e.type + "Label"), r = Gt(a, n, {
      before: "[",
      after: "]"
    }), o(), t(), r ? "[" + r + "]" : "";
  }(e, t) + function (e, n) {
    var t,
        o,
        r,
        a,
        l,
        i,
        c = Xt(n),
        s = "textDirective" === e.type ? [c] : [c, "\n", "\r"],
        u = e.attributes || {},
        d = [];

    for (l in u) {
      if (Zt.call(u, l) && null != u[l]) if (a = String(u[l]), "id" === l) t = $t.test(a) ? "#" + a : f("id", a);else if ("class" === l) {
        for (a = a.split(/[\t\n\r ]+/g), o = [], r = [], i = -1; ++i < a.length;) {
          ($t.test(a[i]) ? r : o).push(a[i]);
        }

        o = o.length ? f("class", o.join(" ")) : "", r = r.length ? "." + r.join(".") : "";
      } else d.push(f(l, a));
    }

    o && d.unshift(o);
    r && d.unshift(r);
    t && d.unshift(t);
    return d.length ? "{" + d.join(" ") + "}" : "";

    function f(e, n) {
      return e + (n ? "=" + c + Wt(n, {
        subset: s
      }) + c : "");
    }
  }(e, t);

  return "containerDirective" === e.type && ((o = function (e, n) {
    var t = no(e) ? Object.assign({}, e, {
      children: e.children.slice(1)
    }) : e;
    return Yt(t, n);
  }(e, t)) && (l += "\n" + o), l += "\n" + r), a(), l;
}

function no(e) {
  return e.children && e.children[0] && e.children[0].data && e.children[0].data.directiveLabel;
}

var to = {
  unsafe: [{
    character: "\r",
    inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
  }, {
    character: "\n",
    inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
  }, {
    before: "[^:]",
    character: ":",
    after: "[A-Za-z]",
    inConstruct: ["phrasing"]
  }, {
    atBreak: !0,
    character: ":",
    after: ":"
  }],
  handlers: _t
},
    oo = function oo(e) {
  return "[33m" + e + "[39m";
};

var ro = ao;

function ao(e, n, t, o) {
  var r, a;
  "function" == typeof n && "function" != typeof t && (o = t, t = n, n = null), a = qt(n), r = o ? -1 : 1, function e(l, i, c) {
    var s,
        u = "object" == _typeof(l) && null !== l ? l : {};
    "string" == typeof u.type && (s = "string" == typeof u.tagName ? u.tagName : "string" == typeof u.name ? u.name : void 0, d.displayName = "node (" + oo(u.type + (s ? "<" + s + ">" : "")) + ")");
    return d;

    function d() {
      var s,
          u,
          d = c.concat(l),
          f = [];
      if ((!n || a(l, i, c[c.length - 1] || null)) && false === (f = function (e) {
        if (null !== e && "object" == _typeof(e) && "length" in e) return e;
        if ("number" == typeof e) return [true, e];
        return [e];
      }(t(l, c)))[0]) return f;
      if (l.children && "skip" !== f[0]) for (u = (o ? l.children.length : -1) + r; u > -1 && u < l.children.length;) {
        if (false === (s = e(l.children[u], u, d)())[0]) return s;
        u = "number" == typeof s[1] ? s[1] : u + r;
      }
      return f;
    }
  }(e, null, [])();
}

ao.CONTINUE = true, ao.SKIP = "skip", ao.EXIT = false;
var lo = uo,
    io = ro.CONTINUE,
    co = ro.SKIP,
    so = ro.EXIT;

function uo(e, n, t, o) {
  "function" == typeof n && "function" != typeof t && (o = t, t = n, n = null), ro(e, n, function (e, n) {
    var o = n[n.length - 1],
        r = o ? o.children.indexOf(e) : null;
    return t(e, r, o);
  }, o);
}

uo.CONTINUE = io, uo.SKIP = co, uo.EXIT = so;
var fo = ["http", "https", "mailto", "tel"];
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

var po = function po(e) {
  return null != e && null != e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
};

function go(e) {
  return ho(e && e.line) + ":" + ho(e && e.column);
}

function mo(e) {
  return go(e && e.start) + "-" + go(e && e.end);
}

function ho(e) {
  return e && "number" == typeof e ? e : 1;
}

var bo = /*#__PURE__*/function (_Error) {
  _inherits(bo, _Error);

  var _super = _createSuper(bo);

  function bo(e, n, t) {
    var _this;

    _classCallCheck(this, bo);

    var o = [null, null];
    var r = {
      start: {
        line: null,
        column: null
      },
      end: {
        line: null,
        column: null
      }
    };

    if (_this = _super.call(this), "string" == typeof n && (t = n, n = void 0), "string" == typeof t) {
      var _e2 = t.indexOf(":");

      -1 === _e2 ? o[1] = t : (o[0] = t.slice(0, _e2), o[1] = t.slice(_e2 + 1));
    }

    var a;
    n && ("type" in n || "position" in n ? n.position && (r = n.position) : "start" in n || "end" in n ? r = n : ("line" in n || "column" in n) && (r.start = n)), _this.name = ((a = n) && "object" == _typeof(a) ? "position" in a || "type" in a ? mo(a.position) : "start" in a || "end" in a ? mo(a) : "line" in a || "column" in a ? go(a) : "" : "") || "1:1", _this.message = "object" == _typeof(e) ? e.message : e, _this.stack = "object" == _typeof(e) ? e.stack : "", _this.reason = _this.message, _this.fatal, _this.line = r.start.line, _this.column = r.start.column, _this.source = o[0], _this.ruleId = o[1], _this.position = r, _this.actual, _this.expected, _this.file, _this.url, _this.note;
    return _possibleConstructorReturn(_this);
  }

  return bo;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function yo(e) {
  return null !== e && "object" == _typeof(e) && e.href && e.origin;
}

bo.prototype.file = "", bo.prototype.name = "", bo.prototype.reason = "", bo.prototype.message = "", bo.prototype.stack = "", bo.prototype.fatal = null, bo.prototype.column = null, bo.prototype.line = null, bo.prototype.source = null, bo.prototype.ruleId = null, bo.prototype.position = null;
var ko = ["history", "path", "basename", "stem", "extname", "dirname"];

var vo = /*#__PURE__*/function () {
  function vo(e) {
    _classCallCheck(this, vo);

    var n;
    n = e ? "string" == typeof e || po(e) ? {
      value: e
    } : yo(e) ? {
      path: e
    } : e : {}, this.data = {}, this.messages = [], this.history = [], this.cwd = pe.cwd(), this.value, this.stored, this.result, this.map;
    var t,
        o = -1;

    for (; ++o < ko.length;) {
      var _e3 = ko[o];
      _e3 in n && void 0 !== n[_e3] && (this[_e3] = "history" === _e3 ? _toConsumableArray(n[_e3]) : n[_e3]);
    }

    for (t in n) {
      ko.includes(t) || (this[t] = n[t]);
    }
  }

  _createClass(vo, [{
    key: "path",
    get: function get() {
      return this.history[this.history.length - 1];
    },
    set: function set(e) {
      yo(e) && (e = ge(e)), xo(e, "path"), this.path !== e && this.history.push(e);
    }
  }, {
    key: "dirname",
    get: function get() {
      return "string" == typeof this.path ? me.dirname(this.path) : void 0;
    },
    set: function set(e) {
      Ao(this.basename, "dirname"), this.path = me.join(e || "", this.basename);
    }
  }, {
    key: "basename",
    get: function get() {
      return "string" == typeof this.path ? me.basename(this.path) : void 0;
    },
    set: function set(e) {
      xo(e, "basename"), wo(e, "basename"), this.path = me.join(this.dirname || "", e);
    }
  }, {
    key: "extname",
    get: function get() {
      return "string" == typeof this.path ? me.extname(this.path) : void 0;
    },
    set: function set(e) {
      if (wo(e, "extname"), Ao(this.dirname, "extname"), e) {
        if (46 !== e.charCodeAt(0)) throw new Error("`extname` must start with `.`");
        if (e.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
      }

      this.path = me.join(this.dirname, this.stem + (e || ""));
    }
  }, {
    key: "stem",
    get: function get() {
      return "string" == typeof this.path ? me.basename(this.path, this.extname) : void 0;
    },
    set: function set(e) {
      xo(e, "stem"), wo(e, "stem"), this.path = me.join(this.dirname || "", e + (this.extname || ""));
    }
  }, {
    key: "toString",
    value: function toString(e) {
      return (this.value || "").toString(e);
    }
  }, {
    key: "message",
    value: function message(e, n, t) {
      var o = new bo(e, n, t);
      return this.path && (o.name = this.path + ":" + o.name, o.file = this.path), o.fatal = !1, this.messages.push(o), o;
    }
  }, {
    key: "info",
    value: function info(e, n, t) {
      var o = this.message(e, n, t);
      return o.fatal = null, o;
    }
  }, {
    key: "fail",
    value: function fail(e, n, t) {
      var o = this.message(e, n, t);
      throw o.fatal = !0, o;
    }
  }]);

  return vo;
}();

function wo(e, n) {
  if (e && e.includes(me.sep)) throw new Error("`" + n + "` cannot be a path: did not expect `" + me.sep + "`");
}

function xo(e, n) {
  if (!e) throw new Error("`" + n + "` cannot be empty");
}

function Ao(e, n) {
  if (!e) throw new Error("Setting `" + n + "` requires `path` to be set too");
}

function So(e) {
  if (e) throw e;
}

var Eo = Object.prototype.hasOwnProperty,
    Co = Object.prototype.toString,
    zo = Object.defineProperty,
    To = Object.getOwnPropertyDescriptor,
    Mo = function Mo(e) {
  return "function" == typeof Array.isArray ? Array.isArray(e) : "[object Array]" === Co.call(e);
},
    Oo = function Oo(e) {
  if (!e || "[object Object]" !== Co.call(e)) return !1;
  var n,
      t = Eo.call(e, "constructor"),
      o = e.constructor && e.constructor.prototype && Eo.call(e.constructor.prototype, "isPrototypeOf");
  if (e.constructor && !t && !o) return !1;

  for (n in e) {
    ;
  }

  return void 0 === n || Eo.call(e, n);
},
    Do = function Do(e, n) {
  zo && "__proto__" === n.name ? zo(e, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : e[n.name] = n.newValue;
},
    Fo = function Fo(e, n) {
  if ("__proto__" === n) {
    if (!Eo.call(e, n)) return;
    if (To) return To(e, n).value;
  }

  return e[n];
},
    Po = function e() {
  var n,
      t,
      o,
      r,
      a,
      l,
      i = arguments[0],
      c = 1,
      s = arguments.length,
      u = !1;

  for ("boolean" == typeof i && (u = i, i = arguments[1] || {}, c = 2), (null == i || "object" != _typeof(i) && "function" != typeof i) && (i = {}); c < s; ++c) {
    if (null != (n = arguments[c])) for (t in n) {
      o = Fo(i, t), i !== (r = Fo(n, t)) && (u && r && (Oo(r) || (a = Mo(r))) ? (a ? (a = !1, l = o && Mo(o) ? o : []) : l = o && Oo(o) ? o : {}, Do(i, {
        name: t,
        newValue: e(u, l, r)
      })) : void 0 !== r && Do(i, {
        name: t,
        newValue: r
      }));
    }
  }

  return i;
};

function Lo(e) {
  if ("object" != _typeof(e) || null === e) return !1;
  var n = Object.getPrototypeOf(e);
  return !(null !== n && n !== Object.prototype && null !== Object.getPrototypeOf(n) || Symbol.toStringTag in e || Symbol.iterator in e);
}

function Bo() {
  var e = [],
      n = {
    run: function run() {
      for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
        n[_key] = arguments[_key];
      }

      var t = -1;
      var o = n.pop();
      if ("function" != typeof o) throw new TypeError("Expected function as last argument, not " + o);
      !function r(a) {
        var i = e[++t];
        var c = -1;
        if (a) o(a);else {
          for (var _len2 = arguments.length, l = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            l[_key2 - 1] = arguments[_key2];
          }

          for (; ++c < n.length;) {
            null !== l[c] && void 0 !== l[c] || (l[c] = n[c]);
          }

          n = l, i ? function (e, n) {
            var t;
            return o;

            function o() {
              for (var _len3 = arguments.length, n = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                n[_key3] = arguments[_key3];
              }

              var o = e.length > n.length;
              var l;
              o && n.push(r);

              try {
                l = e.apply(this, n);
              } catch (e) {
                var _n2 = e;
                if (o && t) throw _n2;
                return r(_n2);
              }

              o || (l instanceof Promise ? l.then(a, r) : l instanceof Error ? r(l) : a(l));
            }

            function r(e) {
              for (var _len4 = arguments.length, o = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                o[_key4 - 1] = arguments[_key4];
              }

              t || (t = !0, n.apply(void 0, [e].concat(o)));
            }

            function a(e) {
              r(null, e);
            }
          }(i, r).apply(void 0, l) : o.apply(void 0, [null].concat(l));
        }
      }.apply(void 0, [null].concat(_toConsumableArray(n)));
    },
    use: function use(t) {
      if ("function" != typeof t) throw new TypeError("Expected `middelware` to be a function, not " + t);
      return e.push(t), n;
    }
  };
  return n;
}

function Ro(e) {
  return No(e && e.line) + ":" + No(e && e.column);
}

function Ho(e) {
  return Ro(e && e.start) + "-" + Ro(e && e.end);
}

function No(e) {
  return e && "number" == typeof e ? e : 1;
}

var Io = /*#__PURE__*/function (_Error2) {
  _inherits(Io, _Error2);

  var _super2 = _createSuper(Io);

  function Io(e, n, t) {
    var _this2;

    _classCallCheck(this, Io);

    var o = [null, null];
    var r = {
      start: {
        line: null,
        column: null
      },
      end: {
        line: null,
        column: null
      }
    };

    if (_this2 = _super2.call(this), "string" == typeof n && (t = n, n = void 0), "string" == typeof t) {
      var _e4 = t.indexOf(":");

      -1 === _e4 ? o[1] = t : (o[0] = t.slice(0, _e4), o[1] = t.slice(_e4 + 1));
    }

    var a;
    n && ("type" in n || "position" in n ? n.position && (r = n.position) : "start" in n || "end" in n ? r = n : ("line" in n || "column" in n) && (r.start = n)), _this2.name = ((a = n) && "object" == _typeof(a) ? "position" in a || "type" in a ? Ho(a.position) : "start" in a || "end" in a ? Ho(a) : "line" in a || "column" in a ? Ro(a) : "" : "") || "1:1", _this2.message = "object" == _typeof(e) ? e.message : e, _this2.stack = "object" == _typeof(e) ? e.stack : "", _this2.reason = _this2.message, _this2.fatal, _this2.line = r.start.line, _this2.column = r.start.column, _this2.source = o[0], _this2.ruleId = o[1], _this2.position = r, _this2.actual, _this2.expected, _this2.file, _this2.url, _this2.note;
    return _possibleConstructorReturn(_this2);
  }

  return Io;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function jo(e) {
  return null !== e && "object" == _typeof(e) && e.href && e.origin;
}

Io.prototype.file = "", Io.prototype.name = "", Io.prototype.reason = "", Io.prototype.message = "", Io.prototype.stack = "", Io.prototype.fatal = null, Io.prototype.column = null, Io.prototype.line = null, Io.prototype.source = null, Io.prototype.ruleId = null, Io.prototype.position = null;
var Wo = ["history", "path", "basename", "stem", "extname", "dirname"];

var qo = /*#__PURE__*/function () {
  function qo(e) {
    _classCallCheck(this, qo);

    var n;
    n = e ? "string" == typeof e || po(e) ? {
      value: e
    } : jo(e) ? {
      path: e
    } : e : {}, this.data = {}, this.messages = [], this.history = [], this.cwd = pe.cwd(), this.value, this.stored, this.result, this.map;
    var t,
        o = -1;

    for (; ++o < Wo.length;) {
      var _e5 = Wo[o];
      _e5 in n && void 0 !== n[_e5] && (this[_e5] = "history" === _e5 ? _toConsumableArray(n[_e5]) : n[_e5]);
    }

    for (t in n) {
      Wo.includes(t) || (this[t] = n[t]);
    }
  }

  _createClass(qo, [{
    key: "path",
    get: function get() {
      return this.history[this.history.length - 1];
    },
    set: function set(e) {
      jo(e) && (e = ge(e)), Vo(e, "path"), this.path !== e && this.history.push(e);
    }
  }, {
    key: "dirname",
    get: function get() {
      return "string" == typeof this.path ? me.dirname(this.path) : void 0;
    },
    set: function set(e) {
      Jo(this.basename, "dirname"), this.path = me.join(e || "", this.basename);
    }
  }, {
    key: "basename",
    get: function get() {
      return "string" == typeof this.path ? me.basename(this.path) : void 0;
    },
    set: function set(e) {
      Vo(e, "basename"), Uo(e, "basename"), this.path = me.join(this.dirname || "", e);
    }
  }, {
    key: "extname",
    get: function get() {
      return "string" == typeof this.path ? me.extname(this.path) : void 0;
    },
    set: function set(e) {
      if (Uo(e, "extname"), Jo(this.dirname, "extname"), e) {
        if (46 !== e.charCodeAt(0)) throw new Error("`extname` must start with `.`");
        if (e.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
      }

      this.path = me.join(this.dirname, this.stem + (e || ""));
    }
  }, {
    key: "stem",
    get: function get() {
      return "string" == typeof this.path ? me.basename(this.path, this.extname) : void 0;
    },
    set: function set(e) {
      Vo(e, "stem"), Uo(e, "stem"), this.path = me.join(this.dirname || "", e + (this.extname || ""));
    }
  }, {
    key: "toString",
    value: function toString(e) {
      return (this.value || "").toString(e);
    }
  }, {
    key: "message",
    value: function message(e, n, t) {
      var o = new Io(e, n, t);
      return this.path && (o.name = this.path + ":" + o.name, o.file = this.path), o.fatal = !1, this.messages.push(o), o;
    }
  }, {
    key: "info",
    value: function info(e, n, t) {
      var o = this.message(e, n, t);
      return o.fatal = null, o;
    }
  }, {
    key: "fail",
    value: function fail(e, n, t) {
      var o = this.message(e, n, t);
      throw o.fatal = !0, o;
    }
  }]);

  return qo;
}();

function Uo(e, n) {
  if (e && e.includes(me.sep)) throw new Error("`" + n + "` cannot be a path: did not expect `" + me.sep + "`");
}

function Vo(e, n) {
  if (!e) throw new Error("`" + n + "` cannot be empty");
}

function Jo(e, n) {
  if (!e) throw new Error("Setting `" + n + "` requires `path` to be set too");
}

var Ko = function e() {
  var n = Bo(),
      t = [];
  var o,
      r = {},
      a = -1;
  return l.data = function (e, n) {
    if ("string" == typeof e) return 2 === arguments.length ? (_o("data", o), r[e] = n, l) : Qo.call(r, e) && r[e] || null;
    if (e) return _o("data", o), r = e, l;
    return r;
  }, l.Parser = void 0, l.Compiler = void 0, l.freeze = function () {
    if (o) return l;

    for (; ++a < t.length;) {
      var _t$a = _toArray(t[a]),
          _e6 = _t$a[0],
          _o2 = _t$a.slice(1);

      if (!1 === _o2[0]) continue;
      !0 === _o2[0] && (_o2[0] = void 0);

      var _r2 = _e6.call.apply(_e6, [l].concat(_toConsumableArray(_o2)));

      "function" == typeof _r2 && n.use(_r2);
    }

    return o = !0, a = Number.POSITIVE_INFINITY, l;
  }, l.attachers = t, l.use = function (e) {
    for (var _len5 = arguments.length, n = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      n[_key5 - 1] = arguments[_key5];
    }

    var a;
    if (_o("use", o), null == e) ;else if ("function" == typeof e) u.apply(void 0, [e].concat(n));else {
      if ("object" != _typeof(e)) throw new TypeError("Expected usable value, not `" + e + "`");
      Array.isArray(e) ? s(e) : c(e);
    }
    a && (r.settings = Object.assign(r.settings || {}, a));
    return l;

    function i(e) {
      if ("function" == typeof e) u(e);else {
        if ("object" != _typeof(e)) throw new TypeError("Expected usable value, not `" + e + "`");

        if (Array.isArray(e)) {
          var _e7 = _toArray(e),
              _n3 = _e7[0],
              _t2 = _e7.slice(1);

          u.apply(void 0, [_n3].concat(_toConsumableArray(_t2)));
        } else c(e);
      }
    }

    function c(e) {
      s(e.plugins), e.settings && (a = Object.assign(a || {}, e.settings));
    }

    function s(e) {
      var n = -1;
      if (null == e) ;else {
        if (!Array.isArray(e)) throw new TypeError("Expected a list of plugins, not `" + e + "`");

        for (; ++n < e.length;) {
          i(e[n]);
        }
      }
    }

    function u(e, n) {
      var o,
          r = -1;

      for (; ++r < t.length;) {
        if (t[r][0] === e) {
          o = t[r];
          break;
        }
      }

      o ? (Lo(o[1]) && Lo(n) && (n = Po(!0, o[1], n)), o[1] = n) : t.push(Array.prototype.slice.call(arguments));
    }
  }, l.parse = function (e) {
    l.freeze();
    var n = er(e),
        t = l.Parser;
    if (Go("parse", t), Yo(t, "parse")) return new t(String(n), n).parse();
    return t(String(n), n);
  }, l.stringify = function (e, n) {
    l.freeze();
    var t = er(n),
        o = l.Compiler;
    if (Xo("stringify", o), Zo(e), Yo(o, "compile")) return new o(e, t).compile();
    return o(e, t);
  }, l.run = function (e, t, o) {
    Zo(e), l.freeze(), o || "function" != typeof t || (o = t, t = void 0);
    if (!o) return new Promise(r);

    function r(r, a) {
      function l(n, t, l) {
        t = t || e, n ? a(n) : r ? r(t) : o(null, t, l);
      }

      n.run(e, er(t), l);
    }

    r(null, o);
  }, l.runSync = function (e, n) {
    var t, o;
    return l.run(e, n, r), $o("runSync", "run", o), t;

    function r(e, n) {
      So(e), t = n, o = !0;
    }
  }, l.process = function (e, n) {
    if (l.freeze(), Go("process", l.Parser), Xo("process", l.Compiler), !n) return new Promise(t);

    function t(t, o) {
      var r = er(e);

      function a(e, r) {
        e || !r ? o(e) : t ? t(r) : n(null, r);
      }

      l.run(l.parse(r), r, function (e, n, t) {
        if (!e && n && t) {
          var _r3 = l.stringify(n, t);

          null == _r3 || ("string" == typeof (o = _r3) || po(o) ? t.value = _r3 : t.result = _r3), a(e, t);
        } else a(e);

        var o;
      });
    }

    t(null, n);
  }, l.processSync = function (e) {
    var n;
    l.freeze(), Go("processSync", l.Parser), Xo("processSync", l.Compiler);
    var t = er(e);
    return l.process(t, o), $o("processSync", "process", n), t;

    function o(e) {
      n = !0, So(e);
    }
  }, l;

  function l() {
    var n = e();
    var o = -1;

    for (; ++o < t.length;) {
      n.use.apply(n, _toConsumableArray(t[o]));
    }

    return n.data(Po(!0, {}, r)), n;
  }
}().freeze(),
    Qo = {}.hasOwnProperty;

function Yo(e, n) {
  return "function" == typeof e && e.prototype && (function (e) {
    var n;

    for (n in e) {
      if (Qo.call(e, n)) return !0;
    }

    return !1;
  }(e.prototype) || n in e.prototype);
}

function Go(e, n) {
  if ("function" != typeof n) throw new TypeError("Cannot `" + e + "` without `Parser`");
}

function Xo(e, n) {
  if ("function" != typeof n) throw new TypeError("Cannot `" + e + "` without `Compiler`");
}

function _o(e, n) {
  if (n) throw new Error("Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}

function Zo(e) {
  if (!Lo(e) || "string" != typeof e.type) throw new TypeError("Expected node, got `" + e + "`");
}

function $o(e, n, t) {
  if (!t) throw new Error("`" + e + "` finished async. Use `" + n + "` instead");
}

function er(e) {
  return function (e) {
    return Boolean(e && "object" == _typeof(e) && "message" in e && "messages" in e);
  }(e) ? e : new qo(e);
}

function nr(e, n) {
  return e && "object" == _typeof(e) && (e.value || (n ? e.alt : "") || "children" in e && tr(e.children, n) || Array.isArray(e) && tr(e, n)) || "";
}

function tr(e, n) {
  for (var t = [], o = -1; ++o < e.length;) {
    t[o] = nr(e[o], n);
  }

  return t.join("");
}

function or(e, n, t, o) {
  var r = e.length;
  var a,
      l = 0;
  if (n = n < 0 ? -n > r ? 0 : r + n : n > r ? r : n, t = t > 0 ? t : 0, o.length < 1e4) a = Array.from(o), a.unshift(n, t), [].splice.apply(e, a);else for (t && [].splice.apply(e, [n, t]); l < o.length;) {
    a = o.slice(l, l + 1e4), a.unshift(n, 0), [].splice.apply(e, a), l += 1e4, n += 1e4;
  }
}

function rr(e, n) {
  return e.length > 0 ? (or(e, e.length, 0, n), e) : n;
}

var ar = {}.hasOwnProperty;

function lr(e) {
  var n = {};
  var t = -1;

  for (; ++t < e.length;) {
    ir(n, e[t]);
  }

  return n;
}

function ir(e, n) {
  var t;

  for (t in n) {
    var _o3 = (ar.call(e, t) ? e[t] : void 0) || (e[t] = {}),
        _r4 = n[t];

    var _a2 = void 0;

    for (_a2 in _r4) {
      ar.call(_o3, _a2) || (_o3[_a2] = []);
      var _e8 = _r4[_a2];
      cr(_o3[_a2], Array.isArray(_e8) ? _e8 : _e8 ? [_e8] : []);
    }
  }
}

function cr(e, n) {
  var t = -1;
  var o = [];

  for (; ++t < n.length;) {
    ("after" === n[t].add ? e : o).push(n[t]);
  }

  or(e, 0, 0, o);
}

var sr = wr(/[A-Za-z]/),
    ur = wr(/\d/),
    dr = wr(/[\dA-Fa-f]/),
    fr = wr(/[\dA-Za-z]/),
    pr = wr(/[!-/:-@[-`{-~]/),
    gr = wr(/[#-'*+\--9=?A-Z^-~]/);

function mr(e) {
  return null !== e && (e < 32 || 127 === e);
}

function hr(e) {
  return null !== e && (e < 0 || 32 === e);
}

function br(e) {
  return null !== e && e < -2;
}

function yr(e) {
  return -2 === e || -1 === e || 32 === e;
}

var kr = wr(/\s/),
    vr = wr(/[!-/:-@[-`{-~\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/);

function wr(e) {
  return function (n) {
    return null !== n && e.test(String.fromCharCode(n));
  };
}

function xr(e, n, t, o) {
  var r = o ? o - 1 : Number.POSITIVE_INFINITY;
  var a = 0;
  return function (o) {
    if (yr(o)) return e.enter(t), l(o);
    return n(o);
  };

  function l(o) {
    return yr(o) && a++ < r ? (e.consume(o), l) : (e.exit(t), n(o));
  }
}

var Ar = {
  tokenize: function tokenize(e) {
    var n = e.attempt(this.parser.constructs.contentInitial, function (t) {
      if (null === t) return void e.consume(t);
      return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), xr(e, n, "linePrefix");
    }, function (n) {
      return e.enter("paragraph"), o(n);
    });
    var t;
    return n;

    function o(n) {
      var o = e.enter("chunkText", {
        contentType: "text",
        previous: t
      });
      return t && (t.next = o), t = o, r(n);
    }

    function r(n) {
      return null === n ? (e.exit("chunkText"), e.exit("paragraph"), void e.consume(n)) : br(n) ? (e.consume(n), e.exit("chunkText"), o) : (e.consume(n), r);
    }
  }
};
var Sr = {
  tokenize: function tokenize(e) {
    var n = this,
        t = [];
    var o,
        r,
        a,
        l = 0;
    return i;

    function i(o) {
      if (l < t.length) {
        var _r5 = t[l];
        return n.containerState = _r5[1], e.attempt(_r5[0].continuation, c, s)(o);
      }

      return s(o);
    }

    function c(e) {
      if (l++, n.containerState._closeFlow) {
        n.containerState._closeFlow = void 0, o && y();
        var _t3 = n.events.length;

        var _r6,
            _a3 = _t3;

        for (; _a3--;) {
          if ("exit" === n.events[_a3][0] && "chunkFlow" === n.events[_a3][1].type) {
            _r6 = n.events[_a3][1].end;
            break;
          }
        }

        b(l);
        var _i2 = _t3;

        for (; _i2 < n.events.length;) {
          n.events[_i2][1].end = Object.assign({}, _r6), _i2++;
        }

        return or(n.events, _a3 + 1, 0, n.events.slice(_t3)), n.events.length = _i2, s(e);
      }

      return i(e);
    }

    function s(r) {
      if (l === t.length) {
        if (!o) return f(r);
        if (o.currentConstruct && o.currentConstruct.concrete) return g(r);
        n.interrupt = Boolean(o.currentConstruct && !o._gfmTableDynamicInterruptHack);
      }

      return n.containerState = {}, e.check(Er, u, d)(r);
    }

    function u(e) {
      return o && y(), b(l), f(e);
    }

    function d(e) {
      return n.parser.lazy[n.now().line] = l !== t.length, a = n.now().offset, g(e);
    }

    function f(t) {
      return n.containerState = {}, e.attempt(Er, p, g)(t);
    }

    function p(e) {
      return l++, t.push([n.currentConstruct, n.containerState]), f(e);
    }

    function g(t) {
      return null === t ? (o && y(), b(0), void e.consume(t)) : (o = o || n.parser.flow(n.now()), e.enter("chunkFlow", {
        contentType: "flow",
        previous: r,
        _tokenizer: o
      }), m(t));
    }

    function m(t) {
      return null === t ? (h(e.exit("chunkFlow"), !0), b(0), void e.consume(t)) : br(t) ? (e.consume(t), h(e.exit("chunkFlow")), l = 0, n.interrupt = void 0, i) : (e.consume(t), m);
    }

    function h(e, t) {
      var i = n.sliceStream(e);

      if (t && i.push(null), e.previous = r, r && (r.next = e), r = e, o.defineSkip(e.start), o.write(i), n.parser.lazy[e.start.line]) {
        var _e9 = o.events.length;

        for (; _e9--;) {
          if (o.events[_e9][1].start.offset < a && (!o.events[_e9][1].end || o.events[_e9][1].end.offset > a)) return;
        }

        var _t4 = n.events.length;

        var _r7,
            _i3,
            _c2 = _t4;

        for (; _c2--;) {
          if ("exit" === n.events[_c2][0] && "chunkFlow" === n.events[_c2][1].type) {
            if (_r7) {
              _i3 = n.events[_c2][1].end;
              break;
            }

            _r7 = !0;
          }
        }

        for (b(l), _e9 = _t4; _e9 < n.events.length;) {
          n.events[_e9][1].end = Object.assign({}, _i3), _e9++;
        }

        or(n.events, _c2 + 1, 0, n.events.slice(_t4)), n.events.length = _e9;
      }
    }

    function b(o) {
      var r = t.length;

      for (; r-- > o;) {
        var _o4 = t[r];
        n.containerState = _o4[1], _o4[0].exit.call(n, e);
      }

      t.length = o;
    }

    function y() {
      o.write([null]), r = void 0, o = void 0, n.containerState._closeFlow = void 0;
    }
  }
},
    Er = {
  tokenize: function tokenize(e, n, t) {
    return xr(e, e.attempt(this.parser.constructs.document, n, t), "linePrefix", this.parser.constructs.disable["null"].includes("codeIndented") ? void 0 : 4);
  }
};

function Cr(e) {
  return null === e || hr(e) || kr(e) ? 1 : vr(e) ? 2 : void 0;
}

function zr(e, n, t) {
  var o = [];
  var r = -1;

  for (; ++r < e.length;) {
    var _a4 = e[r].resolveAll;
    _a4 && !o.includes(_a4) && (n = _a4(n, t), o.push(_a4));
  }

  return n;
}

var Tr = {
  name: "attention",
  tokenize: function tokenize(e, n) {
    var t = this.parser.constructs.attentionMarkers["null"],
        o = this.previous,
        r = Cr(o);
    var a;
    return function (n) {
      return e.enter("attentionSequence"), a = n, l(n);
    };

    function l(i) {
      if (i === a) return e.consume(i), l;
      var c = e.exit("attentionSequence"),
          s = Cr(i),
          u = !s || 2 === s && r || t.includes(i),
          d = !r || 2 === r && s || t.includes(o);
      return c._open = Boolean(42 === a ? u : u && (r || !d)), c._close = Boolean(42 === a ? d : d && (s || !u)), n(i);
    }
  },
  resolveAll: function resolveAll(e, n) {
    var t,
        o,
        r,
        a,
        l,
        i,
        c,
        s,
        u = -1;

    for (; ++u < e.length;) {
      if ("enter" === e[u][0] && "attentionSequence" === e[u][1].type && e[u][1]._close) for (t = u; t--;) {
        if ("exit" === e[t][0] && "attentionSequence" === e[t][1].type && e[t][1]._open && n.sliceSerialize(e[t][1]).charCodeAt(0) === n.sliceSerialize(e[u][1]).charCodeAt(0)) {
          if ((e[t][1]._close || e[u][1]._open) && (e[u][1].end.offset - e[u][1].start.offset) % 3 && !((e[t][1].end.offset - e[t][1].start.offset + e[u][1].end.offset - e[u][1].start.offset) % 3)) continue;
          i = e[t][1].end.offset - e[t][1].start.offset > 1 && e[u][1].end.offset - e[u][1].start.offset > 1 ? 2 : 1;

          var _d2 = Object.assign({}, e[t][1].end),
              _f2 = Object.assign({}, e[u][1].start);

          Mr(_d2, -i), Mr(_f2, i), a = {
            type: i > 1 ? "strongSequence" : "emphasisSequence",
            start: _d2,
            end: Object.assign({}, e[t][1].end)
          }, l = {
            type: i > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[u][1].start),
            end: _f2
          }, r = {
            type: i > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[t][1].end),
            end: Object.assign({}, e[u][1].start)
          }, o = {
            type: i > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, l.end)
          }, e[t][1].end = Object.assign({}, a.start), e[u][1].start = Object.assign({}, l.end), c = [], e[t][1].end.offset - e[t][1].start.offset && (c = rr(c, [["enter", e[t][1], n], ["exit", e[t][1], n]])), c = rr(c, [["enter", o, n], ["enter", a, n], ["exit", a, n], ["enter", r, n]]), c = rr(c, zr(n.parser.constructs.insideSpan["null"], e.slice(t + 1, u), n)), c = rr(c, [["exit", r, n], ["enter", l, n], ["exit", l, n], ["exit", o, n]]), e[u][1].end.offset - e[u][1].start.offset ? (s = 2, c = rr(c, [["enter", e[u][1], n], ["exit", e[u][1], n]])) : s = 0, or(e, t - 1, u - t + 3, c), u = t + c.length - s - 2;
          break;
        }
      }
    }

    u = -1;

    for (; ++u < e.length;) {
      "attentionSequence" === e[u][1].type && (e[u][1].type = "data");
    }

    return e;
  }
};

function Mr(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}

var Or = {
  name: "autolink",
  tokenize: function tokenize(e, n, t) {
    var o = 1;
    return function (n) {
      return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(n), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), r;
    };

    function r(n) {
      return sr(n) ? (e.consume(n), a) : gr(n) ? c(n) : t(n);
    }

    function a(e) {
      return 43 === e || 45 === e || 46 === e || fr(e) ? l(e) : c(e);
    }

    function l(n) {
      return 58 === n ? (e.consume(n), i) : (43 === n || 45 === n || 46 === n || fr(n)) && o++ < 32 ? (e.consume(n), l) : c(n);
    }

    function i(n) {
      return 62 === n ? (e.exit("autolinkProtocol"), f(n)) : null === n || 32 === n || 60 === n || mr(n) ? t(n) : (e.consume(n), i);
    }

    function c(n) {
      return 64 === n ? (e.consume(n), o = 0, s) : gr(n) ? (e.consume(n), c) : t(n);
    }

    function s(e) {
      return fr(e) ? u(e) : t(e);
    }

    function u(n) {
      return 46 === n ? (e.consume(n), o = 0, s) : 62 === n ? (e.exit("autolinkProtocol").type = "autolinkEmail", f(n)) : d(n);
    }

    function d(n) {
      return (45 === n || fr(n)) && o++ < 63 ? (e.consume(n), 45 === n ? d : u) : t(n);
    }

    function f(t) {
      return e.enter("autolinkMarker"), e.consume(t), e.exit("autolinkMarker"), e.exit("autolink"), n;
    }
  }
};
var Dr = {
  tokenize: function tokenize(e, n, t) {
    return xr(e, function (e) {
      return null === e || br(e) ? n(e) : t(e);
    }, "linePrefix");
  },
  partial: !0
};
var Fr = {
  name: "blockQuote",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return function (n) {
      if (62 === n) {
        var _t5 = o.containerState;
        return _t5.open || (e.enter("blockQuote", {
          _container: !0
        }), _t5.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(n), e.exit("blockQuoteMarker"), r;
      }

      return t(n);
    };

    function r(t) {
      return yr(t) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(t), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(t));
    }
  },
  continuation: {
    tokenize: function tokenize(e, n, t) {
      return xr(e, e.attempt(Fr, n, t), "linePrefix", this.parser.constructs.disable["null"].includes("codeIndented") ? void 0 : 4);
    }
  },
  exit: function exit(e) {
    e.exit("blockQuote");
  }
};
var Pr = {
  name: "characterEscape",
  tokenize: function tokenize(e, n, t) {
    return function (n) {
      return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(n), e.exit("escapeMarker"), o;
    };

    function o(o) {
      return pr(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(o);
    }
  }
};
var Lr = {
  AElig: "Æ",
  AMP: "&",
  Aacute: "Á",
  Abreve: "Ă",
  Acirc: "Â",
  Acy: "А",
  Afr: "𝔄",
  Agrave: "À",
  Alpha: "Α",
  Amacr: "Ā",
  And: "⩓",
  Aogon: "Ą",
  Aopf: "𝔸",
  ApplyFunction: "⁡",
  Aring: "Å",
  Ascr: "𝒜",
  Assign: "≔",
  Atilde: "Ã",
  Auml: "Ä",
  Backslash: "∖",
  Barv: "⫧",
  Barwed: "⌆",
  Bcy: "Б",
  Because: "∵",
  Bernoullis: "ℬ",
  Beta: "Β",
  Bfr: "𝔅",
  Bopf: "𝔹",
  Breve: "˘",
  Bscr: "ℬ",
  Bumpeq: "≎",
  CHcy: "Ч",
  COPY: "©",
  Cacute: "Ć",
  Cap: "⋒",
  CapitalDifferentialD: "ⅅ",
  Cayleys: "ℭ",
  Ccaron: "Č",
  Ccedil: "Ç",
  Ccirc: "Ĉ",
  Cconint: "∰",
  Cdot: "Ċ",
  Cedilla: "¸",
  CenterDot: "·",
  Cfr: "ℭ",
  Chi: "Χ",
  CircleDot: "⊙",
  CircleMinus: "⊖",
  CirclePlus: "⊕",
  CircleTimes: "⊗",
  ClockwiseContourIntegral: "∲",
  CloseCurlyDoubleQuote: "”",
  CloseCurlyQuote: "’",
  Colon: "∷",
  Colone: "⩴",
  Congruent: "≡",
  Conint: "∯",
  ContourIntegral: "∮",
  Copf: "ℂ",
  Coproduct: "∐",
  CounterClockwiseContourIntegral: "∳",
  Cross: "⨯",
  Cscr: "𝒞",
  Cup: "⋓",
  CupCap: "≍",
  DD: "ⅅ",
  DDotrahd: "⤑",
  DJcy: "Ђ",
  DScy: "Ѕ",
  DZcy: "Џ",
  Dagger: "‡",
  Darr: "↡",
  Dashv: "⫤",
  Dcaron: "Ď",
  Dcy: "Д",
  Del: "∇",
  Delta: "Δ",
  Dfr: "𝔇",
  DiacriticalAcute: "´",
  DiacriticalDot: "˙",
  DiacriticalDoubleAcute: "˝",
  DiacriticalGrave: "`",
  DiacriticalTilde: "˜",
  Diamond: "⋄",
  DifferentialD: "ⅆ",
  Dopf: "𝔻",
  Dot: "¨",
  DotDot: "⃜",
  DotEqual: "≐",
  DoubleContourIntegral: "∯",
  DoubleDot: "¨",
  DoubleDownArrow: "⇓",
  DoubleLeftArrow: "⇐",
  DoubleLeftRightArrow: "⇔",
  DoubleLeftTee: "⫤",
  DoubleLongLeftArrow: "⟸",
  DoubleLongLeftRightArrow: "⟺",
  DoubleLongRightArrow: "⟹",
  DoubleRightArrow: "⇒",
  DoubleRightTee: "⊨",
  DoubleUpArrow: "⇑",
  DoubleUpDownArrow: "⇕",
  DoubleVerticalBar: "∥",
  DownArrow: "↓",
  DownArrowBar: "⤓",
  DownArrowUpArrow: "⇵",
  DownBreve: "̑",
  DownLeftRightVector: "⥐",
  DownLeftTeeVector: "⥞",
  DownLeftVector: "↽",
  DownLeftVectorBar: "⥖",
  DownRightTeeVector: "⥟",
  DownRightVector: "⇁",
  DownRightVectorBar: "⥗",
  DownTee: "⊤",
  DownTeeArrow: "↧",
  Downarrow: "⇓",
  Dscr: "𝒟",
  Dstrok: "Đ",
  ENG: "Ŋ",
  ETH: "Ð",
  Eacute: "É",
  Ecaron: "Ě",
  Ecirc: "Ê",
  Ecy: "Э",
  Edot: "Ė",
  Efr: "𝔈",
  Egrave: "È",
  Element: "∈",
  Emacr: "Ē",
  EmptySmallSquare: "◻",
  EmptyVerySmallSquare: "▫",
  Eogon: "Ę",
  Eopf: "𝔼",
  Epsilon: "Ε",
  Equal: "⩵",
  EqualTilde: "≂",
  Equilibrium: "⇌",
  Escr: "ℰ",
  Esim: "⩳",
  Eta: "Η",
  Euml: "Ë",
  Exists: "∃",
  ExponentialE: "ⅇ",
  Fcy: "Ф",
  Ffr: "𝔉",
  FilledSmallSquare: "◼",
  FilledVerySmallSquare: "▪",
  Fopf: "𝔽",
  ForAll: "∀",
  Fouriertrf: "ℱ",
  Fscr: "ℱ",
  GJcy: "Ѓ",
  GT: ">",
  Gamma: "Γ",
  Gammad: "Ϝ",
  Gbreve: "Ğ",
  Gcedil: "Ģ",
  Gcirc: "Ĝ",
  Gcy: "Г",
  Gdot: "Ġ",
  Gfr: "𝔊",
  Gg: "⋙",
  Gopf: "𝔾",
  GreaterEqual: "≥",
  GreaterEqualLess: "⋛",
  GreaterFullEqual: "≧",
  GreaterGreater: "⪢",
  GreaterLess: "≷",
  GreaterSlantEqual: "⩾",
  GreaterTilde: "≳",
  Gscr: "𝒢",
  Gt: "≫",
  HARDcy: "Ъ",
  Hacek: "ˇ",
  Hat: "^",
  Hcirc: "Ĥ",
  Hfr: "ℌ",
  HilbertSpace: "ℋ",
  Hopf: "ℍ",
  HorizontalLine: "─",
  Hscr: "ℋ",
  Hstrok: "Ħ",
  HumpDownHump: "≎",
  HumpEqual: "≏",
  IEcy: "Е",
  IJlig: "Ĳ",
  IOcy: "Ё",
  Iacute: "Í",
  Icirc: "Î",
  Icy: "И",
  Idot: "İ",
  Ifr: "ℑ",
  Igrave: "Ì",
  Im: "ℑ",
  Imacr: "Ī",
  ImaginaryI: "ⅈ",
  Implies: "⇒",
  Int: "∬",
  Integral: "∫",
  Intersection: "⋂",
  InvisibleComma: "⁣",
  InvisibleTimes: "⁢",
  Iogon: "Į",
  Iopf: "𝕀",
  Iota: "Ι",
  Iscr: "ℐ",
  Itilde: "Ĩ",
  Iukcy: "І",
  Iuml: "Ï",
  Jcirc: "Ĵ",
  Jcy: "Й",
  Jfr: "𝔍",
  Jopf: "𝕁",
  Jscr: "𝒥",
  Jsercy: "Ј",
  Jukcy: "Є",
  KHcy: "Х",
  KJcy: "Ќ",
  Kappa: "Κ",
  Kcedil: "Ķ",
  Kcy: "К",
  Kfr: "𝔎",
  Kopf: "𝕂",
  Kscr: "𝒦",
  LJcy: "Љ",
  LT: "<",
  Lacute: "Ĺ",
  Lambda: "Λ",
  Lang: "⟪",
  Laplacetrf: "ℒ",
  Larr: "↞",
  Lcaron: "Ľ",
  Lcedil: "Ļ",
  Lcy: "Л",
  LeftAngleBracket: "⟨",
  LeftArrow: "←",
  LeftArrowBar: "⇤",
  LeftArrowRightArrow: "⇆",
  LeftCeiling: "⌈",
  LeftDoubleBracket: "⟦",
  LeftDownTeeVector: "⥡",
  LeftDownVector: "⇃",
  LeftDownVectorBar: "⥙",
  LeftFloor: "⌊",
  LeftRightArrow: "↔",
  LeftRightVector: "⥎",
  LeftTee: "⊣",
  LeftTeeArrow: "↤",
  LeftTeeVector: "⥚",
  LeftTriangle: "⊲",
  LeftTriangleBar: "⧏",
  LeftTriangleEqual: "⊴",
  LeftUpDownVector: "⥑",
  LeftUpTeeVector: "⥠",
  LeftUpVector: "↿",
  LeftUpVectorBar: "⥘",
  LeftVector: "↼",
  LeftVectorBar: "⥒",
  Leftarrow: "⇐",
  Leftrightarrow: "⇔",
  LessEqualGreater: "⋚",
  LessFullEqual: "≦",
  LessGreater: "≶",
  LessLess: "⪡",
  LessSlantEqual: "⩽",
  LessTilde: "≲",
  Lfr: "𝔏",
  Ll: "⋘",
  Lleftarrow: "⇚",
  Lmidot: "Ŀ",
  LongLeftArrow: "⟵",
  LongLeftRightArrow: "⟷",
  LongRightArrow: "⟶",
  Longleftarrow: "⟸",
  Longleftrightarrow: "⟺",
  Longrightarrow: "⟹",
  Lopf: "𝕃",
  LowerLeftArrow: "↙",
  LowerRightArrow: "↘",
  Lscr: "ℒ",
  Lsh: "↰",
  Lstrok: "Ł",
  Lt: "≪",
  Map: "⤅",
  Mcy: "М",
  MediumSpace: " ",
  Mellintrf: "ℳ",
  Mfr: "𝔐",
  MinusPlus: "∓",
  Mopf: "𝕄",
  Mscr: "ℳ",
  Mu: "Μ",
  NJcy: "Њ",
  Nacute: "Ń",
  Ncaron: "Ň",
  Ncedil: "Ņ",
  Ncy: "Н",
  NegativeMediumSpace: "​",
  NegativeThickSpace: "​",
  NegativeThinSpace: "​",
  NegativeVeryThinSpace: "​",
  NestedGreaterGreater: "≫",
  NestedLessLess: "≪",
  NewLine: "\n",
  Nfr: "𝔑",
  NoBreak: "⁠",
  NonBreakingSpace: " ",
  Nopf: "ℕ",
  Not: "⫬",
  NotCongruent: "≢",
  NotCupCap: "≭",
  NotDoubleVerticalBar: "∦",
  NotElement: "∉",
  NotEqual: "≠",
  NotEqualTilde: "≂̸",
  NotExists: "∄",
  NotGreater: "≯",
  NotGreaterEqual: "≱",
  NotGreaterFullEqual: "≧̸",
  NotGreaterGreater: "≫̸",
  NotGreaterLess: "≹",
  NotGreaterSlantEqual: "⩾̸",
  NotGreaterTilde: "≵",
  NotHumpDownHump: "≎̸",
  NotHumpEqual: "≏̸",
  NotLeftTriangle: "⋪",
  NotLeftTriangleBar: "⧏̸",
  NotLeftTriangleEqual: "⋬",
  NotLess: "≮",
  NotLessEqual: "≰",
  NotLessGreater: "≸",
  NotLessLess: "≪̸",
  NotLessSlantEqual: "⩽̸",
  NotLessTilde: "≴",
  NotNestedGreaterGreater: "⪢̸",
  NotNestedLessLess: "⪡̸",
  NotPrecedes: "⊀",
  NotPrecedesEqual: "⪯̸",
  NotPrecedesSlantEqual: "⋠",
  NotReverseElement: "∌",
  NotRightTriangle: "⋫",
  NotRightTriangleBar: "⧐̸",
  NotRightTriangleEqual: "⋭",
  NotSquareSubset: "⊏̸",
  NotSquareSubsetEqual: "⋢",
  NotSquareSuperset: "⊐̸",
  NotSquareSupersetEqual: "⋣",
  NotSubset: "⊂⃒",
  NotSubsetEqual: "⊈",
  NotSucceeds: "⊁",
  NotSucceedsEqual: "⪰̸",
  NotSucceedsSlantEqual: "⋡",
  NotSucceedsTilde: "≿̸",
  NotSuperset: "⊃⃒",
  NotSupersetEqual: "⊉",
  NotTilde: "≁",
  NotTildeEqual: "≄",
  NotTildeFullEqual: "≇",
  NotTildeTilde: "≉",
  NotVerticalBar: "∤",
  Nscr: "𝒩",
  Ntilde: "Ñ",
  Nu: "Ν",
  OElig: "Œ",
  Oacute: "Ó",
  Ocirc: "Ô",
  Ocy: "О",
  Odblac: "Ő",
  Ofr: "𝔒",
  Ograve: "Ò",
  Omacr: "Ō",
  Omega: "Ω",
  Omicron: "Ο",
  Oopf: "𝕆",
  OpenCurlyDoubleQuote: "“",
  OpenCurlyQuote: "‘",
  Or: "⩔",
  Oscr: "𝒪",
  Oslash: "Ø",
  Otilde: "Õ",
  Otimes: "⨷",
  Ouml: "Ö",
  OverBar: "‾",
  OverBrace: "⏞",
  OverBracket: "⎴",
  OverParenthesis: "⏜",
  PartialD: "∂",
  Pcy: "П",
  Pfr: "𝔓",
  Phi: "Φ",
  Pi: "Π",
  PlusMinus: "±",
  Poincareplane: "ℌ",
  Popf: "ℙ",
  Pr: "⪻",
  Precedes: "≺",
  PrecedesEqual: "⪯",
  PrecedesSlantEqual: "≼",
  PrecedesTilde: "≾",
  Prime: "″",
  Product: "∏",
  Proportion: "∷",
  Proportional: "∝",
  Pscr: "𝒫",
  Psi: "Ψ",
  QUOT: '"',
  Qfr: "𝔔",
  Qopf: "ℚ",
  Qscr: "𝒬",
  RBarr: "⤐",
  REG: "®",
  Racute: "Ŕ",
  Rang: "⟫",
  Rarr: "↠",
  Rarrtl: "⤖",
  Rcaron: "Ř",
  Rcedil: "Ŗ",
  Rcy: "Р",
  Re: "ℜ",
  ReverseElement: "∋",
  ReverseEquilibrium: "⇋",
  ReverseUpEquilibrium: "⥯",
  Rfr: "ℜ",
  Rho: "Ρ",
  RightAngleBracket: "⟩",
  RightArrow: "→",
  RightArrowBar: "⇥",
  RightArrowLeftArrow: "⇄",
  RightCeiling: "⌉",
  RightDoubleBracket: "⟧",
  RightDownTeeVector: "⥝",
  RightDownVector: "⇂",
  RightDownVectorBar: "⥕",
  RightFloor: "⌋",
  RightTee: "⊢",
  RightTeeArrow: "↦",
  RightTeeVector: "⥛",
  RightTriangle: "⊳",
  RightTriangleBar: "⧐",
  RightTriangleEqual: "⊵",
  RightUpDownVector: "⥏",
  RightUpTeeVector: "⥜",
  RightUpVector: "↾",
  RightUpVectorBar: "⥔",
  RightVector: "⇀",
  RightVectorBar: "⥓",
  Rightarrow: "⇒",
  Ropf: "ℝ",
  RoundImplies: "⥰",
  Rrightarrow: "⇛",
  Rscr: "ℛ",
  Rsh: "↱",
  RuleDelayed: "⧴",
  SHCHcy: "Щ",
  SHcy: "Ш",
  SOFTcy: "Ь",
  Sacute: "Ś",
  Sc: "⪼",
  Scaron: "Š",
  Scedil: "Ş",
  Scirc: "Ŝ",
  Scy: "С",
  Sfr: "𝔖",
  ShortDownArrow: "↓",
  ShortLeftArrow: "←",
  ShortRightArrow: "→",
  ShortUpArrow: "↑",
  Sigma: "Σ",
  SmallCircle: "∘",
  Sopf: "𝕊",
  Sqrt: "√",
  Square: "□",
  SquareIntersection: "⊓",
  SquareSubset: "⊏",
  SquareSubsetEqual: "⊑",
  SquareSuperset: "⊐",
  SquareSupersetEqual: "⊒",
  SquareUnion: "⊔",
  Sscr: "𝒮",
  Star: "⋆",
  Sub: "⋐",
  Subset: "⋐",
  SubsetEqual: "⊆",
  Succeeds: "≻",
  SucceedsEqual: "⪰",
  SucceedsSlantEqual: "≽",
  SucceedsTilde: "≿",
  SuchThat: "∋",
  Sum: "∑",
  Sup: "⋑",
  Superset: "⊃",
  SupersetEqual: "⊇",
  Supset: "⋑",
  THORN: "Þ",
  TRADE: "™",
  TSHcy: "Ћ",
  TScy: "Ц",
  Tab: "\t",
  Tau: "Τ",
  Tcaron: "Ť",
  Tcedil: "Ţ",
  Tcy: "Т",
  Tfr: "𝔗",
  Therefore: "∴",
  Theta: "Θ",
  ThickSpace: "  ",
  ThinSpace: " ",
  Tilde: "∼",
  TildeEqual: "≃",
  TildeFullEqual: "≅",
  TildeTilde: "≈",
  Topf: "𝕋",
  TripleDot: "⃛",
  Tscr: "𝒯",
  Tstrok: "Ŧ",
  Uacute: "Ú",
  Uarr: "↟",
  Uarrocir: "⥉",
  Ubrcy: "Ў",
  Ubreve: "Ŭ",
  Ucirc: "Û",
  Ucy: "У",
  Udblac: "Ű",
  Ufr: "𝔘",
  Ugrave: "Ù",
  Umacr: "Ū",
  UnderBar: "_",
  UnderBrace: "⏟",
  UnderBracket: "⎵",
  UnderParenthesis: "⏝",
  Union: "⋃",
  UnionPlus: "⊎",
  Uogon: "Ų",
  Uopf: "𝕌",
  UpArrow: "↑",
  UpArrowBar: "⤒",
  UpArrowDownArrow: "⇅",
  UpDownArrow: "↕",
  UpEquilibrium: "⥮",
  UpTee: "⊥",
  UpTeeArrow: "↥",
  Uparrow: "⇑",
  Updownarrow: "⇕",
  UpperLeftArrow: "↖",
  UpperRightArrow: "↗",
  Upsi: "ϒ",
  Upsilon: "Υ",
  Uring: "Ů",
  Uscr: "𝒰",
  Utilde: "Ũ",
  Uuml: "Ü",
  VDash: "⊫",
  Vbar: "⫫",
  Vcy: "В",
  Vdash: "⊩",
  Vdashl: "⫦",
  Vee: "⋁",
  Verbar: "‖",
  Vert: "‖",
  VerticalBar: "∣",
  VerticalLine: "|",
  VerticalSeparator: "❘",
  VerticalTilde: "≀",
  VeryThinSpace: " ",
  Vfr: "𝔙",
  Vopf: "𝕍",
  Vscr: "𝒱",
  Vvdash: "⊪",
  Wcirc: "Ŵ",
  Wedge: "⋀",
  Wfr: "𝔚",
  Wopf: "𝕎",
  Wscr: "𝒲",
  Xfr: "𝔛",
  Xi: "Ξ",
  Xopf: "𝕏",
  Xscr: "𝒳",
  YAcy: "Я",
  YIcy: "Ї",
  YUcy: "Ю",
  Yacute: "Ý",
  Ycirc: "Ŷ",
  Ycy: "Ы",
  Yfr: "𝔜",
  Yopf: "𝕐",
  Yscr: "𝒴",
  Yuml: "Ÿ",
  ZHcy: "Ж",
  Zacute: "Ź",
  Zcaron: "Ž",
  Zcy: "З",
  Zdot: "Ż",
  ZeroWidthSpace: "​",
  Zeta: "Ζ",
  Zfr: "ℨ",
  Zopf: "ℤ",
  Zscr: "𝒵",
  aacute: "á",
  abreve: "ă",
  ac: "∾",
  acE: "∾̳",
  acd: "∿",
  acirc: "â",
  acute: "´",
  acy: "а",
  aelig: "æ",
  af: "⁡",
  afr: "𝔞",
  agrave: "à",
  alefsym: "ℵ",
  aleph: "ℵ",
  alpha: "α",
  amacr: "ā",
  amalg: "⨿",
  amp: "&",
  and: "∧",
  andand: "⩕",
  andd: "⩜",
  andslope: "⩘",
  andv: "⩚",
  ang: "∠",
  ange: "⦤",
  angle: "∠",
  angmsd: "∡",
  angmsdaa: "⦨",
  angmsdab: "⦩",
  angmsdac: "⦪",
  angmsdad: "⦫",
  angmsdae: "⦬",
  angmsdaf: "⦭",
  angmsdag: "⦮",
  angmsdah: "⦯",
  angrt: "∟",
  angrtvb: "⊾",
  angrtvbd: "⦝",
  angsph: "∢",
  angst: "Å",
  angzarr: "⍼",
  aogon: "ą",
  aopf: "𝕒",
  ap: "≈",
  apE: "⩰",
  apacir: "⩯",
  ape: "≊",
  apid: "≋",
  apos: "'",
  approx: "≈",
  approxeq: "≊",
  aring: "å",
  ascr: "𝒶",
  ast: "*",
  asymp: "≈",
  asympeq: "≍",
  atilde: "ã",
  auml: "ä",
  awconint: "∳",
  awint: "⨑",
  bNot: "⫭",
  backcong: "≌",
  backepsilon: "϶",
  backprime: "‵",
  backsim: "∽",
  backsimeq: "⋍",
  barvee: "⊽",
  barwed: "⌅",
  barwedge: "⌅",
  bbrk: "⎵",
  bbrktbrk: "⎶",
  bcong: "≌",
  bcy: "б",
  bdquo: "„",
  becaus: "∵",
  because: "∵",
  bemptyv: "⦰",
  bepsi: "϶",
  bernou: "ℬ",
  beta: "β",
  beth: "ℶ",
  between: "≬",
  bfr: "𝔟",
  bigcap: "⋂",
  bigcirc: "◯",
  bigcup: "⋃",
  bigodot: "⨀",
  bigoplus: "⨁",
  bigotimes: "⨂",
  bigsqcup: "⨆",
  bigstar: "★",
  bigtriangledown: "▽",
  bigtriangleup: "△",
  biguplus: "⨄",
  bigvee: "⋁",
  bigwedge: "⋀",
  bkarow: "⤍",
  blacklozenge: "⧫",
  blacksquare: "▪",
  blacktriangle: "▴",
  blacktriangledown: "▾",
  blacktriangleleft: "◂",
  blacktriangleright: "▸",
  blank: "␣",
  blk12: "▒",
  blk14: "░",
  blk34: "▓",
  block: "█",
  bne: "=⃥",
  bnequiv: "≡⃥",
  bnot: "⌐",
  bopf: "𝕓",
  bot: "⊥",
  bottom: "⊥",
  bowtie: "⋈",
  boxDL: "╗",
  boxDR: "╔",
  boxDl: "╖",
  boxDr: "╓",
  boxH: "═",
  boxHD: "╦",
  boxHU: "╩",
  boxHd: "╤",
  boxHu: "╧",
  boxUL: "╝",
  boxUR: "╚",
  boxUl: "╜",
  boxUr: "╙",
  boxV: "║",
  boxVH: "╬",
  boxVL: "╣",
  boxVR: "╠",
  boxVh: "╫",
  boxVl: "╢",
  boxVr: "╟",
  boxbox: "⧉",
  boxdL: "╕",
  boxdR: "╒",
  boxdl: "┐",
  boxdr: "┌",
  boxh: "─",
  boxhD: "╥",
  boxhU: "╨",
  boxhd: "┬",
  boxhu: "┴",
  boxminus: "⊟",
  boxplus: "⊞",
  boxtimes: "⊠",
  boxuL: "╛",
  boxuR: "╘",
  boxul: "┘",
  boxur: "└",
  boxv: "│",
  boxvH: "╪",
  boxvL: "╡",
  boxvR: "╞",
  boxvh: "┼",
  boxvl: "┤",
  boxvr: "├",
  bprime: "‵",
  breve: "˘",
  brvbar: "¦",
  bscr: "𝒷",
  bsemi: "⁏",
  bsim: "∽",
  bsime: "⋍",
  bsol: "\\",
  bsolb: "⧅",
  bsolhsub: "⟈",
  bull: "•",
  bullet: "•",
  bump: "≎",
  bumpE: "⪮",
  bumpe: "≏",
  bumpeq: "≏",
  cacute: "ć",
  cap: "∩",
  capand: "⩄",
  capbrcup: "⩉",
  capcap: "⩋",
  capcup: "⩇",
  capdot: "⩀",
  caps: "∩︀",
  caret: "⁁",
  caron: "ˇ",
  ccaps: "⩍",
  ccaron: "č",
  ccedil: "ç",
  ccirc: "ĉ",
  ccups: "⩌",
  ccupssm: "⩐",
  cdot: "ċ",
  cedil: "¸",
  cemptyv: "⦲",
  cent: "¢",
  centerdot: "·",
  cfr: "𝔠",
  chcy: "ч",
  check: "✓",
  checkmark: "✓",
  chi: "χ",
  cir: "○",
  cirE: "⧃",
  circ: "ˆ",
  circeq: "≗",
  circlearrowleft: "↺",
  circlearrowright: "↻",
  circledR: "®",
  circledS: "Ⓢ",
  circledast: "⊛",
  circledcirc: "⊚",
  circleddash: "⊝",
  cire: "≗",
  cirfnint: "⨐",
  cirmid: "⫯",
  cirscir: "⧂",
  clubs: "♣",
  clubsuit: "♣",
  colon: ":",
  colone: "≔",
  coloneq: "≔",
  comma: ",",
  commat: "@",
  comp: "∁",
  compfn: "∘",
  complement: "∁",
  complexes: "ℂ",
  cong: "≅",
  congdot: "⩭",
  conint: "∮",
  copf: "𝕔",
  coprod: "∐",
  copy: "©",
  copysr: "℗",
  crarr: "↵",
  cross: "✗",
  cscr: "𝒸",
  csub: "⫏",
  csube: "⫑",
  csup: "⫐",
  csupe: "⫒",
  ctdot: "⋯",
  cudarrl: "⤸",
  cudarrr: "⤵",
  cuepr: "⋞",
  cuesc: "⋟",
  cularr: "↶",
  cularrp: "⤽",
  cup: "∪",
  cupbrcap: "⩈",
  cupcap: "⩆",
  cupcup: "⩊",
  cupdot: "⊍",
  cupor: "⩅",
  cups: "∪︀",
  curarr: "↷",
  curarrm: "⤼",
  curlyeqprec: "⋞",
  curlyeqsucc: "⋟",
  curlyvee: "⋎",
  curlywedge: "⋏",
  curren: "¤",
  curvearrowleft: "↶",
  curvearrowright: "↷",
  cuvee: "⋎",
  cuwed: "⋏",
  cwconint: "∲",
  cwint: "∱",
  cylcty: "⌭",
  dArr: "⇓",
  dHar: "⥥",
  dagger: "†",
  daleth: "ℸ",
  darr: "↓",
  dash: "‐",
  dashv: "⊣",
  dbkarow: "⤏",
  dblac: "˝",
  dcaron: "ď",
  dcy: "д",
  dd: "ⅆ",
  ddagger: "‡",
  ddarr: "⇊",
  ddotseq: "⩷",
  deg: "°",
  delta: "δ",
  demptyv: "⦱",
  dfisht: "⥿",
  dfr: "𝔡",
  dharl: "⇃",
  dharr: "⇂",
  diam: "⋄",
  diamond: "⋄",
  diamondsuit: "♦",
  diams: "♦",
  die: "¨",
  digamma: "ϝ",
  disin: "⋲",
  div: "÷",
  divide: "÷",
  divideontimes: "⋇",
  divonx: "⋇",
  djcy: "ђ",
  dlcorn: "⌞",
  dlcrop: "⌍",
  dollar: "$",
  dopf: "𝕕",
  dot: "˙",
  doteq: "≐",
  doteqdot: "≑",
  dotminus: "∸",
  dotplus: "∔",
  dotsquare: "⊡",
  doublebarwedge: "⌆",
  downarrow: "↓",
  downdownarrows: "⇊",
  downharpoonleft: "⇃",
  downharpoonright: "⇂",
  drbkarow: "⤐",
  drcorn: "⌟",
  drcrop: "⌌",
  dscr: "𝒹",
  dscy: "ѕ",
  dsol: "⧶",
  dstrok: "đ",
  dtdot: "⋱",
  dtri: "▿",
  dtrif: "▾",
  duarr: "⇵",
  duhar: "⥯",
  dwangle: "⦦",
  dzcy: "џ",
  dzigrarr: "⟿",
  eDDot: "⩷",
  eDot: "≑",
  eacute: "é",
  easter: "⩮",
  ecaron: "ě",
  ecir: "≖",
  ecirc: "ê",
  ecolon: "≕",
  ecy: "э",
  edot: "ė",
  ee: "ⅇ",
  efDot: "≒",
  efr: "𝔢",
  eg: "⪚",
  egrave: "è",
  egs: "⪖",
  egsdot: "⪘",
  el: "⪙",
  elinters: "⏧",
  ell: "ℓ",
  els: "⪕",
  elsdot: "⪗",
  emacr: "ē",
  empty: "∅",
  emptyset: "∅",
  emptyv: "∅",
  emsp13: " ",
  emsp14: " ",
  emsp: " ",
  eng: "ŋ",
  ensp: " ",
  eogon: "ę",
  eopf: "𝕖",
  epar: "⋕",
  eparsl: "⧣",
  eplus: "⩱",
  epsi: "ε",
  epsilon: "ε",
  epsiv: "ϵ",
  eqcirc: "≖",
  eqcolon: "≕",
  eqsim: "≂",
  eqslantgtr: "⪖",
  eqslantless: "⪕",
  equals: "=",
  equest: "≟",
  equiv: "≡",
  equivDD: "⩸",
  eqvparsl: "⧥",
  erDot: "≓",
  erarr: "⥱",
  escr: "ℯ",
  esdot: "≐",
  esim: "≂",
  eta: "η",
  eth: "ð",
  euml: "ë",
  euro: "€",
  excl: "!",
  exist: "∃",
  expectation: "ℰ",
  exponentiale: "ⅇ",
  fallingdotseq: "≒",
  fcy: "ф",
  female: "♀",
  ffilig: "ﬃ",
  fflig: "ﬀ",
  ffllig: "ﬄ",
  ffr: "𝔣",
  filig: "ﬁ",
  fjlig: "fj",
  flat: "♭",
  fllig: "ﬂ",
  fltns: "▱",
  fnof: "ƒ",
  fopf: "𝕗",
  forall: "∀",
  fork: "⋔",
  forkv: "⫙",
  fpartint: "⨍",
  frac12: "½",
  frac13: "⅓",
  frac14: "¼",
  frac15: "⅕",
  frac16: "⅙",
  frac18: "⅛",
  frac23: "⅔",
  frac25: "⅖",
  frac34: "¾",
  frac35: "⅗",
  frac38: "⅜",
  frac45: "⅘",
  frac56: "⅚",
  frac58: "⅝",
  frac78: "⅞",
  frasl: "⁄",
  frown: "⌢",
  fscr: "𝒻",
  gE: "≧",
  gEl: "⪌",
  gacute: "ǵ",
  gamma: "γ",
  gammad: "ϝ",
  gap: "⪆",
  gbreve: "ğ",
  gcirc: "ĝ",
  gcy: "г",
  gdot: "ġ",
  ge: "≥",
  gel: "⋛",
  geq: "≥",
  geqq: "≧",
  geqslant: "⩾",
  ges: "⩾",
  gescc: "⪩",
  gesdot: "⪀",
  gesdoto: "⪂",
  gesdotol: "⪄",
  gesl: "⋛︀",
  gesles: "⪔",
  gfr: "𝔤",
  gg: "≫",
  ggg: "⋙",
  gimel: "ℷ",
  gjcy: "ѓ",
  gl: "≷",
  glE: "⪒",
  gla: "⪥",
  glj: "⪤",
  gnE: "≩",
  gnap: "⪊",
  gnapprox: "⪊",
  gne: "⪈",
  gneq: "⪈",
  gneqq: "≩",
  gnsim: "⋧",
  gopf: "𝕘",
  grave: "`",
  gscr: "ℊ",
  gsim: "≳",
  gsime: "⪎",
  gsiml: "⪐",
  gt: ">",
  gtcc: "⪧",
  gtcir: "⩺",
  gtdot: "⋗",
  gtlPar: "⦕",
  gtquest: "⩼",
  gtrapprox: "⪆",
  gtrarr: "⥸",
  gtrdot: "⋗",
  gtreqless: "⋛",
  gtreqqless: "⪌",
  gtrless: "≷",
  gtrsim: "≳",
  gvertneqq: "≩︀",
  gvnE: "≩︀",
  hArr: "⇔",
  hairsp: " ",
  half: "½",
  hamilt: "ℋ",
  hardcy: "ъ",
  harr: "↔",
  harrcir: "⥈",
  harrw: "↭",
  hbar: "ℏ",
  hcirc: "ĥ",
  hearts: "♥",
  heartsuit: "♥",
  hellip: "…",
  hercon: "⊹",
  hfr: "𝔥",
  hksearow: "⤥",
  hkswarow: "⤦",
  hoarr: "⇿",
  homtht: "∻",
  hookleftarrow: "↩",
  hookrightarrow: "↪",
  hopf: "𝕙",
  horbar: "―",
  hscr: "𝒽",
  hslash: "ℏ",
  hstrok: "ħ",
  hybull: "⁃",
  hyphen: "‐",
  iacute: "í",
  ic: "⁣",
  icirc: "î",
  icy: "и",
  iecy: "е",
  iexcl: "¡",
  iff: "⇔",
  ifr: "𝔦",
  igrave: "ì",
  ii: "ⅈ",
  iiiint: "⨌",
  iiint: "∭",
  iinfin: "⧜",
  iiota: "℩",
  ijlig: "ĳ",
  imacr: "ī",
  image: "ℑ",
  imagline: "ℐ",
  imagpart: "ℑ",
  imath: "ı",
  imof: "⊷",
  imped: "Ƶ",
  "in": "∈",
  incare: "℅",
  infin: "∞",
  infintie: "⧝",
  inodot: "ı",
  "int": "∫",
  intcal: "⊺",
  integers: "ℤ",
  intercal: "⊺",
  intlarhk: "⨗",
  intprod: "⨼",
  iocy: "ё",
  iogon: "į",
  iopf: "𝕚",
  iota: "ι",
  iprod: "⨼",
  iquest: "¿",
  iscr: "𝒾",
  isin: "∈",
  isinE: "⋹",
  isindot: "⋵",
  isins: "⋴",
  isinsv: "⋳",
  isinv: "∈",
  it: "⁢",
  itilde: "ĩ",
  iukcy: "і",
  iuml: "ï",
  jcirc: "ĵ",
  jcy: "й",
  jfr: "𝔧",
  jmath: "ȷ",
  jopf: "𝕛",
  jscr: "𝒿",
  jsercy: "ј",
  jukcy: "є",
  kappa: "κ",
  kappav: "ϰ",
  kcedil: "ķ",
  kcy: "к",
  kfr: "𝔨",
  kgreen: "ĸ",
  khcy: "х",
  kjcy: "ќ",
  kopf: "𝕜",
  kscr: "𝓀",
  lAarr: "⇚",
  lArr: "⇐",
  lAtail: "⤛",
  lBarr: "⤎",
  lE: "≦",
  lEg: "⪋",
  lHar: "⥢",
  lacute: "ĺ",
  laemptyv: "⦴",
  lagran: "ℒ",
  lambda: "λ",
  lang: "⟨",
  langd: "⦑",
  langle: "⟨",
  lap: "⪅",
  laquo: "«",
  larr: "←",
  larrb: "⇤",
  larrbfs: "⤟",
  larrfs: "⤝",
  larrhk: "↩",
  larrlp: "↫",
  larrpl: "⤹",
  larrsim: "⥳",
  larrtl: "↢",
  lat: "⪫",
  latail: "⤙",
  late: "⪭",
  lates: "⪭︀",
  lbarr: "⤌",
  lbbrk: "❲",
  lbrace: "{",
  lbrack: "[",
  lbrke: "⦋",
  lbrksld: "⦏",
  lbrkslu: "⦍",
  lcaron: "ľ",
  lcedil: "ļ",
  lceil: "⌈",
  lcub: "{",
  lcy: "л",
  ldca: "⤶",
  ldquo: "“",
  ldquor: "„",
  ldrdhar: "⥧",
  ldrushar: "⥋",
  ldsh: "↲",
  le: "≤",
  leftarrow: "←",
  leftarrowtail: "↢",
  leftharpoondown: "↽",
  leftharpoonup: "↼",
  leftleftarrows: "⇇",
  leftrightarrow: "↔",
  leftrightarrows: "⇆",
  leftrightharpoons: "⇋",
  leftrightsquigarrow: "↭",
  leftthreetimes: "⋋",
  leg: "⋚",
  leq: "≤",
  leqq: "≦",
  leqslant: "⩽",
  les: "⩽",
  lescc: "⪨",
  lesdot: "⩿",
  lesdoto: "⪁",
  lesdotor: "⪃",
  lesg: "⋚︀",
  lesges: "⪓",
  lessapprox: "⪅",
  lessdot: "⋖",
  lesseqgtr: "⋚",
  lesseqqgtr: "⪋",
  lessgtr: "≶",
  lesssim: "≲",
  lfisht: "⥼",
  lfloor: "⌊",
  lfr: "𝔩",
  lg: "≶",
  lgE: "⪑",
  lhard: "↽",
  lharu: "↼",
  lharul: "⥪",
  lhblk: "▄",
  ljcy: "љ",
  ll: "≪",
  llarr: "⇇",
  llcorner: "⌞",
  llhard: "⥫",
  lltri: "◺",
  lmidot: "ŀ",
  lmoust: "⎰",
  lmoustache: "⎰",
  lnE: "≨",
  lnap: "⪉",
  lnapprox: "⪉",
  lne: "⪇",
  lneq: "⪇",
  lneqq: "≨",
  lnsim: "⋦",
  loang: "⟬",
  loarr: "⇽",
  lobrk: "⟦",
  longleftarrow: "⟵",
  longleftrightarrow: "⟷",
  longmapsto: "⟼",
  longrightarrow: "⟶",
  looparrowleft: "↫",
  looparrowright: "↬",
  lopar: "⦅",
  lopf: "𝕝",
  loplus: "⨭",
  lotimes: "⨴",
  lowast: "∗",
  lowbar: "_",
  loz: "◊",
  lozenge: "◊",
  lozf: "⧫",
  lpar: "(",
  lparlt: "⦓",
  lrarr: "⇆",
  lrcorner: "⌟",
  lrhar: "⇋",
  lrhard: "⥭",
  lrm: "‎",
  lrtri: "⊿",
  lsaquo: "‹",
  lscr: "𝓁",
  lsh: "↰",
  lsim: "≲",
  lsime: "⪍",
  lsimg: "⪏",
  lsqb: "[",
  lsquo: "‘",
  lsquor: "‚",
  lstrok: "ł",
  lt: "<",
  ltcc: "⪦",
  ltcir: "⩹",
  ltdot: "⋖",
  lthree: "⋋",
  ltimes: "⋉",
  ltlarr: "⥶",
  ltquest: "⩻",
  ltrPar: "⦖",
  ltri: "◃",
  ltrie: "⊴",
  ltrif: "◂",
  lurdshar: "⥊",
  luruhar: "⥦",
  lvertneqq: "≨︀",
  lvnE: "≨︀",
  mDDot: "∺",
  macr: "¯",
  male: "♂",
  malt: "✠",
  maltese: "✠",
  map: "↦",
  mapsto: "↦",
  mapstodown: "↧",
  mapstoleft: "↤",
  mapstoup: "↥",
  marker: "▮",
  mcomma: "⨩",
  mcy: "м",
  mdash: "—",
  measuredangle: "∡",
  mfr: "𝔪",
  mho: "℧",
  micro: "µ",
  mid: "∣",
  midast: "*",
  midcir: "⫰",
  middot: "·",
  minus: "−",
  minusb: "⊟",
  minusd: "∸",
  minusdu: "⨪",
  mlcp: "⫛",
  mldr: "…",
  mnplus: "∓",
  models: "⊧",
  mopf: "𝕞",
  mp: "∓",
  mscr: "𝓂",
  mstpos: "∾",
  mu: "μ",
  multimap: "⊸",
  mumap: "⊸",
  nGg: "⋙̸",
  nGt: "≫⃒",
  nGtv: "≫̸",
  nLeftarrow: "⇍",
  nLeftrightarrow: "⇎",
  nLl: "⋘̸",
  nLt: "≪⃒",
  nLtv: "≪̸",
  nRightarrow: "⇏",
  nVDash: "⊯",
  nVdash: "⊮",
  nabla: "∇",
  nacute: "ń",
  nang: "∠⃒",
  nap: "≉",
  napE: "⩰̸",
  napid: "≋̸",
  napos: "ŉ",
  napprox: "≉",
  natur: "♮",
  natural: "♮",
  naturals: "ℕ",
  nbsp: " ",
  nbump: "≎̸",
  nbumpe: "≏̸",
  ncap: "⩃",
  ncaron: "ň",
  ncedil: "ņ",
  ncong: "≇",
  ncongdot: "⩭̸",
  ncup: "⩂",
  ncy: "н",
  ndash: "–",
  ne: "≠",
  neArr: "⇗",
  nearhk: "⤤",
  nearr: "↗",
  nearrow: "↗",
  nedot: "≐̸",
  nequiv: "≢",
  nesear: "⤨",
  nesim: "≂̸",
  nexist: "∄",
  nexists: "∄",
  nfr: "𝔫",
  ngE: "≧̸",
  nge: "≱",
  ngeq: "≱",
  ngeqq: "≧̸",
  ngeqslant: "⩾̸",
  nges: "⩾̸",
  ngsim: "≵",
  ngt: "≯",
  ngtr: "≯",
  nhArr: "⇎",
  nharr: "↮",
  nhpar: "⫲",
  ni: "∋",
  nis: "⋼",
  nisd: "⋺",
  niv: "∋",
  njcy: "њ",
  nlArr: "⇍",
  nlE: "≦̸",
  nlarr: "↚",
  nldr: "‥",
  nle: "≰",
  nleftarrow: "↚",
  nleftrightarrow: "↮",
  nleq: "≰",
  nleqq: "≦̸",
  nleqslant: "⩽̸",
  nles: "⩽̸",
  nless: "≮",
  nlsim: "≴",
  nlt: "≮",
  nltri: "⋪",
  nltrie: "⋬",
  nmid: "∤",
  nopf: "𝕟",
  not: "¬",
  notin: "∉",
  notinE: "⋹̸",
  notindot: "⋵̸",
  notinva: "∉",
  notinvb: "⋷",
  notinvc: "⋶",
  notni: "∌",
  notniva: "∌",
  notnivb: "⋾",
  notnivc: "⋽",
  npar: "∦",
  nparallel: "∦",
  nparsl: "⫽⃥",
  npart: "∂̸",
  npolint: "⨔",
  npr: "⊀",
  nprcue: "⋠",
  npre: "⪯̸",
  nprec: "⊀",
  npreceq: "⪯̸",
  nrArr: "⇏",
  nrarr: "↛",
  nrarrc: "⤳̸",
  nrarrw: "↝̸",
  nrightarrow: "↛",
  nrtri: "⋫",
  nrtrie: "⋭",
  nsc: "⊁",
  nsccue: "⋡",
  nsce: "⪰̸",
  nscr: "𝓃",
  nshortmid: "∤",
  nshortparallel: "∦",
  nsim: "≁",
  nsime: "≄",
  nsimeq: "≄",
  nsmid: "∤",
  nspar: "∦",
  nsqsube: "⋢",
  nsqsupe: "⋣",
  nsub: "⊄",
  nsubE: "⫅̸",
  nsube: "⊈",
  nsubset: "⊂⃒",
  nsubseteq: "⊈",
  nsubseteqq: "⫅̸",
  nsucc: "⊁",
  nsucceq: "⪰̸",
  nsup: "⊅",
  nsupE: "⫆̸",
  nsupe: "⊉",
  nsupset: "⊃⃒",
  nsupseteq: "⊉",
  nsupseteqq: "⫆̸",
  ntgl: "≹",
  ntilde: "ñ",
  ntlg: "≸",
  ntriangleleft: "⋪",
  ntrianglelefteq: "⋬",
  ntriangleright: "⋫",
  ntrianglerighteq: "⋭",
  nu: "ν",
  num: "#",
  numero: "№",
  numsp: " ",
  nvDash: "⊭",
  nvHarr: "⤄",
  nvap: "≍⃒",
  nvdash: "⊬",
  nvge: "≥⃒",
  nvgt: ">⃒",
  nvinfin: "⧞",
  nvlArr: "⤂",
  nvle: "≤⃒",
  nvlt: "<⃒",
  nvltrie: "⊴⃒",
  nvrArr: "⤃",
  nvrtrie: "⊵⃒",
  nvsim: "∼⃒",
  nwArr: "⇖",
  nwarhk: "⤣",
  nwarr: "↖",
  nwarrow: "↖",
  nwnear: "⤧",
  oS: "Ⓢ",
  oacute: "ó",
  oast: "⊛",
  ocir: "⊚",
  ocirc: "ô",
  ocy: "о",
  odash: "⊝",
  odblac: "ő",
  odiv: "⨸",
  odot: "⊙",
  odsold: "⦼",
  oelig: "œ",
  ofcir: "⦿",
  ofr: "𝔬",
  ogon: "˛",
  ograve: "ò",
  ogt: "⧁",
  ohbar: "⦵",
  ohm: "Ω",
  oint: "∮",
  olarr: "↺",
  olcir: "⦾",
  olcross: "⦻",
  oline: "‾",
  olt: "⧀",
  omacr: "ō",
  omega: "ω",
  omicron: "ο",
  omid: "⦶",
  ominus: "⊖",
  oopf: "𝕠",
  opar: "⦷",
  operp: "⦹",
  oplus: "⊕",
  or: "∨",
  orarr: "↻",
  ord: "⩝",
  order: "ℴ",
  orderof: "ℴ",
  ordf: "ª",
  ordm: "º",
  origof: "⊶",
  oror: "⩖",
  orslope: "⩗",
  orv: "⩛",
  oscr: "ℴ",
  oslash: "ø",
  osol: "⊘",
  otilde: "õ",
  otimes: "⊗",
  otimesas: "⨶",
  ouml: "ö",
  ovbar: "⌽",
  par: "∥",
  para: "¶",
  parallel: "∥",
  parsim: "⫳",
  parsl: "⫽",
  part: "∂",
  pcy: "п",
  percnt: "%",
  period: ".",
  permil: "‰",
  perp: "⊥",
  pertenk: "‱",
  pfr: "𝔭",
  phi: "φ",
  phiv: "ϕ",
  phmmat: "ℳ",
  phone: "☎",
  pi: "π",
  pitchfork: "⋔",
  piv: "ϖ",
  planck: "ℏ",
  planckh: "ℎ",
  plankv: "ℏ",
  plus: "+",
  plusacir: "⨣",
  plusb: "⊞",
  pluscir: "⨢",
  plusdo: "∔",
  plusdu: "⨥",
  pluse: "⩲",
  plusmn: "±",
  plussim: "⨦",
  plustwo: "⨧",
  pm: "±",
  pointint: "⨕",
  popf: "𝕡",
  pound: "£",
  pr: "≺",
  prE: "⪳",
  prap: "⪷",
  prcue: "≼",
  pre: "⪯",
  prec: "≺",
  precapprox: "⪷",
  preccurlyeq: "≼",
  preceq: "⪯",
  precnapprox: "⪹",
  precneqq: "⪵",
  precnsim: "⋨",
  precsim: "≾",
  prime: "′",
  primes: "ℙ",
  prnE: "⪵",
  prnap: "⪹",
  prnsim: "⋨",
  prod: "∏",
  profalar: "⌮",
  profline: "⌒",
  profsurf: "⌓",
  prop: "∝",
  propto: "∝",
  prsim: "≾",
  prurel: "⊰",
  pscr: "𝓅",
  psi: "ψ",
  puncsp: " ",
  qfr: "𝔮",
  qint: "⨌",
  qopf: "𝕢",
  qprime: "⁗",
  qscr: "𝓆",
  quaternions: "ℍ",
  quatint: "⨖",
  quest: "?",
  questeq: "≟",
  quot: '"',
  rAarr: "⇛",
  rArr: "⇒",
  rAtail: "⤜",
  rBarr: "⤏",
  rHar: "⥤",
  race: "∽̱",
  racute: "ŕ",
  radic: "√",
  raemptyv: "⦳",
  rang: "⟩",
  rangd: "⦒",
  range: "⦥",
  rangle: "⟩",
  raquo: "»",
  rarr: "→",
  rarrap: "⥵",
  rarrb: "⇥",
  rarrbfs: "⤠",
  rarrc: "⤳",
  rarrfs: "⤞",
  rarrhk: "↪",
  rarrlp: "↬",
  rarrpl: "⥅",
  rarrsim: "⥴",
  rarrtl: "↣",
  rarrw: "↝",
  ratail: "⤚",
  ratio: "∶",
  rationals: "ℚ",
  rbarr: "⤍",
  rbbrk: "❳",
  rbrace: "}",
  rbrack: "]",
  rbrke: "⦌",
  rbrksld: "⦎",
  rbrkslu: "⦐",
  rcaron: "ř",
  rcedil: "ŗ",
  rceil: "⌉",
  rcub: "}",
  rcy: "р",
  rdca: "⤷",
  rdldhar: "⥩",
  rdquo: "”",
  rdquor: "”",
  rdsh: "↳",
  real: "ℜ",
  realine: "ℛ",
  realpart: "ℜ",
  reals: "ℝ",
  rect: "▭",
  reg: "®",
  rfisht: "⥽",
  rfloor: "⌋",
  rfr: "𝔯",
  rhard: "⇁",
  rharu: "⇀",
  rharul: "⥬",
  rho: "ρ",
  rhov: "ϱ",
  rightarrow: "→",
  rightarrowtail: "↣",
  rightharpoondown: "⇁",
  rightharpoonup: "⇀",
  rightleftarrows: "⇄",
  rightleftharpoons: "⇌",
  rightrightarrows: "⇉",
  rightsquigarrow: "↝",
  rightthreetimes: "⋌",
  ring: "˚",
  risingdotseq: "≓",
  rlarr: "⇄",
  rlhar: "⇌",
  rlm: "‏",
  rmoust: "⎱",
  rmoustache: "⎱",
  rnmid: "⫮",
  roang: "⟭",
  roarr: "⇾",
  robrk: "⟧",
  ropar: "⦆",
  ropf: "𝕣",
  roplus: "⨮",
  rotimes: "⨵",
  rpar: ")",
  rpargt: "⦔",
  rppolint: "⨒",
  rrarr: "⇉",
  rsaquo: "›",
  rscr: "𝓇",
  rsh: "↱",
  rsqb: "]",
  rsquo: "’",
  rsquor: "’",
  rthree: "⋌",
  rtimes: "⋊",
  rtri: "▹",
  rtrie: "⊵",
  rtrif: "▸",
  rtriltri: "⧎",
  ruluhar: "⥨",
  rx: "℞",
  sacute: "ś",
  sbquo: "‚",
  sc: "≻",
  scE: "⪴",
  scap: "⪸",
  scaron: "š",
  sccue: "≽",
  sce: "⪰",
  scedil: "ş",
  scirc: "ŝ",
  scnE: "⪶",
  scnap: "⪺",
  scnsim: "⋩",
  scpolint: "⨓",
  scsim: "≿",
  scy: "с",
  sdot: "⋅",
  sdotb: "⊡",
  sdote: "⩦",
  seArr: "⇘",
  searhk: "⤥",
  searr: "↘",
  searrow: "↘",
  sect: "§",
  semi: ";",
  seswar: "⤩",
  setminus: "∖",
  setmn: "∖",
  sext: "✶",
  sfr: "𝔰",
  sfrown: "⌢",
  sharp: "♯",
  shchcy: "щ",
  shcy: "ш",
  shortmid: "∣",
  shortparallel: "∥",
  shy: "­",
  sigma: "σ",
  sigmaf: "ς",
  sigmav: "ς",
  sim: "∼",
  simdot: "⩪",
  sime: "≃",
  simeq: "≃",
  simg: "⪞",
  simgE: "⪠",
  siml: "⪝",
  simlE: "⪟",
  simne: "≆",
  simplus: "⨤",
  simrarr: "⥲",
  slarr: "←",
  smallsetminus: "∖",
  smashp: "⨳",
  smeparsl: "⧤",
  smid: "∣",
  smile: "⌣",
  smt: "⪪",
  smte: "⪬",
  smtes: "⪬︀",
  softcy: "ь",
  sol: "/",
  solb: "⧄",
  solbar: "⌿",
  sopf: "𝕤",
  spades: "♠",
  spadesuit: "♠",
  spar: "∥",
  sqcap: "⊓",
  sqcaps: "⊓︀",
  sqcup: "⊔",
  sqcups: "⊔︀",
  sqsub: "⊏",
  sqsube: "⊑",
  sqsubset: "⊏",
  sqsubseteq: "⊑",
  sqsup: "⊐",
  sqsupe: "⊒",
  sqsupset: "⊐",
  sqsupseteq: "⊒",
  squ: "□",
  square: "□",
  squarf: "▪",
  squf: "▪",
  srarr: "→",
  sscr: "𝓈",
  ssetmn: "∖",
  ssmile: "⌣",
  sstarf: "⋆",
  star: "☆",
  starf: "★",
  straightepsilon: "ϵ",
  straightphi: "ϕ",
  strns: "¯",
  sub: "⊂",
  subE: "⫅",
  subdot: "⪽",
  sube: "⊆",
  subedot: "⫃",
  submult: "⫁",
  subnE: "⫋",
  subne: "⊊",
  subplus: "⪿",
  subrarr: "⥹",
  subset: "⊂",
  subseteq: "⊆",
  subseteqq: "⫅",
  subsetneq: "⊊",
  subsetneqq: "⫋",
  subsim: "⫇",
  subsub: "⫕",
  subsup: "⫓",
  succ: "≻",
  succapprox: "⪸",
  succcurlyeq: "≽",
  succeq: "⪰",
  succnapprox: "⪺",
  succneqq: "⪶",
  succnsim: "⋩",
  succsim: "≿",
  sum: "∑",
  sung: "♪",
  sup1: "¹",
  sup2: "²",
  sup3: "³",
  sup: "⊃",
  supE: "⫆",
  supdot: "⪾",
  supdsub: "⫘",
  supe: "⊇",
  supedot: "⫄",
  suphsol: "⟉",
  suphsub: "⫗",
  suplarr: "⥻",
  supmult: "⫂",
  supnE: "⫌",
  supne: "⊋",
  supplus: "⫀",
  supset: "⊃",
  supseteq: "⊇",
  supseteqq: "⫆",
  supsetneq: "⊋",
  supsetneqq: "⫌",
  supsim: "⫈",
  supsub: "⫔",
  supsup: "⫖",
  swArr: "⇙",
  swarhk: "⤦",
  swarr: "↙",
  swarrow: "↙",
  swnwar: "⤪",
  szlig: "ß",
  target: "⌖",
  tau: "τ",
  tbrk: "⎴",
  tcaron: "ť",
  tcedil: "ţ",
  tcy: "т",
  tdot: "⃛",
  telrec: "⌕",
  tfr: "𝔱",
  there4: "∴",
  therefore: "∴",
  theta: "θ",
  thetasym: "ϑ",
  thetav: "ϑ",
  thickapprox: "≈",
  thicksim: "∼",
  thinsp: " ",
  thkap: "≈",
  thksim: "∼",
  thorn: "þ",
  tilde: "˜",
  times: "×",
  timesb: "⊠",
  timesbar: "⨱",
  timesd: "⨰",
  tint: "∭",
  toea: "⤨",
  top: "⊤",
  topbot: "⌶",
  topcir: "⫱",
  topf: "𝕥",
  topfork: "⫚",
  tosa: "⤩",
  tprime: "‴",
  trade: "™",
  triangle: "▵",
  triangledown: "▿",
  triangleleft: "◃",
  trianglelefteq: "⊴",
  triangleq: "≜",
  triangleright: "▹",
  trianglerighteq: "⊵",
  tridot: "◬",
  trie: "≜",
  triminus: "⨺",
  triplus: "⨹",
  trisb: "⧍",
  tritime: "⨻",
  trpezium: "⏢",
  tscr: "𝓉",
  tscy: "ц",
  tshcy: "ћ",
  tstrok: "ŧ",
  twixt: "≬",
  twoheadleftarrow: "↞",
  twoheadrightarrow: "↠",
  uArr: "⇑",
  uHar: "⥣",
  uacute: "ú",
  uarr: "↑",
  ubrcy: "ў",
  ubreve: "ŭ",
  ucirc: "û",
  ucy: "у",
  udarr: "⇅",
  udblac: "ű",
  udhar: "⥮",
  ufisht: "⥾",
  ufr: "𝔲",
  ugrave: "ù",
  uharl: "↿",
  uharr: "↾",
  uhblk: "▀",
  ulcorn: "⌜",
  ulcorner: "⌜",
  ulcrop: "⌏",
  ultri: "◸",
  umacr: "ū",
  uml: "¨",
  uogon: "ų",
  uopf: "𝕦",
  uparrow: "↑",
  updownarrow: "↕",
  upharpoonleft: "↿",
  upharpoonright: "↾",
  uplus: "⊎",
  upsi: "υ",
  upsih: "ϒ",
  upsilon: "υ",
  upuparrows: "⇈",
  urcorn: "⌝",
  urcorner: "⌝",
  urcrop: "⌎",
  uring: "ů",
  urtri: "◹",
  uscr: "𝓊",
  utdot: "⋰",
  utilde: "ũ",
  utri: "▵",
  utrif: "▴",
  uuarr: "⇈",
  uuml: "ü",
  uwangle: "⦧",
  vArr: "⇕",
  vBar: "⫨",
  vBarv: "⫩",
  vDash: "⊨",
  vangrt: "⦜",
  varepsilon: "ϵ",
  varkappa: "ϰ",
  varnothing: "∅",
  varphi: "ϕ",
  varpi: "ϖ",
  varpropto: "∝",
  varr: "↕",
  varrho: "ϱ",
  varsigma: "ς",
  varsubsetneq: "⊊︀",
  varsubsetneqq: "⫋︀",
  varsupsetneq: "⊋︀",
  varsupsetneqq: "⫌︀",
  vartheta: "ϑ",
  vartriangleleft: "⊲",
  vartriangleright: "⊳",
  vcy: "в",
  vdash: "⊢",
  vee: "∨",
  veebar: "⊻",
  veeeq: "≚",
  vellip: "⋮",
  verbar: "|",
  vert: "|",
  vfr: "𝔳",
  vltri: "⊲",
  vnsub: "⊂⃒",
  vnsup: "⊃⃒",
  vopf: "𝕧",
  vprop: "∝",
  vrtri: "⊳",
  vscr: "𝓋",
  vsubnE: "⫋︀",
  vsubne: "⊊︀",
  vsupnE: "⫌︀",
  vsupne: "⊋︀",
  vzigzag: "⦚",
  wcirc: "ŵ",
  wedbar: "⩟",
  wedge: "∧",
  wedgeq: "≙",
  weierp: "℘",
  wfr: "𝔴",
  wopf: "𝕨",
  wp: "℘",
  wr: "≀",
  wreath: "≀",
  wscr: "𝓌",
  xcap: "⋂",
  xcirc: "◯",
  xcup: "⋃",
  xdtri: "▽",
  xfr: "𝔵",
  xhArr: "⟺",
  xharr: "⟷",
  xi: "ξ",
  xlArr: "⟸",
  xlarr: "⟵",
  xmap: "⟼",
  xnis: "⋻",
  xodot: "⨀",
  xopf: "𝕩",
  xoplus: "⨁",
  xotime: "⨂",
  xrArr: "⟹",
  xrarr: "⟶",
  xscr: "𝓍",
  xsqcup: "⨆",
  xuplus: "⨄",
  xutri: "△",
  xvee: "⋁",
  xwedge: "⋀",
  yacute: "ý",
  yacy: "я",
  ycirc: "ŷ",
  ycy: "ы",
  yen: "¥",
  yfr: "𝔶",
  yicy: "ї",
  yopf: "𝕪",
  yscr: "𝓎",
  yucy: "ю",
  yuml: "ÿ",
  zacute: "ź",
  zcaron: "ž",
  zcy: "з",
  zdot: "ż",
  zeetrf: "ℨ",
  zeta: "ζ",
  zfr: "𝔷",
  zhcy: "ж",
  zigrarr: "⇝",
  zopf: "𝕫",
  zscr: "𝓏",
  zwj: "‍",
  zwnj: "‌"
},
    Br = {}.hasOwnProperty;

function Rr(e) {
  return !!Br.call(Lr, e) && Lr[e];
}

var Hr = {
  name: "characterReference",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    var r,
        a,
        l = 0;
    return function (n) {
      return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(n), e.exit("characterReferenceMarker"), i;
    };

    function i(n) {
      return 35 === n ? (e.enter("characterReferenceMarkerNumeric"), e.consume(n), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), r = 31, a = fr, s(n));
    }

    function c(n) {
      return 88 === n || 120 === n ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(n), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), r = 6, a = dr, s) : (e.enter("characterReferenceValue"), r = 7, a = ur, s(n));
    }

    function s(i) {
      var c;
      return 59 === i && l ? (c = e.exit("characterReferenceValue"), a !== fr || Rr(o.sliceSerialize(c)) ? (e.enter("characterReferenceMarker"), e.consume(i), e.exit("characterReferenceMarker"), e.exit("characterReference"), n) : t(i)) : a(i) && l++ < r ? (e.consume(i), s) : t(i);
    }
  }
};
var Nr = {
  name: "codeFenced",
  tokenize: function tokenize(e, n, t) {
    var o = this,
        r = {
      tokenize: function tokenize(e, n, t) {
        var o = 0;
        return xr(e, r, "linePrefix", this.parser.constructs.disable["null"].includes("codeIndented") ? void 0 : 4);

        function r(n) {
          return e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), a(n);
        }

        function a(n) {
          return n === c ? (e.consume(n), o++, a) : o < s ? t(n) : (e.exit("codeFencedFenceSequence"), xr(e, l, "whitespace")(n));
        }

        function l(o) {
          return null === o || br(o) ? (e.exit("codeFencedFence"), n(o)) : t(o);
        }
      },
      partial: !0
    },
        a = {
      tokenize: function tokenize(e, n, t) {
        var o = this;
        return r;

        function r(n) {
          return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), a;
        }

        function a(e) {
          return o.parser.lazy[o.now().line] ? t(e) : n(e);
        }
      },
      partial: !0
    },
        l = this.events[this.events.length - 1],
        i = l && "linePrefix" === l[1].type ? l[2].sliceSerialize(l[1], !0).length : 0;
    var c,
        s = 0;
    return function (n) {
      return e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), c = n, u(n);
    };

    function u(n) {
      return n === c ? (e.consume(n), s++, u) : (e.exit("codeFencedFenceSequence"), s < 3 ? t(n) : xr(e, d, "whitespace")(n));
    }

    function d(n) {
      return null === n || br(n) ? m(n) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
        contentType: "string"
      }), f(n));
    }

    function f(n) {
      return null === n || hr(n) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), xr(e, p, "whitespace")(n)) : 96 === n && n === c ? t(n) : (e.consume(n), f);
    }

    function p(n) {
      return null === n || br(n) ? m(n) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
        contentType: "string"
      }), g(n));
    }

    function g(n) {
      return null === n || br(n) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), m(n)) : 96 === n && n === c ? t(n) : (e.consume(n), g);
    }

    function m(t) {
      return e.exit("codeFencedFence"), o.interrupt ? n(t) : h(t);
    }

    function h(n) {
      return null === n ? y(n) : br(n) ? e.attempt(a, e.attempt(r, y, i ? xr(e, h, "linePrefix", i + 1) : h), y)(n) : (e.enter("codeFlowValue"), b(n));
    }

    function b(n) {
      return null === n || br(n) ? (e.exit("codeFlowValue"), h(n)) : (e.consume(n), b);
    }

    function y(t) {
      return e.exit("codeFenced"), n(t);
    }
  },
  concrete: !0
};
var Ir = {
  name: "codeIndented",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return function (n) {
      return e.enter("codeIndented"), xr(e, r, "linePrefix", 5)(n);
    };

    function r(e) {
      var n = o.events[o.events.length - 1];
      return n && "linePrefix" === n[1].type && n[2].sliceSerialize(n[1], !0).length >= 4 ? a(e) : t(e);
    }

    function a(n) {
      return null === n ? i(n) : br(n) ? e.attempt(jr, a, i)(n) : (e.enter("codeFlowValue"), l(n));
    }

    function l(n) {
      return null === n || br(n) ? (e.exit("codeFlowValue"), a(n)) : (e.consume(n), l);
    }

    function i(t) {
      return e.exit("codeIndented"), n(t);
    }
  }
},
    jr = {
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return r;

    function r(n) {
      return o.parser.lazy[o.now().line] ? t(n) : br(n) ? (e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), r) : xr(e, a, "linePrefix", 5)(n);
    }

    function a(e) {
      var a = o.events[o.events.length - 1];
      return a && "linePrefix" === a[1].type && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(e) : br(e) ? r(e) : t(e);
    }
  },
  partial: !0
};
var Wr = {
  name: "codeText",
  tokenize: function tokenize(e, n, t) {
    var o,
        r,
        a = 0;
    return function (n) {
      return e.enter("codeText"), e.enter("codeTextSequence"), l(n);
    };

    function l(n) {
      return 96 === n ? (e.consume(n), a++, l) : (e.exit("codeTextSequence"), i(n));
    }

    function i(n) {
      return null === n ? t(n) : 96 === n ? (r = e.enter("codeTextSequence"), o = 0, s(n)) : 32 === n ? (e.enter("space"), e.consume(n), e.exit("space"), i) : br(n) ? (e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), i) : (e.enter("codeTextData"), c(n));
    }

    function c(n) {
      return null === n || 32 === n || 96 === n || br(n) ? (e.exit("codeTextData"), i(n)) : (e.consume(n), c);
    }

    function s(t) {
      return 96 === t ? (e.consume(t), o++, s) : o === a ? (e.exit("codeTextSequence"), e.exit("codeText"), n(t)) : (r.type = "codeTextData", c(t));
    }
  },
  resolve: function resolve(e) {
    var n,
        t,
        o = e.length - 4,
        r = 3;
    if (!("lineEnding" !== e[r][1].type && "space" !== e[r][1].type || "lineEnding" !== e[o][1].type && "space" !== e[o][1].type)) for (n = r; ++n < o;) {
      if ("codeTextData" === e[n][1].type) {
        e[r][1].type = "codeTextPadding", e[o][1].type = "codeTextPadding", r += 2, o -= 2;
        break;
      }
    }
    n = r - 1, o++;

    for (; ++n <= o;) {
      void 0 === t ? n !== o && "lineEnding" !== e[n][1].type && (t = n) : n !== o && "lineEnding" !== e[n][1].type || (e[t][1].type = "codeTextData", n !== t + 2 && (e[t][1].end = e[n - 1][1].end, e.splice(t + 2, n - t - 2), o -= n - t - 2, n = t + 2), t = void 0);
    }

    return e;
  },
  previous: function previous(e) {
    return 96 !== e || "characterEscape" === this.events[this.events.length - 1][1].type;
  }
};

function qr(e) {
  var n = {};
  var t,
      o,
      r,
      a,
      l,
      i,
      c,
      s = -1;

  for (; ++s < e.length;) {
    for (; (s in n);) {
      s = n[s];
    }

    if (t = e[s], s && "chunkFlow" === t[1].type && "listItemPrefix" === e[s - 1][1].type && (i = t[1]._tokenizer.events, r = 0, r < i.length && "lineEndingBlank" === i[r][1].type && (r += 2), r < i.length && "content" === i[r][1].type)) for (; ++r < i.length && "content" !== i[r][1].type;) {
      "chunkText" === i[r][1].type && (i[r][1]._isInFirstContentOfListItem = !0, r++);
    }
    if ("enter" === t[0]) t[1].contentType && (Object.assign(n, Ur(e, s)), s = n[s], c = !0);else if (t[1]._container) {
      for (r = s, o = void 0; r-- && (a = e[r], "lineEnding" === a[1].type || "lineEndingBlank" === a[1].type);) {
        "enter" === a[0] && (o && (e[o][1].type = "lineEndingBlank"), a[1].type = "lineEnding", o = r);
      }

      o && (t[1].end = Object.assign({}, e[o][1].start), l = e.slice(o, s), l.unshift(t), or(e, o, s - o + 1, l));
    }
  }

  return !c;
}

function Ur(e, n) {
  var t = e[n][1],
      o = e[n][2];
  var r = n - 1;
  var a = [],
      l = t._tokenizer || o.parser[t.contentType](t.start),
      i = l.events,
      c = [],
      s = {};
  var u,
      d,
      f = -1,
      p = t,
      g = 0,
      m = 0;
  var h = [m];

  for (; p;) {
    for (; e[++r][1] !== p;) {
      ;
    }

    a.push(r), p._tokenizer || (u = o.sliceStream(p), p.next || u.push(null), d && l.defineSkip(p.start), p._isInFirstContentOfListItem && (l._gfmTasklistFirstContentOfListItem = !0), l.write(u), p._isInFirstContentOfListItem && (l._gfmTasklistFirstContentOfListItem = void 0)), d = p, p = p.next;
  }

  for (p = t; ++f < i.length;) {
    "exit" === i[f][0] && "enter" === i[f - 1][0] && i[f][1].type === i[f - 1][1].type && i[f][1].start.line !== i[f][1].end.line && (m = f + 1, h.push(m), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  }

  for (l.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : h.pop(), f = h.length; f--;) {
    var _n4 = i.slice(h[f], h[f + 1]),
        _t6 = a.pop();

    c.unshift([_t6, _t6 + _n4.length - 1]), or(e, _t6, 2, _n4);
  }

  for (f = -1; ++f < c.length;) {
    s[g + c[f][0]] = g + c[f][1], g += c[f][1] - c[f][0] - 1;
  }

  return s;
}

var Vr = {
  tokenize: function tokenize(e, n) {
    var t;
    return function (n) {
      return e.enter("content"), t = e.enter("chunkContent", {
        contentType: "content"
      }), o(n);
    };

    function o(n) {
      return null === n ? r(n) : br(n) ? e.check(Jr, a, r)(n) : (e.consume(n), o);
    }

    function r(t) {
      return e.exit("chunkContent"), e.exit("content"), n(t);
    }

    function a(n) {
      return e.consume(n), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
        contentType: "content",
        previous: t
      }), t = t.next, o;
    }
  },
  resolve: function resolve(e) {
    return qr(e), e;
  }
},
    Jr = {
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return function (n) {
      return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), xr(e, r, "linePrefix");
    };

    function r(r) {
      if (null === r || br(r)) return t(r);
      var a = o.events[o.events.length - 1];
      return !o.parser.constructs.disable["null"].includes("codeIndented") && a && "linePrefix" === a[1].type && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(r) : e.interrupt(o.parser.constructs.flow, t, n)(r);
    }
  },
  partial: !0
};

function Kr(e, n, t, o, r, a, l, i, c) {
  var s = c || Number.POSITIVE_INFINITY;
  var u = 0;
  return function (n) {
    if (60 === n) return e.enter(o), e.enter(r), e.enter(a), e.consume(n), e.exit(a), d;
    if (null === n || 41 === n || mr(n)) return t(n);
    return e.enter(o), e.enter(l), e.enter(i), e.enter("chunkString", {
      contentType: "string"
    }), g(n);
  };

  function d(t) {
    return 62 === t ? (e.enter(a), e.consume(t), e.exit(a), e.exit(r), e.exit(o), n) : (e.enter(i), e.enter("chunkString", {
      contentType: "string"
    }), f(t));
  }

  function f(n) {
    return 62 === n ? (e.exit("chunkString"), e.exit(i), d(n)) : null === n || 60 === n || br(n) ? t(n) : (e.consume(n), 92 === n ? p : f);
  }

  function p(n) {
    return 60 === n || 62 === n || 92 === n ? (e.consume(n), f) : f(n);
  }

  function g(r) {
    return 40 === r ? ++u > s ? t(r) : (e.consume(r), g) : 41 === r ? u-- ? (e.consume(r), g) : (e.exit("chunkString"), e.exit(i), e.exit(l), e.exit(o), n(r)) : null === r || hr(r) ? u ? t(r) : (e.exit("chunkString"), e.exit(i), e.exit(l), e.exit(o), n(r)) : mr(r) ? t(r) : (e.consume(r), 92 === r ? m : g);
  }

  function m(n) {
    return 40 === n || 41 === n || 92 === n ? (e.consume(n), g) : g(n);
  }
}

function Qr(e, n, t, o, r, a) {
  var l = this;
  var i,
      c = 0;
  return function (n) {
    return e.enter(o), e.enter(r), e.consume(n), e.exit(r), e.enter(a), s;
  };

  function s(d) {
    return null === d || 91 === d || 93 === d && !i || 94 === d && !c && "_hiddenFootnoteSupport" in l.parser.constructs || c > 999 ? t(d) : 93 === d ? (e.exit(a), e.enter(r), e.consume(d), e.exit(r), e.exit(o), n) : br(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), s) : (e.enter("chunkString", {
      contentType: "string"
    }), u(d));
  }

  function u(n) {
    return null === n || 91 === n || 93 === n || br(n) || c++ > 999 ? (e.exit("chunkString"), s(n)) : (e.consume(n), i = i || !yr(n), 92 === n ? d : u);
  }

  function d(n) {
    return 91 === n || 92 === n || 93 === n ? (e.consume(n), c++, u) : u(n);
  }
}

function Yr(e, n, t, o, r, a) {
  var l;
  return function (n) {
    return e.enter(o), e.enter(r), e.consume(n), e.exit(r), l = 40 === n ? 41 : n, i;
  };

  function i(t) {
    return t === l ? (e.enter(r), e.consume(t), e.exit(r), e.exit(o), n) : (e.enter(a), c(t));
  }

  function c(n) {
    return n === l ? (e.exit(a), i(l)) : null === n ? t(n) : br(n) ? (e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), xr(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), s(n));
  }

  function s(n) {
    return n === l || null === n || br(n) ? (e.exit("chunkString"), c(n)) : (e.consume(n), 92 === n ? u : s);
  }

  function u(n) {
    return n === l || 92 === n ? (e.consume(n), s) : s(n);
  }
}

function Gr(e, n) {
  var t;
  return function o(r) {
    if (br(r)) return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), t = !0, o;
    if (yr(r)) return xr(e, o, t ? "linePrefix" : "lineSuffix")(r);
    return n(r);
  };
}

function Xr(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}

var _r = {
  name: "definition",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    var r;
    return function (n) {
      return e.enter("definition"), Qr.call(o, e, a, t, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(n);
    };

    function a(n) {
      return r = Xr(o.sliceSerialize(o.events[o.events.length - 1][1]).slice(1, -1)), 58 === n ? (e.enter("definitionMarker"), e.consume(n), e.exit("definitionMarker"), Gr(e, Kr(e, e.attempt(Zr, xr(e, l, "whitespace"), xr(e, l, "whitespace")), t, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString"))) : t(n);
    }

    function l(a) {
      return null === a || br(a) ? (e.exit("definition"), o.parser.defined.includes(r) || o.parser.defined.push(r), n(a)) : t(a);
    }
  }
},
    Zr = {
  tokenize: function tokenize(e, n, t) {
    return function (n) {
      return hr(n) ? Gr(e, o)(n) : t(n);
    };

    function o(n) {
      return 34 === n || 39 === n || 40 === n ? Yr(e, xr(e, r, "whitespace"), t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(n) : t(n);
    }

    function r(e) {
      return null === e || br(e) ? n(e) : t(e);
    }
  },
  partial: !0
};
var $r = {
  name: "hardBreakEscape",
  tokenize: function tokenize(e, n, t) {
    return function (n) {
      return e.enter("hardBreakEscape"), e.enter("escapeMarker"), e.consume(n), o;
    };

    function o(o) {
      return br(o) ? (e.exit("escapeMarker"), e.exit("hardBreakEscape"), n(o)) : t(o);
    }
  }
};
var ea = {
  name: "headingAtx",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    var r = 0;
    return function (n) {
      return e.enter("atxHeading"), e.enter("atxHeadingSequence"), a(n);
    };

    function a(i) {
      return 35 === i && r++ < 6 ? (e.consume(i), a) : null === i || hr(i) ? (e.exit("atxHeadingSequence"), o.interrupt ? n(i) : l(i)) : t(i);
    }

    function l(t) {
      return 35 === t ? (e.enter("atxHeadingSequence"), i(t)) : null === t || br(t) ? (e.exit("atxHeading"), n(t)) : yr(t) ? xr(e, l, "whitespace")(t) : (e.enter("atxHeadingText"), c(t));
    }

    function i(n) {
      return 35 === n ? (e.consume(n), i) : (e.exit("atxHeadingSequence"), l(n));
    }

    function c(n) {
      return null === n || 35 === n || hr(n) ? (e.exit("atxHeadingText"), l(n)) : (e.consume(n), c);
    }
  },
  resolve: function resolve(e, n) {
    var t,
        o,
        r = e.length - 2,
        a = 3;
    "whitespace" === e[a][1].type && (a += 2);
    r - 2 > a && "whitespace" === e[r][1].type && (r -= 2);
    "atxHeadingSequence" === e[r][1].type && (a === r - 1 || r - 4 > a && "whitespace" === e[r - 2][1].type) && (r -= a + 1 === r ? 2 : 4);
    r > a && (t = {
      type: "atxHeadingText",
      start: e[a][1].start,
      end: e[r][1].end
    }, o = {
      type: "chunkText",
      start: e[a][1].start,
      end: e[r][1].end,
      contentType: "text"
    }, or(e, a, r - a + 1, [["enter", t, n], ["enter", o, n], ["exit", o, n], ["exit", t, n]]));
    return e;
  }
};
var na = ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "title", "tr", "track", "ul"],
    ta = ["pre", "script", "style", "textarea"],
    oa = {
  name: "htmlFlow",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    var r, a, l, i, c;
    return function (n) {
      return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(n), s;
    };

    function s(i) {
      return 33 === i ? (e.consume(i), u) : 47 === i ? (e.consume(i), p) : 63 === i ? (e.consume(i), r = 3, o.interrupt ? n : L) : sr(i) ? (e.consume(i), l = String.fromCharCode(i), a = !0, g) : t(i);
    }

    function u(a) {
      return 45 === a ? (e.consume(a), r = 2, d) : 91 === a ? (e.consume(a), r = 5, l = "CDATA[", i = 0, f) : sr(a) ? (e.consume(a), r = 4, o.interrupt ? n : L) : t(a);
    }

    function d(r) {
      return 45 === r ? (e.consume(r), o.interrupt ? n : L) : t(r);
    }

    function f(r) {
      return r === l.charCodeAt(i++) ? (e.consume(r), i === l.length ? o.interrupt ? n : C : f) : t(r);
    }

    function p(n) {
      return sr(n) ? (e.consume(n), l = String.fromCharCode(n), g) : t(n);
    }

    function g(i) {
      return null === i || 47 === i || 62 === i || hr(i) ? 47 !== i && a && ta.includes(l.toLowerCase()) ? (r = 1, o.interrupt ? n(i) : C(i)) : na.includes(l.toLowerCase()) ? (r = 6, 47 === i ? (e.consume(i), m) : o.interrupt ? n(i) : C(i)) : (r = 7, o.interrupt && !o.parser.lazy[o.now().line] ? t(i) : a ? b(i) : h(i)) : 45 === i || fr(i) ? (e.consume(i), l += String.fromCharCode(i), g) : t(i);
    }

    function m(r) {
      return 62 === r ? (e.consume(r), o.interrupt ? n : C) : t(r);
    }

    function h(n) {
      return yr(n) ? (e.consume(n), h) : S(n);
    }

    function b(n) {
      return 47 === n ? (e.consume(n), S) : 58 === n || 95 === n || sr(n) ? (e.consume(n), y) : yr(n) ? (e.consume(n), b) : S(n);
    }

    function y(n) {
      return 45 === n || 46 === n || 58 === n || 95 === n || fr(n) ? (e.consume(n), y) : k(n);
    }

    function k(n) {
      return 61 === n ? (e.consume(n), v) : yr(n) ? (e.consume(n), k) : b(n);
    }

    function v(n) {
      return null === n || 60 === n || 61 === n || 62 === n || 96 === n ? t(n) : 34 === n || 39 === n ? (e.consume(n), c = n, w) : yr(n) ? (e.consume(n), v) : (c = null, x(n));
    }

    function w(n) {
      return null === n || br(n) ? t(n) : n === c ? (e.consume(n), A) : (e.consume(n), w);
    }

    function x(n) {
      return null === n || 34 === n || 39 === n || 60 === n || 61 === n || 62 === n || 96 === n || hr(n) ? k(n) : (e.consume(n), x);
    }

    function A(e) {
      return 47 === e || 62 === e || yr(e) ? b(e) : t(e);
    }

    function S(n) {
      return 62 === n ? (e.consume(n), E) : t(n);
    }

    function E(n) {
      return yr(n) ? (e.consume(n), E) : null === n || br(n) ? C(n) : t(n);
    }

    function C(n) {
      return 45 === n && 2 === r ? (e.consume(n), O) : 60 === n && 1 === r ? (e.consume(n), D) : 62 === n && 4 === r ? (e.consume(n), B) : 63 === n && 3 === r ? (e.consume(n), L) : 93 === n && 5 === r ? (e.consume(n), P) : !br(n) || 6 !== r && 7 !== r ? null === n || br(n) ? z(n) : (e.consume(n), C) : e.check(ra, B, z)(n);
    }

    function z(n) {
      return e.exit("htmlFlowData"), T(n);
    }

    function T(n) {
      return null === n ? R(n) : br(n) ? e.attempt({
        tokenize: M,
        partial: !0
      }, T, R)(n) : (e.enter("htmlFlowData"), C(n));
    }

    function M(e, n, t) {
      return function (n) {
        return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), r;
      };

      function r(e) {
        return o.parser.lazy[o.now().line] ? t(e) : n(e);
      }
    }

    function O(n) {
      return 45 === n ? (e.consume(n), L) : C(n);
    }

    function D(n) {
      return 47 === n ? (e.consume(n), l = "", F) : C(n);
    }

    function F(n) {
      return 62 === n && ta.includes(l.toLowerCase()) ? (e.consume(n), B) : sr(n) && l.length < 8 ? (e.consume(n), l += String.fromCharCode(n), F) : C(n);
    }

    function P(n) {
      return 93 === n ? (e.consume(n), L) : C(n);
    }

    function L(n) {
      return 62 === n ? (e.consume(n), B) : 45 === n && 2 === r ? (e.consume(n), L) : C(n);
    }

    function B(n) {
      return null === n || br(n) ? (e.exit("htmlFlowData"), R(n)) : (e.consume(n), B);
    }

    function R(t) {
      return e.exit("htmlFlow"), n(t);
    }
  },
  resolveTo: function resolveTo(e) {
    var n = e.length;

    for (; n-- && ("enter" !== e[n][0] || "htmlFlow" !== e[n][1].type);) {
      ;
    }

    n > 1 && "linePrefix" === e[n - 2][1].type && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2));
    return e;
  },
  concrete: !0
},
    ra = {
  tokenize: function tokenize(e, n, t) {
    return function (o) {
      return e.exit("htmlFlowData"), e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), e.attempt(Dr, n, t);
    };
  },
  partial: !0
};
var aa = {
  name: "htmlText",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    var r, a, l, i;
    return function (n) {
      return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(n), c;
    };

    function c(n) {
      return 33 === n ? (e.consume(n), s) : 47 === n ? (e.consume(n), x) : 63 === n ? (e.consume(n), v) : sr(n) ? (e.consume(n), E) : t(n);
    }

    function s(n) {
      return 45 === n ? (e.consume(n), u) : 91 === n ? (e.consume(n), a = "CDATA[", l = 0, m) : sr(n) ? (e.consume(n), k) : t(n);
    }

    function u(n) {
      return 45 === n ? (e.consume(n), d) : t(n);
    }

    function d(n) {
      return null === n || 62 === n ? t(n) : 45 === n ? (e.consume(n), f) : p(n);
    }

    function f(e) {
      return null === e || 62 === e ? t(e) : p(e);
    }

    function p(n) {
      return null === n ? t(n) : 45 === n ? (e.consume(n), g) : br(n) ? (i = p, P(n)) : (e.consume(n), p);
    }

    function g(n) {
      return 45 === n ? (e.consume(n), B) : p(n);
    }

    function m(n) {
      return n === a.charCodeAt(l++) ? (e.consume(n), l === a.length ? h : m) : t(n);
    }

    function h(n) {
      return null === n ? t(n) : 93 === n ? (e.consume(n), b) : br(n) ? (i = h, P(n)) : (e.consume(n), h);
    }

    function b(n) {
      return 93 === n ? (e.consume(n), y) : h(n);
    }

    function y(n) {
      return 62 === n ? B(n) : 93 === n ? (e.consume(n), y) : h(n);
    }

    function k(n) {
      return null === n || 62 === n ? B(n) : br(n) ? (i = k, P(n)) : (e.consume(n), k);
    }

    function v(n) {
      return null === n ? t(n) : 63 === n ? (e.consume(n), w) : br(n) ? (i = v, P(n)) : (e.consume(n), v);
    }

    function w(e) {
      return 62 === e ? B(e) : v(e);
    }

    function x(n) {
      return sr(n) ? (e.consume(n), A) : t(n);
    }

    function A(n) {
      return 45 === n || fr(n) ? (e.consume(n), A) : S(n);
    }

    function S(n) {
      return br(n) ? (i = S, P(n)) : yr(n) ? (e.consume(n), S) : B(n);
    }

    function E(n) {
      return 45 === n || fr(n) ? (e.consume(n), E) : 47 === n || 62 === n || hr(n) ? C(n) : t(n);
    }

    function C(n) {
      return 47 === n ? (e.consume(n), B) : 58 === n || 95 === n || sr(n) ? (e.consume(n), z) : br(n) ? (i = C, P(n)) : yr(n) ? (e.consume(n), C) : B(n);
    }

    function z(n) {
      return 45 === n || 46 === n || 58 === n || 95 === n || fr(n) ? (e.consume(n), z) : T(n);
    }

    function T(n) {
      return 61 === n ? (e.consume(n), M) : br(n) ? (i = T, P(n)) : yr(n) ? (e.consume(n), T) : C(n);
    }

    function M(n) {
      return null === n || 60 === n || 61 === n || 62 === n || 96 === n ? t(n) : 34 === n || 39 === n ? (e.consume(n), r = n, O) : br(n) ? (i = M, P(n)) : yr(n) ? (e.consume(n), M) : (e.consume(n), r = void 0, F);
    }

    function O(n) {
      return n === r ? (e.consume(n), D) : null === n ? t(n) : br(n) ? (i = O, P(n)) : (e.consume(n), O);
    }

    function D(e) {
      return 62 === e || 47 === e || hr(e) ? C(e) : t(e);
    }

    function F(n) {
      return null === n || 34 === n || 39 === n || 60 === n || 61 === n || 96 === n ? t(n) : 62 === n || hr(n) ? C(n) : (e.consume(n), F);
    }

    function P(n) {
      return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), xr(e, L, "linePrefix", o.parser.constructs.disable["null"].includes("codeIndented") ? void 0 : 4);
    }

    function L(n) {
      return e.enter("htmlTextData"), i(n);
    }

    function B(o) {
      return 62 === o ? (e.consume(o), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(o);
    }
  }
};
var la = {
  name: "labelEnd",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    var r,
        a,
        l = o.events.length;

    for (; l--;) {
      if (("labelImage" === o.events[l][1].type || "labelLink" === o.events[l][1].type) && !o.events[l][1]._balanced) {
        r = o.events[l][1];
        break;
      }
    }

    return function (n) {
      if (!r) return t(n);
      return r._inactive ? c(n) : (a = o.parser.defined.includes(Xr(o.sliceSerialize({
        start: r.end,
        end: o.now()
      }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(n), e.exit("labelMarker"), e.exit("labelEnd"), i);
    };

    function i(t) {
      return 40 === t ? e.attempt(ia, n, a ? n : c)(t) : 91 === t ? e.attempt(ca, n, a ? e.attempt(sa, n, c) : c)(t) : a ? n(t) : c(t);
    }

    function c(e) {
      return r._balanced = !0, t(e);
    }
  },
  resolveTo: function resolveTo(e, n) {
    var t,
        o,
        r,
        a,
        l = e.length,
        i = 0;

    for (; l--;) {
      if (t = e[l][1], o) {
        if ("link" === t.type || "labelLink" === t.type && t._inactive) break;
        "enter" === e[l][0] && "labelLink" === t.type && (t._inactive = !0);
      } else if (r) {
        if ("enter" === e[l][0] && ("labelImage" === t.type || "labelLink" === t.type) && !t._balanced && (o = l, "labelLink" !== t.type)) {
          i = 2;
          break;
        }
      } else "labelEnd" === t.type && (r = l);
    }

    var c = {
      type: "labelLink" === e[o][1].type ? "link" : "image",
      start: Object.assign({}, e[o][1].start),
      end: Object.assign({}, e[e.length - 1][1].end)
    },
        s = {
      type: "label",
      start: Object.assign({}, e[o][1].start),
      end: Object.assign({}, e[r][1].end)
    },
        u = {
      type: "labelText",
      start: Object.assign({}, e[o + i + 2][1].end),
      end: Object.assign({}, e[r - 2][1].start)
    };
    return a = [["enter", c, n], ["enter", s, n]], a = rr(a, e.slice(o + 1, o + i + 3)), a = rr(a, [["enter", u, n]]), a = rr(a, zr(n.parser.constructs.insideSpan["null"], e.slice(o + i + 4, r - 3), n)), a = rr(a, [["exit", u, n], e[r - 2], e[r - 1], ["exit", s, n]]), a = rr(a, e.slice(r + 1)), a = rr(a, [["exit", c, n]]), or(e, o, e.length, a), e;
  },
  resolveAll: function resolveAll(e) {
    var n,
        t = -1;

    for (; ++t < e.length;) {
      n = e[t][1], "labelImage" !== n.type && "labelLink" !== n.type && "labelEnd" !== n.type || (e.splice(t + 1, "labelImage" === n.type ? 4 : 2), n.type = "data", t++);
    }

    return e;
  }
},
    ia = {
  tokenize: function tokenize(e, n, t) {
    return function (n) {
      return e.enter("resource"), e.enter("resourceMarker"), e.consume(n), e.exit("resourceMarker"), Gr(e, o);
    };

    function o(n) {
      return 41 === n ? l(n) : Kr(e, r, t, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(n);
    }

    function r(n) {
      return hr(n) ? Gr(e, a)(n) : l(n);
    }

    function a(n) {
      return 34 === n || 39 === n || 40 === n ? Yr(e, Gr(e, l), t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(n) : l(n);
    }

    function l(o) {
      return 41 === o ? (e.enter("resourceMarker"), e.consume(o), e.exit("resourceMarker"), e.exit("resource"), n) : t(o);
    }
  }
},
    ca = {
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return function (n) {
      return Qr.call(o, e, r, t, "reference", "referenceMarker", "referenceString")(n);
    };

    function r(e) {
      return o.parser.defined.includes(Xr(o.sliceSerialize(o.events[o.events.length - 1][1]).slice(1, -1))) ? n(e) : t(e);
    }
  }
},
    sa = {
  tokenize: function tokenize(e, n, t) {
    return function (n) {
      return e.enter("reference"), e.enter("referenceMarker"), e.consume(n), e.exit("referenceMarker"), o;
    };

    function o(o) {
      return 93 === o ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : t(o);
    }
  }
};
var ua = {
  name: "labelStartImage",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return function (n) {
      return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(n), e.exit("labelImageMarker"), r;
    };

    function r(n) {
      return 91 === n ? (e.enter("labelMarker"), e.consume(n), e.exit("labelMarker"), e.exit("labelImage"), a) : t(n);
    }

    function a(e) {
      return 94 === e && "_hiddenFootnoteSupport" in o.parser.constructs ? t(e) : n(e);
    }
  },
  resolveAll: la.resolveAll
};
var da = {
  name: "labelStartLink",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return function (n) {
      return e.enter("labelLink"), e.enter("labelMarker"), e.consume(n), e.exit("labelMarker"), e.exit("labelLink"), r;
    };

    function r(e) {
      return 94 === e && "_hiddenFootnoteSupport" in o.parser.constructs ? t(e) : n(e);
    }
  },
  resolveAll: la.resolveAll
};
var fa = {
  name: "lineEnding",
  tokenize: function tokenize(e, n) {
    return function (t) {
      return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), xr(e, n, "linePrefix");
    };
  }
};
var pa = {
  name: "thematicBreak",
  tokenize: function tokenize(e, n, t) {
    var o,
        r = 0;
    return function (n) {
      return e.enter("thematicBreak"), o = n, a(n);
    };

    function a(i) {
      return i === o ? (e.enter("thematicBreakSequence"), l(i)) : yr(i) ? xr(e, a, "whitespace")(i) : r < 3 || null !== i && !br(i) ? t(i) : (e.exit("thematicBreak"), n(i));
    }

    function l(n) {
      return n === o ? (e.consume(n), r++, l) : (e.exit("thematicBreakSequence"), a(n));
    }
  }
};
var ga = {
  name: "list",
  tokenize: function tokenize(e, n, t) {
    var o = this,
        r = o.events[o.events.length - 1];
    var a = r && "linePrefix" === r[1].type ? r[2].sliceSerialize(r[1], !0).length : 0,
        l = 0;
    return function (n) {
      var r = o.containerState.type || (42 === n || 43 === n || 45 === n ? "listUnordered" : "listOrdered");

      if ("listUnordered" === r ? !o.containerState.marker || n === o.containerState.marker : ur(n)) {
        if (o.containerState.type || (o.containerState.type = r, e.enter(r, {
          _container: !0
        })), "listUnordered" === r) return e.enter("listItemPrefix"), 42 === n || 45 === n ? e.check(pa, t, c)(n) : c(n);
        if (!o.interrupt || 49 === n) return e.enter("listItemPrefix"), e.enter("listItemValue"), i(n);
      }

      return t(n);
    };

    function i(n) {
      return ur(n) && ++l < 10 ? (e.consume(n), i) : (!o.interrupt || l < 2) && (o.containerState.marker ? n === o.containerState.marker : 41 === n || 46 === n) ? (e.exit("listItemValue"), c(n)) : t(n);
    }

    function c(n) {
      return e.enter("listItemMarker"), e.consume(n), e.exit("listItemMarker"), o.containerState.marker = o.containerState.marker || n, e.check(Dr, o.interrupt ? t : s, e.attempt(ma, d, u));
    }

    function s(e) {
      return o.containerState.initialBlankLine = !0, a++, d(e);
    }

    function u(n) {
      return yr(n) ? (e.enter("listItemPrefixWhitespace"), e.consume(n), e.exit("listItemPrefixWhitespace"), d) : t(n);
    }

    function d(t) {
      return o.containerState.size = a + o.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(t);
    }
  },
  continuation: {
    tokenize: function tokenize(e, n, t) {
      var o = this;
      return o.containerState._closeFlow = void 0, e.check(Dr, r, a);

      function r(t) {
        return o.containerState.furtherBlankLines = o.containerState.furtherBlankLines || o.containerState.initialBlankLine, xr(e, n, "listItemIndent", o.containerState.size + 1)(t);
      }

      function a(t) {
        return o.containerState.furtherBlankLines || !yr(t) ? (o.containerState.furtherBlankLines = void 0, o.containerState.initialBlankLine = void 0, l(t)) : (o.containerState.furtherBlankLines = void 0, o.containerState.initialBlankLine = void 0, e.attempt(ha, n, l)(t));
      }

      function l(r) {
        return o.containerState._closeFlow = !0, o.interrupt = void 0, xr(e, e.attempt(ga, n, t), "linePrefix", o.parser.constructs.disable["null"].includes("codeIndented") ? void 0 : 4)(r);
      }
    }
  },
  exit: function exit(e) {
    e.exit(this.containerState.type);
  }
},
    ma = {
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return xr(e, function (e) {
      var r = o.events[o.events.length - 1];
      return !yr(e) && r && "listItemPrefixWhitespace" === r[1].type ? n(e) : t(e);
    }, "listItemPrefixWhitespace", o.parser.constructs.disable["null"].includes("codeIndented") ? void 0 : 5);
  },
  partial: !0
},
    ha = {
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return xr(e, function (e) {
      var r = o.events[o.events.length - 1];
      return r && "listItemIndent" === r[1].type && r[2].sliceSerialize(r[1], !0).length === o.containerState.size ? n(e) : t(e);
    }, "listItemIndent", o.containerState.size + 1);
  },
  partial: !0
};
var ba = {
  name: "setextUnderline",
  tokenize: function tokenize(e, n, t) {
    var o = this;
    var r,
        a,
        l = o.events.length;

    for (; l--;) {
      if ("lineEnding" !== o.events[l][1].type && "linePrefix" !== o.events[l][1].type && "content" !== o.events[l][1].type) {
        a = "paragraph" === o.events[l][1].type;
        break;
      }
    }

    return function (n) {
      if (!o.parser.lazy[o.now().line] && (o.interrupt || a)) return e.enter("setextHeadingLine"), e.enter("setextHeadingLineSequence"), r = n, i(n);
      return t(n);
    };

    function i(n) {
      return n === r ? (e.consume(n), i) : (e.exit("setextHeadingLineSequence"), xr(e, c, "lineSuffix")(n));
    }

    function c(o) {
      return null === o || br(o) ? (e.exit("setextHeadingLine"), n(o)) : t(o);
    }
  },
  resolveTo: function resolveTo(e, n) {
    var t,
        o,
        r,
        a = e.length;

    for (; a--;) {
      if ("enter" === e[a][0]) {
        if ("content" === e[a][1].type) {
          t = a;
          break;
        }

        "paragraph" === e[a][1].type && (o = a);
      } else "content" === e[a][1].type && e.splice(a, 1), r || "definition" !== e[a][1].type || (r = a);
    }

    var l = {
      type: "setextHeading",
      start: Object.assign({}, e[o][1].start),
      end: Object.assign({}, e[e.length - 1][1].end)
    };
    e[o][1].type = "setextHeadingText", r ? (e.splice(o, 0, ["enter", l, n]), e.splice(r + 1, 0, ["exit", e[t][1], n]), e[t][1].end = Object.assign({}, e[r][1].end)) : e[t][1] = l;
    return e.push(["exit", l, n]), e;
  }
};
var ya = {
  tokenize: function tokenize(e) {
    var n = this,
        t = e.attempt(Dr, function (o) {
      if (null === o) return void e.consume(o);
      return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
    }, e.attempt(this.parser.constructs.flowInitial, o, xr(e, e.attempt(this.parser.constructs.flow, o, e.attempt(Vr, o)), "linePrefix")));
    return t;

    function o(o) {
      if (null !== o) return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, t;
      e.consume(o);
    }
  }
};
var ka = {
  resolveAll: Aa()
},
    va = xa("string"),
    wa = xa("text");

function xa(e) {
  return {
    tokenize: function tokenize(n) {
      var t = this,
          o = this.parser.constructs[e],
          r = n.attempt(o, a, l);
      return a;

      function a(e) {
        return c(e) ? r(e) : l(e);
      }

      function l(e) {
        if (null !== e) return n.enter("data"), n.consume(e), i;
        n.consume(e);
      }

      function i(e) {
        return c(e) ? (n.exit("data"), r(e)) : (n.consume(e), i);
      }

      function c(e) {
        if (null === e) return !0;
        var n = o[e];
        var r = -1;
        if (n) for (; ++r < n.length;) {
          var _e10 = n[r];
          if (!_e10.previous || _e10.previous.call(t, t.previous)) return !0;
        }
        return !1;
      }
    },
    resolveAll: Aa("text" === e ? Sa : void 0)
  };
}

function Aa(e) {
  return function (n, t) {
    var o,
        r = -1;

    for (; ++r <= n.length;) {
      void 0 === o ? n[r] && "data" === n[r][1].type && (o = r, r++) : n[r] && "data" === n[r][1].type || (r !== o + 2 && (n[o][1].end = n[r - 1][1].end, n.splice(o + 2, r - o - 2), r = o + 2), o = void 0);
    }

    return e ? e(n, t) : n;
  };
}

function Sa(e, n) {
  var t = 0;

  for (; ++t <= e.length;) {
    if ((t === e.length || "lineEnding" === e[t][1].type) && "data" === e[t - 1][1].type) {
      var _o5 = e[t - 1][1],
          _r8 = n.sliceStream(_o5);

      var _a5 = void 0,
          _l2 = _r8.length,
          _i4 = -1,
          _c3 = 0;

      for (; _l2--;) {
        var _e11 = _r8[_l2];

        if ("string" == typeof _e11) {
          for (_i4 = _e11.length; 32 === _e11.charCodeAt(_i4 - 1);) {
            _c3++, _i4--;
          }

          if (_i4) break;
          _i4 = -1;
        } else if (-2 === _e11) _a5 = !0, _c3++;else if (-1 !== _e11) {
          _l2++;
          break;
        }
      }

      if (_c3) {
        var _r9 = {
          type: t === e.length || _a5 || _c3 < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: _o5.end.line,
            column: _o5.end.column - _c3,
            offset: _o5.end.offset - _c3,
            _index: _o5.start._index + _l2,
            _bufferIndex: _l2 ? _i4 : _o5.start._bufferIndex + _i4
          },
          end: Object.assign({}, _o5.end)
        };
        _o5.end = Object.assign({}, _r9.start), _o5.start.offset === _o5.end.offset ? Object.assign(_o5, _r9) : (e.splice(t, 0, ["enter", _r9, n], ["exit", _r9, n]), t += 2);
      }

      t++;
    }
  }

  return e;
}

function Ea(e, n, t) {
  var o = Object.assign(t ? Object.assign({}, t) : {
    line: 1,
    column: 1,
    offset: 0
  }, {
    _index: 0,
    _bufferIndex: -1
  });
  var r = {},
      a = [];
  var l = [],
      i = [];
  var c = {
    consume: function consume(e) {
      br(e) ? (o.line++, o.column = 1, o.offset += -3 === e ? 2 : 1, y()) : -1 !== e && (o.column++, o.offset++);
      o._bufferIndex < 0 ? o._index++ : (o._bufferIndex++, o._bufferIndex === l[o._index].length && (o._bufferIndex = -1, o._index++));
      s.previous = e;
    },
    enter: function enter(e, n) {
      var t = n || {};
      return t.type = e, t.start = f(), s.events.push(["enter", t, s]), i.push(t), t;
    },
    exit: function exit(e) {
      var n = i.pop();
      return n.end = f(), s.events.push(["exit", n, s]), n;
    },
    attempt: h(function (e, n) {
      b(e, n.from);
    }),
    check: h(m),
    interrupt: h(m, {
      interrupt: !0
    })
  },
      s = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: d,
    sliceSerialize: function sliceSerialize(e, n) {
      return function (e, n) {
        var t = -1;
        var o = [];
        var r;

        for (; ++t < e.length;) {
          var _a6 = e[t];

          var _l3 = void 0;

          if ("string" == typeof _a6) _l3 = _a6;else switch (_a6) {
            case -5:
              _l3 = "\r";
              break;

            case -4:
              _l3 = "\n";
              break;

            case -3:
              _l3 = "\r\n";
              break;

            case -2:
              _l3 = n ? " " : "\t";
              break;

            case -1:
              if (!n && r) continue;
              _l3 = " ";
              break;

            default:
              _l3 = String.fromCharCode(_a6);
          }
          r = -2 === _a6, o.push(_l3);
        }

        return o.join("");
      }(d(e), n);
    },
    now: f,
    defineSkip: function defineSkip(e) {
      r[e.line] = e.column, y();
    },
    write: function write(e) {
      if (l = rr(l, e), p(), null !== l[l.length - 1]) return [];
      return b(n, 0), s.events = zr(a, s.events, s), s.events;
    }
  };
  var u = n.tokenize.call(s, c);
  return n.resolveAll && a.push(n), s;

  function d(e) {
    return function (e, n) {
      var t = n.start._index,
          o = n.start._bufferIndex,
          r = n.end._index,
          a = n.end._bufferIndex;
      var l;
      t === r ? l = [e[t].slice(o, a)] : (l = e.slice(t, r), o > -1 && (l[0] = l[0].slice(o)), a > 0 && l.push(e[r].slice(0, a)));
      return l;
    }(l, e);
  }

  function f() {
    return Object.assign({}, o);
  }

  function p() {
    var e;

    for (; o._index < l.length;) {
      var _n5 = l[o._index];
      if ("string" == typeof _n5) for (e = o._index, o._bufferIndex < 0 && (o._bufferIndex = 0); o._index === e && o._bufferIndex < _n5.length;) {
        g(_n5.charCodeAt(o._bufferIndex));
      } else g(_n5);
    }
  }

  function g(e) {
    u = u(e);
  }

  function m(e, n) {
    n.restore();
  }

  function h(e, n) {
    return function (t, r, a) {
      var l, u, d, p;
      return Array.isArray(t) ? g(t) : "tokenize" in t ? g([t]) : function (e) {
        return n;

        function n(n) {
          var t = null !== n && e[n],
              o = null !== n && e["null"];
          return g([].concat(_toConsumableArray(Array.isArray(t) ? t : t ? [t] : []), _toConsumableArray(Array.isArray(o) ? o : o ? [o] : [])))(n);
        }
      }(t);

      function g(e) {
        return l = e, u = 0, 0 === e.length ? a : m(e[u]);
      }

      function m(e) {
        return function (t) {
          p = function () {
            var e = f(),
                n = s.previous,
                t = s.currentConstruct,
                r = s.events.length,
                a = Array.from(i);
            return {
              restore: l,
              from: r
            };

            function l() {
              o = e, s.previous = n, s.currentConstruct = t, s.events.length = r, i = a, y();
            }
          }(), d = e, e.partial || (s.currentConstruct = e);
          if (e.name && s.parser.constructs.disable["null"].includes(e.name)) return b();
          return e.tokenize.call(n ? Object.assign(Object.create(s), n) : s, c, h, b)(t);
        };
      }

      function h(n) {
        return e(d, p), r;
      }

      function b(e) {
        return p.restore(), ++u < l.length ? m(l[u]) : a;
      }
    };
  }

  function b(e, n) {
    e.resolveAll && !a.includes(e) && a.push(e), e.resolve && or(s.events, n, s.events.length - n, e.resolve(s.events.slice(n), s)), e.resolveTo && (s.events = e.resolveTo(s.events, s));
  }

  function y() {
    o.line in r && o.column < 2 && (o.column = r[o.line], o.offset += r[o.line] - 1);
  }
}

var Ca = {
  42: ga,
  43: ga,
  45: ga,
  48: ga,
  49: ga,
  50: ga,
  51: ga,
  52: ga,
  53: ga,
  54: ga,
  55: ga,
  56: ga,
  57: ga,
  62: Fr
},
    za = {
  91: _r
},
    Ta = (_Ta = {}, _defineProperty(_Ta, -2, Ir), _defineProperty(_Ta, -1, Ir), _defineProperty(_Ta, 32, Ir), _Ta),
    Ma = {
  35: ea,
  42: pa,
  45: [ba, pa],
  60: oa,
  61: ba,
  95: pa,
  96: Nr,
  126: Nr
},
    Oa = {
  38: Hr,
  92: Pr
},
    Da = (_Da = {}, _defineProperty(_Da, -5, fa), _defineProperty(_Da, -4, fa), _defineProperty(_Da, -3, fa), _defineProperty(_Da, 33, ua), _defineProperty(_Da, 38, Hr), _defineProperty(_Da, 42, Tr), _defineProperty(_Da, 60, [Or, aa]), _defineProperty(_Da, 91, da), _defineProperty(_Da, 92, [$r, Pr]), _defineProperty(_Da, 93, la), _defineProperty(_Da, 95, Tr), _defineProperty(_Da, 96, Wr), _Da),
    Fa = {
  "null": [Tr, ka]
};
var Pa = Object.freeze({
  __proto__: null,
  document: Ca,
  contentInitial: za,
  flowInitial: Ta,
  flow: Ma,
  string: Oa,
  text: Da,
  insideSpan: Fa,
  attentionMarkers: {
    "null": [42, 95]
  },
  disable: {
    "null": []
  }
});
var La = /[\0\t\n\r]/g;

function Ba(e, n) {
  var t = Number.parseInt(e, n);
  return t < 9 || 11 === t || t > 13 && t < 32 || t > 126 && t < 160 || t > 55295 && t < 57344 || t > 64975 && t < 65008 || 65535 == (65535 & t) || 65534 == (65535 & t) || t > 1114111 ? "�" : String.fromCharCode(t);
}

var Ra = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;

function Ha(e) {
  return e.replace(Ra, Na);
}

function Na(e, n, t) {
  if (n) return n;

  if (35 === t.charCodeAt(0)) {
    var _e12 = t.charCodeAt(1),
        _n6 = 120 === _e12 || 88 === _e12;

    return Ba(t.slice(_n6 ? 2 : 1), _n6 ? 16 : 10);
  }

  return Rr(t) || e;
}

function Ia(e) {
  return e && "object" == _typeof(e) ? "position" in e || "type" in e ? Wa(e.position) : "start" in e || "end" in e ? Wa(e) : "line" in e || "column" in e ? ja(e) : "" : "";
}

function ja(e) {
  return qa(e && e.line) + ":" + qa(e && e.column);
}

function Wa(e) {
  return ja(e && e.start) + "-" + ja(e && e.end);
}

function qa(e) {
  return e && "number" == typeof e ? e : 1;
}

var Ua = {}.hasOwnProperty,
    Va = function Va(e, n, t) {
  return "string" != typeof n && (t = n, n = void 0), function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var n = Ja({
      transforms: [],
      canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
      enter: {
        autolink: c(oe),
        autolinkProtocol: T,
        autolinkEmail: T,
        atxHeading: c($),
        blockQuote: c(Y),
        characterEscape: T,
        characterReference: T,
        codeFenced: c(G),
        codeFencedFenceInfo: s,
        codeFencedFenceMeta: s,
        codeIndented: c(G, s),
        codeText: c(X, s),
        codeTextData: T,
        data: T,
        codeFlowValue: T,
        definition: c(_),
        definitionDestinationString: s,
        definitionLabelString: s,
        definitionTitleString: s,
        emphasis: c(Z),
        hardBreakEscape: c(ee),
        hardBreakTrailing: c(ee),
        htmlFlow: c(ne, s),
        htmlFlowData: T,
        htmlText: c(ne, s),
        htmlTextData: T,
        image: c(te),
        label: s,
        link: c(oe),
        listItem: c(ae),
        listItemValue: m,
        listOrdered: c(re, g),
        listUnordered: c(re),
        paragraph: c(le),
        reference: q,
        referenceString: s,
        resourceDestinationString: s,
        resourceTitleString: s,
        setextHeading: c($),
        strong: c(ie),
        thematicBreak: c(se)
      },
      exit: {
        atxHeading: d(),
        atxHeadingSequence: S,
        autolink: d(),
        autolinkEmail: Q,
        autolinkProtocol: K,
        blockQuote: d(),
        characterEscapeValue: M,
        characterReferenceMarkerHexadecimal: V,
        characterReferenceMarkerNumeric: V,
        characterReferenceValue: J,
        codeFenced: d(k),
        codeFencedFence: y,
        codeFencedFenceInfo: h,
        codeFencedFenceMeta: b,
        codeFlowValue: M,
        codeIndented: d(v),
        codeText: d(L),
        codeTextData: M,
        data: M,
        definition: d(),
        definitionDestinationString: A,
        definitionLabelString: w,
        definitionTitleString: x,
        emphasis: d(),
        hardBreakEscape: d(D),
        hardBreakTrailing: d(D),
        htmlFlow: d(F),
        htmlFlowData: M,
        htmlText: d(P),
        htmlTextData: M,
        image: d(R),
        label: N,
        labelText: H,
        lineEnding: O,
        link: d(B),
        listItem: d(),
        listOrdered: d(),
        listUnordered: d(),
        paragraph: d(),
        referenceString: U,
        resourceDestinationString: I,
        resourceTitleString: j,
        resource: W,
        setextHeading: d(z),
        setextHeadingLineSequence: C,
        setextHeadingText: E,
        strong: d(),
        thematicBreak: d()
      }
    }, e.mdastExtensions || []),
        t = {};
    return o;

    function o(e) {
      var t = {
        type: "root",
        children: []
      };
      var o = [],
          c = [],
          d = {
        stack: [t],
        tokenStack: o,
        config: n,
        enter: u,
        exit: f,
        buffer: s,
        resume: p,
        setData: a,
        getData: l
      };
      var g = -1;

      for (; ++g < e.length;) {
        if ("listOrdered" === e[g][1].type || "listUnordered" === e[g][1].type) if ("enter" === e[g][0]) c.push(g);else {
          g = r(e, c.pop(), g);
        }
      }

      for (g = -1; ++g < e.length;) {
        var _t7 = n[e[g][0]];
        Ua.call(_t7, e[g][1].type) && _t7[e[g][1].type].call(Object.assign({
          sliceSerialize: e[g][2].sliceSerialize
        }, d), e[g][1]);
      }

      if (o.length > 0) {
        var _e13 = o[o.length - 1];
        (_e13[1] || Qa).call(d, void 0, _e13[0]);
      }

      for (t.position = {
        start: i(e.length > 0 ? e[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }),
        end: i(e.length > 0 ? e[e.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        })
      }, g = -1; ++g < n.transforms.length;) {
        t = n.transforms[g](t) || t;
      }

      return t;
    }

    function r(e, n, t) {
      var o,
          r,
          a,
          l,
          i = n - 1,
          c = -1,
          s = !1;

      for (; ++i <= t;) {
        var _n7 = e[i];

        if ("listUnordered" === _n7[1].type || "listOrdered" === _n7[1].type || "blockQuote" === _n7[1].type ? ("enter" === _n7[0] ? c++ : c--, l = void 0) : "lineEndingBlank" === _n7[1].type ? "enter" === _n7[0] && (!o || l || c || a || (a = i), l = void 0) : "linePrefix" === _n7[1].type || "listItemValue" === _n7[1].type || "listItemMarker" === _n7[1].type || "listItemPrefix" === _n7[1].type || "listItemPrefixWhitespace" === _n7[1].type || (l = void 0), !c && "enter" === _n7[0] && "listItemPrefix" === _n7[1].type || -1 === c && "exit" === _n7[0] && ("listUnordered" === _n7[1].type || "listOrdered" === _n7[1].type)) {
          if (o) {
            var _l4 = i;

            for (r = void 0; _l4--;) {
              var _n8 = e[_l4];

              if ("lineEnding" === _n8[1].type || "lineEndingBlank" === _n8[1].type) {
                if ("exit" === _n8[0]) continue;
                r && (e[r][1].type = "lineEndingBlank", s = !0), _n8[1].type = "lineEnding", r = _l4;
              } else if ("linePrefix" !== _n8[1].type && "blockQuotePrefix" !== _n8[1].type && "blockQuotePrefixWhitespace" !== _n8[1].type && "blockQuoteMarker" !== _n8[1].type && "listItemIndent" !== _n8[1].type) break;
            }

            a && (!r || a < r) && (o._spread = !0), o.end = Object.assign({}, r ? e[r][1].start : _n7[1].end), e.splice(r || i, 0, ["exit", o, _n7[2]]), i++, t++;
          }

          "listItemPrefix" === _n7[1].type && (o = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, _n7[1].start)
          }, e.splice(i, 0, ["enter", o, _n7[2]]), i++, t++, a = void 0, l = !0);
        }
      }

      return e[n][1]._spread = s, t;
    }

    function a(e, n) {
      t[e] = n;
    }

    function l(e) {
      return t[e];
    }

    function i(e) {
      return {
        line: e.line,
        column: e.column,
        offset: e.offset
      };
    }

    function c(e, n) {
      return t;

      function t(t) {
        u.call(this, e(t), t), n && n.call(this, t);
      }
    }

    function s() {
      this.stack.push({
        type: "fragment",
        children: []
      });
    }

    function u(e, n, t) {
      return this.stack[this.stack.length - 1].children.push(e), this.stack.push(e), this.tokenStack.push([n, t]), e.position = {
        start: i(n.start)
      }, e;
    }

    function d(e) {
      return n;

      function n(n) {
        e && e.call(this, n), f.call(this, n);
      }
    }

    function f(e, n) {
      var t = this.stack.pop(),
          o = this.tokenStack.pop();
      if (!o) throw new Error("Cannot close `" + e.type + "` (" + Ia({
        start: e.start,
        end: e.end
      }) + "): it’s not open");
      if (o[0].type !== e.type) if (n) n.call(this, e, o[0]);else {
        (o[1] || Qa).call(this, e, o[0]);
      }
      return t.position.end = i(e.end), t;
    }

    function p() {
      return function (e, n) {
        var _ref = n || {},
            _ref$includeImageAlt = _ref.includeImageAlt,
            t = _ref$includeImageAlt === void 0 ? !0 : _ref$includeImageAlt;

        return nr(e, t);
      }(this.stack.pop());
    }

    function g() {
      a("expectingFirstListItemValue", !0);
    }

    function m(e) {
      if (l("expectingFirstListItemValue")) {
        this.stack[this.stack.length - 2].start = Number.parseInt(this.sliceSerialize(e), 10), a("expectingFirstListItemValue");
      }
    }

    function h() {
      var e = this.resume();
      this.stack[this.stack.length - 1].lang = e;
    }

    function b() {
      var e = this.resume();
      this.stack[this.stack.length - 1].meta = e;
    }

    function y() {
      l("flowCodeInside") || (this.buffer(), a("flowCodeInside", !0));
    }

    function k() {
      var e = this.resume();
      this.stack[this.stack.length - 1].value = e.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), a("flowCodeInside");
    }

    function v() {
      var e = this.resume();
      this.stack[this.stack.length - 1].value = e.replace(/(\r?\n|\r)$/g, "");
    }

    function w(e) {
      var n = this.resume(),
          t = this.stack[this.stack.length - 1];
      t.label = n, t.identifier = Xr(this.sliceSerialize(e)).toLowerCase();
    }

    function x() {
      var e = this.resume();
      this.stack[this.stack.length - 1].title = e;
    }

    function A() {
      var e = this.resume();
      this.stack[this.stack.length - 1].url = e;
    }

    function S(e) {
      var n = this.stack[this.stack.length - 1];

      if (!n.depth) {
        var _t8 = this.sliceSerialize(e).length;
        n.depth = _t8;
      }
    }

    function E() {
      a("setextHeadingSlurpLineEnding", !0);
    }

    function C(e) {
      this.stack[this.stack.length - 1].depth = 61 === this.sliceSerialize(e).charCodeAt(0) ? 1 : 2;
    }

    function z() {
      a("setextHeadingSlurpLineEnding");
    }

    function T(e) {
      var n = this.stack[this.stack.length - 1];
      var t = n.children[n.children.length - 1];
      t && "text" === t.type || (t = ce(), t.position = {
        start: i(e.start)
      }, n.children.push(t)), this.stack.push(t);
    }

    function M(e) {
      var n = this.stack.pop();
      n.value += this.sliceSerialize(e), n.position.end = i(e.end);
    }

    function O(e) {
      var t = this.stack[this.stack.length - 1];

      if (l("atHardBreak")) {
        return t.children[t.children.length - 1].position.end = i(e.end), void a("atHardBreak");
      }

      !l("setextHeadingSlurpLineEnding") && n.canContainEols.includes(t.type) && (T.call(this, e), M.call(this, e));
    }

    function D() {
      a("atHardBreak", !0);
    }

    function F() {
      var e = this.resume();
      this.stack[this.stack.length - 1].value = e;
    }

    function P() {
      var e = this.resume();
      this.stack[this.stack.length - 1].value = e;
    }

    function L() {
      var e = this.resume();
      this.stack[this.stack.length - 1].value = e;
    }

    function B() {
      var e = this.stack[this.stack.length - 1];
      l("inReference") ? (e.type += "Reference", e.referenceType = l("referenceType") || "shortcut", delete e.url, delete e.title) : (delete e.identifier, delete e.label), a("referenceType");
    }

    function R() {
      var e = this.stack[this.stack.length - 1];
      l("inReference") ? (e.type += "Reference", e.referenceType = l("referenceType") || "shortcut", delete e.url, delete e.title) : (delete e.identifier, delete e.label), a("referenceType");
    }

    function H(e) {
      var n = this.stack[this.stack.length - 2],
          t = this.sliceSerialize(e);
      n.label = Ha(t), n.identifier = Xr(t).toLowerCase();
    }

    function N() {
      var e = this.stack[this.stack.length - 1],
          n = this.resume(),
          t = this.stack[this.stack.length - 1];
      a("inReference", !0), "link" === t.type ? t.children = e.children : t.alt = n;
    }

    function I() {
      var e = this.resume();
      this.stack[this.stack.length - 1].url = e;
    }

    function j() {
      var e = this.resume();
      this.stack[this.stack.length - 1].title = e;
    }

    function W() {
      a("inReference");
    }

    function q() {
      a("referenceType", "collapsed");
    }

    function U(e) {
      var n = this.resume(),
          t = this.stack[this.stack.length - 1];
      t.label = n, t.identifier = Xr(this.sliceSerialize(e)).toLowerCase(), a("referenceType", "full");
    }

    function V(e) {
      a("characterReferenceType", e.type);
    }

    function J(e) {
      var n = this.sliceSerialize(e),
          t = l("characterReferenceType");
      var o;
      t ? (o = Ba(n, "characterReferenceMarkerNumeric" === t ? 10 : 16), a("characterReferenceType")) : o = Rr(n);
      var r = this.stack.pop();
      r.value += o, r.position.end = i(e.end);
    }

    function K(e) {
      M.call(this, e);
      this.stack[this.stack.length - 1].url = this.sliceSerialize(e);
    }

    function Q(e) {
      M.call(this, e);
      this.stack[this.stack.length - 1].url = "mailto:" + this.sliceSerialize(e);
    }

    function Y() {
      return {
        type: "blockquote",
        children: []
      };
    }

    function G() {
      return {
        type: "code",
        lang: null,
        meta: null,
        value: ""
      };
    }

    function X() {
      return {
        type: "inlineCode",
        value: ""
      };
    }

    function _() {
      return {
        type: "definition",
        identifier: "",
        label: null,
        title: null,
        url: ""
      };
    }

    function Z() {
      return {
        type: "emphasis",
        children: []
      };
    }

    function $() {
      return {
        type: "heading",
        depth: void 0,
        children: []
      };
    }

    function ee() {
      return {
        type: "break"
      };
    }

    function ne() {
      return {
        type: "html",
        value: ""
      };
    }

    function te() {
      return {
        type: "image",
        title: null,
        url: "",
        alt: null
      };
    }

    function oe() {
      return {
        type: "link",
        title: null,
        url: "",
        children: []
      };
    }

    function re(e) {
      return {
        type: "list",
        ordered: "listOrdered" === e.type,
        start: null,
        spread: e._spread,
        children: []
      };
    }

    function ae(e) {
      return {
        type: "listItem",
        spread: e._spread,
        checked: null,
        children: []
      };
    }

    function le() {
      return {
        type: "paragraph",
        children: []
      };
    }

    function ie() {
      return {
        type: "strong",
        children: []
      };
    }

    function ce() {
      return {
        type: "text",
        value: ""
      };
    }

    function se() {
      return {
        type: "thematicBreak"
      };
    }
  }(t)(function (e) {
    for (; !qr(e);) {
      ;
    }

    return e;
  }(function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var n = {
      defined: [],
      lazy: {},
      constructs: lr([Pa].concat(e.extensions || [])),
      content: t(Ar),
      document: t(Sr),
      flow: t(ya),
      string: t(va),
      text: t(wa)
    };
    return n;

    function t(e) {
      return function (t) {
        return Ea(n, e, t);
      };
    }
  }(t).document().write(function () {
    var e,
        n = 1,
        t = "",
        o = !0;
    return function (r, a, l) {
      var i = [];
      var c, s, u, d, f;

      for (r = t + r.toString(a), u = 0, t = "", o && (65279 === r.charCodeAt(0) && u++, o = void 0); u < r.length;) {
        if (La.lastIndex = u, c = La.exec(r), d = c && void 0 !== c.index ? c.index : r.length, f = r.charCodeAt(d), !c) {
          t = r.slice(u);
          break;
        }

        if (10 === f && u === d && e) i.push(-3), e = void 0;else switch (e && (i.push(-5), e = void 0), u < d && (i.push(r.slice(u, d)), n += d - u), f) {
          case 0:
            i.push(65533), n++;
            break;

          case 9:
            for (s = 4 * Math.ceil(n / 4), i.push(-2); n++ < s;) {
              i.push(-1);
            }

            break;

          case 10:
            i.push(-4), n = 1;
            break;

          default:
            e = !0, n = 1;
        }
        u = d + 1;
      }

      return l && (e && i.push(-5), t && i.push(t), i.push(null)), i;
    };
  }()(e, n, !0))));
};

function Ja(e, n) {
  var t = -1;

  for (; ++t < n.length;) {
    var _o6 = n[t];
    Array.isArray(_o6) ? Ja(e, _o6) : Ka(e, _o6);
  }

  return e;
}

function Ka(e, n) {
  var t;

  for (t in n) {
    if (Ua.call(n, t)) {
      var _o7 = "canContainEols" === t || "transforms" === t,
          _r10 = (Ua.call(e, t) ? e[t] : void 0) || (e[t] = _o7 ? [] : {}),
          _a7 = n[t];

      _a7 && (_o7 ? e[t] = [].concat(_toConsumableArray(_r10), _toConsumableArray(_a7)) : Object.assign(_r10, _a7));
    }
  }
}

function Qa(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ia({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ia({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ia({
    start: n.start,
    end: n.end
  }) + ") is still open");
}

function Ya(e) {
  var _this3 = this;

  Object.assign(this, {
    Parser: function Parser(n) {
      var t = _this3.data("settings");

      return Va(n, Object.assign({}, t, e, {
        extensions: _this3.data("micromarkExtensions") || [],
        mdastExtensions: _this3.data("fromMarkdownExtensions") || []
      }));
    }
  });
}

var Ga = function Ga(e, n, t) {
  var o = {
    type: String(e)
  };
  return null != t || "string" != typeof n && !Array.isArray(n) ? Object.assign(o, n) : t = n, Array.isArray(t) ? o.children = t : null != t && (o.value = String(t)), o;
};

var Xa = {}.hasOwnProperty;

function _a(e, n) {
  var t = n.data || {};
  return "value" in n && !(Xa.call(t, "hName") || Xa.call(t, "hProperties") || Xa.call(t, "hChildren")) ? e.augment(n, Ga("text", n.value)) : e(n, "div", el(e, n));
}

function Za(e, n, t) {
  var o = n && n.type;
  var r;
  if (!o) throw new Error("Expected node, got `" + n + "`");
  return r = Xa.call(e.handlers, o) ? e.handlers[o] : e.passThrough && e.passThrough.includes(o) ? $a : e.unknownHandler, ("function" == typeof r ? r : _a)(e, n, t);
}

function $a(e, n) {
  return "children" in n ? _objectSpread(_objectSpread({}, n), {}, {
    children: el(e, n)
  }) : n;
}

function el(e, n) {
  var t = [];

  if ("children" in n) {
    var _o8 = n.children;

    var _r11 = -1;

    for (; ++_r11 < _o8.length;) {
      var _a8 = Za(e, _o8[_r11], n);

      if (_a8) {
        if (_r11 && "break" === _o8[_r11 - 1].type && (Array.isArray(_a8) || "text" !== _a8.type || (_a8.value = _a8.value.replace(/^\s+/, "")), !Array.isArray(_a8) && "element" === _a8.type)) {
          var _e14 = _a8.children[0];
          _e14 && "text" === _e14.type && (_e14.value = _e14.value.replace(/^\s+/, ""));
        }

        Array.isArray(_a8) ? t.push.apply(t, _toConsumableArray(_a8)) : t.push(_a8);
      }
    }
  }

  return t;
}

var nl = function nl(e) {
  if (null == e) return ol;
  if ("string" == typeof e) return function (e) {
    return tl(n);

    function n(n) {
      return n && n.type === e;
    }
  }(e);
  if ("object" == _typeof(e)) return Array.isArray(e) ? function (e) {
    var n = [];
    var t = -1;

    for (; ++t < e.length;) {
      n[t] = nl(e[t]);
    }

    return tl(o);

    function o() {
      var t = -1;

      for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        e[_key6] = arguments[_key6];
      }

      for (; ++t < n.length;) {
        var _n$t;

        if ((_n$t = n[t]).call.apply(_n$t, [this].concat(e))) return !0;
      }

      return !1;
    }
  }(e) : function (e) {
    return tl(n);

    function n(n) {
      var t;

      for (t in e) {
        if (n[t] !== e[t]) return !1;
      }

      return !0;
    }
  }(e);
  if ("function" == typeof e) return tl(e);
  throw new Error("Expected function, string, or object as test");
};

function tl(e) {
  return function () {
    for (var _len7 = arguments.length, n = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      n[_key7] = arguments[_key7];
    }

    return Boolean(e.call.apply(e, [this].concat(n)));
  };
}

function ol() {
  return !0;
}

function rl(e) {
  return "[33m" + e + "[39m";
}

var al = function al(e, n, t, o) {
  "function" == typeof n && "function" != typeof t && (o = t, t = n, n = null);
  var r = nl(n),
      a = o ? -1 : 1;
  !function e(l, i, c) {
    var s = "object" == _typeof(l) && null !== l ? l : {};
    var u;
    "string" == typeof s.type && (u = "string" == typeof s.tagName ? s.tagName : "string" == typeof s.name ? s.name : void 0, Object.defineProperty(d, "name", {
      value: "node (" + rl(s.type + (u ? "<" + u + ">" : "")) + ")"
    }));
    return d;

    function d() {
      var s,
          u,
          d,
          f = [];
      if ((!n || r(l, i, c[c.length - 1] || null)) && (f = function (e) {
        if (Array.isArray(e)) return e;
        if ("number" == typeof e) return [true, e];
        return [e];
      }(t(l, c)), false === f[0])) return f;
      if (l.children && "skip" !== f[0]) for (u = (o ? l.children.length : -1) + a, d = c.concat(l); u > -1 && u < l.children.length;) {
        if (s = e(l.children[u], u, d)(), false === s[0]) return s;
        u = "number" == typeof s[1] ? s[1] : u + a;
      }
      return f;
    }
  }(e, null, [])();
};

var ll = function ll(e, n, t, o) {
  "function" == typeof n && "function" != typeof t && (o = t, t = n, n = null), al(e, n, function (e, n) {
    var o = n[n.length - 1];
    return t(e, o ? o.children.indexOf(e) : null, o);
  }, o);
},
    il = sl("start"),
    cl = sl("end");

function sl(e) {
  return function (n) {
    var t = n && n.position && n.position[e] || {};
    return {
      line: t.line || null,
      column: t.column || null,
      offset: t.offset > -1 ? t.offset : null
    };
  };
}

var ul = {}.hasOwnProperty;

function dl(e) {
  return String(e || "").toUpperCase();
}

var fl = {
  '"': "quot",
  "&": "amp",
  "<": "lt",
  ">": "gt"
};

function pl(e, n) {
  var t = function (e) {
    return e.replace(/["&<>]/g, function (e) {
      return "&" + fl[e] + ";";
    });
  }(function (e) {
    var n = [];
    var t = -1,
        o = 0,
        r = 0;

    for (; ++t < e.length;) {
      var _a9 = e.charCodeAt(t);

      var _l5 = "";
      if (37 === _a9 && fr(e.charCodeAt(t + 1)) && fr(e.charCodeAt(t + 2))) r = 2;else if (_a9 < 128) /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(_a9)) || (_l5 = String.fromCharCode(_a9));else if (_a9 > 55295 && _a9 < 57344) {
        var _n9 = e.charCodeAt(t + 1);

        _a9 < 56320 && _n9 > 56319 && _n9 < 57344 ? (_l5 = String.fromCharCode(_a9, _n9), r = 1) : _l5 = "�";
      } else _l5 = String.fromCharCode(_a9);
      _l5 && (n.push(e.slice(o, t), encodeURIComponent(_l5)), o = t + r + 1, _l5 = ""), r && (t += r, r = 0);
    }

    return n.join("") + e.slice(o);
  }(e || ""));

  if (!n) return t;
  var o = t.indexOf(":"),
      r = t.indexOf("?"),
      a = t.indexOf("#"),
      l = t.indexOf("/");
  return o < 0 || l > -1 && o > l || r > -1 && o > r || a > -1 && o > a || n.test(t.slice(0, o)) ? t : "";
}

function gl(e, n) {
  var t = [];
  var o = -1;

  for (n && t.push(Ga("text", "\n")); ++o < e.length;) {
    o && t.push(Ga("text", "\n")), t.push(e[o]);
  }

  return n && e.length > 0 && t.push(Ga("text", "\n")), t;
}

function ml(e, n) {
  var t = String(n.identifier),
      o = pl(t.toLowerCase()),
      r = e.footnoteOrder.indexOf(t);
  var a;
  -1 === r ? (e.footnoteOrder.push(t), e.footnoteCounts[t] = 1, a = e.footnoteOrder.length) : (e.footnoteCounts[t]++, a = r + 1);
  var l = e.footnoteCounts[t];
  return e(n, "sup", [e(n.position, "a", {
    href: "#" + e.clobberPrefix + "fn-" + o,
    id: e.clobberPrefix + "fnref-" + o + (l > 1 ? "-" + l : ""),
    dataFootnoteRef: !0,
    ariaDescribedBy: "footnote-label"
  }, [Ga("text", String(a))])]);
}

var hl = {};

function bl(e, n, t) {
  var o,
      r,
      a,
      l,
      i,
      c = "";

  for ("string" != typeof n && (t = n, n = bl.defaultChars), void 0 === t && (t = !0), i = function (e) {
    var n,
        t,
        o = hl[e];
    if (o) return o;

    for (o = hl[e] = [], n = 0; n < 128; n++) {
      t = String.fromCharCode(n), /^[0-9a-z]$/i.test(t) ? o.push(t) : o.push("%" + ("0" + n.toString(16).toUpperCase()).slice(-2));
    }

    for (n = 0; n < e.length; n++) {
      o[e.charCodeAt(n)] = e[n];
    }

    return o;
  }(n), o = 0, r = e.length; o < r; o++) {
    if (a = e.charCodeAt(o), t && 37 === a && o + 2 < r && /^[0-9a-f]{2}$/i.test(e.slice(o + 1, o + 3))) c += e.slice(o, o + 3), o += 2;else if (a < 128) c += i[a];else if (a >= 55296 && a <= 57343) {
      if (a >= 55296 && a <= 56319 && o + 1 < r && (l = e.charCodeAt(o + 1)) >= 56320 && l <= 57343) {
        c += encodeURIComponent(e[o] + e[o + 1]), o++;
        continue;
      }

      c += "%EF%BF%BD";
    } else c += encodeURIComponent(e[o]);
  }

  return c;
}

bl.defaultChars = ";/?:@&=+$,-_.!~*'()#", bl.componentChars = "-_.!~*'()";
var yl = bl;

function kl(e, n) {
  var t = n.referenceType;
  var o = "]";
  if ("collapsed" === t ? o += "[]" : "full" === t && (o += "[" + (n.label || n.identifier) + "]"), "imageReference" === n.type) return Ga("text", "![" + n.alt + o);
  var r = el(e, n),
      a = r[0];
  a && "text" === a.type ? a.value = "[" + a.value : r.unshift(Ga("text", "["));
  var l = r[r.length - 1];
  return l && "text" === l.type ? l.value += o : r.push(Ga("text", o)), r;
}

function vl(e) {
  var n = e.spread;
  return null == n ? e.children.length > 1 : n;
}

function wl(e, n, t) {
  var o = 0,
      r = e.length;

  if (n) {
    var _n10 = e.codePointAt(o);

    for (; 9 === _n10 || 32 === _n10;) {
      o++, _n10 = e.codePointAt(o);
    }
  }

  if (t) {
    var _n11 = e.codePointAt(r - 1);

    for (; 9 === _n11 || 32 === _n11;) {
      r--, _n11 = e.codePointAt(r - 1);
    }
  }

  return r > o ? e.slice(o, r) : "";
}

var xl = {
  blockquote: function blockquote(e, n) {
    return e(n, "blockquote", gl(el(e, n), !0));
  },
  "break": function _break(e, n) {
    return [e(n, "br"), Ga("text", "\n")];
  },
  code: function code(e, n) {
    var t = n.value ? n.value + "\n" : "",
        o = n.lang && n.lang.match(/^[^ \t]+(?=[ \t]|$)/),
        r = {};
    o && (r.className = ["language-" + o]);
    var a = e(n, "code", r, [Ga("text", t)]);
    return n.meta && (a.data = {
      meta: n.meta
    }), e(n.position, "pre", [a]);
  },
  "delete": function _delete(e, n) {
    return e(n, "del", el(e, n));
  },
  emphasis: function emphasis(e, n) {
    return e(n, "em", el(e, n));
  },
  footnoteReference: ml,
  footnote: function footnote(e, n) {
    var t = e.footnoteById;
    var o = 1;

    for (; (o in t);) {
      o++;
    }

    var r = String(o);
    return t[r] = {
      type: "footnoteDefinition",
      identifier: r,
      children: [{
        type: "paragraph",
        children: n.children
      }],
      position: n.position
    }, ml(e, {
      type: "footnoteReference",
      identifier: r,
      position: n.position
    });
  },
  heading: function heading(e, n) {
    return e(n, "h" + n.depth, el(e, n));
  },
  html: function html(e, n) {
    return e.dangerous ? e.augment(n, Ga("raw", n.value)) : null;
  },
  imageReference: function imageReference(e, n) {
    var t = e.definition(n.identifier);
    if (!t) return kl(e, n);
    var o = {
      src: yl(t.url || ""),
      alt: n.alt
    };
    return null !== t.title && void 0 !== t.title && (o.title = t.title), e(n, "img", o);
  },
  image: function image(e, n) {
    var t = {
      src: yl(n.url),
      alt: n.alt
    };
    return null !== n.title && void 0 !== n.title && (t.title = n.title), e(n, "img", t);
  },
  inlineCode: function inlineCode(e, n) {
    return e(n, "code", [Ga("text", n.value.replace(/\r?\n|\r/g, " "))]);
  },
  linkReference: function linkReference(e, n) {
    var t = e.definition(n.identifier);
    if (!t) return kl(e, n);
    var o = {
      href: yl(t.url || "")
    };
    return null !== t.title && void 0 !== t.title && (o.title = t.title), e(n, "a", o, el(e, n));
  },
  link: function link(e, n) {
    var t = {
      href: yl(n.url)
    };
    return null !== n.title && void 0 !== n.title && (t.title = n.title), e(n, "a", t, el(e, n));
  },
  listItem: function listItem(e, n, t) {
    var o = el(e, n),
        r = t ? function (e) {
      var n = e.spread;
      var t = e.children;
      var o = -1;

      for (; !n && ++o < t.length;) {
        n = vl(t[o]);
      }

      return Boolean(n);
    }(t) : vl(n),
        a = {},
        l = [];

    if ("boolean" == typeof n.checked) {
      var _t9;

      o[0] && "element" === o[0].type && "p" === o[0].tagName ? _t9 = o[0] : (_t9 = e(null, "p", []), o.unshift(_t9)), _t9.children.length > 0 && _t9.children.unshift(Ga("text", " ")), _t9.children.unshift(e(null, "input", {
        type: "checkbox",
        checked: n.checked,
        disabled: !0
      })), a.className = ["task-list-item"];
    }

    var i = -1;

    for (; ++i < o.length;) {
      var _e15 = o[i];
      (r || 0 !== i || "element" !== _e15.type || "p" !== _e15.tagName) && l.push(Ga("text", "\n")), "element" !== _e15.type || "p" !== _e15.tagName || r ? l.push(_e15) : l.push.apply(l, _toConsumableArray(_e15.children));
    }

    var c = o[o.length - 1];
    return !c || !r && "tagName" in c && "p" === c.tagName || l.push(Ga("text", "\n")), e(n, "li", a, l);
  },
  list: function list(e, n) {
    var t = {},
        o = n.ordered ? "ol" : "ul",
        r = el(e, n);
    var a = -1;

    for ("number" == typeof n.start && 1 !== n.start && (t.start = n.start); ++a < r.length;) {
      var _e16 = r[a];

      if ("element" === _e16.type && "li" === _e16.tagName && _e16.properties && Array.isArray(_e16.properties.className) && _e16.properties.className.includes("task-list-item")) {
        t.className = ["contains-task-list"];
        break;
      }
    }

    return e(n, o, t, gl(r, !0));
  },
  paragraph: function paragraph(e, n) {
    return e(n, "p", el(e, n));
  },
  root: function root(e, n) {
    return e.augment(n, Ga("root", gl(el(e, n))));
  },
  strong: function strong(e, n) {
    return e(n, "strong", el(e, n));
  },
  table: function table(e, n) {
    var t = n.children;
    var o = -1;
    var r = n.align || [],
        a = [];

    for (; ++o < t.length;) {
      var _l6 = t[o].children,
          _i5 = 0 === o ? "th" : "td",
          _c4 = [];

      var _s2 = -1;

      var _u2 = n.align ? r.length : _l6.length;

      for (; ++_s2 < _u2;) {
        var _n12 = _l6[_s2];

        _c4.push(e(_n12, _i5, {
          align: r[_s2]
        }, _n12 ? el(e, _n12) : []));
      }

      a[o] = e(t[o], "tr", gl(_c4, !0));
    }

    return e(n, "table", gl([e(a[0].position, "thead", gl([a[0]], !0))].concat(a[1] ? e({
      start: il(a[1]),
      end: cl(a[a.length - 1])
    }, "tbody", gl(a.slice(1), !0)) : []), !0));
  },
  text: function text(e, n) {
    return e.augment(n, Ga("text", function (e) {
      var n = String(e),
          t = /\r?\n|\r/g;
      var o = t.exec(n),
          r = 0;
      var a = [];

      for (; o;) {
        a.push(wl(n.slice(r, o.index), r > 0, !0), o[0]), r = o.index + o[0].length, o = t.exec(n);
      }

      return a.push(wl(n.slice(r), r > 0, !1)), a.join("");
    }(String(n.value))));
  },
  thematicBreak: function thematicBreak(e, n) {
    return e(n, "hr");
  },
  toml: Al,
  yaml: Al,
  definition: Al,
  footnoteDefinition: Al
};

function Al() {
  return null;
}

var Sl = {}.hasOwnProperty;

function El(e, n) {
  var t = n || {},
      o = t.allowDangerousHtml || !1,
      r = {};
  return l.dangerous = o, l.clobberPrefix = void 0 === t.clobberPrefix || null === t.clobberPrefix ? "user-content-" : t.clobberPrefix, l.footnoteLabel = t.footnoteLabel || "Footnotes", l.footnoteLabelTagName = t.footnoteLabelTagName || "h2", l.footnoteLabelProperties = t.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l.footnoteBackLabel = t.footnoteBackLabel || "Back to content", l.definition = function (e) {
    var n = Object.create(null);
    if (!e || !e.type) throw new Error("mdast-util-definitions expected node");
    return ll(e, "definition", function (e) {
      var t = dl(e.identifier);
      t && !ul.call(n, t) && (n[t] = e);
    }), function (e) {
      var t = dl(e);
      return t && ul.call(n, t) ? n[t] : null;
    };
  }(e), l.footnoteById = r, l.footnoteOrder = [], l.footnoteCounts = {}, l.augment = a, l.handlers = _objectSpread(_objectSpread({}, xl), t.handlers), l.unknownHandler = t.unknownHandler, l.passThrough = t.passThrough, ll(e, "footnoteDefinition", function (e) {
    var n = String(e.identifier).toUpperCase();
    Sl.call(r, n) || (r[n] = e);
  }), l;

  function a(e, n) {
    if (e && "data" in e && e.data) {
      var _t10 = e.data;
      _t10.hName && ("element" !== n.type && (n = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), n.tagName = _t10.hName), "element" === n.type && _t10.hProperties && (n.properties = _objectSpread(_objectSpread({}, n.properties), _t10.hProperties)), "children" in n && n.children && _t10.hChildren && (n.children = _t10.hChildren);
    }

    if (e) {
      var _o9 = "type" in e ? e : {
        position: e
      };

      (t = _o9) && t.position && t.position.start && t.position.start.line && t.position.start.column && t.position.end && t.position.end.line && t.position.end.column && (n.position = {
        start: il(_o9),
        end: cl(_o9)
      });
    }

    var t;
    return n;
  }

  function l(e, n, t, o) {
    return Array.isArray(t) && (o = t, t = {}), a(e, {
      type: "element",
      tagName: n,
      properties: t || {},
      children: o || []
    });
  }
}

function Cl(e, n) {
  var t = El(e, n),
      o = Za(t, e, null),
      r = function (e) {
    var n = -1;
    var t = [];

    for (; ++n < e.footnoteOrder.length;) {
      var _o10 = e.footnoteById[e.footnoteOrder[n].toUpperCase()];
      if (!_o10) continue;

      var _r12 = el(e, _o10),
          _a10 = String(_o10.identifier),
          _l7 = pl(_a10.toLowerCase());

      var _i6 = 0;
      var _c5 = [];

      for (; ++_i6 <= e.footnoteCounts[_a10];) {
        var _n13 = {
          type: "element",
          tagName: "a",
          properties: {
            href: "#" + e.clobberPrefix + "fnref-" + _l7 + (_i6 > 1 ? "-" + _i6 : ""),
            dataFootnoteBackref: !0,
            className: ["data-footnote-backref"],
            ariaLabel: e.footnoteBackLabel
          },
          children: [{
            type: "text",
            value: "↩"
          }]
        };
        _i6 > 1 && _n13.children.push({
          type: "element",
          tagName: "sup",
          children: [{
            type: "text",
            value: String(_i6)
          }]
        }), _c5.length > 0 && _c5.push({
          type: "text",
          value: " "
        }), _c5.push(_n13);
      }

      var _s3 = _r12[_r12.length - 1];

      if (_s3 && "element" === _s3.type && "p" === _s3.tagName) {
        var _s3$children;

        var _e17 = _s3.children[_s3.children.length - 1];
        _e17 && "text" === _e17.type ? _e17.value += " " : _s3.children.push({
          type: "text",
          value: " "
        }), (_s3$children = _s3.children).push.apply(_s3$children, _c5);
      } else _r12.push.apply(_r12, _c5);

      var _u3 = {
        type: "element",
        tagName: "li",
        properties: {
          id: e.clobberPrefix + "fn-" + _l7
        },
        children: gl(_r12, !0)
      };
      _o10.position && (_u3.position = _o10.position), t.push(_u3);
    }

    return 0 === t.length ? null : {
      type: "element",
      tagName: "section",
      properties: {
        dataFootnotes: !0,
        className: ["footnotes"]
      },
      children: [{
        type: "element",
        tagName: e.footnoteLabelTagName,
        properties: _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(e.footnoteLabelProperties))), {}, {
          id: "footnote-label"
        }),
        children: [Ga("text", e.footnoteLabel)]
      }, {
        type: "text",
        value: "\n"
      }, {
        type: "element",
        tagName: "ol",
        properties: {},
        children: gl(t, !0)
      }, {
        type: "text",
        value: "\n"
      }]
    };
  }(t);

  return r && o.children.push(Ga("text", "\n"), r), Array.isArray(o) ? {
    type: "root",
    children: o
  } : o;
}

var zl = function zl(e, n) {
  return e && "run" in e ? function (e, n) {
    return function (t, o, r) {
      e.run(Cl(t, n), o, function (e) {
        r(e);
      });
    };
  }(e, n) : function (e) {
    return function (n) {
      return Cl(n, e);
    };
    /** @license React v16.13.1
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
  }(e || n);
};

var Tl = "function" == typeof Symbol && Symbol["for"],
    Ml = Tl ? Symbol["for"]("react.element") : 60103,
    Ol = Tl ? Symbol["for"]("react.portal") : 60106,
    Dl = Tl ? Symbol["for"]("react.fragment") : 60107,
    Fl = Tl ? Symbol["for"]("react.strict_mode") : 60108,
    Pl = Tl ? Symbol["for"]("react.profiler") : 60114,
    Ll = Tl ? Symbol["for"]("react.provider") : 60109,
    Bl = Tl ? Symbol["for"]("react.context") : 60110,
    Rl = Tl ? Symbol["for"]("react.async_mode") : 60111,
    Hl = Tl ? Symbol["for"]("react.concurrent_mode") : 60111,
    Nl = Tl ? Symbol["for"]("react.forward_ref") : 60112,
    Il = Tl ? Symbol["for"]("react.suspense") : 60113,
    jl = Tl ? Symbol["for"]("react.suspense_list") : 60120,
    Wl = Tl ? Symbol["for"]("react.memo") : 60115,
    ql = Tl ? Symbol["for"]("react.lazy") : 60116,
    Ul = Tl ? Symbol["for"]("react.block") : 60121,
    Vl = Tl ? Symbol["for"]("react.fundamental") : 60117,
    Jl = Tl ? Symbol["for"]("react.responder") : 60118,
    Kl = Tl ? Symbol["for"]("react.scope") : 60119;

function Ql(e) {
  if ("object" == _typeof(e) && null !== e) {
    var n = e.$$typeof;

    switch (n) {
      case Ml:
        switch (e = e.type) {
          case Rl:
          case Hl:
          case Dl:
          case Pl:
          case Fl:
          case Il:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case Bl:
              case Nl:
              case ql:
              case Wl:
              case Ll:
                return e;

              default:
                return n;
            }

        }

      case Ol:
        return n;
    }
  }
}

function Yl(e) {
  return Ql(e) === Hl;
}

var Gl = {
  AsyncMode: Rl,
  ConcurrentMode: Hl,
  ContextConsumer: Bl,
  ContextProvider: Ll,
  Element: Ml,
  ForwardRef: Nl,
  Fragment: Dl,
  Lazy: ql,
  Memo: Wl,
  Portal: Ol,
  Profiler: Pl,
  StrictMode: Fl,
  Suspense: Il,
  isAsyncMode: function isAsyncMode(e) {
    return Yl(e) || Ql(e) === Rl;
  },
  isConcurrentMode: Yl,
  isContextConsumer: function isContextConsumer(e) {
    return Ql(e) === Bl;
  },
  isContextProvider: function isContextProvider(e) {
    return Ql(e) === Ll;
  },
  isElement: function isElement(e) {
    return "object" == _typeof(e) && null !== e && e.$$typeof === Ml;
  },
  isForwardRef: function isForwardRef(e) {
    return Ql(e) === Nl;
  },
  isFragment: function isFragment(e) {
    return Ql(e) === Dl;
  },
  isLazy: function isLazy(e) {
    return Ql(e) === ql;
  },
  isMemo: function isMemo(e) {
    return Ql(e) === Wl;
  },
  isPortal: function isPortal(e) {
    return Ql(e) === Ol;
  },
  isProfiler: function isProfiler(e) {
    return Ql(e) === Pl;
  },
  isStrictMode: function isStrictMode(e) {
    return Ql(e) === Fl;
  },
  isSuspense: function isSuspense(e) {
    return Ql(e) === Il;
  },
  isValidElementType: function isValidElementType(e) {
    return "string" == typeof e || "function" == typeof e || e === Dl || e === Hl || e === Pl || e === Fl || e === Il || e === jl || "object" == _typeof(e) && null !== e && (e.$$typeof === ql || e.$$typeof === Wl || e.$$typeof === Ll || e.$$typeof === Bl || e.$$typeof === Nl || e.$$typeof === Vl || e.$$typeof === Jl || e.$$typeof === Kl || e.$$typeof === Ul);
  },
  typeOf: Ql
},
    Xl = de(function (e, n) {
  "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol["for"],
        t = e ? Symbol["for"]("react.element") : 60103,
        o = e ? Symbol["for"]("react.portal") : 60106,
        r = e ? Symbol["for"]("react.fragment") : 60107,
        a = e ? Symbol["for"]("react.strict_mode") : 60108,
        l = e ? Symbol["for"]("react.profiler") : 60114,
        i = e ? Symbol["for"]("react.provider") : 60109,
        c = e ? Symbol["for"]("react.context") : 60110,
        s = e ? Symbol["for"]("react.async_mode") : 60111,
        u = e ? Symbol["for"]("react.concurrent_mode") : 60111,
        d = e ? Symbol["for"]("react.forward_ref") : 60112,
        f = e ? Symbol["for"]("react.suspense") : 60113,
        p = e ? Symbol["for"]("react.suspense_list") : 60120,
        g = e ? Symbol["for"]("react.memo") : 60115,
        m = e ? Symbol["for"]("react.lazy") : 60116,
        h = e ? Symbol["for"]("react.block") : 60121,
        b = e ? Symbol["for"]("react.fundamental") : 60117,
        y = e ? Symbol["for"]("react.responder") : 60118,
        k = e ? Symbol["for"]("react.scope") : 60119;

    function v(e) {
      if ("object" == _typeof(e) && null !== e) {
        var n = e.$$typeof;

        switch (n) {
          case t:
            var p = e.type;

            switch (p) {
              case s:
              case u:
              case r:
              case l:
              case a:
              case f:
                return p;

              default:
                var h = p && p.$$typeof;

                switch (h) {
                  case c:
                  case d:
                  case m:
                  case g:
                  case i:
                    return h;

                  default:
                    return n;
                }

            }

          case o:
            return n;
        }
      }
    }

    var w = s,
        x = u,
        A = c,
        S = i,
        E = t,
        C = d,
        z = r,
        T = m,
        M = g,
        O = o,
        D = l,
        F = a,
        P = f,
        L = !1;

    function B(e) {
      return v(e) === u;
    }

    n.AsyncMode = w, n.ConcurrentMode = x, n.ContextConsumer = A, n.ContextProvider = S, n.Element = E, n.ForwardRef = C, n.Fragment = z, n.Lazy = T, n.Memo = M, n.Portal = O, n.Profiler = D, n.StrictMode = F, n.Suspense = P, n.isAsyncMode = function (e) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(e) || v(e) === s;
    }, n.isConcurrentMode = B, n.isContextConsumer = function (e) {
      return v(e) === c;
    }, n.isContextProvider = function (e) {
      return v(e) === i;
    }, n.isElement = function (e) {
      return "object" == _typeof(e) && null !== e && e.$$typeof === t;
    }, n.isForwardRef = function (e) {
      return v(e) === d;
    }, n.isFragment = function (e) {
      return v(e) === r;
    }, n.isLazy = function (e) {
      return v(e) === m;
    }, n.isMemo = function (e) {
      return v(e) === g;
    }, n.isPortal = function (e) {
      return v(e) === o;
    }, n.isProfiler = function (e) {
      return v(e) === l;
    }, n.isStrictMode = function (e) {
      return v(e) === a;
    }, n.isSuspense = function (e) {
      return v(e) === f;
    }, n.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === u || e === l || e === a || e === f || e === p || "object" == _typeof(e) && null !== e && (e.$$typeof === m || e.$$typeof === g || e.$$typeof === i || e.$$typeof === c || e.$$typeof === d || e.$$typeof === b || e.$$typeof === y || e.$$typeof === k || e.$$typeof === h);
    }, n.typeOf = v;
  }();
}),
    _l = de(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = Gl : e.exports = Xl;
}),
    Zl = Object.getOwnPropertySymbols,
    $l = Object.prototype.hasOwnProperty,
    ei = Object.prototype.propertyIsEnumerable;

function ni(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

var ti = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var n = {}, t = 0; t < 10; t++) {
      n["_" + String.fromCharCode(t)] = t;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
      return n[e];
    }).join("")) return !1;
    var o = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      o[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, n) {
  for (var t, o, r = ni(e), a = 1; a < arguments.length; a++) {
    for (var l in t = Object(arguments[a])) {
      $l.call(t, l) && (r[l] = t[l]);
    }

    if (Zl) {
      o = Zl(t);

      for (var i = 0; i < o.length; i++) {
        ei.call(t, o[i]) && (r[o[i]] = t[o[i]]);
      }
    }
  }

  return r;
},
    oi = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    ri = function ri() {};

if ("production" !== process.env.NODE_ENV) {
  var ai = oi,
      li = {},
      ii = Function.call.bind(Object.prototype.hasOwnProperty);

  ri = function ri(e) {
    var n = "Warning: " + e;
    "undefined" != typeof console && console.error(n);

    try {
      throw new Error(n);
    } catch (e) {}
  };
}

function ci(e, n, t, o, r) {
  if ("production" !== process.env.NODE_ENV) for (var a in e) {
    if (ii(e, a)) {
      var l;

      try {
        if ("function" != typeof e[a]) {
          var i = Error((o || "React class") + ": " + t + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _typeof(e[a]) + "`.");
          throw i.name = "Invariant Violation", i;
        }

        l = e[a](n, a, o, t, null, ai);
      } catch (e) {
        l = e;
      }

      if (!l || l instanceof Error || ri((o || "React class") + ": type specification of " + t + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + _typeof(l) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), l instanceof Error && !(l.message in li)) {
        li[l.message] = !0;
        var c = r ? r() : "";
        ri("Failed " + t + " type: " + l.message + (null != c ? c : ""));
      }
    }
  }
}

ci.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (li = {});
};

var si = ci,
    ui = Function.call.bind(Object.prototype.hasOwnProperty),
    di = function di() {};

function fi() {
  return null;
}

"production" !== process.env.NODE_ENV && (di = function di(e) {
  var n = "Warning: " + e;
  "undefined" != typeof console && console.error(n);

  try {
    throw new Error(n);
  } catch (e) {}
});

var pi = function pi(e, n) {
  var t = "function" == typeof Symbol && Symbol.iterator;
  var o = "<<anonymous>>",
      r = {
    array: c("array"),
    bool: c("boolean"),
    func: c("function"),
    number: c("number"),
    object: c("object"),
    string: c("string"),
    symbol: c("symbol"),
    any: i(fi),
    arrayOf: function arrayOf(e) {
      return i(function (n, t, o, r, a) {
        if ("function" != typeof e) return new l("Property `" + a + "` of component `" + o + "` has invalid PropType notation inside arrayOf.");
        var i = n[t];
        if (!Array.isArray(i)) return new l("Invalid " + r + " `" + a + "` of type `" + u(i) + "` supplied to `" + o + "`, expected an array.");

        for (var c = 0; c < i.length; c++) {
          var s = e(i, c, o, r, a + "[" + c + "]", oi);
          if (s instanceof Error) return s;
        }

        return null;
      });
    },
    element: i(function (n, t, o, r, a) {
      var i = n[t];
      return e(i) ? null : new l("Invalid " + r + " `" + a + "` of type `" + u(i) + "` supplied to `" + o + "`, expected a single ReactElement.");
    }),
    elementType: i(function (e, n, t, o, r) {
      var a = e[n];
      return _l.isValidElementType(a) ? null : new l("Invalid " + o + " `" + r + "` of type `" + u(a) + "` supplied to `" + t + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(e) {
      return i(function (n, t, r, a, i) {
        if (!(n[t] instanceof e)) {
          var c = e.name || o;
          return new l("Invalid " + a + " `" + i + "` of type `" + (((s = n[t]).constructor && s.constructor.name ? s.constructor.name : o) + "` supplied to `") + r + "`, expected instance of `" + c + "`.");
        }

        var s;
        return null;
      });
    },
    node: i(function (e, n, t, o, r) {
      return s(e[n]) ? null : new l("Invalid " + o + " `" + r + "` supplied to `" + t + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(e) {
      return i(function (n, t, o, r, a) {
        if ("function" != typeof e) return new l("Property `" + a + "` of component `" + o + "` has invalid PropType notation inside objectOf.");
        var i = n[t],
            c = u(i);
        if ("object" !== c) return new l("Invalid " + r + " `" + a + "` of type `" + c + "` supplied to `" + o + "`, expected an object.");

        for (var s in i) {
          if (ui(i, s)) {
            var d = e(i, s, o, r, a + "." + s, oi);
            if (d instanceof Error) return d;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && di(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), fi;

      function n(n, t, o, r, i) {
        for (var c = n[t], s = 0; s < e.length; s++) {
          if (a(c, e[s])) return null;
        }

        var u = JSON.stringify(e, function (e, n) {
          return "symbol" === d(n) ? String(n) : n;
        });
        return new l("Invalid " + r + " `" + i + "` of value `" + String(c) + "` supplied to `" + o + "`, expected one of " + u + ".");
      }

      return i(n);
    },
    oneOfType: function oneOfType(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && di("Invalid argument supplied to oneOfType, expected an instance of array."), fi;

      for (var n = 0; n < e.length; n++) {
        var t = e[n];
        if ("function" != typeof t) return di("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + f(t) + " at index " + n + "."), fi;
      }

      return i(function (n, t, o, r, a) {
        for (var i = 0; i < e.length; i++) {
          if (null == (0, e[i])(n, t, o, r, a, oi)) return null;
        }

        return new l("Invalid " + r + " `" + a + "` supplied to `" + o + "`.");
      });
    },
    shape: function shape(e) {
      return i(function (n, t, o, r, a) {
        var i = n[t],
            c = u(i);
        if ("object" !== c) return new l("Invalid " + r + " `" + a + "` of type `" + c + "` supplied to `" + o + "`, expected `object`.");

        for (var s in e) {
          var d = e[s];

          if (d) {
            var f = d(i, s, o, r, a + "." + s, oi);
            if (f) return f;
          }
        }

        return null;
      });
    },
    exact: function exact(e) {
      return i(function (n, t, o, r, a) {
        var i = n[t],
            c = u(i);
        if ("object" !== c) return new l("Invalid " + r + " `" + a + "` of type `" + c + "` supplied to `" + o + "`, expected `object`.");
        var s = ti({}, n[t], e);

        for (var d in s) {
          var f = e[d];
          if (!f) return new l("Invalid " + r + " `" + a + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(n[t], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
          var p = f(i, d, o, r, a + "." + d, oi);
          if (p) return p;
        }

        return null;
      });
    }
  };

  function a(e, n) {
    return e === n ? 0 !== e || 1 / e == 1 / n : e != e && n != n;
  }

  function l(e) {
    this.message = e, this.stack = "";
  }

  function i(e) {
    if ("production" !== process.env.NODE_ENV) var t = {},
        r = 0;

    function a(a, i, c, s, u, d, f) {
      if (s = s || o, d = d || c, f !== oi) {
        if (n) {
          var p = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw p.name = "Invariant Violation", p;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var g = s + ":" + c;
          !t[g] && r < 3 && (di("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), t[g] = !0, r++);
        }
      }

      return null == i[c] ? a ? null === i[c] ? new l("The " + u + " `" + d + "` is marked as required in `" + s + "`, but its value is `null`.") : new l("The " + u + " `" + d + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(i, c, s, u, d);
    }

    var i = a.bind(null, !1);
    return i.isRequired = a.bind(null, !0), i;
  }

  function c(e) {
    return i(function (n, t, o, r, a, i) {
      var c = n[t];
      return u(c) !== e ? new l("Invalid " + r + " `" + a + "` of type `" + d(c) + "` supplied to `" + o + "`, expected `" + e + "`.") : null;
    });
  }

  function s(n) {
    switch (_typeof(n)) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !n;

      case "object":
        if (Array.isArray(n)) return n.every(s);
        if (null === n || e(n)) return !0;

        var o = function (e) {
          var n = e && (t && e[t] || e["@@iterator"]);
          if ("function" == typeof n) return n;
        }(n);

        if (!o) return !1;
        var r,
            a = o.call(n);

        if (o !== n.entries) {
          for (; !(r = a.next()).done;) {
            if (!s(r.value)) return !1;
          }
        } else for (; !(r = a.next()).done;) {
          var l = r.value;
          if (l && !s(l[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function u(e) {
    var n = _typeof(e);

    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, n) {
      return "symbol" === e || !!n && ("Symbol" === n["@@toStringTag"] || "function" == typeof Symbol && n instanceof Symbol);
    }(n, e) ? "symbol" : n;
  }

  function d(e) {
    if (null == e) return "" + e;
    var n = u(e);

    if ("object" === n) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }

    return n;
  }

  function f(e) {
    var n = d(e);

    switch (n) {
      case "array":
      case "object":
        return "an " + n;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + n;

      default:
        return n;
    }
  }

  return l.prototype = Error.prototype, r.checkPropTypes = si, r.resetWarningCache = si.resetWarningCache, r.PropTypes = r, r;
};

function gi() {}

function mi() {}

mi.resetWarningCache = gi;
var hi = de(function (e) {
  if ("production" !== process.env.NODE_ENV) {
    var n = _l;
    e.exports = pi(n.isElement, !0);
  } else e.exports = function () {
    function e(e, n, t, o, r, a) {
      if (a !== oi) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }

    function n() {
      return e;
    }

    e.isRequired = e;
    var t = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: n,
      element: e,
      elementType: e,
      instanceOf: n,
      node: e,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: mi,
      resetWarningCache: gi
    };
    return t.PropTypes = t, t;
  }();
});

var bi = function bi(e, n, t) {
  _classCallCheck(this, bi);

  this.property = e, this.normal = n, t && (this.space = t);
};

function yi(e, n) {
  var t = {},
      o = {};
  var r = -1;

  for (; ++r < e.length;) {
    Object.assign(t, e[r].property), Object.assign(o, e[r].normal);
  }

  return new bi(t, o, n);
}

function ki(e) {
  return e.toLowerCase();
}

bi.prototype.property = {}, bi.prototype.normal = {}, bi.prototype.space = null;

var vi = function vi(e, n) {
  _classCallCheck(this, vi);

  this.property = e, this.attribute = n;
};

vi.prototype.space = null, vi.prototype["boolean"] = !1, vi.prototype.booleanish = !1, vi.prototype.overloadedBoolean = !1, vi.prototype.number = !1, vi.prototype.commaSeparated = !1, vi.prototype.spaceSeparated = !1, vi.prototype.commaOrSpaceSeparated = !1, vi.prototype.mustUseProperty = !1, vi.prototype.defined = !1;
var wi = 0;
var xi = Mi(),
    Ai = Mi(),
    Si = Mi(),
    Ei = Mi(),
    Ci = Mi(),
    zi = Mi(),
    Ti = Mi();

function Mi() {
  return Math.pow(2, ++wi);
}

var Oi = Object.freeze({
  __proto__: null,
  "boolean": xi,
  booleanish: Ai,
  overloadedBoolean: Si,
  number: Ei,
  spaceSeparated: Ci,
  commaSeparated: zi,
  commaOrSpaceSeparated: Ti
});
var Di = Object.keys(Oi);

var Fi = /*#__PURE__*/function (_vi) {
  _inherits(Fi, _vi);

  var _super3 = _createSuper(Fi);

  function Fi(e, n, t, o) {
    var _this4;

    _classCallCheck(this, Fi);

    var r = -1;
    if (_this4 = _super3.call(this, e, n), Pi(_assertThisInitialized(_this4), "space", o), "number" == typeof t) for (; ++r < Di.length;) {
      var _e18 = Di[r];
      Pi(_assertThisInitialized(_this4), Di[r], (t & Oi[_e18]) === Oi[_e18]);
    }
    return _possibleConstructorReturn(_this4);
  }

  return Fi;
}(vi);

function Pi(e, n, t) {
  t && (e[n] = t);
}

Fi.prototype.defined = !0;
var Li = {}.hasOwnProperty;

function Bi(e) {
  var n = {},
      t = {};
  var o;

  for (o in e.properties) {
    if (Li.call(e.properties, o)) {
      var _r13 = e.properties[o],
          _a11 = new Fi(o, e.transform(e.attributes || {}, o), _r13, e.space);

      e.mustUseProperty && e.mustUseProperty.includes(o) && (_a11.mustUseProperty = !0), n[o] = _a11, t[ki(o)] = o, t[ki(_a11.attribute)] = o;
    }
  }

  return new bi(n, t, e.space);
}

var Ri = Bi({
  space: "xlink",
  transform: function transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}),
    Hi = Bi({
  space: "xml",
  transform: function transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});

function Ni(e, n) {
  return n in e ? e[n] : n;
}

function Ii(e, n) {
  return Ni(e, n.toLowerCase());
}

var ji = Bi({
  space: "xmlns",
  attributes: {
    xmlnsxlink: "xmlns:xlink"
  },
  transform: Ii,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
}),
    Wi = Bi({
  transform: function transform(e, n) {
    return "role" === n ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Ai,
    ariaAutoComplete: null,
    ariaBusy: Ai,
    ariaChecked: Ai,
    ariaColCount: Ei,
    ariaColIndex: Ei,
    ariaColSpan: Ei,
    ariaControls: Ci,
    ariaCurrent: null,
    ariaDescribedBy: Ci,
    ariaDetails: null,
    ariaDisabled: Ai,
    ariaDropEffect: Ci,
    ariaErrorMessage: null,
    ariaExpanded: Ai,
    ariaFlowTo: Ci,
    ariaGrabbed: Ai,
    ariaHasPopup: null,
    ariaHidden: Ai,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Ci,
    ariaLevel: Ei,
    ariaLive: null,
    ariaModal: Ai,
    ariaMultiLine: Ai,
    ariaMultiSelectable: Ai,
    ariaOrientation: null,
    ariaOwns: Ci,
    ariaPlaceholder: null,
    ariaPosInSet: Ei,
    ariaPressed: Ai,
    ariaReadOnly: Ai,
    ariaRelevant: null,
    ariaRequired: Ai,
    ariaRoleDescription: Ci,
    ariaRowCount: Ei,
    ariaRowIndex: Ei,
    ariaRowSpan: Ei,
    ariaSelected: Ai,
    ariaSetSize: Ei,
    ariaSort: null,
    ariaValueMax: Ei,
    ariaValueMin: Ei,
    ariaValueNow: Ei,
    ariaValueText: null,
    role: null
  }
}),
    qi = Bi({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: Ii,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    abbr: null,
    accept: zi,
    acceptCharset: Ci,
    accessKey: Ci,
    action: null,
    allow: null,
    allowFullScreen: xi,
    allowPaymentRequest: xi,
    allowUserMedia: xi,
    alt: null,
    as: null,
    async: xi,
    autoCapitalize: null,
    autoComplete: Ci,
    autoFocus: xi,
    autoPlay: xi,
    capture: xi,
    charSet: null,
    checked: xi,
    cite: null,
    className: Ci,
    cols: Ei,
    colSpan: null,
    content: null,
    contentEditable: Ai,
    controls: xi,
    controlsList: Ci,
    coords: Ei | zi,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    "default": xi,
    defer: xi,
    dir: null,
    dirName: null,
    disabled: xi,
    download: Si,
    draggable: Ai,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: xi,
    formTarget: null,
    headers: Ci,
    height: Ei,
    hidden: xi,
    high: Ei,
    href: null,
    hrefLang: null,
    htmlFor: Ci,
    httpEquiv: Ci,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: xi,
    itemId: null,
    itemProp: Ci,
    itemRef: Ci,
    itemScope: xi,
    itemType: Ci,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: xi,
    low: Ei,
    manifest: null,
    max: null,
    maxLength: Ei,
    media: null,
    method: null,
    min: null,
    minLength: Ei,
    multiple: xi,
    muted: xi,
    name: null,
    nonce: null,
    noModule: xi,
    noValidate: xi,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: xi,
    optimum: Ei,
    pattern: null,
    ping: Ci,
    placeholder: null,
    playsInline: xi,
    poster: null,
    preload: null,
    readOnly: xi,
    referrerPolicy: null,
    rel: Ci,
    required: xi,
    reversed: xi,
    rows: Ei,
    rowSpan: Ei,
    sandbox: Ci,
    scope: null,
    scoped: xi,
    seamless: xi,
    selected: xi,
    shape: null,
    size: Ei,
    sizes: null,
    slot: null,
    span: Ei,
    spellCheck: Ai,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ei,
    step: null,
    style: null,
    tabIndex: Ei,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: xi,
    useMap: null,
    value: Ai,
    width: Ei,
    wrap: null,
    align: null,
    aLink: null,
    archive: Ci,
    axis: null,
    background: null,
    bgColor: null,
    border: Ei,
    borderColor: null,
    bottomMargin: Ei,
    cellPadding: null,
    cellSpacing: null,
    "char": null,
    charOff: null,
    classId: null,
    clear: null,
    code: null,
    codeBase: null,
    codeType: null,
    color: null,
    compact: xi,
    declare: xi,
    event: null,
    face: null,
    frame: null,
    frameBorder: null,
    hSpace: Ei,
    leftMargin: Ei,
    link: null,
    longDesc: null,
    lowSrc: null,
    marginHeight: Ei,
    marginWidth: Ei,
    noResize: xi,
    noHref: xi,
    noShade: xi,
    noWrap: xi,
    object: null,
    profile: null,
    prompt: null,
    rev: null,
    rightMargin: Ei,
    rules: null,
    scheme: null,
    scrolling: Ai,
    standby: null,
    summary: null,
    text: null,
    topMargin: Ei,
    valueType: null,
    version: null,
    vAlign: null,
    vLink: null,
    vSpace: Ei,
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: xi,
    disableRemotePlayback: xi,
    prefix: null,
    property: null,
    results: Ei,
    security: null,
    unselectable: null
  }
}),
    Ui = Bi({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Ni,
  properties: {
    about: Ti,
    accentHeight: Ei,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ei,
    amplitude: Ei,
    arabicForm: null,
    ascent: Ei,
    attributeName: null,
    attributeType: null,
    azimuth: Ei,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ei,
    by: null,
    calcMode: null,
    capHeight: Ei,
    className: Ci,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ei,
    diffuseConstant: Ei,
    direction: null,
    display: null,
    dur: null,
    divisor: Ei,
    dominantBaseline: null,
    download: xi,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ei,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ei,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ei,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: zi,
    g2: zi,
    glyphName: zi,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ei,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ei,
    horizOriginX: Ei,
    horizOriginY: Ei,
    id: null,
    ideographic: Ei,
    imageRendering: null,
    initialVisibility: null,
    "in": null,
    in2: null,
    intercept: Ei,
    k: Ei,
    k1: Ei,
    k2: Ei,
    k3: Ei,
    k4: Ei,
    kernelMatrix: Ti,
    kernelUnitLength: null,
    keyPoints: null,
    keySplines: null,
    keyTimes: null,
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ei,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ei,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ei,
    overlineThickness: Ei,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ei,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Ci,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ei,
    pointsAtY: Ei,
    pointsAtZ: Ei,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Ti,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Ti,
    rev: Ti,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Ti,
    requiredFeatures: Ti,
    requiredFonts: Ti,
    requiredFormats: Ti,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ei,
    specularExponent: Ei,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ei,
    strikethroughThickness: Ei,
    string: null,
    stroke: null,
    strokeDashArray: Ti,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ei,
    strokeOpacity: Ei,
    strokeWidth: null,
    style: null,
    surfaceScale: Ei,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Ti,
    tabIndex: Ei,
    tableValues: null,
    target: null,
    targetX: Ei,
    targetY: Ei,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Ti,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: Ei,
    underlineThickness: Ei,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ei,
    values: null,
    vAlphabetic: Ei,
    vMathematical: Ei,
    vectorEffect: null,
    vHanging: Ei,
    vIdeographic: Ei,
    version: null,
    vertAdvY: Ei,
    vertOriginX: Ei,
    vertOriginY: Ei,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ei,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}),
    Vi = /^data[-\w.:]+$/i,
    Ji = /-[a-z]/g,
    Ki = /[A-Z]/g;

function Qi(e) {
  return "-" + e.toLowerCase();
}

function Yi(e) {
  return e.charAt(1).toUpperCase();
}

var Gi = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
},
    Xi = yi([Hi, Ri, ji, Wi, qi], "html"),
    _i = yi([Hi, Ri, ji, Wi, Ui], "svg");

function Zi(e) {
  if (e.allowedElements && e.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
  if (e.allowedElements || e.disallowedElements || e.allowElement) return function (n) {
    ll(n, "element", function (n, t, o) {
      var _r$children;

      var r = o;
      var a;
      if (e.allowedElements ? a = !e.allowedElements.includes(n.tagName) : e.disallowedElements && (a = e.disallowedElements.includes(n.tagName)), !a && e.allowElement && "number" == typeof t && (a = !e.allowElement(n, t, r)), a && "number" == typeof t) return e.unwrapDisallowed && n.children ? (_r$children = r.children).splice.apply(_r$children, [t, 1].concat(_toConsumableArray(n.children))) : r.children.splice(t, 1), t;
    });
  };
}
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var $i,
    ec = Symbol["for"]("react.element"),
    nc = Symbol["for"]("react.portal"),
    tc = Symbol["for"]("react.fragment"),
    oc = Symbol["for"]("react.strict_mode"),
    rc = Symbol["for"]("react.profiler"),
    ac = Symbol["for"]("react.provider"),
    lc = Symbol["for"]("react.context"),
    ic = Symbol["for"]("react.server_context"),
    cc = Symbol["for"]("react.forward_ref"),
    sc = Symbol["for"]("react.suspense"),
    uc = Symbol["for"]("react.suspense_list"),
    dc = Symbol["for"]("react.memo"),
    fc = Symbol["for"]("react.lazy"),
    pc = Symbol["for"]("react.offscreen");

function gc(e) {
  if ("object" == _typeof(e) && null !== e) {
    var n = e.$$typeof;

    switch (n) {
      case ec:
        switch (e = e.type) {
          case tc:
          case rc:
          case oc:
          case sc:
          case uc:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case ic:
              case lc:
              case cc:
              case fc:
              case dc:
              case ac:
                return e;

              default:
                return n;
            }

        }

      case nc:
        return n;
    }
  }
}

$i = Symbol["for"]("react.module.reference");
var mc = {
  ContextConsumer: lc,
  ContextProvider: ac,
  Element: ec,
  ForwardRef: cc,
  Fragment: tc,
  Lazy: fc,
  Memo: dc,
  Portal: nc,
  Profiler: rc,
  StrictMode: oc,
  Suspense: sc,
  SuspenseList: uc,
  isAsyncMode: function isAsyncMode() {
    return !1;
  },
  isConcurrentMode: function isConcurrentMode() {
    return !1;
  },
  isContextConsumer: function isContextConsumer(e) {
    return gc(e) === lc;
  },
  isContextProvider: function isContextProvider(e) {
    return gc(e) === ac;
  },
  isElement: function isElement(e) {
    return "object" == _typeof(e) && null !== e && e.$$typeof === ec;
  },
  isForwardRef: function isForwardRef(e) {
    return gc(e) === cc;
  },
  isFragment: function isFragment(e) {
    return gc(e) === tc;
  },
  isLazy: function isLazy(e) {
    return gc(e) === fc;
  },
  isMemo: function isMemo(e) {
    return gc(e) === dc;
  },
  isPortal: function isPortal(e) {
    return gc(e) === nc;
  },
  isProfiler: function isProfiler(e) {
    return gc(e) === rc;
  },
  isStrictMode: function isStrictMode(e) {
    return gc(e) === oc;
  },
  isSuspense: function isSuspense(e) {
    return gc(e) === sc;
  },
  isSuspenseList: function isSuspenseList(e) {
    return gc(e) === uc;
  },
  isValidElementType: function isValidElementType(e) {
    return "string" == typeof e || "function" == typeof e || e === tc || e === rc || e === oc || e === sc || e === uc || e === pc || "object" == _typeof(e) && null !== e && (e.$$typeof === fc || e.$$typeof === dc || e.$$typeof === ac || e.$$typeof === lc || e.$$typeof === cc || e.$$typeof === $i || void 0 !== e.getModuleId);
  },
  typeOf: gc
},
    hc = de(function (e, n) {
  "production" !== process.env.NODE_ENV && function () {
    var e,
        t = Symbol["for"]("react.element"),
        o = Symbol["for"]("react.portal"),
        r = Symbol["for"]("react.fragment"),
        a = Symbol["for"]("react.strict_mode"),
        l = Symbol["for"]("react.profiler"),
        i = Symbol["for"]("react.provider"),
        c = Symbol["for"]("react.context"),
        s = Symbol["for"]("react.server_context"),
        u = Symbol["for"]("react.forward_ref"),
        d = Symbol["for"]("react.suspense"),
        f = Symbol["for"]("react.suspense_list"),
        p = Symbol["for"]("react.memo"),
        g = Symbol["for"]("react.lazy"),
        m = Symbol["for"]("react.offscreen");

    function h(e) {
      if ("object" == _typeof(e) && null !== e) {
        var n = e.$$typeof;

        switch (n) {
          case t:
            var m = e.type;

            switch (m) {
              case r:
              case l:
              case a:
              case d:
              case f:
                return m;

              default:
                var h = m && m.$$typeof;

                switch (h) {
                  case s:
                  case c:
                  case u:
                  case g:
                  case p:
                  case i:
                    return h;

                  default:
                    return n;
                }

            }

          case o:
            return n;
        }
      }
    }

    e = Symbol["for"]("react.module.reference");
    var b = c,
        y = i,
        k = t,
        v = u,
        w = r,
        x = g,
        A = p,
        S = o,
        E = l,
        C = a,
        z = d,
        T = f,
        M = !1,
        O = !1;
    n.ContextConsumer = b, n.ContextProvider = y, n.Element = k, n.ForwardRef = v, n.Fragment = w, n.Lazy = x, n.Memo = A, n.Portal = S, n.Profiler = E, n.StrictMode = C, n.Suspense = z, n.SuspenseList = T, n.isAsyncMode = function (e) {
      return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }, n.isConcurrentMode = function (e) {
      return O || (O = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }, n.isContextConsumer = function (e) {
      return h(e) === c;
    }, n.isContextProvider = function (e) {
      return h(e) === i;
    }, n.isElement = function (e) {
      return "object" == _typeof(e) && null !== e && e.$$typeof === t;
    }, n.isForwardRef = function (e) {
      return h(e) === u;
    }, n.isFragment = function (e) {
      return h(e) === r;
    }, n.isLazy = function (e) {
      return h(e) === g;
    }, n.isMemo = function (e) {
      return h(e) === p;
    }, n.isPortal = function (e) {
      return h(e) === o;
    }, n.isProfiler = function (e) {
      return h(e) === l;
    }, n.isStrictMode = function (e) {
      return h(e) === a;
    }, n.isSuspense = function (e) {
      return h(e) === d;
    }, n.isSuspenseList = function (e) {
      return h(e) === f;
    }, n.isValidElementType = function (n) {
      return "string" == typeof n || "function" == typeof n || n === r || n === l || n === a || n === d || n === f || n === m || "object" == _typeof(n) && null !== n && (n.$$typeof === g || n.$$typeof === p || n.$$typeof === i || n.$$typeof === c || n.$$typeof === u || n.$$typeof === e || void 0 !== n.getModuleId);
    }, n.typeOf = h;
  }();
}),
    bc = de(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = mc : e.exports = hc;
});
var yc = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g,
    kc = /\n/g,
    vc = /^\s*/,
    wc = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/,
    xc = /^:\s*/,
    Ac = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/,
    Sc = /^[;\s]*/,
    Ec = /^\s+|\s+$/g;

function Cc(e) {
  return e ? e.replace(Ec, "") : "";
}

var zc = function zc(e, n) {
  var t,
      o = null;
  if (!e || "string" != typeof e) return o;

  for (var r, a, l = function (e, n) {
    if ("string" != typeof e) throw new TypeError("First argument must be a string");
    if (!e) return [];
    n = n || {};
    var t = 1,
        o = 1;

    function r(e) {
      var n = e.match(kc);
      n && (t += n.length);
      var r = e.lastIndexOf("\n");
      o = ~r ? e.length - r : o + e.length;
    }

    function a() {
      var e = {
        line: t,
        column: o
      };
      return function (n) {
        return n.position = new l(e), s(), n;
      };
    }

    function l(e) {
      this.start = e, this.end = {
        line: t,
        column: o
      }, this.source = n.source;
    }

    function i(r) {
      var a = new Error(n.source + ":" + t + ":" + o + ": " + r);
      if (a.reason = r, a.filename = n.source, a.line = t, a.column = o, a.source = e, !n.silent) throw a;
    }

    function c(n) {
      var t = n.exec(e);

      if (t) {
        var o = t[0];
        return r(o), e = e.slice(o.length), t;
      }
    }

    function s() {
      c(vc);
    }

    function u(e) {
      var n;

      for (e = e || []; n = d();) {
        !1 !== n && e.push(n);
      }

      return e;
    }

    function d() {
      var n = a();

      if ("/" == e.charAt(0) && "*" == e.charAt(1)) {
        for (var t = 2; "" != e.charAt(t) && ("*" != e.charAt(t) || "/" != e.charAt(t + 1));) {
          ++t;
        }

        if (t += 2, "" === e.charAt(t - 1)) return i("End of comment missing");
        var l = e.slice(2, t - 2);
        return o += 2, r(l), e = e.slice(t), o += 2, n({
          type: "comment",
          comment: l
        });
      }
    }

    function f() {
      var e = a(),
          n = c(wc);

      if (n) {
        if (d(), !c(xc)) return i("property missing ':'");
        var t = c(Ac),
            o = e({
          type: "declaration",
          property: Cc(n[0].replace(yc, "")),
          value: t ? Cc(t[0].replace(yc, "")) : ""
        });
        return c(Sc), o;
      }
    }

    return l.prototype.content = e, s(), function () {
      var e,
          n = [];

      for (u(n); e = f();) {
        !1 !== e && (n.push(e), u(n));
      }

      return n;
    }();
  }(e), i = "function" == typeof n, c = 0, s = l.length; c < s; c++) {
    r = (t = l[c]).property, a = t.value, i ? n(r, a, t) : a && (o || (o = {}), o[r] = a);
  }

  return o;
};

var Tc = {}.hasOwnProperty,
    Mc = new Set(["table", "thead", "tbody", "tfoot", "tr"]);

function Oc(e, n) {
  var t = [];
  var o,
      r = -1;

  for (; ++r < n.children.length;) {
    o = n.children[r], "element" === o.type ? t.push(Dc(e, o, r, n)) : "text" === o.type ? "element" === n.type && Mc.has(n.tagName) && (l = void 0, "string" == typeof (l = (a = o) && "object" == _typeof(a) && "text" === a.type ? a.value || "" : a) && "" === l.replace(/[ \t\n\f\r]/g, "")) || t.push(o.value) : "raw" !== o.type || e.options.skipHtml || t.push(o.value);
  }

  var a, l;
  return t;
}

function Dc(e, n, t, o) {
  var r = e.options,
      a = e.schema,
      l = n.tagName,
      i = {};
  var c,
      s = a;
  if ("html" === a.space && "svg" === l && (s = _i, e.schema = s), n.properties) for (c in n.properties) {
    Tc.call(n.properties, c) && Pc(i, c, n.properties[c], e);
  }
  "ol" !== l && "ul" !== l || e.listDepth++;
  var u = Oc(e, n);
  "ol" !== l && "ul" !== l || e.listDepth--, e.schema = a;
  var d = n.position || {
    start: {
      line: null,
      column: null,
      offset: null
    },
    end: {
      line: null,
      column: null,
      offset: null
    }
  },
      p = r.components && Tc.call(r.components, l) ? r.components[l] : l,
      g = "string" == typeof p || p === f.Fragment;
  if (!bc.isValidElementType(p)) throw new TypeError("Component for name `".concat(l, "` not defined or is not renderable"));

  if (i.key = [l, d.start.line, d.start.column, t].join("-"), "a" === l && r.linkTarget && (i.target = "function" == typeof r.linkTarget ? r.linkTarget(String(i.href || ""), n.children, "string" == typeof i.title ? i.title : null) : r.linkTarget), "a" === l && r.transformLinkUri && (i.href = r.transformLinkUri(String(i.href || ""), n.children, "string" == typeof i.title ? i.title : null)), g || "code" !== l || "element" !== o.type || "pre" === o.tagName || (i.inline = !0), g || "h1" !== l && "h2" !== l && "h3" !== l && "h4" !== l && "h5" !== l && "h6" !== l || (i.level = Number.parseInt(l.charAt(1), 10)), "img" === l && r.transformImageUri && (i.src = r.transformImageUri(String(i.src || ""), String(i.alt || ""), "string" == typeof i.title ? i.title : null)), !g && "li" === l && "element" === o.type) {
    var _e19 = function (e) {
      var n = -1;

      for (; ++n < e.children.length;) {
        var _t11 = e.children[n];
        if ("element" === _t11.type && "input" === _t11.tagName) return _t11;
      }

      return null;
    }(n);

    i.checked = _e19 && _e19.properties ? Boolean(_e19.properties.checked) : null, i.index = Fc(o, n), i.ordered = "ol" === o.tagName;
  }

  var m;
  return g || "ol" !== l && "ul" !== l || (i.ordered = "ol" === l, i.depth = e.listDepth), "td" !== l && "th" !== l || (i.align && (i.style || (i.style = {}), i.style.textAlign = i.align, delete i.align), g || (i.isHeader = "th" === l)), g || "tr" !== l || "element" !== o.type || (i.isHeader = Boolean("thead" === o.tagName)), r.sourcePos && (i["data-sourcepos"] = [(m = d).start.line, ":", m.start.column, "-", m.end.line, ":", m.end.column].map(function (e) {
    return String(e);
  }).join("")), !g && r.rawSourcePos && (i.sourcePosition = n.position), !g && r.includeElementIndex && (i.index = Fc(o, n), i.siblingCount = Fc(o)), g || (i.node = n), u.length > 0 ? f.createElement(p, i, u) : f.createElement(p, i);
}

function Fc(e, n) {
  var t = -1,
      o = 0;

  for (; ++t < e.children.length && e.children[t] !== n;) {
    "element" === e.children[t].type && o++;
  }

  return o;
}

function Pc(e, n, t, o) {
  var r = function (e, n) {
    var t = ki(n);
    var o = n,
        r = vi;
    if (t in e.normal) return e.property[e.normal[t]];

    if (t.length > 4 && "data" === t.slice(0, 4) && Vi.test(n)) {
      if ("-" === n.charAt(4)) {
        var _e20 = n.slice(5).replace(Ji, Yi);

        o = "data" + _e20.charAt(0).toUpperCase() + _e20.slice(1);
      } else {
        var _e21 = n.slice(4);

        if (!Ji.test(_e21)) {
          var _t12 = _e21.replace(Ki, Qi);

          "-" !== _t12.charAt(0) && (_t12 = "-" + _t12), n = "data" + _t12;
        }
      }

      r = Fi;
    }

    return new r(o, n);
  }(o.schema, n);

  var a = t;
  var l, i, c;
  null != a && a == a && (Array.isArray(a) && (a = r.commaSeparated ? (c = i || {}, "" === (l = a)[l.length - 1] && (l = l.concat("")), l.join((c.padRight ? " " : "") + "," + (!1 === c.padLeft ? "" : " ")).trim()) : function (e) {
    return e.join(" ").trim();
  }(a)), "style" === r.property && "string" == typeof a && (a = function (e) {
    var n = {};

    try {
      zc(e, t);
    } catch (_unused) {}

    return n;

    function t(e, t) {
      var o = "-ms-" === e.slice(0, 4) ? "ms-".concat(e.slice(4)) : e;
      n[o.replace(/-([a-z])/g, Lc)] = t;
    }
  }(a)), r.space && r.property ? e[Tc.call(Gi, r.property) ? Gi[r.property] : r.property] = a : r.attribute && (e[r.attribute] = a));
}

function Lc(e, n) {
  return n.toUpperCase();
}

var Bc = {}.hasOwnProperty,
    Rc = {
  plugins: {
    to: "plugins",
    id: "change-plugins-to-remarkplugins"
  },
  renderers: {
    to: "components",
    id: "change-renderers-to-components"
  },
  astPlugins: {
    id: "remove-buggy-html-in-markdown-parser"
  },
  allowDangerousHtml: {
    id: "remove-buggy-html-in-markdown-parser"
  },
  escapeHtml: {
    id: "remove-buggy-html-in-markdown-parser"
  },
  source: {
    to: "children",
    id: "change-source-to-children"
  },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};

function Hc(e) {
  for (var _n14 in Rc) {
    if (Bc.call(Rc, _n14) && Bc.call(e, _n14)) {
      var _e22 = Rc[_n14];
      console.warn("[react-markdown] Warning: please ".concat(_e22.to ? "use `".concat(_e22.to, "` instead of") : "remove", " `").concat(_n14, "` (see <https://github.com/remarkjs/react-markdown/blob/main/changelog.md#").concat(_e22.id, "> for more info)")), delete Rc[_n14];
    }
  }

  var n = Ko().use(Ya).use(e.remarkPlugins || []).use(zl, _objectSpread(_objectSpread({}, e.remarkRehypeOptions), {}, {
    allowDangerousHtml: !0
  })).use(e.rehypePlugins || []).use(Zi, e),
      t = new vo();
  "string" == typeof e.children ? t.value = e.children : void 0 !== e.children && null !== e.children && console.warn("[react-markdown] Warning: please pass a string as `children` (not: `".concat(e.children, "`)"));
  var o = n.runSync(n.parse(t), t);
  if ("root" !== o.type) throw new TypeError("Expected a `root` node");
  var r = f.createElement(f.Fragment, {}, Oc({
    options: e,
    schema: Xi,
    listDepth: 0
  }, o));
  return e.className && (r = f.createElement("div", {
    className: e.className
  }, r)), r;
}

Hc.defaultProps = {
  transformLinkUri: function transformLinkUri(e) {
    var n = (e || "").trim(),
        t = n.charAt(0);
    if ("#" === t || "/" === t) return n;
    var o = n.indexOf(":");
    if (-1 === o) return n;
    var r = -1;

    for (; ++r < fo.length;) {
      var _e23 = fo[r];
      if (o === _e23.length && n.slice(0, _e23.length).toLowerCase() === _e23) return n;
    }

    return r = n.indexOf("?"), -1 !== r && o > r ? n : (r = n.indexOf("#"), -1 !== r && o > r ? n : "javascript:void(0)");
  }
}, Hc.propTypes = {
  children: hi.string,
  className: hi.string,
  allowElement: hi.func,
  allowedElements: hi.arrayOf(hi.string),
  disallowedElements: hi.arrayOf(hi.string),
  unwrapDisallowed: hi.bool,
  remarkPlugins: hi.arrayOf(hi.oneOfType([hi.object, hi.func, hi.arrayOf(hi.oneOfType([hi.bool, hi.string, hi.object, hi.func, hi.arrayOf(hi.any)]))])),
  rehypePlugins: hi.arrayOf(hi.oneOfType([hi.object, hi.func, hi.arrayOf(hi.oneOfType([hi.bool, hi.string, hi.object, hi.func, hi.arrayOf(hi.any)]))])),
  sourcePos: hi.bool,
  rawSourcePos: hi.bool,
  skipHtml: hi.bool,
  includeElementIndex: hi.bool,
  transformLinkUri: hi.oneOfType([hi.func, hi.bool]),
  linkTarget: hi.oneOfType([hi.func, hi.string]),
  transformImageUri: hi.func,
  components: hi.object
};
var Nc = {
  tokenize: function tokenize(e, n, t) {
    return function (n) {
      return e.consume(n), o;
    };

    function o(n) {
      return 87 === n || 119 === n ? (e.consume(n), r) : t(n);
    }

    function r(n) {
      return 87 === n || 119 === n ? (e.consume(n), a) : t(n);
    }

    function a(n) {
      return 46 === n ? (e.consume(n), l) : t(n);
    }

    function l(e) {
      return null === e || br(e) ? t(e) : n(e);
    }
  },
  partial: !0
},
    Ic = {
  tokenize: function tokenize(e, n, t) {
    var o, r;
    return a;

    function a(n) {
      return 38 === n ? e.check(qc, i, l)(n) : 46 === n || 95 === n ? e.check(Wc, i, l)(n) : null === n || mr(n) || kr(n) || 45 !== n && vr(n) ? i(n) : (e.consume(n), a);
    }

    function l(n) {
      return 46 === n ? (r = o, o = void 0, e.consume(n), a) : (95 === n && (o = !0), e.consume(n), a);
    }

    function i(e) {
      return r || o ? t(e) : n(e);
    }
  },
  partial: !0
},
    jc = {
  tokenize: function tokenize(e, n) {
    var t = 0;
    return o;

    function o(l) {
      return 38 === l ? e.check(qc, n, r)(l) : (40 === l && t++, 41 === l ? e.check(Wc, a, r)(l) : Xc(l) ? n(l) : Gc(l) ? e.check(Wc, n, r)(l) : (e.consume(l), o));
    }

    function r(n) {
      return e.consume(n), o;
    }

    function a(e) {
      return t--, t < 0 ? n(e) : r(e);
    }
  },
  partial: !0
},
    Wc = {
  tokenize: function tokenize(e, n, t) {
    return function (n) {
      return e.consume(n), o;
    };

    function o(r) {
      return Gc(r) ? (e.consume(r), o) : Xc(r) ? n(r) : t(r);
    }
  },
  partial: !0
},
    qc = {
  tokenize: function tokenize(e, n, t) {
    return function (n) {
      return e.consume(n), o;
    };

    function o(n) {
      return sr(n) ? (e.consume(n), o) : 59 === n ? (e.consume(n), r) : t(n);
    }

    function r(e) {
      return Xc(e) ? n(e) : t(e);
    }
  },
  partial: !0
},
    Uc = {
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return function (n) {
      if (87 !== n && 119 !== n || !Zc(o.previous) || ns(o.events)) return t(n);
      return e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(Nc, e.attempt(Ic, e.attempt(jc, r), t), t)(n);
    };

    function r(t) {
      return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), n(t);
    }
  },
  previous: Zc
},
    Vc = {
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return function (n) {
      if (72 !== n && 104 !== n || !$c(o.previous) || ns(o.events)) return t(n);
      return e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), e.consume(n), r;
    };

    function r(n) {
      return 84 === n || 116 === n ? (e.consume(n), a) : t(n);
    }

    function a(n) {
      return 84 === n || 116 === n ? (e.consume(n), l) : t(n);
    }

    function l(n) {
      return 80 === n || 112 === n ? (e.consume(n), i) : t(n);
    }

    function i(n) {
      return 83 === n || 115 === n ? (e.consume(n), c) : c(n);
    }

    function c(n) {
      return 58 === n ? (e.consume(n), s) : t(n);
    }

    function s(n) {
      return 47 === n ? (e.consume(n), u) : t(n);
    }

    function u(n) {
      return 47 === n ? (e.consume(n), d) : t(n);
    }

    function d(n) {
      return null === n || mr(n) || kr(n) || vr(n) ? t(n) : e.attempt(Ic, e.attempt(jc, f), t)(n);
    }

    function f(t) {
      return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), n(t);
    }
  },
  previous: $c
},
    Jc = {
  tokenize: function tokenize(e, n, t) {
    var o = this;
    var r, a;
    return function (n) {
      if (!_c(n) || !es(o.previous) || ns(o.events)) return t(n);
      return e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), l(n);
    };

    function l(n) {
      return _c(n) ? (e.consume(n), l) : 64 === n ? (e.consume(n), i) : t(n);
    }

    function i(n) {
      return 46 === n ? e.check(Wc, d, c)(n) : 45 === n || 95 === n ? e.check(Wc, t, s)(n) : fr(n) ? (!a && ur(n) && (a = !0), e.consume(n), i) : d(n);
    }

    function c(n) {
      return e.consume(n), r = !0, a = void 0, i;
    }

    function s(n) {
      return e.consume(n), u;
    }

    function u(n) {
      return 46 === n ? e.check(Wc, t, c)(n) : i(n);
    }

    function d(o) {
      return r && !a ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), n(o)) : t(o);
    }
  },
  previous: es
},
    Kc = {},
    Qc = {
  text: Kc
};
var Yc = 48;

for (; Yc < 123;) {
  Kc[Yc] = Jc, Yc++, 58 === Yc ? Yc = 65 : 91 === Yc && (Yc = 97);
}

function Gc(e) {
  return 33 === e || 34 === e || 39 === e || 41 === e || 42 === e || 44 === e || 46 === e || 58 === e || 59 === e || 60 === e || 63 === e || 95 === e || 126 === e;
}

function Xc(e) {
  return null === e || 60 === e || hr(e);
}

function _c(e) {
  return 43 === e || 45 === e || 46 === e || 95 === e || fr(e);
}

function Zc(e) {
  return null === e || 40 === e || 42 === e || 95 === e || 126 === e || hr(e);
}

function $c(e) {
  return null === e || !sr(e);
}

function es(e) {
  return 47 !== e && $c(e);
}

function ns(e) {
  var n = e.length,
      t = !1;

  for (; n--;) {
    var _o11 = e[n][1];

    if (("labelLink" === _o11.type || "labelImage" === _o11.type) && !_o11._balanced) {
      t = !0;
      break;
    }

    if (_o11._gfmAutolinkLiteralWalkedInto) {
      t = !1;
      break;
    }
  }

  return e.length > 0 && !t && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), t;
}

Kc[43] = Jc, Kc[45] = Jc, Kc[46] = Jc, Kc[95] = Jc, Kc[72] = [Jc, Vc], Kc[104] = [Jc, Vc], Kc[87] = [Jc, Uc], Kc[119] = [Jc, Uc];
var ts = {
  tokenize: function tokenize(e, n, t) {
    var o = this;
    return xr(e, function (e) {
      var r = o.events[o.events.length - 1];
      return r && "gfmFootnoteDefinitionIndent" === r[1].type && 4 === r[2].sliceSerialize(r[1], !0).length ? n(e) : t(e);
    }, "gfmFootnoteDefinitionIndent", 5);
  },
  partial: !0
};

function os(e, n, t) {
  var o = this;
  var r = o.events.length;
  var a = o.parser.gfmFootnotes || (o.parser.gfmFootnotes = []);
  var l;

  for (; r--;) {
    var _e24 = o.events[r][1];

    if ("labelImage" === _e24.type) {
      l = _e24;
      break;
    }

    if ("gfmFootnoteCall" === _e24.type || "labelLink" === _e24.type || "label" === _e24.type || "image" === _e24.type || "link" === _e24.type) break;
  }

  return function (r) {
    if (!l || !l._balanced) return t(r);
    var i = Xr(o.sliceSerialize({
      start: l.end,
      end: o.now()
    }));
    if (94 !== i.charCodeAt(0) || !a.includes(i.slice(1))) return t(r);
    return e.enter("gfmFootnoteCallLabelMarker"), e.consume(r), e.exit("gfmFootnoteCallLabelMarker"), n(r);
  };
}

function rs(e, n) {
  var t = e.length;

  for (; t--;) {
    if ("labelImage" === e[t][1].type && "enter" === e[t][0]) {
      e[t][1];
      break;
    }
  }

  e[t + 1][1].type = "data", e[t + 3][1].type = "gfmFootnoteCallLabelMarker";
  var o = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[t + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  },
      r = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[t + 3][1].end),
    end: Object.assign({}, e[t + 3][1].end)
  };
  r.end.column++, r.end.offset++, r.end._bufferIndex++;
  var a = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, r.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  },
      l = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, a.start),
    end: Object.assign({}, a.end)
  },
      i = [e[t + 1], e[t + 2], ["enter", o, n], e[t + 3], e[t + 4], ["enter", r, n], ["exit", r, n], ["enter", a, n], ["enter", l, n], ["exit", l, n], ["exit", a, n], e[e.length - 2], e[e.length - 1], ["exit", o, n]];
  return e.splice.apply(e, [t, e.length - t + 1].concat(i)), e;
}

function as(e, n, t) {
  var o = this,
      r = o.parser.gfmFootnotes || (o.parser.gfmFootnotes = []);
  var a,
      l = 0;
  return function (n) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(n), e.exit("gfmFootnoteCallLabelMarker"), i;
  };

  function i(n) {
    return 94 !== n ? t(n) : (e.enter("gfmFootnoteCallMarker"), e.consume(n), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", c);
  }

  function c(i) {
    var u;
    return null === i || 91 === i || l++ > 999 ? t(i) : 93 === i ? a ? (e.exit("chunkString"), u = e.exit("gfmFootnoteCallString"), r.includes(Xr(o.sliceSerialize(u))) ? function (t) {
      return e.enter("gfmFootnoteCallLabelMarker"), e.consume(t), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), n;
    }(i) : t(i)) : t(i) : (e.consume(i), hr(i) || (a = !0), 92 === i ? s : c);
  }

  function s(n) {
    return 91 === n || 92 === n || 93 === n ? (e.consume(n), l++, c) : c(n);
  }
}

function ls(e, n, t) {
  var o = this,
      r = o.parser.gfmFootnotes || (o.parser.gfmFootnotes = []);
  var a,
      l,
      i = 0;
  return function (n) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(n), e.exit("gfmFootnoteDefinitionLabelMarker"), c;
  };

  function c(n) {
    return 94 === n ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(n), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), s) : t(n);
  }

  function s(n) {
    var r;
    return null === n || 91 === n || i > 999 ? t(n) : 93 === n ? l ? (r = e.exit("gfmFootnoteDefinitionLabelString"), a = Xr(o.sliceSerialize(r)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(n), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), f) : t(n) : br(n) ? (e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), i++, s) : (e.enter("chunkString").contentType = "string", u(n));
  }

  function u(n) {
    return null === n || br(n) || 91 === n || 93 === n || i > 999 ? (e.exit("chunkString"), s(n)) : (hr(n) || (l = !0), i++, e.consume(n), 92 === n ? d : u);
  }

  function d(n) {
    return 91 === n || 92 === n || 93 === n ? (e.consume(n), i++, u) : u(n);
  }

  function f(n) {
    return 58 === n ? (e.enter("definitionMarker"), e.consume(n), e.exit("definitionMarker"), xr(e, p, "gfmFootnoteDefinitionWhitespace")) : t(n);
  }

  function p(e) {
    return r.includes(a) || r.push(a), n(e);
  }
}

function is(e, n, t) {
  return e.check(Dr, n, e.attempt(ts, n, t));
}

function cs(e) {
  e.exit("gfmFootnoteDefinition");
}

function ss() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var n = e.singleTilde;
  var t = {
    tokenize: function tokenize(e, t, o) {
      var r = this.previous,
          a = this.events;
      var l = 0;
      return function (n) {
        if (126 === r && "characterEscape" !== a[a.length - 1][1].type) return o(n);
        return e.enter("strikethroughSequenceTemporary"), i(n);
      };

      function i(a) {
        var c = Cr(r);
        if (126 === a) return l > 1 ? o(a) : (e.consume(a), l++, i);
        if (l < 2 && !n) return o(a);
        var s = e.exit("strikethroughSequenceTemporary"),
            u = Cr(a);
        return s._open = !u || 2 === u && Boolean(c), s._close = !c || 2 === c && Boolean(u), t(a);
      }
    },
    resolveAll: function resolveAll(e, n) {
      var t = -1;

      for (; ++t < e.length;) {
        if ("enter" === e[t][0] && "strikethroughSequenceTemporary" === e[t][1].type && e[t][1]._close) {
          var _o12 = t;

          for (; _o12--;) {
            if ("exit" === e[_o12][0] && "strikethroughSequenceTemporary" === e[_o12][1].type && e[_o12][1]._open && e[t][1].end.offset - e[t][1].start.offset == e[_o12][1].end.offset - e[_o12][1].start.offset) {
              e[t][1].type = "strikethroughSequence", e[_o12][1].type = "strikethroughSequence";
              var _r14 = {
                type: "strikethrough",
                start: Object.assign({}, e[_o12][1].start),
                end: Object.assign({}, e[t][1].end)
              },
                  _a12 = {
                type: "strikethroughText",
                start: Object.assign({}, e[_o12][1].end),
                end: Object.assign({}, e[t][1].start)
              },
                  _l8 = [["enter", _r14, n], ["enter", e[_o12][1], n], ["exit", e[_o12][1], n], ["enter", _a12, n]];
              or(_l8, _l8.length, 0, zr(n.parser.constructs.insideSpan["null"], e.slice(_o12 + 1, t), n)), or(_l8, _l8.length, 0, [["exit", _a12, n], ["enter", e[t][1], n], ["exit", e[t][1], n], ["exit", _r14, n]]), or(e, _o12 - 1, t - _o12 + 3, _l8), t = _o12 + _l8.length - 2;
              break;
            }
          }
        }
      }

      t = -1;

      for (; ++t < e.length;) {
        "strikethroughSequenceTemporary" === e[t][1].type && (e[t][1].type = "data");
      }

      return e;
    }
  };
  return null == n && (n = !0), {
    text: {
      126: t
    },
    insideSpan: {
      "null": [t]
    },
    attentionMarkers: {
      "null": [126]
    }
  };
}

var us = {
  flow: {
    "null": {
      tokenize: function tokenize(e, n, t) {
        var o = this,
            r = [];
        var a,
            l,
            i = 0;
        return function (n) {
          if (e.enter("table")._align = r, e.enter("tableHead"), e.enter("tableRow"), 124 === n) return c(n);
          return i++, e.enter("temporaryTableCellContent"), d(n);
        };

        function c(n) {
          return e.enter("tableCellDivider"), e.consume(n), e.exit("tableCellDivider"), a = !0, s;
        }

        function s(n) {
          return null === n || br(n) ? function (n) {
            if (null === n) return t(n);
            e.exit("tableRow"), e.exit("tableHead");
            var r = o.interrupt;
            return o.interrupt = !0, e.attempt({
              tokenize: T,
              partial: !0
            }, function (n) {
              return o.interrupt = r, e.enter("tableDelimiterRow"), p(n);
            }, function (e) {
              return o.interrupt = r, t(e);
            })(n);
          }(n) : yr(n) ? (e.enter("whitespace"), e.consume(n), u) : (a && (a = void 0, i++), 124 === n ? c(n) : (e.enter("temporaryTableCellContent"), d(n)));
        }

        function u(n) {
          return yr(n) ? (e.consume(n), u) : (e.exit("whitespace"), s(n));
        }

        function d(n) {
          return null === n || 124 === n || hr(n) ? (e.exit("temporaryTableCellContent"), s(n)) : (e.consume(n), 92 === n ? f : d);
        }

        function f(n) {
          return 92 === n || 124 === n ? (e.consume(n), d) : d(n);
        }

        function p(n) {
          return null === n || br(n) ? y(n) : yr(n) ? (e.enter("whitespace"), e.consume(n), g) : 45 === n ? (e.enter("tableDelimiterFiller"), e.consume(n), l = !0, r.push("none"), m) : 58 === n ? (e.enter("tableDelimiterAlignment"), e.consume(n), e.exit("tableDelimiterAlignment"), r.push("left"), h) : 124 === n ? (e.enter("tableCellDivider"), e.consume(n), e.exit("tableCellDivider"), p) : t(n);
        }

        function g(n) {
          return yr(n) ? (e.consume(n), g) : (e.exit("whitespace"), p(n));
        }

        function m(n) {
          return 45 === n ? (e.consume(n), m) : (e.exit("tableDelimiterFiller"), 58 === n ? (e.enter("tableDelimiterAlignment"), e.consume(n), e.exit("tableDelimiterAlignment"), r[r.length - 1] = "left" === r[r.length - 1] ? "center" : "right", b) : p(n));
        }

        function h(n) {
          return 45 === n ? (e.enter("tableDelimiterFiller"), e.consume(n), l = !0, m) : t(n);
        }

        function b(n) {
          return null === n || br(n) ? y(n) : yr(n) ? (e.enter("whitespace"), e.consume(n), g) : 124 === n ? (e.enter("tableCellDivider"), e.consume(n), e.exit("tableCellDivider"), p) : t(n);
        }

        function y(n) {
          return e.exit("tableDelimiterRow"), l && i === r.length ? null === n ? k(n) : e.check(ds, k, e.attempt({
            tokenize: T,
            partial: !0
          }, xr(e, v, "linePrefix", 4), k))(n) : t(n);
        }

        function k(t) {
          return e.exit("table"), n(t);
        }

        function v(n) {
          return e.enter("tableBody"), w(n);
        }

        function w(n) {
          return e.enter("tableRow"), 124 === n ? x(n) : (e.enter("temporaryTableCellContent"), E(n));
        }

        function x(n) {
          return e.enter("tableCellDivider"), e.consume(n), e.exit("tableCellDivider"), A;
        }

        function A(n) {
          return null === n || br(n) ? function (n) {
            if (e.exit("tableRow"), null === n) return z(n);
            return e.check(ds, z, e.attempt({
              tokenize: T,
              partial: !0
            }, xr(e, w, "linePrefix", 4), z))(n);
          }(n) : yr(n) ? (e.enter("whitespace"), e.consume(n), S) : 124 === n ? x(n) : (e.enter("temporaryTableCellContent"), E(n));
        }

        function S(n) {
          return yr(n) ? (e.consume(n), S) : (e.exit("whitespace"), A(n));
        }

        function E(n) {
          return null === n || 124 === n || hr(n) ? (e.exit("temporaryTableCellContent"), A(n)) : (e.consume(n), 92 === n ? C : E);
        }

        function C(n) {
          return 92 === n || 124 === n ? (e.consume(n), E) : E(n);
        }

        function z(n) {
          return e.exit("tableBody"), k(n);
        }

        function T(e, n, t) {
          return function (n) {
            return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), xr(e, r, "linePrefix");
          };

          function r(r) {
            if (o.parser.lazy[o.now().line] || null === r || br(r)) return t(r);
            var a = o.events[o.events.length - 1];
            return !o.parser.constructs.disable["null"].includes("codeIndented") && a && "linePrefix" === a[1].type && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(r) : (o._gfmTableDynamicInterruptHack = !0, e.check(o.parser.constructs.flow, function (e) {
              return o._gfmTableDynamicInterruptHack = !1, t(e);
            }, function (e) {
              return o._gfmTableDynamicInterruptHack = !1, n(e);
            })(r));
          }
        }
      },
      resolve: function resolve(e, n) {
        var t,
            o,
            r,
            a,
            l,
            i,
            c,
            s = -1;

        for (; ++s < e.length;) {
          var _u4 = e[s][1];

          if (r && ("temporaryTableCellContent" === _u4.type && (a = a || s, l = s), ("tableCellDivider" === _u4.type || "tableRow" === _u4.type) && l)) {
            var _t13 = {
              type: "tableContent",
              start: e[a][1].start,
              end: e[l][1].end
            },
                _o13 = {
              type: "chunkText",
              start: _t13.start,
              end: _t13.end,
              contentType: "text"
            };
            e.splice(a, l - a + 1, ["enter", _t13, n], ["enter", _o13, n], ["exit", _o13, n], ["exit", _t13, n]), s -= l - a - 3, a = void 0, l = void 0;
          }

          if ("exit" === e[s][0] && void 0 !== i && i + (c ? 0 : 1) < s && ("tableCellDivider" === _u4.type || "tableRow" === _u4.type && (i + 3 < s || "whitespace" !== e[i][1].type))) {
            var _r15 = {
              type: o ? "tableDelimiter" : t ? "tableHeader" : "tableData",
              start: e[i][1].start,
              end: e[s][1].end
            };
            e.splice(s + ("tableCellDivider" === _u4.type ? 1 : 0), 0, ["exit", _r15, n]), e.splice(i, 0, ["enter", _r15, n]), s += 2, i = s + 1, c = !0;
          }

          "tableRow" === _u4.type && (r = "enter" === e[s][0], r && (i = s + 1, c = !1)), "tableDelimiterRow" === _u4.type && (o = "enter" === e[s][0], o && (i = s + 1, c = !1)), "tableHead" === _u4.type && (t = "enter" === e[s][0]);
        }

        return e;
      }
    }
  }
},
    ds = {
  tokenize: function tokenize(e, n, t) {
    var o = 0;
    return function (n) {
      return e.enter("check"), e.consume(n), r;
    };

    function r(a) {
      return -1 === a || 32 === a ? (e.consume(a), o++, 4 === o ? n : r) : null === a || hr(a) ? n(a) : t(a);
    }
  },
  partial: !0
};
var fs = {
  text: {
    91: {
      tokenize: function tokenize(e, n, t) {
        var o = this;
        return function (n) {
          if (null !== o.previous || !o._gfmTasklistFirstContentOfListItem) return t(n);
          return e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(n), e.exit("taskListCheckMarker"), r;
        };

        function r(n) {
          return hr(n) ? (e.enter("taskListCheckValueUnchecked"), e.consume(n), e.exit("taskListCheckValueUnchecked"), a) : 88 === n || 120 === n ? (e.enter("taskListCheckValueChecked"), e.consume(n), e.exit("taskListCheckValueChecked"), a) : t(n);
        }

        function a(o) {
          return 93 === o ? (e.enter("taskListCheckMarker"), e.consume(o), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), e.check({
            tokenize: ps
          }, n, t)) : t(o);
        }
      }
    }
  }
};

function ps(e, n, t) {
  var o = this;
  return xr(e, function (e) {
    var r = o.events[o.events.length - 1];
    return (r && "whitespace" === r[1].type || br(e)) && null !== e ? n(e) : t(e);
  }, "whitespace");
}

function gs(e, n) {
  var t = String(e);
  if ("string" != typeof n) throw new TypeError("Expected character");
  var o = 0,
      r = t.indexOf(n);

  for (; -1 !== r;) {
    o++, r = t.indexOf(n, r + n.length);
  }

  return o;
}

var ms = function ms(e) {
  if (null == e) return bs;
  if ("string" == typeof e) return function (e) {
    return hs(n);

    function n(n) {
      return n && n.type === e;
    }
  }(e);
  if ("object" == _typeof(e)) return Array.isArray(e) ? function (e) {
    var n = [];
    var t = -1;

    for (; ++t < e.length;) {
      n[t] = ms(e[t]);
    }

    return hs(o);

    function o() {
      var t = -1;

      for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        e[_key8] = arguments[_key8];
      }

      for (; ++t < n.length;) {
        var _n$t2;

        if ((_n$t2 = n[t]).call.apply(_n$t2, [this].concat(e))) return !0;
      }

      return !1;
    }
  }(e) : function (e) {
    return hs(n);

    function n(n) {
      var t;

      for (t in e) {
        if (n[t] !== e[t]) return !1;
      }

      return !0;
    }
  }(e);
  if ("function" == typeof e) return hs(e);
  throw new Error("Expected function, string, or object as test");
};

function hs(e) {
  return function () {
    for (var _len9 = arguments.length, n = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      n[_key9] = arguments[_key9];
    }

    return Boolean(e.call.apply(e, [this].concat(n)));
  };
}

function bs() {
  return !0;
}

var ys = {}.hasOwnProperty,
    ks = function ks(e, n, t, o) {
  var r, a;
  "string" == typeof n || n instanceof RegExp ? (a = [[n, t]], r = o) : (a = n, r = t), r || (r = {});

  var l = ms(r.ignore || []),
      i = function (e) {
    var n = [];
    if ("object" != _typeof(e)) throw new TypeError("Expected array or object as schema");

    if (Array.isArray(e)) {
      var _t14 = -1;

      for (; ++_t14 < e.length;) {
        n.push([vs(e[_t14][0]), ws(e[_t14][1])]);
      }
    } else {
      var _t15;

      for (_t15 in e) {
        ys.call(e, _t15) && n.push([vs(_t15), ws(e[_t15])]);
      }
    }

    return n;
  }(a);

  var c = -1;

  for (; ++c < i.length;) {
    al(e, "text", s);
  }

  return e;

  function s(e, n) {
    var t,
        o = -1;

    for (; ++o < n.length;) {
      var _e25 = n[o];
      if (l(_e25, t ? t.children.indexOf(_e25) : void 0, t)) return;
      t = _e25;
    }

    if (t) return function (e, n) {
      var _t$children;

      var t = n[n.length - 1],
          o = i[c][0],
          r = i[c][1];
      var a = 0;
      var l = t.children.indexOf(e);
      var s,
          u = !1,
          d = [];
      o.lastIndex = 0;
      var f = o.exec(e.value);

      for (; f;) {
        var _d3;

        s = f.index;
        var _t16 = {
          index: f.index,
          input: f.input,
          stack: [].concat(_toConsumableArray(n), [e])
        };

        var _l9 = r.apply(void 0, _toConsumableArray(f).concat([_t16]));

        if ("string" == typeof _l9 && (_l9 = _l9.length > 0 ? {
          type: "text",
          value: _l9
        } : void 0), !1 !== _l9 && (a !== s && d.push({
          type: "text",
          value: e.value.slice(a, s)
        }), Array.isArray(_l9) ? (_d3 = d).push.apply(_d3, _toConsumableArray(_l9)) : _l9 && d.push(_l9), a = s + f[0].length, u = !0), !o.global) break;
        f = o.exec(e.value);
      }

      u ? (a < e.value.length && d.push({
        type: "text",
        value: e.value.slice(a)
      }), (_t$children = t.children).splice.apply(_t$children, [l, 1].concat(_toConsumableArray(d)))) : d = [e];
      return l + d.length;
    }(e, n);
  }
};

function vs(e) {
  return "string" == typeof e ? new RegExp(function (e) {
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }(e), "g") : e;
}

function ws(e) {
  return "function" == typeof e ? e : function () {
    return e;
  };
}

var xs = ["autolink", "link", "image", "label"],
    As = {
  transforms: [function (e) {
    ks(e, [[/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, Cs], [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, zs]], {
      ignore: ["link", "linkReference"]
    });
  }],
  enter: {
    literalAutolink: function literalAutolink(e) {
      this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
      }, e);
    },
    literalAutolinkEmail: Es,
    literalAutolinkHttp: Es,
    literalAutolinkWww: Es
  },
  exit: {
    literalAutolink: function literalAutolink(e) {
      this.exit(e);
    },
    literalAutolinkEmail: function literalAutolinkEmail(e) {
      this.config.exit.autolinkEmail.call(this, e);
    },
    literalAutolinkHttp: function literalAutolinkHttp(e) {
      this.config.exit.autolinkProtocol.call(this, e);
    },
    literalAutolinkWww: function literalAutolinkWww(e) {
      this.config.exit.data.call(this, e);
      this.stack[this.stack.length - 1].url = "http://" + this.sliceSerialize(e);
    }
  }
},
    Ss = {
  unsafe: [{
    character: "@",
    before: "[+\\-.\\w]",
    after: "[\\-.\\w]",
    inConstruct: "phrasing",
    notInConstruct: xs
  }, {
    character: ".",
    before: "[Ww]",
    after: "[\\-.\\w]",
    inConstruct: "phrasing",
    notInConstruct: xs
  }, {
    character: ":",
    before: "[ps]",
    after: "\\/",
    inConstruct: "phrasing",
    notInConstruct: xs
  }]
};

function Es(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}

function Cs(e, n, t, o, r) {
  var a = "";
  if (!Ts(r)) return !1;
  if (/^w/i.test(n) && (t = n + t, n = "", a = "http://"), !function (e) {
    var n = e.split(".");
    if (n.length < 2 || n[n.length - 1] && (/_/.test(n[n.length - 1]) || !/[a-zA-Z\d]/.test(n[n.length - 1])) || n[n.length - 2] && (/_/.test(n[n.length - 2]) || !/[a-zA-Z\d]/.test(n[n.length - 2]))) return !1;
    return !0;
  }(t)) return !1;

  var l = function (e) {
    var n = /[!"&'),.:;<>?\]}]+$/.exec(e);
    var t, o, r, a;
    if (n) for (e = e.slice(0, n.index), a = n[0], t = a.indexOf(")"), o = gs(e, "("), r = gs(e, ")"); -1 !== t && o > r;) {
      e += a.slice(0, t + 1), a = a.slice(t + 1), t = a.indexOf(")"), r++;
    }
    return [e, a];
  }(t + o);

  if (!l[0]) return !1;
  var i = {
    type: "link",
    title: null,
    url: a + n + l[0],
    children: [{
      type: "text",
      value: n + l[0]
    }]
  };
  return l[1] ? [i, {
    type: "text",
    value: l[1]
  }] : i;
}

function zs(e, n, t, o) {
  return !(!Ts(o, !0) || /[_-\d]$/.test(t)) && {
    type: "link",
    title: null,
    url: "mailto:" + n + "@" + t,
    children: [{
      type: "text",
      value: n + "@" + t
    }]
  };
}

function Ts(e, n) {
  var t = e.input.charCodeAt(e.index - 1);
  return (0 === e.index || kr(t) || vr(t)) && (!n || 47 !== t);
}

function Ms(e) {
  return e.label || !e.identifier ? e.label || "" : Ha(e.identifier);
}

function Os(e) {
  var n = e || {},
      t = n.now || {};
  var o = n.lineShift || 0,
      r = t.line || 1,
      a = t.column || 1;
  return {
    move: function move() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var n = e.split(/\r?\n|\r/g),
          t = n[n.length - 1];
      return r += n.length - 1, a = 1 === n.length ? a + t.length : 1 + t.length + o, e;
    },
    current: function current() {
      return {
        now: {
          line: r,
          column: a
        },
        lineShift: o
      };
    },
    shift: function shift(e) {
      o += e;
    }
  };
}

function Ds(e, n, t) {
  var o = n.indexStack,
      r = e.children || [],
      a = Os(t),
      l = [];
  var i = -1;

  for (o.push(-1); ++i < r.length;) {
    var _t17 = r[i];
    o[o.length - 1] = i, l.push(a.move(n.handle(_t17, e, n, _objectSpread({
      before: "\n",
      after: "\n"
    }, a.current())))), "list" !== _t17.type && (n.bulletLastUsed = void 0), i < r.length - 1 && l.push(a.move(c(_t17, r[i + 1])));
  }

  return o.pop(), l.join("");

  function c(t, o) {
    var r = n.join.length;

    for (; r--;) {
      var _a13 = n.join[r](t, o, e, n);

      if (!0 === _a13 || 1 === _a13) break;
      if ("number" == typeof _a13) return "\n".repeat(1 + _a13);
      if (!1 === _a13) return "\n\n\x3c!----\x3e\n\n";
    }

    return "\n\n";
  }
}

var Fs = /\r?\n|\r/g;

function Ps(e, n) {
  var t = [];
  var o,
      r = 0,
      a = 0;

  for (; o = Fs.exec(e);) {
    l(e.slice(r, o.index)), t.push(o[0]), r = o.index + o[0].length, a++;
  }

  return l(e.slice(r)), t.join("");

  function l(e) {
    t.push(n(e, a, !e));
  }
}

function Ls(e) {
  if (!e._compiled) {
    var _n15 = (e.atBreak ? "[\\r\\n][\\t ]*" : "") + (e.before ? "(?:" + e.before + ")" : "");

    e._compiled = new RegExp((_n15 ? "(" + _n15 + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(e.character) ? "\\" : "") + e.character + (e.after ? "(?:" + e.after + ")" : ""), "g");
  }

  return e._compiled;
}

function Bs(e, n) {
  return Rs(e, n.inConstruct, !0) && !Rs(e, n.notInConstruct, !1);
}

function Rs(e, n, t) {
  if (!n) return t;
  "string" == typeof n && (n = [n]);
  var o = -1;

  for (; ++o < n.length;) {
    if (e.includes(n[o])) return !0;
  }

  return !1;
}

function Hs(e, n, t) {
  var o = (t.before || "") + (n || "") + (t.after || ""),
      r = [],
      a = [],
      l = {};
  var i = -1;

  for (; ++i < e.unsafe.length;) {
    var _n16 = e.unsafe[i];
    if (!Bs(e.stack, _n16)) continue;

    var _t18 = Ls(_n16);

    var _a14 = void 0;

    for (; _a14 = _t18.exec(o);) {
      var _e26 = "before" in _n16 || Boolean(_n16.atBreak),
          _t19 = ("after" in _n16),
          _o14 = _a14.index + (_e26 ? _a14[1].length : 0);

      r.includes(_o14) ? (l[_o14].before && !_e26 && (l[_o14].before = !1), l[_o14].after && !_t19 && (l[_o14].after = !1)) : (r.push(_o14), l[_o14] = {
        before: _e26,
        after: _t19
      });
    }
  }

  r.sort(Ns);
  var c = t.before ? t.before.length : 0;
  var s = o.length - (t.after ? t.after.length : 0);

  for (i = -1; ++i < r.length;) {
    var _e27 = r[i];
    _e27 < c || _e27 >= s || _e27 + 1 < s && r[i + 1] === _e27 + 1 && l[_e27].after && !l[_e27 + 1].before && !l[_e27 + 1].after || r[i - 1] === _e27 - 1 && l[_e27].before && !l[_e27 - 1].before && !l[_e27 - 1].after || (c !== _e27 && a.push(Is(o.slice(c, _e27), "\\")), c = _e27, !/[!-/:-@[-`{-~]/.test(o.charAt(_e27)) || t.encode && t.encode.includes(o.charAt(_e27)) ? (a.push("&#x" + o.charCodeAt(_e27).toString(16).toUpperCase() + ";"), c++) : a.push("\\"));
  }

  return a.push(Is(o.slice(c, s), t.after)), a.join("");
}

function Ns(e, n) {
  return e - n;
}

function Is(e, n) {
  var t = /\\(?=[!-/:-@[-`{-~])/g,
      o = [],
      r = [],
      a = e + n;
  var l,
      i = -1,
      c = 0;

  for (; l = t.exec(a);) {
    o.push(l.index);
  }

  for (; ++i < o.length;) {
    c !== o[i] && r.push(e.slice(c, o[i])), r.push("\\"), c = o[i];
  }

  return r.push(e.slice(c)), r.join("");
}

function js() {
  return e.peek = function () {
    return "[";
  }, {
    unsafe: [{
      character: "[",
      inConstruct: ["phrasing", "label", "reference"]
    }],
    handlers: {
      footnoteDefinition: function footnoteDefinition(e, n, t, o) {
        var r = Os(o);
        var a = r.move("[^");
        var l = t.enter("footnoteDefinition"),
            i = t.enter("label");
        return a += r.move(Hs(t, Ms(e), _objectSpread(_objectSpread({}, r.current()), {}, {
          before: a,
          after: "]"
        }))), i(), a += r.move("]:" + (e.children && e.children.length > 0 ? " " : "")), r.shift(4), a += r.move(Ps(Ds(e, t, r.current()), function (e, n, t) {
          if (n) return (t ? "" : "    ") + e;
          return e;
        })), l(), a;
      },
      footnoteReference: e
    }
  };

  function e(e, n, t, o) {
    var r = Os(o);
    var a = r.move("[^");
    var l = t.enter("footnoteReference"),
        i = t.enter("reference");
    return a += r.move(Hs(t, Ms(e), _objectSpread(_objectSpread({}, r.current()), {}, {
      before: a,
      after: "]"
    }))), i(), l(), a += r.move("]"), a;
  }
}

function Ws(e, n, t) {
  var o = n.indexStack,
      r = e.children || [],
      a = [];
  var l = -1,
      i = t.before;
  o.push(-1);
  var c = Os(t);

  for (; ++l < r.length;) {
    var _s4 = r[l];

    var _u5 = void 0;

    if (o[o.length - 1] = l, l + 1 < r.length) {
      var _t20 = n.handle.handlers[r[l + 1].type];
      _t20 && _t20.peek && (_t20 = _t20.peek), _u5 = _t20 ? _t20(r[l + 1], e, n, _objectSpread({
        before: "",
        after: ""
      }, c.current())).charAt(0) : "";
    } else _u5 = t.after;

    a.length > 0 && ("\r" === i || "\n" === i) && "html" === _s4.type && (a[a.length - 1] = a[a.length - 1].replace(/(\r?\n|\r)$/, " "), i = " ", c = Os(t), c.move(a.join(""))), a.push(c.move(n.handle(_s4, e, n, _objectSpread(_objectSpread({}, c.current()), {}, {
      before: i,
      after: _u5
    })))), i = a[a.length - 1].slice(-1);
  }

  return o.pop(), a.join("");
}

var qs = {
  canContainEols: ["delete"],
  enter: {
    strikethrough: function strikethrough(e) {
      this.enter({
        type: "delete",
        children: []
      }, e);
    }
  },
  exit: {
    strikethrough: function strikethrough(e) {
      this.exit(e);
    }
  }
},
    Us = {
  unsafe: [{
    character: "~",
    inConstruct: "phrasing"
  }],
  handlers: {
    "delete": Vs
  }
};

function Vs(e, n, t, o) {
  var r = Os(o),
      a = t.enter("emphasis");
  var l = r.move("~~");
  return l += Ws(e, t, _objectSpread(_objectSpread({}, r.current()), {}, {
    before: l,
    after: "~"
  })), l += r.move("~~"), a(), l;
}

function Js(e, n, t) {
  var o = e.value || "",
      r = "`",
      a = -1;

  for (; new RegExp("(^|[^`])" + r + "([^`]|$)").test(o);) {
    r += "`";
  }

  for (/[^ \r\n]/.test(o) && (/^[ \r\n]/.test(o) && /[ \r\n]$/.test(o) || /^`|`$/.test(o)) && (o = " " + o + " "); ++a < t.unsafe.length;) {
    var _e28 = t.unsafe[a],
        _n17 = Ls(_e28);

    var _r16 = void 0;

    if (_e28.atBreak) for (; _r16 = _n17.exec(o);) {
      var _e29 = _r16.index;
      10 === o.charCodeAt(_e29) && 13 === o.charCodeAt(_e29 - 1) && _e29--, o = o.slice(0, _e29) + " " + o.slice(_r16.index + 1);
    }
  }

  return r + o + r;
}

function Ks(e) {
  return e.length;
}

function Qs(e) {
  var n = "string" == typeof e ? e.codePointAt(0) : 0;
  return 67 === n || 99 === n ? 99 : 76 === n || 108 === n ? 108 : 82 === n || 114 === n ? 114 : 0;
}

Vs.peek = function () {
  return "~";
}, Js.peek = function () {
  return "`";
};
var Ys = {
  enter: {
    table: function table(e) {
      var n = e._align;
      this.enter({
        type: "table",
        align: n.map(function (e) {
          return "none" === e ? null : e;
        }),
        children: []
      }, e), this.setData("inTable", !0);
    },
    tableData: Xs,
    tableHeader: Xs,
    tableRow: function tableRow(e) {
      this.enter({
        type: "tableRow",
        children: []
      }, e);
    }
  },
  exit: {
    codeText: function codeText(e) {
      var n = this.resume();
      this.getData("inTable") && (n = n.replace(/\\([\\|])/g, _s));
      this.stack[this.stack.length - 1].value = n, this.exit(e);
    },
    table: function table(e) {
      this.exit(e), this.setData("inTable");
    },
    tableData: Gs,
    tableHeader: Gs,
    tableRow: Gs
  }
};

function Gs(e) {
  this.exit(e);
}

function Xs(e) {
  this.enter({
    type: "tableCell",
    children: []
  }, e);
}

function _s(e, n) {
  return "|" === n ? n : e;
}

function Zs(e) {
  var n = e || {},
      t = n.tableCellPadding,
      o = n.tablePipeAlign,
      r = n.stringLength,
      a = t ? " " : "|";
  return {
    unsafe: [{
      character: "\r",
      inConstruct: "tableCell"
    }, {
      character: "\n",
      inConstruct: "tableCell"
    }, {
      atBreak: !0,
      character: "|",
      after: "[\t :-]"
    }, {
      character: "|",
      inConstruct: "tableCell"
    }, {
      atBreak: !0,
      character: ":",
      after: "-"
    }, {
      atBreak: !0,
      character: "-",
      after: "[:|-]"
    }],
    handlers: {
      table: function table(e, n, t, o) {
        return i(function (e, n, t) {
          var o = e.children;
          var r = -1;
          var a = [],
              l = n.enter("table");

          for (; ++r < o.length;) {
            a[r] = c(o[r], n, t);
          }

          return l(), a;
        }(e, t, o), e.align);
      },
      tableRow: function tableRow(e, n, t, o) {
        var r = i([c(e, t, o)]);
        return r.slice(0, r.indexOf("\n"));
      },
      tableCell: l,
      inlineCode: function inlineCode(e, n, t) {
        var o = Js(e, 0, t);
        t.stack.includes("tableCell") && (o = o.replace(/\|/g, "\\$&"));
        return o;
      }
    }
  };

  function l(e, n, t, o) {
    var r = t.enter("tableCell"),
        l = t.enter("phrasing"),
        i = Ws(e, t, _objectSpread(_objectSpread({}, o), {}, {
      before: a,
      after: a
    }));
    return l(), r(), i;
  }

  function i(e, n) {
    return function (e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var t = (n.align || []).concat(),
          o = n.stringLength || Ks,
          r = [],
          a = [],
          l = [],
          i = [];
      var c = 0,
          s = -1;

      for (; ++s < e.length;) {
        var _t21 = [],
            _r17 = [];

        var _d4 = -1;

        for (e[s].length > c && (c = e[s].length); ++_d4 < e[s].length;) {
          var _a15 = null == (u = e[s][_d4]) ? "" : String(u);

          if (!1 !== n.alignDelimiters) {
            var _e30 = o(_a15);

            _r17[_d4] = _e30, (void 0 === i[_d4] || _e30 > i[_d4]) && (i[_d4] = _e30);
          }

          _t21.push(_a15);
        }

        a[s] = _t21, l[s] = _r17;
      }

      var u;
      var d = -1;
      if ("object" == _typeof(t) && "length" in t) for (; ++d < c;) {
        r[d] = Qs(t[d]);
      } else {
        var _e31 = Qs(t);

        for (; ++d < c;) {
          r[d] = _e31;
        }
      }
      d = -1;
      var f = [],
          p = [];

      for (; ++d < c;) {
        var _e32 = r[d];
        var _t22 = "",
            _o15 = "";
        99 === _e32 ? (_t22 = ":", _o15 = ":") : 108 === _e32 ? _t22 = ":" : 114 === _e32 && (_o15 = ":");

        var _a16 = !1 === n.alignDelimiters ? 1 : Math.max(1, i[d] - _t22.length - _o15.length);

        var _l10 = _t22 + "-".repeat(_a16) + _o15;

        !1 !== n.alignDelimiters && (_a16 = _t22.length + _a16 + _o15.length, _a16 > i[d] && (i[d] = _a16), p[d] = _a16), f[d] = _l10;
      }

      a.splice(1, 0, f), l.splice(1, 0, p), s = -1;
      var g = [];

      for (; ++s < a.length;) {
        var _e33 = a[s],
            _t23 = l[s];
        d = -1;
        var _o16 = [];

        for (; ++d < c;) {
          var _a17 = _e33[d] || "";

          var _l11 = "",
              _s5 = "";

          if (!1 !== n.alignDelimiters) {
            var _e34 = i[d] - (_t23[d] || 0),
                _n18 = r[d];

            114 === _n18 ? _l11 = " ".repeat(_e34) : 99 === _n18 ? _e34 % 2 ? (_l11 = " ".repeat(_e34 / 2 + .5), _s5 = " ".repeat(_e34 / 2 - .5)) : (_l11 = " ".repeat(_e34 / 2), _s5 = _l11) : _s5 = " ".repeat(_e34);
          }

          !1 === n.delimiterStart || d || _o16.push("|"), !1 === n.padding || !1 === n.alignDelimiters && "" === _a17 || !1 === n.delimiterStart && !d || _o16.push(" "), !1 !== n.alignDelimiters && _o16.push(_l11), _o16.push(_a17), !1 !== n.alignDelimiters && _o16.push(_s5), !1 !== n.padding && _o16.push(" "), !1 === n.delimiterEnd && d === c - 1 || _o16.push("|");
        }

        g.push(!1 === n.delimiterEnd ? _o16.join("").replace(/ +$/, "") : _o16.join(""));
      }

      return g.join("\n");
    }(e, {
      align: n,
      alignDelimiters: o,
      padding: t,
      stringLength: r
    });
  }

  function c(e, n, t) {
    var o = e.children;
    var r = -1;
    var a = [],
        i = n.enter("tableRow");

    for (; ++r < o.length;) {
      a[r] = l(o[r], 0, n, t);
    }

    return i(), a;
  }
}

function $s(e, n, t, o) {
  var r = function (e) {
    var n = e.options.listItemIndent || "tab";
    if (1 === n || "1" === n) return "one";
    if ("tab" !== n && "one" !== n && "mixed" !== n) throw new Error("Cannot serialize items with `" + n + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return n;
  }(t);

  var a = t.bulletCurrent || function (e) {
    var n = e.options.bullet || "*";
    if ("*" !== n && "+" !== n && "-" !== n) throw new Error("Cannot serialize items with `" + n + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return n;
  }(t);

  n && "list" === n.type && n.ordered && (a = ("number" == typeof n.start && n.start > -1 ? n.start : 1) + (!1 === t.options.incrementListMarker ? 0 : n.children.indexOf(e)) + a);
  var l = a.length + 1;
  ("tab" === r || "mixed" === r && (n && "list" === n.type && n.spread || e.spread)) && (l = 4 * Math.ceil(l / 4));
  var i = Os(o);
  i.move(a + " ".repeat(l - a.length)), i.shift(l);
  var c = t.enter("listItem"),
      s = Ps(Ds(e, t, i.current()), function (e, n, t) {
    if (n) return (t ? "" : " ".repeat(l)) + e;
    return (t ? a : a + " ".repeat(l - a.length)) + e;
  });
  return c(), s;
}

var eu = {
  exit: {
    taskListCheckValueChecked: tu,
    taskListCheckValueUnchecked: tu,
    paragraph: function paragraph(e) {
      var n = this.stack[this.stack.length - 2],
          t = this.stack[this.stack.length - 1],
          o = n.children,
          r = t.children[0];
      var a,
          l = -1;

      if (n && "listItem" === n.type && "boolean" == typeof n.checked && r && "text" === r.type) {
        for (; ++l < o.length;) {
          var _e35 = o[l];

          if ("paragraph" === _e35.type) {
            a = _e35;
            break;
          }
        }

        a === t && (r.value = r.value.slice(1), 0 === r.value.length ? t.children.shift() : t.position && r.position && "number" == typeof r.position.start.offset && (r.position.start.column++, r.position.start.offset++, t.position.start = Object.assign({}, r.position.start)));
      }

      this.exit(e);
    }
  }
},
    nu = {
  unsafe: [{
    atBreak: !0,
    character: "-",
    after: "[:|-]"
  }],
  handlers: {
    listItem: function listItem(e, n, t, o) {
      var r = e.children[0],
          a = "boolean" == typeof e.checked && r && "paragraph" === r.type,
          l = "[" + (e.checked ? "x" : " ") + "] ",
          i = Os(o);
      a && i.move(l);
      var c = $s(e, n, t, _objectSpread(_objectSpread({}, o), i.current()));
      a && (c = c.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, function (e) {
        return e + l;
      }));
      return c;
    }
  }
};

function tu(e) {
  this.stack[this.stack.length - 2].checked = "taskListCheckValueChecked" === e.type;
}

function ou() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var n = this.data();

  function t(e, t) {
    (n[e] ? n[e] : n[e] = []).push(t);
  }

  t("micromarkExtensions", function (e) {
    return lr([Qc, {
      document: {
        91: {
          tokenize: ls,
          continuation: {
            tokenize: is
          },
          exit: cs
        }
      },
      text: {
        91: {
          tokenize: as
        },
        93: {
          add: "after",
          tokenize: os,
          resolveTo: rs
        }
      }
    }, ss(e), us, fs]);
  }(e)), t("fromMarkdownExtensions", [As, {
    enter: {
      gfmFootnoteDefinition: function gfmFootnoteDefinition(e) {
        this.enter({
          type: "footnoteDefinition",
          identifier: "",
          label: "",
          children: []
        }, e);
      },
      gfmFootnoteDefinitionLabelString: function gfmFootnoteDefinitionLabelString() {
        this.buffer();
      },
      gfmFootnoteCall: function gfmFootnoteCall(e) {
        this.enter({
          type: "footnoteReference",
          identifier: "",
          label: ""
        }, e);
      },
      gfmFootnoteCallString: function gfmFootnoteCallString() {
        this.buffer();
      }
    },
    exit: {
      gfmFootnoteDefinition: function gfmFootnoteDefinition(e) {
        this.exit(e);
      },
      gfmFootnoteDefinitionLabelString: function gfmFootnoteDefinitionLabelString(e) {
        var n = this.resume(),
            t = this.stack[this.stack.length - 1];
        t.label = n, t.identifier = Xr(this.sliceSerialize(e)).toLowerCase();
      },
      gfmFootnoteCall: function gfmFootnoteCall(e) {
        this.exit(e);
      },
      gfmFootnoteCallString: function gfmFootnoteCallString(e) {
        var n = this.resume(),
            t = this.stack[this.stack.length - 1];
        t.label = n, t.identifier = Xr(this.sliceSerialize(e)).toLowerCase();
      }
    }
  }, qs, Ys, eu]), t("toMarkdownExtensions", function (e) {
    return {
      extensions: [Ss, js(), Us, Zs(e), nu]
    };
  }(e));
}

var ru = function ru(e) {
  var o = n([ou], e.remarkPlugins || []);
  return f.createElement(Hc, t({}, e, {
    remarkPlugins: o,
    rawSourcePos: !0,
    skipHtml: !0
  }));
},
    au = function au(e, n) {
  var t = {};
  return Array.isArray(e) && e.forEach(function (e) {
    t[e] = null == n ? void 0 : n[e];
  }), t;
};

function lu(e) {
  if ("string" != typeof e) throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
}

function iu(e, n) {
  for (var t, o = "", r = 0, a = -1, l = 0, i = 0; i <= e.length; ++i) {
    if (i < e.length) t = e.charCodeAt(i);else {
      if (47 === t) break;
      t = 47;
    }

    if (47 === t) {
      if (a === i - 1 || 1 === l) ;else if (a !== i - 1 && 2 === l) {
        if (o.length < 2 || 2 !== r || 46 !== o.charCodeAt(o.length - 1) || 46 !== o.charCodeAt(o.length - 2)) if (o.length > 2) {
          var c = o.lastIndexOf("/");

          if (c !== o.length - 1) {
            -1 === c ? (o = "", r = 0) : r = (o = o.slice(0, c)).length - 1 - o.lastIndexOf("/"), a = i, l = 0;
            continue;
          }
        } else if (2 === o.length || 1 === o.length) {
          o = "", r = 0, a = i, l = 0;
          continue;
        }
        n && (o.length > 0 ? o += "/.." : o = "..", r = 2);
      } else o.length > 0 ? o += "/" + e.slice(a + 1, i) : o = e.slice(a + 1, i), r = i - a - 1;
      a = i, l = 0;
    } else 46 === t && -1 !== l ? ++l : l = -1;
  }

  return o;
}

var cu = {
  resolve: function resolve() {
    for (var e, n = "", t = !1, o = arguments.length - 1; o >= -1 && !t; o--) {
      var r;
      o >= 0 ? r = arguments[o] : (void 0 === e && (e = process.cwd()), r = e), lu(r), 0 !== r.length && (n = r + "/" + n, t = 47 === r.charCodeAt(0));
    }

    return n = iu(n, !t), t ? n.length > 0 ? "/" + n : "/" : n.length > 0 ? n : ".";
  },
  normalize: function normalize(e) {
    if (lu(e), 0 === e.length) return ".";
    var n = 47 === e.charCodeAt(0),
        t = 47 === e.charCodeAt(e.length - 1);
    return 0 !== (e = iu(e, !n)).length || n || (e = "."), e.length > 0 && t && (e += "/"), n ? "/" + e : e;
  },
  isAbsolute: function isAbsolute(e) {
    return lu(e), e.length > 0 && 47 === e.charCodeAt(0);
  },
  join: function join() {
    if (0 === arguments.length) return ".";

    for (var e, n = 0; n < arguments.length; ++n) {
      var t = arguments[n];
      lu(t), t.length > 0 && (void 0 === e ? e = t : e += "/" + t);
    }

    return void 0 === e ? "." : cu.normalize(e);
  },
  relative: function relative(e, n) {
    if (lu(e), lu(n), e === n) return "";
    if ((e = cu.resolve(e)) === (n = cu.resolve(n))) return "";

    for (var t = 1; t < e.length && 47 === e.charCodeAt(t); ++t) {
      ;
    }

    for (var o = e.length, r = o - t, a = 1; a < n.length && 47 === n.charCodeAt(a); ++a) {
      ;
    }

    for (var l = n.length - a, i = r < l ? r : l, c = -1, s = 0; s <= i; ++s) {
      if (s === i) {
        if (l > i) {
          if (47 === n.charCodeAt(a + s)) return n.slice(a + s + 1);
          if (0 === s) return n.slice(a + s);
        } else r > i && (47 === e.charCodeAt(t + s) ? c = s : 0 === s && (c = 0));

        break;
      }

      var u = e.charCodeAt(t + s);
      if (u !== n.charCodeAt(a + s)) break;
      47 === u && (c = s);
    }

    var d = "";

    for (s = t + c + 1; s <= o; ++s) {
      s !== o && 47 !== e.charCodeAt(s) || (0 === d.length ? d += ".." : d += "/..");
    }

    return d.length > 0 ? d + n.slice(a + c) : (a += c, 47 === n.charCodeAt(a) && ++a, n.slice(a));
  },
  _makeLong: function _makeLong(e) {
    return e;
  },
  dirname: function dirname(e) {
    if (lu(e), 0 === e.length) return ".";

    for (var n = e.charCodeAt(0), t = 47 === n, o = -1, r = !0, a = e.length - 1; a >= 1; --a) {
      if (47 === (n = e.charCodeAt(a))) {
        if (!r) {
          o = a;
          break;
        }
      } else r = !1;
    }

    return -1 === o ? t ? "/" : "." : t && 1 === o ? "//" : e.slice(0, o);
  },
  basename: function basename(e, n) {
    if (void 0 !== n && "string" != typeof n) throw new TypeError('"ext" argument must be a string');
    lu(e);
    var t,
        o = 0,
        r = -1,
        a = !0;

    if (void 0 !== n && n.length > 0 && n.length <= e.length) {
      if (n.length === e.length && n === e) return "";
      var l = n.length - 1,
          i = -1;

      for (t = e.length - 1; t >= 0; --t) {
        var c = e.charCodeAt(t);

        if (47 === c) {
          if (!a) {
            o = t + 1;
            break;
          }
        } else -1 === i && (a = !1, i = t + 1), l >= 0 && (c === n.charCodeAt(l) ? -1 == --l && (r = t) : (l = -1, r = i));
      }

      return o === r ? r = i : -1 === r && (r = e.length), e.slice(o, r);
    }

    for (t = e.length - 1; t >= 0; --t) {
      if (47 === e.charCodeAt(t)) {
        if (!a) {
          o = t + 1;
          break;
        }
      } else -1 === r && (a = !1, r = t + 1);
    }

    return -1 === r ? "" : e.slice(o, r);
  },
  extname: function extname(e) {
    lu(e);

    for (var n = -1, t = 0, o = -1, r = !0, a = 0, l = e.length - 1; l >= 0; --l) {
      var i = e.charCodeAt(l);
      if (47 !== i) -1 === o && (r = !1, o = l + 1), 46 === i ? -1 === n ? n = l : 1 !== a && (a = 1) : -1 !== n && (a = -1);else if (!r) {
        t = l + 1;
        break;
      }
    }

    return -1 === n || -1 === o || 0 === a || 1 === a && n === o - 1 && n === t + 1 ? "" : e.slice(n, o);
  },
  format: function format(e) {
    if (null === e || "object" != _typeof(e)) throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + _typeof(e));
    return function (e, n) {
      var t = n.dir || n.root,
          o = n.base || (n.name || "") + (n.ext || "");
      return t ? t === n.root ? t + o : t + e + o : o;
    }("/", e);
  },
  parse: function parse(e) {
    lu(e);
    var n = {
      root: "",
      dir: "",
      base: "",
      ext: "",
      name: ""
    };
    if (0 === e.length) return n;
    var t,
        o = e.charCodeAt(0),
        r = 47 === o;
    r ? (n.root = "/", t = 1) : t = 0;

    for (var a = -1, l = 0, i = -1, c = !0, s = e.length - 1, u = 0; s >= t; --s) {
      if (47 !== (o = e.charCodeAt(s))) -1 === i && (c = !1, i = s + 1), 46 === o ? -1 === a ? a = s : 1 !== u && (u = 1) : -1 !== a && (u = -1);else if (!c) {
        l = s + 1;
        break;
      }
    }

    return -1 === a || -1 === i || 0 === u || 1 === u && a === i - 1 && a === l + 1 ? -1 !== i && (n.base = n.name = 0 === l && r ? e.slice(1, i) : e.slice(l, i)) : (0 === l && r ? (n.name = e.slice(1, a), n.base = e.slice(1, i)) : (n.name = e.slice(l, a), n.base = e.slice(l, i)), n.ext = e.slice(a, i)), l > 0 ? n.dir = e.slice(0, l - 1) : r && (n.dir = "/"), n;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
cu.posix = cu;
var su,
    uu = cu;
!function (e) {
  e.navigate = "navigate", e.download = "download";
}(su || (su = {}));

var du,
    fu = function fu(e) {
  if (e.indexOf("://") > 0 || 0 === e.indexOf("//")) return !0;

  try {
    return new URL(document.baseURI).origin !== new URL(e, document.baseURI).origin;
  } catch (e) {
    return !1;
  }
},
    pu = function pu(e, n) {
  var t = n.baseUrls,
      o = n.queryParamString,
      r = n.linkAction,
      a = void 0 === r ? su.navigate : r;
  if (!e) return "";
  if (e.startsWith("#")) return e;
  if (e.startsWith("www.") && (e = location.protocol + "//" + e), fu(e)) return e;
  var l = uu.join(a === su.download && t["static"] ? t["static"] : location.origin, a !== su.download && t.root ? t.root : "");

  try {
    var i = new URL(uu.join(l, !e.startsWith("/") && t.relative ? t.relative : "", e));
    if (a === su.download && o) new URLSearchParams(o).forEach(function (e, n) {
      i.searchParams.append(n, e);
    });
    var c = i.searchParams.toString();
    return a === su.download ? i.href : i.pathname + (c ? "?" + c : "") + i.hash;
  } catch (e) {
    return;
  }
},
    gu = function gu(e, n) {
  var t;
  void 0 === n && (n = "smooth");

  try {
    var o = e.replace(/^#/, "");
    null === (t = document.getElementById(o)) || void 0 === t || t.scrollIntoView({
      behavior: n
    });
  } catch (e) {}
},
    mu = function mu(e, n) {
  void 0 === n && (n = !0), e.startsWith("#") && (window.history.replaceState(null, "", e), n && gu(e));
},
    hu = "Link-module_link__UHm69",
    bu = "Link-module_icon__9evus",
    yu = "Link-module_imageLink__2S_wP",
    ku = su.navigate,
    vu = function vu(e) {
  var n = e.href,
      o = void 0 === n ? "" : n,
      r = e.children,
      a = e.target,
      l = e.action,
      i = e.external,
      c = e.isImageLink,
      s = le(),
      u = g(Bt).config,
      d = void 0 === u ? {} : u,
      p = d.baseUrls,
      m = void 0 === p ? {} : p,
      b = d.queryParamString,
      y = su[l] ? l : ku,
      k = pu(o, {
    linkAction: l,
    baseUrls: m,
    queryParamString: b
  }) || "",
      v = h(function (e) {
    var n = e.detail,
        t = n.href,
        o = void 0 === t ? "" : t,
        r = n.target,
        a = n.external;
    if ("_blank" !== r) return o.startsWith("#") ? (e.preventDefault(), void mu(o)) : void (a || fu(o) || (e.preventDefault(), s.push(o)));
  }, []),
      w = {
    href: k,
    fontSize: "inherit",
    external: null != i ? i : fu(k),
    target: a
  };
  return y === su.download ? f.createElement("a", {
    href: k,
    className: hu,
    rel: "noopener noreferrer",
    target: "_blank",
    download: !0
  }, r, " ", f.createElement("span", {
    className: bu
  }, f.createElement(L, {
    name: "download",
    size: "inherit"
  }))) : c ? f.createElement("a", {
    className: yu,
    href: w.href,
    "data-image": c,
    target: w.external ? "_blank" : w.target,
    rel: "noopener noreferrer"
  }, r) : f.createElement(S, t({}, w, {
    onFollow: v
  }), r);
},
    wu = "Children-module_children__2bLTY",
    xu = "Children-module_normal__3gGwH";

!function (e) {
  e.LIST = "list", e.NORMAL = "normal";
}(du || (du = {}));

var Au,
    Su,
    Eu = function Eu(n) {
  var t = n.depth,
      o = n.variant,
      r = void 0 === o ? du.LIST : o,
      a = g(Bt).config,
      l = void 0 === a ? {} : a,
      i = l.contentLayout,
      c = function c(n, o) {
    return void 0 === o && (o = 0), o += 1, n && f.createElement("ul", {
      className: (1 === o ? wu : "") + " " + (r === du.NORMAL ? xu : "")
    }, n.map(function (n, r) {
      var a = n.title;

      if ("object" == _typeof(a)) {
        var i = void 0;
        (i = null == a ? void 0 : a[l.locale || ""]) || (i = null == a ? void 0 : a[e.DefaultLocale]), a = i;
      }

      return a || (a = n.path), f.createElement("li", {
        key: n.path + "_" + (r + 1)
      }, f.createElement(vu, {
        href: n.path
      }, a), o < (t || 0) ? c(n.navigation, o) : null);
    }));
  };

  return i ? c(i) : null;
},
    Cu = function Cu(e) {
  if (!e) return {};
  var n = t({}, e);
  return Object.keys(n).forEach(function (e) {
    "true" === n[e] && (n[e] = !0), "false" === n[e] && (n[e] = !1), function (e) {
      if ("number" == typeof e) return !0;
      if ("string" != typeof e) return !1;
      var n = parseFloat(e);
      return !isNaN(Number(e)) && (n || 0 === n);
    }(n[e]) && (n[e] = parseFloat(n[e]));
  }), n;
};

!function (e) {
  e.TEXT = "textDirective", e.LEAF = "leafDirective", e.CONTAINER = "containerDirective";
}(Au || (Au = {})), function (e) {
  e.CODE = "code", e.LINK = "link", e.BUTTON = "button", e.PARAM = "param", e.ASSET_URL = "assetUrl", e.ALERT = "alert", e.EXPAND = "expand", e.CHILDREN = "children", e.VIDEO = "video", e.TABS = "tabs", e.TAB = "tab";
}(Su || (Su = {}));

var zu = function () {
  function e() {}

  return e.prototype.process = function (e) {
    (e.data || (e.data = {})).hName = this.hName, this.appendNodeProperties(e, t(t({}, Cu(e.attributes)), {
      directive: {
        type: e.type,
        name: e.name
      }
    }));
  }, e.prototype.appendNodeProperties = function (e, n) {
    var o = e.data || (e.data = {});
    o.hProperties = t(t({}, o.hProperties), n);
  }, e;
}(),
    Tu = "ErrorMessage-module_errorMessage__MI3aQ",
    Mu = "ErrorMessage-module_message__21NGn",
    Ou = {
  generic: "Content error",
  unknownDirective: "Unknown directive",
  invalidDirectiveType: "Invalid directive type",
  childDirectiveDependency: "Missing child directive"
},
    Du = function Du(e) {
  var n = e.type,
      t = void 0 === n ? "generic" : n,
      o = e.message;
  return f.createElement("div", {
    className: Tu
  }, f.createElement(O, {
    header: Ou[t] || Ou.generic,
    type: "error"
  }, f.createElement(j, null, f.createElement("pre", {
    className: Mu,
    "data-testid": "strategy-error-message"
  }, o))));
},
    Fu = de(function (e) {
  e.exports = function (e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }, e.exports["default"] = e.exports, e.exports.__esModule = !0;
}),
    Pu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "black",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      maxHeight: "inherit",
      height: "inherit",
      padding: "0 1em",
      display: "block",
      overflow: "auto"
    },
    'pre[class*="language-"]': {
      color: "black",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      position: "relative",
      margin: ".5em 0",
      overflow: "visible",
      padding: "0",
      backgroundColor: "#fdfdfd",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box",
      marginBottom: "1em"
    },
    'pre[class*="language-"]>code': {
      position: "relative",
      borderLeft: "10px solid #358ccb",
      boxShadow: "-1px 0px 0px 0px #358ccb, 0px 0px 0px 1px #dfdfdf",
      backgroundColor: "#fdfdfd",
      backgroundImage: "linear-gradient(transparent 50%, rgba(69, 142, 209, 0.04) 50%)",
      backgroundSize: "3em 3em",
      backgroundOrigin: "content-box",
      backgroundAttachment: "local"
    },
    ':not(pre) > code[class*="language-"]': {
      backgroundColor: "#fdfdfd",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box",
      marginBottom: "1em",
      position: "relative",
      padding: ".2em",
      borderRadius: "0.3em",
      color: "#c92c2c",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      display: "inline",
      whiteSpace: "normal"
    },
    'pre[class*="language-"]:before': {
      content: "''",
      zIndex: "-2",
      display: "block",
      position: "absolute",
      bottom: "0.75em",
      left: "0.18em",
      width: "40%",
      height: "20%",
      maxHeight: "13em",
      boxShadow: "0px 13px 8px #979797",
      WebkitTransform: "rotate(-2deg)",
      MozTransform: "rotate(-2deg)",
      msTransform: "rotate(-2deg)",
      OTransform: "rotate(-2deg)",
      transform: "rotate(-2deg)"
    },
    'pre[class*="language-"]:after': {
      content: "''",
      zIndex: "-2",
      display: "block",
      position: "absolute",
      bottom: "0.75em",
      left: "auto",
      width: "40%",
      height: "20%",
      maxHeight: "13em",
      boxShadow: "0px 13px 8px #979797",
      WebkitTransform: "rotate(2deg)",
      MozTransform: "rotate(2deg)",
      msTransform: "rotate(2deg)",
      OTransform: "rotate(2deg)",
      transform: "rotate(2deg)",
      right: "0.75em"
    },
    comment: {
      color: "#7D8B99"
    },
    "block-comment": {
      color: "#7D8B99"
    },
    prolog: {
      color: "#7D8B99"
    },
    doctype: {
      color: "#7D8B99"
    },
    cdata: {
      color: "#7D8B99"
    },
    punctuation: {
      color: "#5F6364"
    },
    property: {
      color: "#c92c2c"
    },
    tag: {
      color: "#c92c2c"
    },
    "boolean": {
      color: "#c92c2c"
    },
    number: {
      color: "#c92c2c"
    },
    "function-name": {
      color: "#c92c2c"
    },
    constant: {
      color: "#c92c2c"
    },
    symbol: {
      color: "#c92c2c"
    },
    deleted: {
      color: "#c92c2c"
    },
    selector: {
      color: "#2f9c0a"
    },
    "attr-name": {
      color: "#2f9c0a"
    },
    string: {
      color: "#2f9c0a"
    },
    "char": {
      color: "#2f9c0a"
    },
    "function": {
      color: "#2f9c0a"
    },
    builtin: {
      color: "#2f9c0a"
    },
    inserted: {
      color: "#2f9c0a"
    },
    operator: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    entity: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)",
      cursor: "help"
    },
    url: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    variable: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    atrule: {
      color: "#1990b8"
    },
    "attr-value": {
      color: "#1990b8"
    },
    keyword: {
      color: "#1990b8"
    },
    "class-name": {
      color: "#1990b8"
    },
    regex: {
      color: "#e90"
    },
    important: {
      color: "#e90",
      fontWeight: "normal"
    },
    ".language-css .token.string": {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    ".style .token.string": {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    namespace: {
      Opacity: ".7"
    },
    'pre[class*="language-"].line-numbers.line-numbers': {
      paddingLeft: "0"
    },
    'pre[class*="language-"].line-numbers.line-numbers code': {
      paddingLeft: "3.8em"
    },
    'pre[class*="language-"].line-numbers.line-numbers .line-numbers-rows': {
      left: "0"
    },
    'pre[class*="language-"][data-line]': {
      paddingTop: "0",
      paddingBottom: "0",
      paddingLeft: "0"
    },
    "pre[data-line] code": {
      position: "relative",
      paddingLeft: "4em"
    },
    "pre .line-highlight": {
      marginTop: "0"
    }
  };
}),
    Lu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "white",
      background: "none",
      textShadow: "0 -.1em .2em black",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "white",
      background: "hsl(30, 20%, 25%)",
      textShadow: "0 -.1em .2em black",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      border: ".3em solid hsl(30, 20%, 40%)",
      borderRadius: ".5em",
      boxShadow: "1px 1px .5em black inset"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "hsl(30, 20%, 25%)",
      padding: ".15em .2em .05em",
      borderRadius: ".3em",
      border: ".13em solid hsl(30, 20%, 40%)",
      boxShadow: "1px 1px .3em -.1em black inset",
      whiteSpace: "normal"
    },
    comment: {
      color: "hsl(30, 20%, 50%)"
    },
    prolog: {
      color: "hsl(30, 20%, 50%)"
    },
    doctype: {
      color: "hsl(30, 20%, 50%)"
    },
    cdata: {
      color: "hsl(30, 20%, 50%)"
    },
    punctuation: {
      Opacity: ".7"
    },
    namespace: {
      Opacity: ".7"
    },
    property: {
      color: "hsl(350, 40%, 70%)"
    },
    tag: {
      color: "hsl(350, 40%, 70%)"
    },
    "boolean": {
      color: "hsl(350, 40%, 70%)"
    },
    number: {
      color: "hsl(350, 40%, 70%)"
    },
    constant: {
      color: "hsl(350, 40%, 70%)"
    },
    symbol: {
      color: "hsl(350, 40%, 70%)"
    },
    selector: {
      color: "hsl(75, 70%, 60%)"
    },
    "attr-name": {
      color: "hsl(75, 70%, 60%)"
    },
    string: {
      color: "hsl(75, 70%, 60%)"
    },
    "char": {
      color: "hsl(75, 70%, 60%)"
    },
    builtin: {
      color: "hsl(75, 70%, 60%)"
    },
    inserted: {
      color: "hsl(75, 70%, 60%)"
    },
    operator: {
      color: "hsl(40, 90%, 60%)"
    },
    entity: {
      color: "hsl(40, 90%, 60%)",
      cursor: "help"
    },
    url: {
      color: "hsl(40, 90%, 60%)"
    },
    ".language-css .token.string": {
      color: "hsl(40, 90%, 60%)"
    },
    ".style .token.string": {
      color: "hsl(40, 90%, 60%)"
    },
    variable: {
      color: "hsl(40, 90%, 60%)"
    },
    atrule: {
      color: "hsl(350, 40%, 70%)"
    },
    "attr-value": {
      color: "hsl(350, 40%, 70%)"
    },
    keyword: {
      color: "hsl(350, 40%, 70%)"
    },
    regex: {
      color: "#e90"
    },
    important: {
      color: "#e90",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    deleted: {
      color: "red"
    }
  };
}),
    Bu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "black",
      color: "white",
      boxShadow: "-.3em 0 0 .3em black, .3em 0 0 .3em black"
    },
    'pre[class*="language-"]': {
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: ".4em .8em",
      margin: ".5em 0",
      overflow: "auto",
      background: 'url(\'data:image/svg+xml;charset=utf-8,<svg%20version%3D"1.1"%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"100"%20height%3D"100"%20fill%3D"rgba(0%2C0%2C0%2C.2)">%0D%0A<polygon%20points%3D"0%2C50%2050%2C0%200%2C0"%20%2F>%0D%0A<polygon%20points%3D"0%2C100%2050%2C100%20100%2C50%20100%2C0"%20%2F>%0D%0A<%2Fsvg>\')',
      backgroundSize: "1em 1em"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".2em",
      borderRadius: ".3em",
      boxShadow: "none",
      whiteSpace: "normal"
    },
    comment: {
      color: "#aaa"
    },
    prolog: {
      color: "#aaa"
    },
    doctype: {
      color: "#aaa"
    },
    cdata: {
      color: "#aaa"
    },
    punctuation: {
      color: "#999"
    },
    namespace: {
      Opacity: ".7"
    },
    property: {
      color: "#0cf"
    },
    tag: {
      color: "#0cf"
    },
    "boolean": {
      color: "#0cf"
    },
    number: {
      color: "#0cf"
    },
    constant: {
      color: "#0cf"
    },
    symbol: {
      color: "#0cf"
    },
    selector: {
      color: "yellow"
    },
    "attr-name": {
      color: "yellow"
    },
    string: {
      color: "yellow"
    },
    "char": {
      color: "yellow"
    },
    builtin: {
      color: "yellow"
    },
    operator: {
      color: "yellowgreen"
    },
    entity: {
      color: "yellowgreen",
      cursor: "help"
    },
    url: {
      color: "yellowgreen"
    },
    ".language-css .token.string": {
      color: "yellowgreen"
    },
    variable: {
      color: "yellowgreen"
    },
    inserted: {
      color: "yellowgreen"
    },
    atrule: {
      color: "deeppink"
    },
    "attr-value": {
      color: "deeppink"
    },
    keyword: {
      color: "deeppink"
    },
    regex: {
      color: "orange"
    },
    important: {
      color: "orange",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    deleted: {
      color: "red"
    },
    "pre.diff-highlight.diff-highlight > code .token.deleted:not(.prefix)": {
      backgroundColor: "rgba(255, 0, 0, .3)",
      display: "inline"
    },
    "pre > code.diff-highlight.diff-highlight .token.deleted:not(.prefix)": {
      backgroundColor: "rgba(255, 0, 0, .3)",
      display: "inline"
    },
    "pre.diff-highlight.diff-highlight > code .token.inserted:not(.prefix)": {
      backgroundColor: "rgba(0, 255, 128, .3)",
      display: "inline"
    },
    "pre > code.diff-highlight.diff-highlight .token.inserted:not(.prefix)": {
      backgroundColor: "rgba(0, 255, 128, .3)",
      display: "inline"
    }
  };
}),
    Ru = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#f8f8f2",
      background: "none",
      textShadow: "0 1px rgba(0, 0, 0, 0.3)",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#f8f8f2",
      background: "#272822",
      textShadow: "0 1px rgba(0, 0, 0, 0.3)",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      borderRadius: "0.3em"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#272822",
      padding: ".1em",
      borderRadius: ".3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "#8292a2"
    },
    prolog: {
      color: "#8292a2"
    },
    doctype: {
      color: "#8292a2"
    },
    cdata: {
      color: "#8292a2"
    },
    punctuation: {
      color: "#f8f8f2"
    },
    namespace: {
      Opacity: ".7"
    },
    property: {
      color: "#f92672"
    },
    tag: {
      color: "#f92672"
    },
    constant: {
      color: "#f92672"
    },
    symbol: {
      color: "#f92672"
    },
    deleted: {
      color: "#f92672"
    },
    "boolean": {
      color: "#ae81ff"
    },
    number: {
      color: "#ae81ff"
    },
    selector: {
      color: "#a6e22e"
    },
    "attr-name": {
      color: "#a6e22e"
    },
    string: {
      color: "#a6e22e"
    },
    "char": {
      color: "#a6e22e"
    },
    builtin: {
      color: "#a6e22e"
    },
    inserted: {
      color: "#a6e22e"
    },
    operator: {
      color: "#f8f8f2"
    },
    entity: {
      color: "#f8f8f2",
      cursor: "help"
    },
    url: {
      color: "#f8f8f2"
    },
    ".language-css .token.string": {
      color: "#f8f8f2"
    },
    ".style .token.string": {
      color: "#f8f8f2"
    },
    variable: {
      color: "#f8f8f2"
    },
    atrule: {
      color: "#e6db74"
    },
    "attr-value": {
      color: "#e6db74"
    },
    "function": {
      color: "#e6db74"
    },
    "class-name": {
      color: "#e6db74"
    },
    keyword: {
      color: "#66d9ef"
    },
    regex: {
      color: "#fd971f"
    },
    important: {
      color: "#fd971f",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    }
  };
}),
    Hu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#657b83",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#657b83",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      borderRadius: "0.3em",
      backgroundColor: "#fdf6e3"
    },
    'pre[class*="language-"]::-moz-selection': {
      background: "#073642"
    },
    'pre[class*="language-"] ::-moz-selection': {
      background: "#073642"
    },
    'code[class*="language-"]::-moz-selection': {
      background: "#073642"
    },
    'code[class*="language-"] ::-moz-selection': {
      background: "#073642"
    },
    'pre[class*="language-"]::selection': {
      background: "#073642"
    },
    'pre[class*="language-"] ::selection': {
      background: "#073642"
    },
    'code[class*="language-"]::selection': {
      background: "#073642"
    },
    'code[class*="language-"] ::selection': {
      background: "#073642"
    },
    ':not(pre) > code[class*="language-"]': {
      backgroundColor: "#fdf6e3",
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#93a1a1"
    },
    prolog: {
      color: "#93a1a1"
    },
    doctype: {
      color: "#93a1a1"
    },
    cdata: {
      color: "#93a1a1"
    },
    punctuation: {
      color: "#586e75"
    },
    namespace: {
      Opacity: ".7"
    },
    property: {
      color: "#268bd2"
    },
    tag: {
      color: "#268bd2"
    },
    "boolean": {
      color: "#268bd2"
    },
    number: {
      color: "#268bd2"
    },
    constant: {
      color: "#268bd2"
    },
    symbol: {
      color: "#268bd2"
    },
    deleted: {
      color: "#268bd2"
    },
    selector: {
      color: "#2aa198"
    },
    "attr-name": {
      color: "#2aa198"
    },
    string: {
      color: "#2aa198"
    },
    "char": {
      color: "#2aa198"
    },
    builtin: {
      color: "#2aa198"
    },
    url: {
      color: "#2aa198"
    },
    inserted: {
      color: "#2aa198"
    },
    entity: {
      color: "#657b83",
      background: "#eee8d5",
      cursor: "help"
    },
    atrule: {
      color: "#859900"
    },
    "attr-value": {
      color: "#859900"
    },
    keyword: {
      color: "#859900"
    },
    "function": {
      color: "#b58900"
    },
    "class-name": {
      color: "#b58900"
    },
    regex: {
      color: "#cb4b16"
    },
    important: {
      color: "#cb4b16",
      fontWeight: "bold"
    },
    variable: {
      color: "#cb4b16"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    }
  };
}),
    Nu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#ccc",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#ccc",
      background: "#2d2d2d",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#2d2d2d",
      padding: ".1em",
      borderRadius: ".3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "#999"
    },
    "block-comment": {
      color: "#999"
    },
    prolog: {
      color: "#999"
    },
    doctype: {
      color: "#999"
    },
    cdata: {
      color: "#999"
    },
    punctuation: {
      color: "#ccc"
    },
    tag: {
      color: "#e2777a"
    },
    "attr-name": {
      color: "#e2777a"
    },
    namespace: {
      color: "#e2777a"
    },
    deleted: {
      color: "#e2777a"
    },
    "function-name": {
      color: "#6196cc"
    },
    "boolean": {
      color: "#f08d49"
    },
    number: {
      color: "#f08d49"
    },
    "function": {
      color: "#f08d49"
    },
    property: {
      color: "#f8c555"
    },
    "class-name": {
      color: "#f8c555"
    },
    constant: {
      color: "#f8c555"
    },
    symbol: {
      color: "#f8c555"
    },
    selector: {
      color: "#cc99cd"
    },
    important: {
      color: "#cc99cd",
      fontWeight: "bold"
    },
    atrule: {
      color: "#cc99cd"
    },
    keyword: {
      color: "#cc99cd"
    },
    builtin: {
      color: "#cc99cd"
    },
    string: {
      color: "#7ec699"
    },
    "char": {
      color: "#7ec699"
    },
    "attr-value": {
      color: "#7ec699"
    },
    regex: {
      color: "#7ec699"
    },
    variable: {
      color: "#7ec699"
    },
    operator: {
      color: "#67cdcc"
    },
    entity: {
      color: "#67cdcc",
      cursor: "help"
    },
    url: {
      color: "#67cdcc"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    inserted: {
      color: "green"
    }
  };
}),
    Iu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "white",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      textShadow: "0 -.1em .2em black",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "white",
      background: "hsl(0, 0%, 8%)",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      textShadow: "0 -.1em .2em black",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      borderRadius: ".5em",
      border: ".3em solid hsl(0, 0%, 33%)",
      boxShadow: "1px 1px .5em black inset",
      margin: ".5em 0",
      overflow: "auto",
      padding: "1em"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "hsl(0, 0%, 8%)",
      borderRadius: ".3em",
      border: ".13em solid hsl(0, 0%, 33%)",
      boxShadow: "1px 1px .3em -.1em black inset",
      padding: ".15em .2em .05em",
      whiteSpace: "normal"
    },
    'pre[class*="language-"]::-moz-selection': {
      background: "hsla(0, 0%, 93%, 0.15)",
      textShadow: "none"
    },
    'pre[class*="language-"]::selection': {
      background: "hsla(0, 0%, 93%, 0.15)",
      textShadow: "none"
    },
    'pre[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "hsla(0, 0%, 93%, 0.15)"
    },
    'code[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "hsla(0, 0%, 93%, 0.15)"
    },
    'code[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "hsla(0, 0%, 93%, 0.15)"
    },
    'pre[class*="language-"] ::selection': {
      textShadow: "none",
      background: "hsla(0, 0%, 93%, 0.15)"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "hsla(0, 0%, 93%, 0.15)"
    },
    'code[class*="language-"] ::selection': {
      textShadow: "none",
      background: "hsla(0, 0%, 93%, 0.15)"
    },
    comment: {
      color: "hsl(0, 0%, 47%)"
    },
    prolog: {
      color: "hsl(0, 0%, 47%)"
    },
    doctype: {
      color: "hsl(0, 0%, 47%)"
    },
    cdata: {
      color: "hsl(0, 0%, 47%)"
    },
    punctuation: {
      Opacity: ".7"
    },
    namespace: {
      Opacity: ".7"
    },
    tag: {
      color: "hsl(14, 58%, 55%)"
    },
    "boolean": {
      color: "hsl(14, 58%, 55%)"
    },
    number: {
      color: "hsl(14, 58%, 55%)"
    },
    deleted: {
      color: "hsl(14, 58%, 55%)"
    },
    keyword: {
      color: "hsl(53, 89%, 79%)"
    },
    property: {
      color: "hsl(53, 89%, 79%)"
    },
    selector: {
      color: "hsl(53, 89%, 79%)"
    },
    constant: {
      color: "hsl(53, 89%, 79%)"
    },
    symbol: {
      color: "hsl(53, 89%, 79%)"
    },
    builtin: {
      color: "hsl(53, 89%, 79%)"
    },
    "attr-name": {
      color: "hsl(76, 21%, 52%)"
    },
    "attr-value": {
      color: "hsl(76, 21%, 52%)"
    },
    string: {
      color: "hsl(76, 21%, 52%)"
    },
    "char": {
      color: "hsl(76, 21%, 52%)"
    },
    operator: {
      color: "hsl(76, 21%, 52%)"
    },
    entity: {
      color: "hsl(76, 21%, 52%)",
      cursor: "help"
    },
    url: {
      color: "hsl(76, 21%, 52%)"
    },
    ".language-css .token.string": {
      color: "hsl(76, 21%, 52%)"
    },
    ".style .token.string": {
      color: "hsl(76, 21%, 52%)"
    },
    variable: {
      color: "hsl(76, 21%, 52%)"
    },
    inserted: {
      color: "hsl(76, 21%, 52%)"
    },
    atrule: {
      color: "hsl(218, 22%, 55%)"
    },
    regex: {
      color: "hsl(42, 75%, 65%)"
    },
    important: {
      color: "hsl(42, 75%, 65%)",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    "pre[data-line]": {
      padding: "1em 0 1em 3em",
      position: "relative"
    },
    ".language-markup .token.tag": {
      color: "hsl(33, 33%, 52%)"
    },
    ".language-markup .token.attr-name": {
      color: "hsl(33, 33%, 52%)"
    },
    ".language-markup .token.punctuation": {
      color: "hsl(33, 33%, 52%)"
    },
    "": {
      position: "relative",
      zIndex: "1"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, hsla(0, 0%, 33%, .1) 70%, hsla(0, 0%, 33%, 0))",
      borderBottom: "1px dashed hsl(0, 0%, 33%)",
      borderTop: "1px dashed hsl(0, 0%, 33%)",
      left: "0",
      lineHeight: "inherit",
      marginTop: "0.75em",
      padding: "inherit 0",
      pointerEvents: "none",
      position: "absolute",
      right: "0",
      whiteSpace: "pre",
      zIndex: "0"
    },
    ".line-highlight:before": {
      backgroundColor: "hsl(215, 15%, 59%)",
      borderRadius: "999px",
      boxShadow: "0 1px white",
      color: "hsl(24, 20%, 95%)",
      content: "attr(data-start)",
      font: "bold 65%/1.5 sans-serif",
      left: ".6em",
      minWidth: "1em",
      padding: "0 .5em",
      position: "absolute",
      textAlign: "center",
      textShadow: "none",
      top: ".4em",
      verticalAlign: ".3em"
    },
    ".line-highlight[data-end]:after": {
      backgroundColor: "hsl(215, 15%, 59%)",
      borderRadius: "999px",
      boxShadow: "0 1px white",
      color: "hsl(24, 20%, 95%)",
      content: "attr(data-end)",
      font: "bold 65%/1.5 sans-serif",
      left: ".6em",
      minWidth: "1em",
      padding: "0 .5em",
      position: "absolute",
      textAlign: "center",
      textShadow: "none",
      top: "auto",
      verticalAlign: ".3em",
      bottom: ".4em"
    }
  };
}),
    ju = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "black",
      background: "none",
      textShadow: "0 1px white",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "black",
      background: "#f5f2f0",
      textShadow: "0 1px white",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    'pre[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#b3d4fc"
    },
    'pre[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#b3d4fc"
    },
    'code[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#b3d4fc"
    },
    'code[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#b3d4fc"
    },
    'pre[class*="language-"]::selection': {
      textShadow: "none",
      background: "#b3d4fc"
    },
    'pre[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#b3d4fc"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "#b3d4fc"
    },
    'code[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#b3d4fc"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#f5f2f0",
      padding: ".1em",
      borderRadius: ".3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "slategray"
    },
    prolog: {
      color: "slategray"
    },
    doctype: {
      color: "slategray"
    },
    cdata: {
      color: "slategray"
    },
    punctuation: {
      color: "#999"
    },
    namespace: {
      Opacity: ".7"
    },
    property: {
      color: "#905"
    },
    tag: {
      color: "#905"
    },
    "boolean": {
      color: "#905"
    },
    number: {
      color: "#905"
    },
    constant: {
      color: "#905"
    },
    symbol: {
      color: "#905"
    },
    deleted: {
      color: "#905"
    },
    selector: {
      color: "#690"
    },
    "attr-name": {
      color: "#690"
    },
    string: {
      color: "#690"
    },
    "char": {
      color: "#690"
    },
    builtin: {
      color: "#690"
    },
    inserted: {
      color: "#690"
    },
    operator: {
      color: "#9a6e3a",
      background: "hsla(0, 0%, 100%, .5)"
    },
    entity: {
      color: "#9a6e3a",
      background: "hsla(0, 0%, 100%, .5)",
      cursor: "help"
    },
    url: {
      color: "#9a6e3a",
      background: "hsla(0, 0%, 100%, .5)"
    },
    ".language-css .token.string": {
      color: "#9a6e3a",
      background: "hsla(0, 0%, 100%, .5)"
    },
    ".style .token.string": {
      color: "#9a6e3a",
      background: "hsla(0, 0%, 100%, .5)"
    },
    atrule: {
      color: "#07a"
    },
    "attr-value": {
      color: "#07a"
    },
    keyword: {
      color: "#07a"
    },
    "function": {
      color: "#DD4A68"
    },
    "class-name": {
      color: "#DD4A68"
    },
    regex: {
      color: "#e90"
    },
    important: {
      color: "#e90",
      fontWeight: "bold"
    },
    variable: {
      color: "#e90"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    }
  };
}),
    Wu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#f8f8f2",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#f8f8f2",
      background: "#2b2b2b",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: "0.5em 0",
      overflow: "auto",
      borderRadius: "0.3em"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#2b2b2b",
      padding: "0.1em",
      borderRadius: "0.3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "#d4d0ab"
    },
    prolog: {
      color: "#d4d0ab"
    },
    doctype: {
      color: "#d4d0ab"
    },
    cdata: {
      color: "#d4d0ab"
    },
    punctuation: {
      color: "#fefefe"
    },
    property: {
      color: "#ffa07a"
    },
    tag: {
      color: "#ffa07a"
    },
    constant: {
      color: "#ffa07a"
    },
    symbol: {
      color: "#ffa07a"
    },
    deleted: {
      color: "#ffa07a"
    },
    "boolean": {
      color: "#00e0e0"
    },
    number: {
      color: "#00e0e0"
    },
    selector: {
      color: "#abe338"
    },
    "attr-name": {
      color: "#abe338"
    },
    string: {
      color: "#abe338"
    },
    "char": {
      color: "#abe338"
    },
    builtin: {
      color: "#abe338"
    },
    inserted: {
      color: "#abe338"
    },
    operator: {
      color: "#00e0e0"
    },
    entity: {
      color: "#00e0e0",
      cursor: "help"
    },
    url: {
      color: "#00e0e0"
    },
    ".language-css .token.string": {
      color: "#00e0e0"
    },
    ".style .token.string": {
      color: "#00e0e0"
    },
    variable: {
      color: "#00e0e0"
    },
    atrule: {
      color: "#ffd700"
    },
    "attr-value": {
      color: "#ffd700"
    },
    "function": {
      color: "#ffd700"
    },
    keyword: {
      color: "#00e0e0"
    },
    regex: {
      color: "#ffd700"
    },
    important: {
      color: "#ffd700",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    }
  };
}),
    qu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#c5c8c6",
      textShadow: "0 1px rgba(0, 0, 0, 0.3)",
      fontFamily: "Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#c5c8c6",
      textShadow: "0 1px rgba(0, 0, 0, 0.3)",
      fontFamily: "Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      borderRadius: "0.3em",
      background: "#1d1f21"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#1d1f21",
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#7C7C7C"
    },
    prolog: {
      color: "#7C7C7C"
    },
    doctype: {
      color: "#7C7C7C"
    },
    cdata: {
      color: "#7C7C7C"
    },
    punctuation: {
      color: "#c5c8c6"
    },
    ".namespace": {
      Opacity: ".7"
    },
    property: {
      color: "#96CBFE"
    },
    keyword: {
      color: "#96CBFE"
    },
    tag: {
      color: "#96CBFE"
    },
    "class-name": {
      color: "#FFFFB6",
      textDecoration: "underline"
    },
    "boolean": {
      color: "#99CC99"
    },
    constant: {
      color: "#99CC99"
    },
    symbol: {
      color: "#f92672"
    },
    deleted: {
      color: "#f92672"
    },
    number: {
      color: "#FF73FD"
    },
    selector: {
      color: "#A8FF60"
    },
    "attr-name": {
      color: "#A8FF60"
    },
    string: {
      color: "#A8FF60"
    },
    "char": {
      color: "#A8FF60"
    },
    builtin: {
      color: "#A8FF60"
    },
    inserted: {
      color: "#A8FF60"
    },
    variable: {
      color: "#C6C5FE"
    },
    operator: {
      color: "#EDEDED"
    },
    entity: {
      color: "#FFFFB6",
      cursor: "help"
    },
    url: {
      color: "#96CBFE"
    },
    ".language-css .token.string": {
      color: "#87C38A"
    },
    ".style .token.string": {
      color: "#87C38A"
    },
    atrule: {
      color: "#F9EE98"
    },
    "attr-value": {
      color: "#F9EE98"
    },
    "function": {
      color: "#DAD085"
    },
    regex: {
      color: "#E9C062"
    },
    important: {
      color: "#fd971f",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    }
  };
}),
    Uu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#f5f7ff",
      color: "#5e6687"
    },
    'pre[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#f5f7ff",
      color: "#5e6687",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    'pre[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#dfe2f1"
    },
    'pre[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#dfe2f1"
    },
    'code[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#dfe2f1"
    },
    'code[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#dfe2f1"
    },
    'pre[class*="language-"]::selection': {
      textShadow: "none",
      background: "#dfe2f1"
    },
    'pre[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#dfe2f1"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "#dfe2f1"
    },
    'code[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#dfe2f1"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#898ea4"
    },
    prolog: {
      color: "#898ea4"
    },
    doctype: {
      color: "#898ea4"
    },
    cdata: {
      color: "#898ea4"
    },
    punctuation: {
      color: "#5e6687"
    },
    namespace: {
      Opacity: ".7"
    },
    operator: {
      color: "#c76b29"
    },
    "boolean": {
      color: "#c76b29"
    },
    number: {
      color: "#c76b29"
    },
    property: {
      color: "#c08b30"
    },
    tag: {
      color: "#3d8fd1"
    },
    string: {
      color: "#22a2c9"
    },
    selector: {
      color: "#6679cc"
    },
    "attr-name": {
      color: "#c76b29"
    },
    entity: {
      color: "#22a2c9",
      cursor: "help"
    },
    url: {
      color: "#22a2c9"
    },
    ".language-css .token.string": {
      color: "#22a2c9"
    },
    ".style .token.string": {
      color: "#22a2c9"
    },
    "attr-value": {
      color: "#ac9739"
    },
    keyword: {
      color: "#ac9739"
    },
    control: {
      color: "#ac9739"
    },
    directive: {
      color: "#ac9739"
    },
    unit: {
      color: "#ac9739"
    },
    statement: {
      color: "#22a2c9"
    },
    regex: {
      color: "#22a2c9"
    },
    atrule: {
      color: "#22a2c9"
    },
    placeholder: {
      color: "#3d8fd1"
    },
    variable: {
      color: "#3d8fd1"
    },
    deleted: {
      textDecoration: "line-through"
    },
    inserted: {
      borderBottom: "1px dotted #202746",
      textDecoration: "none"
    },
    italic: {
      fontStyle: "italic"
    },
    important: {
      fontWeight: "bold",
      color: "#c94922"
    },
    bold: {
      fontWeight: "bold"
    },
    "pre > code.highlight": {
      Outline: "0.4em solid #c94922",
      OutlineOffset: ".4em"
    },
    ".line-numbers .line-numbers-rows": {
      borderRightColor: "#dfe2f1"
    },
    ".line-numbers-rows > span:before": {
      color: "#979db4"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0))"
    }
  };
}),
    Vu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#fff",
      textShadow: "0 1px 1px #000",
      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      direction: "ltr",
      textAlign: "left",
      wordSpacing: "normal",
      whiteSpace: "pre",
      wordWrap: "normal",
      lineHeight: "1.4",
      background: "none",
      border: "0",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#fff",
      textShadow: "0 1px 1px #000",
      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      direction: "ltr",
      textAlign: "left",
      wordSpacing: "normal",
      whiteSpace: "pre",
      wordWrap: "normal",
      lineHeight: "1.4",
      background: "#222",
      border: "0",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "15px",
      margin: "1em 0",
      overflow: "auto",
      MozBorderRadius: "8px",
      WebkitBorderRadius: "8px",
      borderRadius: "8px"
    },
    'pre[class*="language-"] code': {
      "float": "left",
      padding: "0 15px 0 0"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#222",
      padding: "5px 10px",
      lineHeight: "1",
      MozBorderRadius: "3px",
      WebkitBorderRadius: "3px",
      borderRadius: "3px"
    },
    comment: {
      color: "#797979"
    },
    prolog: {
      color: "#797979"
    },
    doctype: {
      color: "#797979"
    },
    cdata: {
      color: "#797979"
    },
    selector: {
      color: "#fff"
    },
    operator: {
      color: "#fff"
    },
    punctuation: {
      color: "#fff"
    },
    namespace: {
      Opacity: ".7"
    },
    tag: {
      color: "#ffd893"
    },
    "boolean": {
      color: "#ffd893"
    },
    atrule: {
      color: "#B0C975"
    },
    "attr-value": {
      color: "#B0C975"
    },
    hex: {
      color: "#B0C975"
    },
    string: {
      color: "#B0C975"
    },
    property: {
      color: "#c27628"
    },
    entity: {
      color: "#c27628",
      cursor: "help"
    },
    url: {
      color: "#c27628"
    },
    "attr-name": {
      color: "#c27628"
    },
    keyword: {
      color: "#c27628"
    },
    regex: {
      color: "#9B71C6"
    },
    "function": {
      color: "#e5a638"
    },
    constant: {
      color: "#e5a638"
    },
    variable: {
      color: "#fdfba8"
    },
    number: {
      color: "#8799B0"
    },
    important: {
      color: "#E45734"
    },
    deliminator: {
      color: "#E45734"
    },
    "pre[data-line]": {
      position: "relative",
      padding: "1em 0 1em 3em"
    },
    ".line-highlight": {
      position: "absolute",
      left: "0",
      right: "0",
      marginTop: "1em",
      background: "rgba(255, 255, 255, .2)",
      pointerEvents: "none",
      lineHeight: "inherit",
      whiteSpace: "pre"
    },
    ".line-highlight:before": {
      content: "attr(data-start)",
      position: "absolute",
      top: ".3em",
      left: ".6em",
      minWidth: "1em",
      padding: "0 .5em",
      backgroundColor: "rgba(255, 255, 255, .3)",
      color: "#fff",
      font: "bold 65%/1.5 sans-serif",
      textAlign: "center",
      MozBorderRadius: "8px",
      WebkitBorderRadius: "8px",
      borderRadius: "8px",
      textShadow: "none"
    },
    ".line-highlight[data-end]:after": {
      content: "attr(data-end)",
      position: "absolute",
      top: "auto",
      left: ".6em",
      minWidth: "1em",
      padding: "0 .5em",
      backgroundColor: "rgba(255, 255, 255, .3)",
      color: "#fff",
      font: "bold 65%/1.5 sans-serif",
      textAlign: "center",
      MozBorderRadius: "8px",
      WebkitBorderRadius: "8px",
      borderRadius: "8px",
      textShadow: "none",
      bottom: ".4em"
    },
    ".line-numbers-rows": {
      margin: "0"
    },
    ".line-numbers-rows span": {
      paddingRight: "10px",
      borderRight: "3px #d9d336 solid"
    }
  };
}),
    Ju = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#111b27",
      background: "none",
      fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#111b27",
      background: "#e3e9f2",
      fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: "0.5em 0",
      overflow: "auto"
    },
    'pre[class*="language-"]::-moz-selection': {
      background: "#ccd6e4"
    },
    'pre[class*="language-"] ::-moz-selection': {
      background: "#ccd6e4"
    },
    'code[class*="language-"]::-moz-selection': {
      background: "#ccd6e4"
    },
    'code[class*="language-"] ::-moz-selection': {
      background: "#ccd6e4"
    },
    'pre[class*="language-"]::selection': {
      background: "#ccd6e4"
    },
    'pre[class*="language-"] ::selection': {
      background: "#ccd6e4"
    },
    'code[class*="language-"]::selection': {
      background: "#ccd6e4"
    },
    'code[class*="language-"] ::selection': {
      background: "#ccd6e4"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#e3e9f2",
      padding: "0.1em 0.3em",
      borderRadius: "0.3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "#304259",
      fontStyle: "italic"
    },
    prolog: {
      color: "#304259",
      fontStyle: "italic"
    },
    doctype: {
      color: "#304259",
      fontStyle: "italic"
    },
    cdata: {
      color: "#304259",
      fontStyle: "italic"
    },
    punctuation: {
      color: "#111b27"
    },
    selector: {
      color: "#007474"
    },
    tag: {
      color: "#007474"
    },
    "attr-name": {
      color: "#7d6600"
    },
    "boolean": {
      color: "#7d6600"
    },
    number: {
      color: "#7d6600"
    },
    constant: {
      color: "#7d6600"
    },
    "pseudo-class": {
      color: "#7d6600"
    },
    "pseudo-element": {
      color: "#7d6600"
    },
    "selector.attribute": {
      color: "#7d6600"
    },
    "class-name": {
      color: "#005c99"
    },
    key: {
      color: "#005c99"
    },
    parameter: {
      color: "#005c99"
    },
    property: {
      color: "#005c99"
    },
    "property-access": {
      color: "#005c99"
    },
    variable: {
      color: "#005c99"
    },
    "attr-value": {
      color: "#237800"
    },
    inserted: {
      color: "#237800"
    },
    color: {
      color: "#237800"
    },
    "selector.value": {
      color: "#237800"
    },
    string: {
      color: "#237800"
    },
    "string.url-link": {
      color: "#237800"
    },
    builtin: {
      color: "#b800b8"
    },
    "keyword-array": {
      color: "#b800b8"
    },
    "package": {
      color: "#b800b8"
    },
    regex: {
      color: "#b800b8"
    },
    "function": {
      color: "#8600c6"
    },
    "selector.class": {
      color: "#8600c6"
    },
    "selector.id": {
      color: "#8600c6"
    },
    "atrule.rule": {
      color: "#aa4d00"
    },
    combinator: {
      color: "#aa4d00"
    },
    keyword: {
      color: "#aa4d00"
    },
    operator: {
      color: "#aa4d00"
    },
    unit: {
      color: "#aa4d00"
    },
    deleted: {
      color: "#bf0100"
    },
    important: {
      color: "#bf0100",
      fontWeight: "bold"
    },
    "keyword-this": {
      color: "#005c99",
      fontWeight: "bold"
    },
    "this": {
      color: "#005c99",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    entity: {
      cursor: "help"
    },
    ".language-markdown .token.title": {
      color: "#005c99",
      fontWeight: "bold"
    },
    ".language-markdown .token.title .token.punctuation": {
      color: "#005c99",
      fontWeight: "bold"
    },
    ".language-markdown .token.code": {
      color: "#007474"
    },
    ".language-markdown .token.url > .token.content": {
      color: "#237800"
    },
    ".language-markdown .token.url-link": {
      color: "#7d6600"
    },
    ".language-markdown .token.list.punctuation": {
      color: "#b800b8"
    },
    ".language-markdown .token.table-header": {
      color: "#111b27"
    },
    ".language-json .token.operator": {
      color: "#111b27"
    },
    "tab:not(:empty):before": {
      color: "#304259"
    },
    "cr:before": {
      color: "#304259"
    },
    "lf:before": {
      color: "#304259"
    },
    "space:before": {
      color: "#304259"
    },
    "div.code-toolbar > .toolbar a": {
      color: "#e3e9f2",
      background: "#005c99"
    },
    "div.code-toolbar > .toolbar button": {
      color: "#e3e9f2",
      background: "#005c99"
    },
    "div.code-toolbar > .toolbar a:hover": {
      color: "#e3e9f2",
      background: "#005c99da",
      textDecoration: "none"
    },
    "div.code-toolbar > .toolbar a:focus": {
      color: "#e3e9f2",
      background: "#005c99da",
      textDecoration: "none"
    },
    "div.code-toolbar > .toolbar button:hover": {
      color: "#e3e9f2",
      background: "#005c99da",
      textDecoration: "none"
    },
    "div.code-toolbar > .toolbar button:focus": {
      color: "#e3e9f2",
      background: "#005c99da",
      textDecoration: "none"
    },
    "div.code-toolbar > .toolbar span": {
      color: "#e3e9f2",
      background: "#304259"
    },
    "div.code-toolbar > .toolbar span:hover": {
      color: "#e3e9f2",
      background: "#304259"
    },
    "div.code-toolbar > .toolbar span:focus": {
      color: "#e3e9f2",
      background: "#304259"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, #3042591f 70%, #30425915)"
    },
    ".line-highlight:before": {
      backgroundColor: "#304259",
      color: "#e3e9f2",
      boxShadow: "0 1px #ccd6e4"
    },
    ".line-highlight[data-end]:after": {
      backgroundColor: "#304259",
      color: "#e3e9f2",
      boxShadow: "0 1px #ccd6e4"
    },
    "pre[id].linkable-line-numbers span.line-numbers-rows > span:hover:before": {
      backgroundColor: "#3042591f"
    },
    ".line-numbers .line-numbers-rows": {
      borderRight: "1px solid #111b271f",
      background: "#d8e0ebda"
    },
    ".line-numbers-rows > span:before": {
      color: "#111b2796"
    },
    ".rainbow-braces .token.punctuation.brace-level-1": {
      color: "#7d6600"
    },
    ".rainbow-braces .token.punctuation.brace-level-5": {
      color: "#7d6600"
    },
    ".rainbow-braces .token.punctuation.brace-level-9": {
      color: "#7d6600"
    },
    ".rainbow-braces .token.punctuation.brace-level-2": {
      color: "#b800b8"
    },
    ".rainbow-braces .token.punctuation.brace-level-6": {
      color: "#b800b8"
    },
    ".rainbow-braces .token.punctuation.brace-level-10": {
      color: "#b800b8"
    },
    ".rainbow-braces .token.punctuation.brace-level-3": {
      color: "#005c99"
    },
    ".rainbow-braces .token.punctuation.brace-level-7": {
      color: "#005c99"
    },
    ".rainbow-braces .token.punctuation.brace-level-11": {
      color: "#005c99"
    },
    ".rainbow-braces .token.punctuation.brace-level-4": {
      color: "#8600c6"
    },
    ".rainbow-braces .token.punctuation.brace-level-8": {
      color: "#8600c6"
    },
    ".rainbow-braces .token.punctuation.brace-level-12": {
      color: "#8600c6"
    },
    "pre.diff-highlight > code .token.deleted:not(.prefix)": {
      backgroundColor: "#bf01001f"
    },
    "pre > code.diff-highlight .token.deleted:not(.prefix)": {
      backgroundColor: "#bf01001f"
    },
    "pre.diff-highlight > code .token.inserted:not(.prefix)": {
      backgroundColor: "#2378001f"
    },
    "pre > code.diff-highlight .token.inserted:not(.prefix)": {
      backgroundColor: "#2378001f"
    },
    ".command-line-prompt": {
      borderRight: "1px solid #111b271f"
    },
    ".command-line-prompt > span:before": {
      color: "#111b2796"
    }
  };
}),
    Ku = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#e3e9f2",
      background: "none",
      fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#e3e9f2",
      background: "#111b27",
      fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: "0.5em 0",
      overflow: "auto"
    },
    'pre[class*="language-"]::-moz-selection': {
      background: "#304259"
    },
    'pre[class*="language-"] ::-moz-selection': {
      background: "#304259"
    },
    'code[class*="language-"]::-moz-selection': {
      background: "#304259"
    },
    'code[class*="language-"] ::-moz-selection': {
      background: "#304259"
    },
    'pre[class*="language-"]::selection': {
      background: "#304259"
    },
    'pre[class*="language-"] ::selection': {
      background: "#304259"
    },
    'code[class*="language-"]::selection': {
      background: "#304259"
    },
    'code[class*="language-"] ::selection': {
      background: "#304259"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#111b27",
      padding: "0.1em 0.3em",
      borderRadius: "0.3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "#ccd6e4",
      fontStyle: "italic"
    },
    prolog: {
      color: "#ccd6e4",
      fontStyle: "italic"
    },
    doctype: {
      color: "#ccd6e4",
      fontStyle: "italic"
    },
    cdata: {
      color: "#ccd6e4",
      fontStyle: "italic"
    },
    punctuation: {
      color: "#e3e9f2"
    },
    selector: {
      color: "#5dc2c2"
    },
    tag: {
      color: "#5dc2c2"
    },
    "attr-name": {
      color: "#cdb74a"
    },
    "boolean": {
      color: "#cdb74a"
    },
    number: {
      color: "#cdb74a"
    },
    constant: {
      color: "#cdb74a"
    },
    "pseudo-class": {
      color: "#cdb74a"
    },
    "pseudo-element": {
      color: "#cdb74a"
    },
    "selector.attribute": {
      color: "#cdb74a"
    },
    "class-name": {
      color: "#6ab3e4"
    },
    key: {
      color: "#6ab3e4"
    },
    parameter: {
      color: "#6ab3e4"
    },
    property: {
      color: "#6ab3e4"
    },
    "property-access": {
      color: "#6ab3e4"
    },
    variable: {
      color: "#6ab3e4"
    },
    "attr-value": {
      color: "#82c366"
    },
    inserted: {
      color: "#82c366"
    },
    color: {
      color: "#82c366"
    },
    "selector.value": {
      color: "#82c366"
    },
    string: {
      color: "#82c366"
    },
    "string.url-link": {
      color: "#82c366"
    },
    builtin: {
      color: "#ea89ea"
    },
    "keyword-array": {
      color: "#ea89ea"
    },
    "package": {
      color: "#ea89ea"
    },
    regex: {
      color: "#ea89ea"
    },
    "function": {
      color: "#cf7ef6"
    },
    "selector.class": {
      color: "#cf7ef6"
    },
    "selector.id": {
      color: "#cf7ef6"
    },
    "atrule.rule": {
      color: "#d88b4a"
    },
    combinator: {
      color: "#d88b4a"
    },
    keyword: {
      color: "#d88b4a"
    },
    operator: {
      color: "#d88b4a"
    },
    "selector.token.operator": {
      color: "#d88b4a"
    },
    unit: {
      color: "#d88b4a"
    },
    deleted: {
      color: "#f57a73"
    },
    important: {
      color: "#f57a73",
      fontWeight: "bold"
    },
    "keyword-this": {
      color: "#6ab3e4",
      fontWeight: "bold"
    },
    "this": {
      color: "#6ab3e4",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    entity: {
      cursor: "help"
    },
    ".language-markdown .token.title": {
      color: "#6ab3e4",
      fontWeight: "bold"
    },
    ".language-markdown .token.title .token.punctuation": {
      color: "#6ab3e4",
      fontWeight: "bold"
    },
    ".language-markdown .token.code": {
      color: "#5dc2c2"
    },
    ".language-markdown .token.url .token.content": {
      color: "#82c366"
    },
    ".language-markdown .token.url-link": {
      color: "#cdb74a"
    },
    ".language-markdown .token.list.punctuation": {
      color: "#ea89ea"
    },
    ".language-markdown .token.table-header": {
      color: "#e3e9f2"
    },
    ".language-json .token.operator": {
      color: "#e3e9f2"
    },
    "tab:not(:empty):before": {
      color: "#ccd6e4"
    },
    "cr:before": {
      color: "#ccd6e4"
    },
    "lf:before": {
      color: "#ccd6e4"
    },
    "space:before": {
      color: "#ccd6e4"
    },
    "div.code-toolbar > .toolbar a": {
      color: "#111b27",
      background: "#6ab3e4"
    },
    "div.code-toolbar > .toolbar button": {
      color: "#111b27",
      background: "#6ab3e4"
    },
    "div.code-toolbar > .toolbar a:hover": {
      color: "#111b27",
      background: "#6ab3e4da",
      textDecoration: "none"
    },
    "div.code-toolbar > .toolbar a:focus": {
      color: "#111b27",
      background: "#6ab3e4da",
      textDecoration: "none"
    },
    "div.code-toolbar > .toolbar button:hover": {
      color: "#111b27",
      background: "#6ab3e4da",
      textDecoration: "none"
    },
    "div.code-toolbar > .toolbar button:focus": {
      color: "#111b27",
      background: "#6ab3e4da",
      textDecoration: "none"
    },
    "div.code-toolbar > .toolbar span": {
      color: "#111b27",
      background: "#ccd6e4"
    },
    "div.code-toolbar > .toolbar span:hover": {
      color: "#111b27",
      background: "#ccd6e4"
    },
    "div.code-toolbar > .toolbar span:focus": {
      color: "#111b27",
      background: "#ccd6e4"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, #ccd6e41f 70%, #ccd6e415)"
    },
    ".line-highlight:before": {
      backgroundColor: "#ccd6e4",
      color: "#111b27",
      boxShadow: "0 1px #304259"
    },
    ".line-highlight[data-end]:after": {
      backgroundColor: "#ccd6e4",
      color: "#111b27",
      boxShadow: "0 1px #304259"
    },
    "pre[id].linkable-line-numbers span.line-numbers-rows > span:hover:before": {
      backgroundColor: "#ccd6e418"
    },
    ".line-numbers .line-numbers-rows": {
      borderRight: "1px solid #0b121b",
      background: "#0b121b7a"
    },
    ".line-numbers-rows > span:before": {
      color: "#e3e9f296"
    },
    ".rainbow-braces .token.punctuation.brace-level-1": {
      color: "#cdb74a"
    },
    ".rainbow-braces .token.punctuation.brace-level-5": {
      color: "#cdb74a"
    },
    ".rainbow-braces .token.punctuation.brace-level-9": {
      color: "#cdb74a"
    },
    ".rainbow-braces .token.punctuation.brace-level-2": {
      color: "#ea89ea"
    },
    ".rainbow-braces .token.punctuation.brace-level-6": {
      color: "#ea89ea"
    },
    ".rainbow-braces .token.punctuation.brace-level-10": {
      color: "#ea89ea"
    },
    ".rainbow-braces .token.punctuation.brace-level-3": {
      color: "#6ab3e4"
    },
    ".rainbow-braces .token.punctuation.brace-level-7": {
      color: "#6ab3e4"
    },
    ".rainbow-braces .token.punctuation.brace-level-11": {
      color: "#6ab3e4"
    },
    ".rainbow-braces .token.punctuation.brace-level-4": {
      color: "#cf7ef6"
    },
    ".rainbow-braces .token.punctuation.brace-level-8": {
      color: "#cf7ef6"
    },
    ".rainbow-braces .token.punctuation.brace-level-12": {
      color: "#cf7ef6"
    },
    "pre.diff-highlight > code .token.deleted:not(.prefix)": {
      backgroundColor: "#f57a731f"
    },
    "pre > code.diff-highlight .token.deleted:not(.prefix)": {
      backgroundColor: "#f57a731f"
    },
    "pre.diff-highlight > code .token.inserted:not(.prefix)": {
      backgroundColor: "#82c3661f"
    },
    "pre > code.diff-highlight .token.inserted:not(.prefix)": {
      backgroundColor: "#82c3661f"
    },
    ".command-line-prompt": {
      borderRight: "1px solid #0b121b"
    },
    ".command-line-prompt > span:before": {
      color: "#e3e9f296"
    }
  };
}),
    Qu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "black",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "black",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      position: "relative",
      borderLeft: "10px solid #358ccb",
      boxShadow: "-1px 0 0 0 #358ccb, 0 0 0 1px #dfdfdf",
      backgroundColor: "#fdfdfd",
      backgroundImage: "linear-gradient(transparent 50%, rgba(69, 142, 209, 0.04) 50%)",
      backgroundSize: "3em 3em",
      backgroundOrigin: "content-box",
      backgroundAttachment: "local",
      margin: ".5em 0",
      padding: "0 1em"
    },
    'pre[class*="language-"] > code': {
      display: "block"
    },
    ':not(pre) > code[class*="language-"]': {
      position: "relative",
      padding: ".2em",
      borderRadius: "0.3em",
      color: "#c92c2c",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      display: "inline",
      whiteSpace: "normal",
      backgroundColor: "#fdfdfd",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box"
    },
    comment: {
      color: "#7D8B99"
    },
    "block-comment": {
      color: "#7D8B99"
    },
    prolog: {
      color: "#7D8B99"
    },
    doctype: {
      color: "#7D8B99"
    },
    cdata: {
      color: "#7D8B99"
    },
    punctuation: {
      color: "#5F6364"
    },
    property: {
      color: "#c92c2c"
    },
    tag: {
      color: "#c92c2c"
    },
    "boolean": {
      color: "#c92c2c"
    },
    number: {
      color: "#c92c2c"
    },
    "function-name": {
      color: "#c92c2c"
    },
    constant: {
      color: "#c92c2c"
    },
    symbol: {
      color: "#c92c2c"
    },
    deleted: {
      color: "#c92c2c"
    },
    selector: {
      color: "#2f9c0a"
    },
    "attr-name": {
      color: "#2f9c0a"
    },
    string: {
      color: "#2f9c0a"
    },
    "char": {
      color: "#2f9c0a"
    },
    "function": {
      color: "#2f9c0a"
    },
    builtin: {
      color: "#2f9c0a"
    },
    inserted: {
      color: "#2f9c0a"
    },
    operator: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    entity: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)",
      cursor: "help"
    },
    url: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    variable: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    atrule: {
      color: "#1990b8"
    },
    "attr-value": {
      color: "#1990b8"
    },
    keyword: {
      color: "#1990b8"
    },
    "class-name": {
      color: "#1990b8"
    },
    regex: {
      color: "#e90"
    },
    important: {
      color: "#e90",
      fontWeight: "normal"
    },
    ".language-css .token.string": {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    ".style .token.string": {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    namespace: {
      Opacity: ".7"
    }
  };
}),
    Yu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#a9b7c6",
      fontFamily: "Consolas, Monaco, 'Andale Mono', monospace",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#a9b7c6",
      fontFamily: "Consolas, Monaco, 'Andale Mono', monospace",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      background: "#2b2b2b"
    },
    'pre[class*="language-"]::-moz-selection': {
      color: "inherit",
      background: "rgba(33, 66, 131, .85)"
    },
    'pre[class*="language-"] ::-moz-selection': {
      color: "inherit",
      background: "rgba(33, 66, 131, .85)"
    },
    'code[class*="language-"]::-moz-selection': {
      color: "inherit",
      background: "rgba(33, 66, 131, .85)"
    },
    'code[class*="language-"] ::-moz-selection': {
      color: "inherit",
      background: "rgba(33, 66, 131, .85)"
    },
    'pre[class*="language-"]::selection': {
      color: "inherit",
      background: "rgba(33, 66, 131, .85)"
    },
    'pre[class*="language-"] ::selection': {
      color: "inherit",
      background: "rgba(33, 66, 131, .85)"
    },
    'code[class*="language-"]::selection': {
      color: "inherit",
      background: "rgba(33, 66, 131, .85)"
    },
    'code[class*="language-"] ::selection': {
      color: "inherit",
      background: "rgba(33, 66, 131, .85)"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#2b2b2b",
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#808080"
    },
    prolog: {
      color: "#808080"
    },
    cdata: {
      color: "#808080"
    },
    delimiter: {
      color: "#cc7832"
    },
    "boolean": {
      color: "#cc7832"
    },
    keyword: {
      color: "#cc7832"
    },
    selector: {
      color: "#cc7832"
    },
    important: {
      color: "#cc7832"
    },
    atrule: {
      color: "#cc7832"
    },
    operator: {
      color: "#a9b7c6"
    },
    punctuation: {
      color: "#a9b7c6"
    },
    "attr-name": {
      color: "#a9b7c6"
    },
    tag: {
      color: "#e8bf6a"
    },
    "tag.punctuation": {
      color: "#e8bf6a"
    },
    doctype: {
      color: "#e8bf6a"
    },
    builtin: {
      color: "#e8bf6a"
    },
    entity: {
      color: "#6897bb"
    },
    number: {
      color: "#6897bb"
    },
    symbol: {
      color: "#6897bb"
    },
    property: {
      color: "#9876aa"
    },
    constant: {
      color: "#9876aa"
    },
    variable: {
      color: "#9876aa"
    },
    string: {
      color: "#6a8759"
    },
    "char": {
      color: "#6a8759"
    },
    "attr-value": {
      color: "#a5c261"
    },
    "attr-value.punctuation": {
      color: "#a5c261"
    },
    "attr-value.punctuation:first-child": {
      color: "#a9b7c6"
    },
    url: {
      color: "#287bde",
      textDecoration: "underline"
    },
    "function": {
      color: "#ffc66d"
    },
    regex: {
      background: "#364135"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    inserted: {
      background: "#294436"
    },
    deleted: {
      background: "#484a4a"
    },
    "code.language-css .token.property": {
      color: "#a9b7c6"
    },
    "code.language-css .token.property + .token.punctuation": {
      color: "#a9b7c6"
    },
    "code.language-css .token.id": {
      color: "#ffc66d"
    },
    "code.language-css .token.selector > .token.class": {
      color: "#ffc66d"
    },
    "code.language-css .token.selector > .token.attribute": {
      color: "#ffc66d"
    },
    "code.language-css .token.selector > .token.pseudo-class": {
      color: "#ffc66d"
    },
    "code.language-css .token.selector > .token.pseudo-element": {
      color: "#ffc66d"
    }
  };
}),
    Gu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#f8f8f2",
      background: "none",
      textShadow: "0 1px rgba(0, 0, 0, 0.3)",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#f8f8f2",
      background: "#282a36",
      textShadow: "0 1px rgba(0, 0, 0, 0.3)",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      borderRadius: "0.3em"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#282a36",
      padding: ".1em",
      borderRadius: ".3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "#6272a4"
    },
    prolog: {
      color: "#6272a4"
    },
    doctype: {
      color: "#6272a4"
    },
    cdata: {
      color: "#6272a4"
    },
    punctuation: {
      color: "#f8f8f2"
    },
    ".namespace": {
      Opacity: ".7"
    },
    property: {
      color: "#ff79c6"
    },
    tag: {
      color: "#ff79c6"
    },
    constant: {
      color: "#ff79c6"
    },
    symbol: {
      color: "#ff79c6"
    },
    deleted: {
      color: "#ff79c6"
    },
    "boolean": {
      color: "#bd93f9"
    },
    number: {
      color: "#bd93f9"
    },
    selector: {
      color: "#50fa7b"
    },
    "attr-name": {
      color: "#50fa7b"
    },
    string: {
      color: "#50fa7b"
    },
    "char": {
      color: "#50fa7b"
    },
    builtin: {
      color: "#50fa7b"
    },
    inserted: {
      color: "#50fa7b"
    },
    operator: {
      color: "#f8f8f2"
    },
    entity: {
      color: "#f8f8f2",
      cursor: "help"
    },
    url: {
      color: "#f8f8f2"
    },
    ".language-css .token.string": {
      color: "#f8f8f2"
    },
    ".style .token.string": {
      color: "#f8f8f2"
    },
    variable: {
      color: "#f8f8f2"
    },
    atrule: {
      color: "#f1fa8c"
    },
    "attr-value": {
      color: "#f1fa8c"
    },
    "function": {
      color: "#f1fa8c"
    },
    "class-name": {
      color: "#f1fa8c"
    },
    keyword: {
      color: "#8be9fd"
    },
    regex: {
      color: "#ffb86c"
    },
    important: {
      color: "#ffb86c",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    }
  };
}),
    Xu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#2a2734",
      color: "#9a86fd"
    },
    'pre[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#2a2734",
      color: "#9a86fd",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    'pre[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#6a51e6"
    },
    'pre[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#6a51e6"
    },
    'code[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#6a51e6"
    },
    'code[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#6a51e6"
    },
    'pre[class*="language-"]::selection': {
      textShadow: "none",
      background: "#6a51e6"
    },
    'pre[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#6a51e6"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "#6a51e6"
    },
    'code[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#6a51e6"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#6c6783"
    },
    prolog: {
      color: "#6c6783"
    },
    doctype: {
      color: "#6c6783"
    },
    cdata: {
      color: "#6c6783"
    },
    punctuation: {
      color: "#6c6783"
    },
    namespace: {
      Opacity: ".7"
    },
    tag: {
      color: "#e09142"
    },
    operator: {
      color: "#e09142"
    },
    number: {
      color: "#e09142"
    },
    property: {
      color: "#9a86fd"
    },
    "function": {
      color: "#9a86fd"
    },
    "tag-id": {
      color: "#eeebff"
    },
    selector: {
      color: "#eeebff"
    },
    "atrule-id": {
      color: "#eeebff"
    },
    "code.language-javascript": {
      color: "#c4b9fe"
    },
    "attr-name": {
      color: "#c4b9fe"
    },
    "code.language-css": {
      color: "#ffcc99"
    },
    "code.language-scss": {
      color: "#ffcc99"
    },
    "boolean": {
      color: "#ffcc99"
    },
    string: {
      color: "#ffcc99"
    },
    entity: {
      color: "#ffcc99",
      cursor: "help"
    },
    url: {
      color: "#ffcc99"
    },
    ".language-css .token.string": {
      color: "#ffcc99"
    },
    ".language-scss .token.string": {
      color: "#ffcc99"
    },
    ".style .token.string": {
      color: "#ffcc99"
    },
    "attr-value": {
      color: "#ffcc99"
    },
    keyword: {
      color: "#ffcc99"
    },
    control: {
      color: "#ffcc99"
    },
    directive: {
      color: "#ffcc99"
    },
    unit: {
      color: "#ffcc99"
    },
    statement: {
      color: "#ffcc99"
    },
    regex: {
      color: "#ffcc99"
    },
    atrule: {
      color: "#ffcc99"
    },
    placeholder: {
      color: "#ffcc99"
    },
    variable: {
      color: "#ffcc99"
    },
    deleted: {
      textDecoration: "line-through"
    },
    inserted: {
      borderBottom: "1px dotted #eeebff",
      textDecoration: "none"
    },
    italic: {
      fontStyle: "italic"
    },
    important: {
      fontWeight: "bold",
      color: "#c4b9fe"
    },
    bold: {
      fontWeight: "bold"
    },
    "pre > code.highlight": {
      Outline: ".4em solid #8a75f5",
      OutlineOffset: ".4em"
    },
    ".line-numbers .line-numbers-rows": {
      borderRightColor: "#2c2937"
    },
    ".line-numbers-rows > span:before": {
      color: "#3c3949"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, rgba(224, 145, 66, 0.2) 70%, rgba(224, 145, 66, 0))"
    }
  };
}),
    _u = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#322d29",
      color: "#88786d"
    },
    'pre[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#322d29",
      color: "#88786d",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    'pre[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#6f5849"
    },
    'pre[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#6f5849"
    },
    'code[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#6f5849"
    },
    'code[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#6f5849"
    },
    'pre[class*="language-"]::selection': {
      textShadow: "none",
      background: "#6f5849"
    },
    'pre[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#6f5849"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "#6f5849"
    },
    'code[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#6f5849"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#6a5f58"
    },
    prolog: {
      color: "#6a5f58"
    },
    doctype: {
      color: "#6a5f58"
    },
    cdata: {
      color: "#6a5f58"
    },
    punctuation: {
      color: "#6a5f58"
    },
    namespace: {
      Opacity: ".7"
    },
    tag: {
      color: "#bfa05a"
    },
    operator: {
      color: "#bfa05a"
    },
    number: {
      color: "#bfa05a"
    },
    property: {
      color: "#88786d"
    },
    "function": {
      color: "#88786d"
    },
    "tag-id": {
      color: "#fff3eb"
    },
    selector: {
      color: "#fff3eb"
    },
    "atrule-id": {
      color: "#fff3eb"
    },
    "code.language-javascript": {
      color: "#a48774"
    },
    "attr-name": {
      color: "#a48774"
    },
    "code.language-css": {
      color: "#fcc440"
    },
    "code.language-scss": {
      color: "#fcc440"
    },
    "boolean": {
      color: "#fcc440"
    },
    string: {
      color: "#fcc440"
    },
    entity: {
      color: "#fcc440",
      cursor: "help"
    },
    url: {
      color: "#fcc440"
    },
    ".language-css .token.string": {
      color: "#fcc440"
    },
    ".language-scss .token.string": {
      color: "#fcc440"
    },
    ".style .token.string": {
      color: "#fcc440"
    },
    "attr-value": {
      color: "#fcc440"
    },
    keyword: {
      color: "#fcc440"
    },
    control: {
      color: "#fcc440"
    },
    directive: {
      color: "#fcc440"
    },
    unit: {
      color: "#fcc440"
    },
    statement: {
      color: "#fcc440"
    },
    regex: {
      color: "#fcc440"
    },
    atrule: {
      color: "#fcc440"
    },
    placeholder: {
      color: "#fcc440"
    },
    variable: {
      color: "#fcc440"
    },
    deleted: {
      textDecoration: "line-through"
    },
    inserted: {
      borderBottom: "1px dotted #fff3eb",
      textDecoration: "none"
    },
    italic: {
      fontStyle: "italic"
    },
    important: {
      fontWeight: "bold",
      color: "#a48774"
    },
    bold: {
      fontWeight: "bold"
    },
    "pre > code.highlight": {
      Outline: ".4em solid #816d5f",
      OutlineOffset: ".4em"
    },
    ".line-numbers .line-numbers-rows": {
      borderRightColor: "#35302b"
    },
    ".line-numbers-rows > span:before": {
      color: "#46403d"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, rgba(191, 160, 90, 0.2) 70%, rgba(191, 160, 90, 0))"
    }
  };
}),
    Zu = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#2a2d2a",
      color: "#687d68"
    },
    'pre[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#2a2d2a",
      color: "#687d68",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    'pre[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#435643"
    },
    'pre[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#435643"
    },
    'code[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#435643"
    },
    'code[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#435643"
    },
    'pre[class*="language-"]::selection': {
      textShadow: "none",
      background: "#435643"
    },
    'pre[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#435643"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "#435643"
    },
    'code[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#435643"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#535f53"
    },
    prolog: {
      color: "#535f53"
    },
    doctype: {
      color: "#535f53"
    },
    cdata: {
      color: "#535f53"
    },
    punctuation: {
      color: "#535f53"
    },
    namespace: {
      Opacity: ".7"
    },
    tag: {
      color: "#a2b34d"
    },
    operator: {
      color: "#a2b34d"
    },
    number: {
      color: "#a2b34d"
    },
    property: {
      color: "#687d68"
    },
    "function": {
      color: "#687d68"
    },
    "tag-id": {
      color: "#f0fff0"
    },
    selector: {
      color: "#f0fff0"
    },
    "atrule-id": {
      color: "#f0fff0"
    },
    "code.language-javascript": {
      color: "#b3d6b3"
    },
    "attr-name": {
      color: "#b3d6b3"
    },
    "code.language-css": {
      color: "#e5fb79"
    },
    "code.language-scss": {
      color: "#e5fb79"
    },
    "boolean": {
      color: "#e5fb79"
    },
    string: {
      color: "#e5fb79"
    },
    entity: {
      color: "#e5fb79",
      cursor: "help"
    },
    url: {
      color: "#e5fb79"
    },
    ".language-css .token.string": {
      color: "#e5fb79"
    },
    ".language-scss .token.string": {
      color: "#e5fb79"
    },
    ".style .token.string": {
      color: "#e5fb79"
    },
    "attr-value": {
      color: "#e5fb79"
    },
    keyword: {
      color: "#e5fb79"
    },
    control: {
      color: "#e5fb79"
    },
    directive: {
      color: "#e5fb79"
    },
    unit: {
      color: "#e5fb79"
    },
    statement: {
      color: "#e5fb79"
    },
    regex: {
      color: "#e5fb79"
    },
    atrule: {
      color: "#e5fb79"
    },
    placeholder: {
      color: "#e5fb79"
    },
    variable: {
      color: "#e5fb79"
    },
    deleted: {
      textDecoration: "line-through"
    },
    inserted: {
      borderBottom: "1px dotted #f0fff0",
      textDecoration: "none"
    },
    italic: {
      fontStyle: "italic"
    },
    important: {
      fontWeight: "bold",
      color: "#b3d6b3"
    },
    bold: {
      fontWeight: "bold"
    },
    "pre > code.highlight": {
      Outline: ".4em solid #5c705c",
      OutlineOffset: ".4em"
    },
    ".line-numbers .line-numbers-rows": {
      borderRightColor: "#2c302c"
    },
    ".line-numbers-rows > span:before": {
      color: "#3b423b"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, rgba(162, 179, 77, 0.2) 70%, rgba(162, 179, 77, 0))"
    }
  };
}),
    $u = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#faf8f5",
      color: "#728fcb"
    },
    'pre[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#faf8f5",
      color: "#728fcb",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    'pre[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#faf8f5"
    },
    'pre[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#faf8f5"
    },
    'code[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#faf8f5"
    },
    'code[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#faf8f5"
    },
    'pre[class*="language-"]::selection': {
      textShadow: "none",
      background: "#faf8f5"
    },
    'pre[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#faf8f5"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "#faf8f5"
    },
    'code[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#faf8f5"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#b6ad9a"
    },
    prolog: {
      color: "#b6ad9a"
    },
    doctype: {
      color: "#b6ad9a"
    },
    cdata: {
      color: "#b6ad9a"
    },
    punctuation: {
      color: "#b6ad9a"
    },
    namespace: {
      Opacity: ".7"
    },
    tag: {
      color: "#063289"
    },
    operator: {
      color: "#063289"
    },
    number: {
      color: "#063289"
    },
    property: {
      color: "#b29762"
    },
    "function": {
      color: "#b29762"
    },
    "tag-id": {
      color: "#2d2006"
    },
    selector: {
      color: "#2d2006"
    },
    "atrule-id": {
      color: "#2d2006"
    },
    "code.language-javascript": {
      color: "#896724"
    },
    "attr-name": {
      color: "#896724"
    },
    "code.language-css": {
      color: "#728fcb"
    },
    "code.language-scss": {
      color: "#728fcb"
    },
    "boolean": {
      color: "#728fcb"
    },
    string: {
      color: "#728fcb"
    },
    entity: {
      color: "#728fcb",
      cursor: "help"
    },
    url: {
      color: "#728fcb"
    },
    ".language-css .token.string": {
      color: "#728fcb"
    },
    ".language-scss .token.string": {
      color: "#728fcb"
    },
    ".style .token.string": {
      color: "#728fcb"
    },
    "attr-value": {
      color: "#728fcb"
    },
    keyword: {
      color: "#728fcb"
    },
    control: {
      color: "#728fcb"
    },
    directive: {
      color: "#728fcb"
    },
    unit: {
      color: "#728fcb"
    },
    statement: {
      color: "#728fcb"
    },
    regex: {
      color: "#728fcb"
    },
    atrule: {
      color: "#728fcb"
    },
    placeholder: {
      color: "#93abdc"
    },
    variable: {
      color: "#93abdc"
    },
    deleted: {
      textDecoration: "line-through"
    },
    inserted: {
      borderBottom: "1px dotted #2d2006",
      textDecoration: "none"
    },
    italic: {
      fontStyle: "italic"
    },
    important: {
      fontWeight: "bold",
      color: "#896724"
    },
    bold: {
      fontWeight: "bold"
    },
    "pre > code.highlight": {
      Outline: ".4em solid #896724",
      OutlineOffset: ".4em"
    },
    ".line-numbers .line-numbers-rows": {
      borderRightColor: "#ece8de"
    },
    ".line-numbers-rows > span:before": {
      color: "#cdc4b1"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, rgba(45, 32, 6, 0.2) 70%, rgba(45, 32, 6, 0))"
    }
  };
}),
    ed = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#1d262f",
      color: "#57718e"
    },
    'pre[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#1d262f",
      color: "#57718e",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    'pre[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#004a9e"
    },
    'pre[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#004a9e"
    },
    'code[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#004a9e"
    },
    'code[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#004a9e"
    },
    'pre[class*="language-"]::selection': {
      textShadow: "none",
      background: "#004a9e"
    },
    'pre[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#004a9e"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "#004a9e"
    },
    'code[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#004a9e"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#4a5f78"
    },
    prolog: {
      color: "#4a5f78"
    },
    doctype: {
      color: "#4a5f78"
    },
    cdata: {
      color: "#4a5f78"
    },
    punctuation: {
      color: "#4a5f78"
    },
    namespace: {
      Opacity: ".7"
    },
    tag: {
      color: "#0aa370"
    },
    operator: {
      color: "#0aa370"
    },
    number: {
      color: "#0aa370"
    },
    property: {
      color: "#57718e"
    },
    "function": {
      color: "#57718e"
    },
    "tag-id": {
      color: "#ebf4ff"
    },
    selector: {
      color: "#ebf4ff"
    },
    "atrule-id": {
      color: "#ebf4ff"
    },
    "code.language-javascript": {
      color: "#7eb6f6"
    },
    "attr-name": {
      color: "#7eb6f6"
    },
    "code.language-css": {
      color: "#47ebb4"
    },
    "code.language-scss": {
      color: "#47ebb4"
    },
    "boolean": {
      color: "#47ebb4"
    },
    string: {
      color: "#47ebb4"
    },
    entity: {
      color: "#47ebb4",
      cursor: "help"
    },
    url: {
      color: "#47ebb4"
    },
    ".language-css .token.string": {
      color: "#47ebb4"
    },
    ".language-scss .token.string": {
      color: "#47ebb4"
    },
    ".style .token.string": {
      color: "#47ebb4"
    },
    "attr-value": {
      color: "#47ebb4"
    },
    keyword: {
      color: "#47ebb4"
    },
    control: {
      color: "#47ebb4"
    },
    directive: {
      color: "#47ebb4"
    },
    unit: {
      color: "#47ebb4"
    },
    statement: {
      color: "#47ebb4"
    },
    regex: {
      color: "#47ebb4"
    },
    atrule: {
      color: "#47ebb4"
    },
    placeholder: {
      color: "#47ebb4"
    },
    variable: {
      color: "#47ebb4"
    },
    deleted: {
      textDecoration: "line-through"
    },
    inserted: {
      borderBottom: "1px dotted #ebf4ff",
      textDecoration: "none"
    },
    italic: {
      fontStyle: "italic"
    },
    important: {
      fontWeight: "bold",
      color: "#7eb6f6"
    },
    bold: {
      fontWeight: "bold"
    },
    "pre > code.highlight": {
      Outline: ".4em solid #34659d",
      OutlineOffset: ".4em"
    },
    ".line-numbers .line-numbers-rows": {
      borderRightColor: "#1f2932"
    },
    ".line-numbers-rows > span:before": {
      color: "#2c3847"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, rgba(10, 163, 112, 0.2) 70%, rgba(10, 163, 112, 0))"
    }
  };
}),
    nd = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#24242e",
      color: "#767693"
    },
    'pre[class*="language-"]': {
      fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
      fontSize: "14px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      background: "#24242e",
      color: "#767693",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    'pre[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#5151e6"
    },
    'pre[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#5151e6"
    },
    'code[class*="language-"]::-moz-selection': {
      textShadow: "none",
      background: "#5151e6"
    },
    'code[class*="language-"] ::-moz-selection': {
      textShadow: "none",
      background: "#5151e6"
    },
    'pre[class*="language-"]::selection': {
      textShadow: "none",
      background: "#5151e6"
    },
    'pre[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#5151e6"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "#5151e6"
    },
    'code[class*="language-"] ::selection': {
      textShadow: "none",
      background: "#5151e6"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#5b5b76"
    },
    prolog: {
      color: "#5b5b76"
    },
    doctype: {
      color: "#5b5b76"
    },
    cdata: {
      color: "#5b5b76"
    },
    punctuation: {
      color: "#5b5b76"
    },
    namespace: {
      Opacity: ".7"
    },
    tag: {
      color: "#dd672c"
    },
    operator: {
      color: "#dd672c"
    },
    number: {
      color: "#dd672c"
    },
    property: {
      color: "#767693"
    },
    "function": {
      color: "#767693"
    },
    "tag-id": {
      color: "#ebebff"
    },
    selector: {
      color: "#ebebff"
    },
    "atrule-id": {
      color: "#ebebff"
    },
    "code.language-javascript": {
      color: "#aaaaca"
    },
    "attr-name": {
      color: "#aaaaca"
    },
    "code.language-css": {
      color: "#fe8c52"
    },
    "code.language-scss": {
      color: "#fe8c52"
    },
    "boolean": {
      color: "#fe8c52"
    },
    string: {
      color: "#fe8c52"
    },
    entity: {
      color: "#fe8c52",
      cursor: "help"
    },
    url: {
      color: "#fe8c52"
    },
    ".language-css .token.string": {
      color: "#fe8c52"
    },
    ".language-scss .token.string": {
      color: "#fe8c52"
    },
    ".style .token.string": {
      color: "#fe8c52"
    },
    "attr-value": {
      color: "#fe8c52"
    },
    keyword: {
      color: "#fe8c52"
    },
    control: {
      color: "#fe8c52"
    },
    directive: {
      color: "#fe8c52"
    },
    unit: {
      color: "#fe8c52"
    },
    statement: {
      color: "#fe8c52"
    },
    regex: {
      color: "#fe8c52"
    },
    atrule: {
      color: "#fe8c52"
    },
    placeholder: {
      color: "#fe8c52"
    },
    variable: {
      color: "#fe8c52"
    },
    deleted: {
      textDecoration: "line-through"
    },
    inserted: {
      borderBottom: "1px dotted #ebebff",
      textDecoration: "none"
    },
    italic: {
      fontStyle: "italic"
    },
    important: {
      fontWeight: "bold",
      color: "#aaaaca"
    },
    bold: {
      fontWeight: "bold"
    },
    "pre > code.highlight": {
      Outline: ".4em solid #7676f4",
      OutlineOffset: ".4em"
    },
    ".line-numbers .line-numbers-rows": {
      borderRightColor: "#262631"
    },
    ".line-numbers-rows > span:before": {
      color: "#393949"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, rgba(221, 103, 44, 0.2) 70%, rgba(221, 103, 44, 0))"
    }
  };
}),
    td = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#393A34",
      fontFamily: '"Consolas", "Bitstream Vera Sans Mono", "Courier New", Courier, monospace',
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      fontSize: ".9em",
      lineHeight: "1.2em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#393A34",
      fontFamily: '"Consolas", "Bitstream Vera Sans Mono", "Courier New", Courier, monospace',
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      fontSize: ".9em",
      lineHeight: "1.2em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      border: "1px solid #dddddd",
      backgroundColor: "white"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    'pre[class*="language-"]::-moz-selection': {
      background: "#b3d4fc"
    },
    'pre[class*="language-"] ::-moz-selection': {
      background: "#b3d4fc"
    },
    'code[class*="language-"]::-moz-selection': {
      background: "#b3d4fc"
    },
    'code[class*="language-"] ::-moz-selection': {
      background: "#b3d4fc"
    },
    'pre[class*="language-"]::selection': {
      background: "#b3d4fc"
    },
    'pre[class*="language-"] ::selection': {
      background: "#b3d4fc"
    },
    'code[class*="language-"]::selection': {
      background: "#b3d4fc"
    },
    'code[class*="language-"] ::selection': {
      background: "#b3d4fc"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".2em",
      paddingTop: "1px",
      paddingBottom: "1px",
      background: "#f8f8f8",
      border: "1px solid #dddddd"
    },
    comment: {
      color: "#999988",
      fontStyle: "italic"
    },
    prolog: {
      color: "#999988",
      fontStyle: "italic"
    },
    doctype: {
      color: "#999988",
      fontStyle: "italic"
    },
    cdata: {
      color: "#999988",
      fontStyle: "italic"
    },
    namespace: {
      Opacity: ".7"
    },
    string: {
      color: "#e3116c"
    },
    "attr-value": {
      color: "#e3116c"
    },
    punctuation: {
      color: "#393A34"
    },
    operator: {
      color: "#393A34"
    },
    entity: {
      color: "#36acaa"
    },
    url: {
      color: "#36acaa"
    },
    symbol: {
      color: "#36acaa"
    },
    number: {
      color: "#36acaa"
    },
    "boolean": {
      color: "#36acaa"
    },
    variable: {
      color: "#36acaa"
    },
    constant: {
      color: "#36acaa"
    },
    property: {
      color: "#36acaa"
    },
    regex: {
      color: "#36acaa"
    },
    inserted: {
      color: "#36acaa"
    },
    atrule: {
      color: "#00a4db"
    },
    keyword: {
      color: "#00a4db"
    },
    "attr-name": {
      color: "#00a4db"
    },
    ".language-autohotkey .token.selector": {
      color: "#00a4db"
    },
    "function": {
      color: "#9a050f",
      fontWeight: "bold"
    },
    deleted: {
      color: "#9a050f"
    },
    ".language-autohotkey .token.tag": {
      color: "#9a050f"
    },
    tag: {
      color: "#00009f"
    },
    selector: {
      color: "#00009f"
    },
    ".language-autohotkey .token.keyword": {
      color: "#00009f"
    },
    important: {
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    }
  };
}),
    od = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      fontFamily: '"Fira Mono", Menlo, Monaco, "Lucida Console", "Courier New", Courier, monospace',
      fontSize: "16px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      wordSpacing: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      whiteSpace: "pre-wrap",
      wordBreak: "break-all",
      wordWrap: "break-word",
      background: "#322931",
      color: "#b9b5b8"
    },
    'pre[class*="language-"]': {
      fontFamily: '"Fira Mono", Menlo, Monaco, "Lucida Console", "Courier New", Courier, monospace',
      fontSize: "16px",
      lineHeight: "1.375",
      direction: "ltr",
      textAlign: "left",
      wordSpacing: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      whiteSpace: "pre-wrap",
      wordBreak: "break-all",
      wordWrap: "break-word",
      background: "#322931",
      color: "#b9b5b8",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".1em",
      borderRadius: ".3em"
    },
    comment: {
      color: "#797379"
    },
    prolog: {
      color: "#797379"
    },
    doctype: {
      color: "#797379"
    },
    cdata: {
      color: "#797379"
    },
    punctuation: {
      color: "#b9b5b8"
    },
    ".namespace": {
      Opacity: ".7"
    },
    "null": {
      color: "#fd8b19"
    },
    operator: {
      color: "#fd8b19"
    },
    "boolean": {
      color: "#fd8b19"
    },
    number: {
      color: "#fd8b19"
    },
    property: {
      color: "#fdcc59"
    },
    tag: {
      color: "#1290bf"
    },
    string: {
      color: "#149b93"
    },
    selector: {
      color: "#c85e7c"
    },
    "attr-name": {
      color: "#fd8b19"
    },
    entity: {
      color: "#149b93",
      cursor: "help"
    },
    url: {
      color: "#149b93"
    },
    ".language-css .token.string": {
      color: "#149b93"
    },
    ".style .token.string": {
      color: "#149b93"
    },
    "attr-value": {
      color: "#8fc13e"
    },
    keyword: {
      color: "#8fc13e"
    },
    control: {
      color: "#8fc13e"
    },
    directive: {
      color: "#8fc13e"
    },
    unit: {
      color: "#8fc13e"
    },
    statement: {
      color: "#149b93"
    },
    regex: {
      color: "#149b93"
    },
    atrule: {
      color: "#149b93"
    },
    placeholder: {
      color: "#1290bf"
    },
    variable: {
      color: "#1290bf"
    },
    important: {
      color: "#dd464c",
      fontWeight: "bold"
    },
    "pre > code.highlight": {
      Outline: ".4em solid red",
      OutlineOffset: ".4em"
    }
  };
}),
    rd = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      color: "#eee",
      background: "#2f2f2f",
      fontFamily: "Roboto Mono, monospace",
      fontSize: "1em",
      lineHeight: "1.5em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      color: "#eee",
      background: "#2f2f2f",
      fontFamily: "Roboto Mono, monospace",
      fontSize: "1em",
      lineHeight: "1.5em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      overflow: "auto",
      position: "relative",
      margin: "0.5em 0",
      padding: "1.25em 1em"
    },
    'code[class*="language-"]::-moz-selection': {
      background: "#363636"
    },
    'pre[class*="language-"]::-moz-selection': {
      background: "#363636"
    },
    'code[class*="language-"] ::-moz-selection': {
      background: "#363636"
    },
    'pre[class*="language-"] ::-moz-selection': {
      background: "#363636"
    },
    'code[class*="language-"]::selection': {
      background: "#363636"
    },
    'pre[class*="language-"]::selection': {
      background: "#363636"
    },
    'code[class*="language-"] ::selection': {
      background: "#363636"
    },
    'pre[class*="language-"] ::selection': {
      background: "#363636"
    },
    ':not(pre) > code[class*="language-"]': {
      whiteSpace: "normal",
      borderRadius: "0.2em",
      padding: "0.1em"
    },
    ".language-css > code": {
      color: "#fd9170"
    },
    ".language-sass > code": {
      color: "#fd9170"
    },
    ".language-scss > code": {
      color: "#fd9170"
    },
    '[class*="language-"] .namespace': {
      Opacity: "0.7"
    },
    atrule: {
      color: "#c792ea"
    },
    "attr-name": {
      color: "#ffcb6b"
    },
    "attr-value": {
      color: "#a5e844"
    },
    attribute: {
      color: "#a5e844"
    },
    "boolean": {
      color: "#c792ea"
    },
    builtin: {
      color: "#ffcb6b"
    },
    cdata: {
      color: "#80cbc4"
    },
    "char": {
      color: "#80cbc4"
    },
    "class": {
      color: "#ffcb6b"
    },
    "class-name": {
      color: "#f2ff00"
    },
    comment: {
      color: "#616161"
    },
    constant: {
      color: "#c792ea"
    },
    deleted: {
      color: "#ff6666"
    },
    doctype: {
      color: "#616161"
    },
    entity: {
      color: "#ff6666"
    },
    "function": {
      color: "#c792ea"
    },
    hexcode: {
      color: "#f2ff00"
    },
    id: {
      color: "#c792ea",
      fontWeight: "bold"
    },
    important: {
      color: "#c792ea",
      fontWeight: "bold"
    },
    inserted: {
      color: "#80cbc4"
    },
    keyword: {
      color: "#c792ea"
    },
    number: {
      color: "#fd9170"
    },
    operator: {
      color: "#89ddff"
    },
    prolog: {
      color: "#616161"
    },
    property: {
      color: "#80cbc4"
    },
    "pseudo-class": {
      color: "#a5e844"
    },
    "pseudo-element": {
      color: "#a5e844"
    },
    punctuation: {
      color: "#89ddff"
    },
    regex: {
      color: "#f2ff00"
    },
    selector: {
      color: "#ff6666"
    },
    string: {
      color: "#a5e844"
    },
    symbol: {
      color: "#c792ea"
    },
    tag: {
      color: "#ff6666"
    },
    unit: {
      color: "#fd9170"
    },
    url: {
      color: "#ff6666"
    },
    variable: {
      color: "#ff6666"
    }
  };
}),
    ad = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      color: "#90a4ae",
      background: "#fafafa",
      fontFamily: "Roboto Mono, monospace",
      fontSize: "1em",
      lineHeight: "1.5em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      color: "#90a4ae",
      background: "#fafafa",
      fontFamily: "Roboto Mono, monospace",
      fontSize: "1em",
      lineHeight: "1.5em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      overflow: "auto",
      position: "relative",
      margin: "0.5em 0",
      padding: "1.25em 1em"
    },
    'code[class*="language-"]::-moz-selection': {
      background: "#cceae7",
      color: "#263238"
    },
    'pre[class*="language-"]::-moz-selection': {
      background: "#cceae7",
      color: "#263238"
    },
    'code[class*="language-"] ::-moz-selection': {
      background: "#cceae7",
      color: "#263238"
    },
    'pre[class*="language-"] ::-moz-selection': {
      background: "#cceae7",
      color: "#263238"
    },
    'code[class*="language-"]::selection': {
      background: "#cceae7",
      color: "#263238"
    },
    'pre[class*="language-"]::selection': {
      background: "#cceae7",
      color: "#263238"
    },
    'code[class*="language-"] ::selection': {
      background: "#cceae7",
      color: "#263238"
    },
    'pre[class*="language-"] ::selection': {
      background: "#cceae7",
      color: "#263238"
    },
    ':not(pre) > code[class*="language-"]': {
      whiteSpace: "normal",
      borderRadius: "0.2em",
      padding: "0.1em"
    },
    ".language-css > code": {
      color: "#f76d47"
    },
    ".language-sass > code": {
      color: "#f76d47"
    },
    ".language-scss > code": {
      color: "#f76d47"
    },
    '[class*="language-"] .namespace': {
      Opacity: "0.7"
    },
    atrule: {
      color: "#7c4dff"
    },
    "attr-name": {
      color: "#39adb5"
    },
    "attr-value": {
      color: "#f6a434"
    },
    attribute: {
      color: "#f6a434"
    },
    "boolean": {
      color: "#7c4dff"
    },
    builtin: {
      color: "#39adb5"
    },
    cdata: {
      color: "#39adb5"
    },
    "char": {
      color: "#39adb5"
    },
    "class": {
      color: "#39adb5"
    },
    "class-name": {
      color: "#6182b8"
    },
    comment: {
      color: "#aabfc9"
    },
    constant: {
      color: "#7c4dff"
    },
    deleted: {
      color: "#e53935"
    },
    doctype: {
      color: "#aabfc9"
    },
    entity: {
      color: "#e53935"
    },
    "function": {
      color: "#7c4dff"
    },
    hexcode: {
      color: "#f76d47"
    },
    id: {
      color: "#7c4dff",
      fontWeight: "bold"
    },
    important: {
      color: "#7c4dff",
      fontWeight: "bold"
    },
    inserted: {
      color: "#39adb5"
    },
    keyword: {
      color: "#7c4dff"
    },
    number: {
      color: "#f76d47"
    },
    operator: {
      color: "#39adb5"
    },
    prolog: {
      color: "#aabfc9"
    },
    property: {
      color: "#39adb5"
    },
    "pseudo-class": {
      color: "#f6a434"
    },
    "pseudo-element": {
      color: "#f6a434"
    },
    punctuation: {
      color: "#39adb5"
    },
    regex: {
      color: "#6182b8"
    },
    selector: {
      color: "#e53935"
    },
    string: {
      color: "#f6a434"
    },
    symbol: {
      color: "#7c4dff"
    },
    tag: {
      color: "#e53935"
    },
    unit: {
      color: "#f76d47"
    },
    url: {
      color: "#e53935"
    },
    variable: {
      color: "#e53935"
    }
  };
}),
    ld = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      color: "#c3cee3",
      background: "#263238",
      fontFamily: "Roboto Mono, monospace",
      fontSize: "1em",
      lineHeight: "1.5em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      color: "#c3cee3",
      background: "#263238",
      fontFamily: "Roboto Mono, monospace",
      fontSize: "1em",
      lineHeight: "1.5em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      overflow: "auto",
      position: "relative",
      margin: "0.5em 0",
      padding: "1.25em 1em"
    },
    'code[class*="language-"]::-moz-selection': {
      background: "#363636"
    },
    'pre[class*="language-"]::-moz-selection': {
      background: "#363636"
    },
    'code[class*="language-"] ::-moz-selection': {
      background: "#363636"
    },
    'pre[class*="language-"] ::-moz-selection': {
      background: "#363636"
    },
    'code[class*="language-"]::selection': {
      background: "#363636"
    },
    'pre[class*="language-"]::selection': {
      background: "#363636"
    },
    'code[class*="language-"] ::selection': {
      background: "#363636"
    },
    'pre[class*="language-"] ::selection': {
      background: "#363636"
    },
    ':not(pre) > code[class*="language-"]': {
      whiteSpace: "normal",
      borderRadius: "0.2em",
      padding: "0.1em"
    },
    ".language-css > code": {
      color: "#fd9170"
    },
    ".language-sass > code": {
      color: "#fd9170"
    },
    ".language-scss > code": {
      color: "#fd9170"
    },
    '[class*="language-"] .namespace': {
      Opacity: "0.7"
    },
    atrule: {
      color: "#c792ea"
    },
    "attr-name": {
      color: "#ffcb6b"
    },
    "attr-value": {
      color: "#c3e88d"
    },
    attribute: {
      color: "#c3e88d"
    },
    "boolean": {
      color: "#c792ea"
    },
    builtin: {
      color: "#ffcb6b"
    },
    cdata: {
      color: "#80cbc4"
    },
    "char": {
      color: "#80cbc4"
    },
    "class": {
      color: "#ffcb6b"
    },
    "class-name": {
      color: "#f2ff00"
    },
    color: {
      color: "#f2ff00"
    },
    comment: {
      color: "#546e7a"
    },
    constant: {
      color: "#c792ea"
    },
    deleted: {
      color: "#f07178"
    },
    doctype: {
      color: "#546e7a"
    },
    entity: {
      color: "#f07178"
    },
    "function": {
      color: "#c792ea"
    },
    hexcode: {
      color: "#f2ff00"
    },
    id: {
      color: "#c792ea",
      fontWeight: "bold"
    },
    important: {
      color: "#c792ea",
      fontWeight: "bold"
    },
    inserted: {
      color: "#80cbc4"
    },
    keyword: {
      color: "#c792ea",
      fontStyle: "italic"
    },
    number: {
      color: "#fd9170"
    },
    operator: {
      color: "#89ddff"
    },
    prolog: {
      color: "#546e7a"
    },
    property: {
      color: "#80cbc4"
    },
    "pseudo-class": {
      color: "#c3e88d"
    },
    "pseudo-element": {
      color: "#c3e88d"
    },
    punctuation: {
      color: "#89ddff"
    },
    regex: {
      color: "#f2ff00"
    },
    selector: {
      color: "#f07178"
    },
    string: {
      color: "#c3e88d"
    },
    symbol: {
      color: "#c792ea"
    },
    tag: {
      color: "#f07178"
    },
    unit: {
      color: "#f07178"
    },
    url: {
      color: "#fd9170"
    },
    variable: {
      color: "#f07178"
    }
  };
}),
    id = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#f8f8f2",
      background: "none",
      fontFamily: "\"Fira Code\", Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#f8f8f2",
      background: "#2E3440",
      fontFamily: "\"Fira Code\", Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      borderRadius: "0.3em"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#2E3440",
      padding: ".1em",
      borderRadius: ".3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "#636f88"
    },
    prolog: {
      color: "#636f88"
    },
    doctype: {
      color: "#636f88"
    },
    cdata: {
      color: "#636f88"
    },
    punctuation: {
      color: "#81A1C1"
    },
    ".namespace": {
      Opacity: ".7"
    },
    property: {
      color: "#81A1C1"
    },
    tag: {
      color: "#81A1C1"
    },
    constant: {
      color: "#81A1C1"
    },
    symbol: {
      color: "#81A1C1"
    },
    deleted: {
      color: "#81A1C1"
    },
    number: {
      color: "#B48EAD"
    },
    "boolean": {
      color: "#81A1C1"
    },
    selector: {
      color: "#A3BE8C"
    },
    "attr-name": {
      color: "#A3BE8C"
    },
    string: {
      color: "#A3BE8C"
    },
    "char": {
      color: "#A3BE8C"
    },
    builtin: {
      color: "#A3BE8C"
    },
    inserted: {
      color: "#A3BE8C"
    },
    operator: {
      color: "#81A1C1"
    },
    entity: {
      color: "#81A1C1",
      cursor: "help"
    },
    url: {
      color: "#81A1C1"
    },
    ".language-css .token.string": {
      color: "#81A1C1"
    },
    ".style .token.string": {
      color: "#81A1C1"
    },
    variable: {
      color: "#81A1C1"
    },
    atrule: {
      color: "#88C0D0"
    },
    "attr-value": {
      color: "#88C0D0"
    },
    "function": {
      color: "#88C0D0"
    },
    "class-name": {
      color: "#88C0D0"
    },
    keyword: {
      color: "#81A1C1"
    },
    regex: {
      color: "#EBCB8B"
    },
    important: {
      color: "#EBCB8B",
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    }
  };
}),
    cd = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      whiteSpace: "pre-wrap",
      wordBreak: "break-all",
      wordWrap: "break-word",
      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      fontSize: "15px",
      lineHeight: "1.5",
      color: "#dccf8f",
      textShadow: "0"
    },
    'pre[class*="language-"]': {
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      whiteSpace: "pre-wrap",
      wordBreak: "break-all",
      wordWrap: "break-word",
      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      fontSize: "15px",
      lineHeight: "1.5",
      color: "#DCCF8F",
      textShadow: "0",
      borderRadius: "5px",
      border: "1px solid #000",
      background: "#181914 url('data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAMAAA/+4ADkFkb2JlAGTAAAAAAf/bAIQACQYGBgcGCQcHCQ0IBwgNDwsJCQsPEQ4ODw4OERENDg4ODg0RERQUFhQUERoaHBwaGiYmJiYmKysrKysrKysrKwEJCAgJCgkMCgoMDwwODA8TDg4ODhMVDg4PDg4VGhMRERERExoXGhYWFhoXHR0aGh0dJCQjJCQrKysrKysrKysr/8AAEQgAjACMAwEiAAIRAQMRAf/EAF4AAQEBAAAAAAAAAAAAAAAAAAABBwEBAQAAAAAAAAAAAAAAAAAAAAIQAAEDAwIHAQEAAAAAAAAAAADwAREhYaExkUFRcYGxwdHh8REBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AyGFEjHaBS2fDDs2zkhKmBKktb7km+ZwwCnXPkLVmCTMItj6AXFxRS465/BTnkAJvkLkJe+7AKKoi2AtRS2zuAWsCb5GOlBN8gKfmuGHZ8MFqIth3ALmFoFwbwKWyAlTAp17uKqBvgBD8sM4fTjhvAhkzhaRkBMKBrfs7jGPIpzy7gFrAqnC0C0gB0EWwBDW2cBVQwm+QtPpa3wBO3sVvszCnLAhkzgL5/RLf13cLQd8/AGlu0Cb5HTx9KuAEieGJEdcehS3eRTp2ATdt3CpIm+QtZwAhROXFeb7swp/ahaM3kBE/jSIUBc/AWrgBN8uNFAl+b7sAXFxFn2YLUU5Ns7gFX8C4ib+hN8gFWXwK3bZglxEJm+gKdciLPsFV/TClsgJUwKJ5FVA7tvIFrfZhVfGJDcsCKaYgAqv6YRbE+RWOWBtu7+AL3yRalXLyKqAIIfk+zARbDgFyEsncYwJvlgFRW+GEWntIi2P0BooyFxcNr8Ep3+ANLbMO+QyhvbiqdgC0kVvgUUiLYgBS2QtPbiVI1/sgOmG9uO+Y8DW+7jS2zAOnj6O2BndwuIAUtkdRN8gFoK3wwXMQyZwHVbClsuNLd4E3yAUR6FVDBR+BafQGt93LVMxJTv8ABts4CVLhcfYWsCb5kC9/BHdU8CLYFY5bMAd+eX9MGthhpbA1vu4B7+RKkaW2Yq4AQtVBBFsAJU/AuIXBhN8gGWnstefhiZyWvLAEnbYS1uzSFP6Jvn4Baxx70JKkQojLib5AVTey1jjgkKJGO0AKWyOm7N7cSpgSpAdPH0Tfd/gp1z5C1ZgKqN9J2wFxcUUuAFLZAm+QC0Fb4YUVRFsAOvj4KW2dwtYE3yAWk/wS/PLMKfmuGHZ8MAXF/Ja32Yi5haAKWz4Ydm2cSpgU693Atb7km+Zwwh+WGcPpxw3gAkzCLY+iYUDW/Z3Adc/gpzyFrAqnALkJe+7DoItgAtRS2zuKqGE3yAx0oJvkdvYrfZmALURbDuL5/RLf13cAuDeBS2RpbtAm+QFVA3wR+3fUtFHoBDJnC0jIXH0HWsgMY8inPLuOkd9chp4z20ALQLSA8cI9jYAIa2zjzjBd8gRafS1vgiUho/kAKcsCGTOGWvoOpkAtB3z8Hm8x2Ff5ADp4+lXAlIvcmwH/2Q==') repeat left top",
      padding: "12px",
      overflow: "auto"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    ':not(pre) > code[class*="language-"]': {
      borderRadius: "5px",
      border: "1px solid #000",
      color: "#DCCF8F",
      background: "#181914 url('data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAMAAA/+4ADkFkb2JlAGTAAAAAAf/bAIQACQYGBgcGCQcHCQ0IBwgNDwsJCQsPEQ4ODw4OERENDg4ODg0RERQUFhQUERoaHBwaGiYmJiYmKysrKysrKysrKwEJCAgJCgkMCgoMDwwODA8TDg4ODhMVDg4PDg4VGhMRERERExoXGhYWFhoXHR0aGh0dJCQjJCQrKysrKysrKysr/8AAEQgAjACMAwEiAAIRAQMRAf/EAF4AAQEBAAAAAAAAAAAAAAAAAAABBwEBAQAAAAAAAAAAAAAAAAAAAAIQAAEDAwIHAQEAAAAAAAAAAADwAREhYaExkUFRcYGxwdHh8REBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AyGFEjHaBS2fDDs2zkhKmBKktb7km+ZwwCnXPkLVmCTMItj6AXFxRS465/BTnkAJvkLkJe+7AKKoi2AtRS2zuAWsCb5GOlBN8gKfmuGHZ8MFqIth3ALmFoFwbwKWyAlTAp17uKqBvgBD8sM4fTjhvAhkzhaRkBMKBrfs7jGPIpzy7gFrAqnC0C0gB0EWwBDW2cBVQwm+QtPpa3wBO3sVvszCnLAhkzgL5/RLf13cLQd8/AGlu0Cb5HTx9KuAEieGJEdcehS3eRTp2ATdt3CpIm+QtZwAhROXFeb7swp/ahaM3kBE/jSIUBc/AWrgBN8uNFAl+b7sAXFxFn2YLUU5Ns7gFX8C4ib+hN8gFWXwK3bZglxEJm+gKdciLPsFV/TClsgJUwKJ5FVA7tvIFrfZhVfGJDcsCKaYgAqv6YRbE+RWOWBtu7+AL3yRalXLyKqAIIfk+zARbDgFyEsncYwJvlgFRW+GEWntIi2P0BooyFxcNr8Ep3+ANLbMO+QyhvbiqdgC0kVvgUUiLYgBS2QtPbiVI1/sgOmG9uO+Y8DW+7jS2zAOnj6O2BndwuIAUtkdRN8gFoK3wwXMQyZwHVbClsuNLd4E3yAUR6FVDBR+BafQGt93LVMxJTv8ABts4CVLhcfYWsCb5kC9/BHdU8CLYFY5bMAd+eX9MGthhpbA1vu4B7+RKkaW2Yq4AQtVBBFsAJU/AuIXBhN8gGWnstefhiZyWvLAEnbYS1uzSFP6Jvn4Baxx70JKkQojLib5AVTey1jjgkKJGO0AKWyOm7N7cSpgSpAdPH0Tfd/gp1z5C1ZgKqN9J2wFxcUUuAFLZAm+QC0Fb4YUVRFsAOvj4KW2dwtYE3yAWk/wS/PLMKfmuGHZ8MAXF/Ja32Yi5haAKWz4Ydm2cSpgU693Atb7km+Zwwh+WGcPpxw3gAkzCLY+iYUDW/Z3Adc/gpzyFrAqnALkJe+7DoItgAtRS2zuKqGE3yAx0oJvkdvYrfZmALURbDuL5/RLf13cAuDeBS2RpbtAm+QFVA3wR+3fUtFHoBDJnC0jIXH0HWsgMY8inPLuOkd9chp4z20ALQLSA8cI9jYAIa2zjzjBd8gRafS1vgiUho/kAKcsCGTOGWvoOpkAtB3z8Hm8x2Ff5ADp4+lXAlIvcmwH/2Q==') repeat left top",
      padding: "2px 6px"
    },
    namespace: {
      Opacity: ".7"
    },
    comment: {
      color: "#586e75",
      fontStyle: "italic"
    },
    prolog: {
      color: "#586e75",
      fontStyle: "italic"
    },
    doctype: {
      color: "#586e75",
      fontStyle: "italic"
    },
    cdata: {
      color: "#586e75",
      fontStyle: "italic"
    },
    number: {
      color: "#b89859"
    },
    string: {
      color: "#468966"
    },
    "char": {
      color: "#468966"
    },
    builtin: {
      color: "#468966"
    },
    inserted: {
      color: "#468966"
    },
    "attr-name": {
      color: "#b89859"
    },
    operator: {
      color: "#dccf8f"
    },
    entity: {
      color: "#dccf8f",
      cursor: "help"
    },
    url: {
      color: "#dccf8f"
    },
    ".language-css .token.string": {
      color: "#dccf8f"
    },
    ".style .token.string": {
      color: "#dccf8f"
    },
    selector: {
      color: "#859900"
    },
    regex: {
      color: "#859900"
    },
    atrule: {
      color: "#cb4b16"
    },
    keyword: {
      color: "#cb4b16"
    },
    "attr-value": {
      color: "#468966"
    },
    "function": {
      color: "#b58900"
    },
    variable: {
      color: "#b58900"
    },
    placeholder: {
      color: "#b58900"
    },
    property: {
      color: "#b89859"
    },
    tag: {
      color: "#ffb03b"
    },
    "boolean": {
      color: "#b89859"
    },
    constant: {
      color: "#b89859"
    },
    symbol: {
      color: "#b89859"
    },
    important: {
      color: "#dc322f"
    },
    statement: {
      color: "#dc322f"
    },
    deleted: {
      color: "#dc322f"
    },
    punctuation: {
      color: "#dccf8f"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    }
  };
}),
    sd = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    "code[class*='language-']": {
      color: "#9efeff",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      fontFamily: "'Operator Mono', 'Fira Code', Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontWeight: "400",
      fontSize: "17px",
      lineHeight: "25px",
      letterSpacing: "0.5px",
      textShadow: "0 1px #222245"
    },
    "pre[class*='language-']": {
      color: "#9efeff",
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      fontFamily: "'Operator Mono', 'Fira Code', Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontWeight: "400",
      fontSize: "17px",
      lineHeight: "25px",
      letterSpacing: "0.5px",
      textShadow: "0 1px #222245",
      padding: "2em",
      margin: "0.5em 0",
      overflow: "auto",
      background: "#1e1e3f"
    },
    "pre[class*='language-']::-moz-selection": {
      color: "inherit",
      background: "#a599e9"
    },
    "pre[class*='language-'] ::-moz-selection": {
      color: "inherit",
      background: "#a599e9"
    },
    "code[class*='language-']::-moz-selection": {
      color: "inherit",
      background: "#a599e9"
    },
    "code[class*='language-'] ::-moz-selection": {
      color: "inherit",
      background: "#a599e9"
    },
    "pre[class*='language-']::selection": {
      color: "inherit",
      background: "#a599e9"
    },
    "pre[class*='language-'] ::selection": {
      color: "inherit",
      background: "#a599e9"
    },
    "code[class*='language-']::selection": {
      color: "inherit",
      background: "#a599e9"
    },
    "code[class*='language-'] ::selection": {
      color: "inherit",
      background: "#a599e9"
    },
    ":not(pre) > code[class*='language-']": {
      background: "#1e1e3f",
      padding: "0.1em",
      borderRadius: "0.3em"
    },
    "": {
      fontWeight: "400"
    },
    comment: {
      color: "#b362ff"
    },
    prolog: {
      color: "#b362ff"
    },
    cdata: {
      color: "#b362ff"
    },
    delimiter: {
      color: "#ff9d00"
    },
    keyword: {
      color: "#ff9d00"
    },
    selector: {
      color: "#ff9d00"
    },
    important: {
      color: "#ff9d00"
    },
    atrule: {
      color: "#ff9d00"
    },
    operator: {
      color: "rgb(255, 180, 84)",
      background: "none"
    },
    "attr-name": {
      color: "rgb(255, 180, 84)"
    },
    punctuation: {
      color: "#ffffff"
    },
    "boolean": {
      color: "rgb(255, 98, 140)"
    },
    tag: {
      color: "rgb(255, 157, 0)"
    },
    "tag.punctuation": {
      color: "rgb(255, 157, 0)"
    },
    doctype: {
      color: "rgb(255, 157, 0)"
    },
    builtin: {
      color: "rgb(255, 157, 0)"
    },
    entity: {
      color: "#6897bb",
      background: "none"
    },
    symbol: {
      color: "#6897bb"
    },
    number: {
      color: "#ff628c"
    },
    property: {
      color: "#ff628c"
    },
    constant: {
      color: "#ff628c"
    },
    variable: {
      color: "#ff628c"
    },
    string: {
      color: "#a5ff90"
    },
    "char": {
      color: "#a5ff90"
    },
    "attr-value": {
      color: "#a5c261"
    },
    "attr-value.punctuation": {
      color: "#a5c261"
    },
    "attr-value.punctuation:first-child": {
      color: "#a9b7c6"
    },
    url: {
      color: "#287bde",
      textDecoration: "underline",
      background: "none"
    },
    "function": {
      color: "rgb(250, 208, 0)"
    },
    regex: {
      background: "#364135"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    inserted: {
      background: "#00ff00"
    },
    deleted: {
      background: "#ff000d"
    },
    "code.language-css .token.property": {
      color: "#a9b7c6"
    },
    "code.language-css .token.property + .token.punctuation": {
      color: "#a9b7c6"
    },
    "code.language-css .token.id": {
      color: "#ffc66d"
    },
    "code.language-css .token.selector > .token.class": {
      color: "#ffc66d"
    },
    "code.language-css .token.selector > .token.attribute": {
      color: "#ffc66d"
    },
    "code.language-css .token.selector > .token.pseudo-class": {
      color: "#ffc66d"
    },
    "code.language-css .token.selector > .token.pseudo-element": {
      color: "#ffc66d"
    },
    "class-name": {
      color: "#fb94ff"
    },
    ".language-css .token.string": {
      background: "none"
    },
    ".style .token.string": {
      background: "none"
    },
    "pre .line-highlight": {
      marginTop: "36px",
      background: "linear-gradient(to right, rgba(179, 98, 255, 0.17), transparent)"
    },
    "pre .line-highlight.line-highlight": {
      marginTop: "36px",
      background: "linear-gradient(to right, rgba(179, 98, 255, 0.17), transparent)"
    },
    "pre > code.line-highlight": {
      marginTop: "36px",
      background: "linear-gradient(to right, rgba(179, 98, 255, 0.17), transparent)"
    },
    "pre .line-highlight:before": {
      content: "''"
    },
    "pre > code.line-highlight:before": {
      content: "''"
    },
    "pre .line-highlight[data-end]:after": {
      content: "''"
    },
    "pre > code.line-highlight[data-end]:after": {
      content: "''"
    }
  };
}),
    ud = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#f92aad",
      textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#f92aad",
      textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      backgroundColor: "transparent !important",
      backgroundImage: "linear-gradient(to bottom, #2a2139 75%, #34294f)"
    },
    ':not(pre) > code[class*="language-"]': {
      backgroundColor: "transparent !important",
      backgroundImage: "linear-gradient(to bottom, #2a2139 75%, #34294f)",
      padding: ".1em",
      borderRadius: ".3em",
      whiteSpace: "normal"
    },
    comment: {
      color: "#8e8e8e"
    },
    "block-comment": {
      color: "#8e8e8e"
    },
    prolog: {
      color: "#8e8e8e"
    },
    doctype: {
      color: "#8e8e8e"
    },
    cdata: {
      color: "#8e8e8e"
    },
    punctuation: {
      color: "#ccc"
    },
    tag: {
      color: "#e2777a"
    },
    "attr-name": {
      color: "#e2777a"
    },
    namespace: {
      color: "#e2777a"
    },
    number: {
      color: "#e2777a"
    },
    unit: {
      color: "#e2777a"
    },
    hexcode: {
      color: "#e2777a"
    },
    deleted: {
      color: "#e2777a"
    },
    property: {
      color: "#72f1b8",
      textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
    },
    selector: {
      color: "#72f1b8",
      textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
    },
    "function-name": {
      color: "#6196cc"
    },
    "boolean": {
      color: "#fdfdfd",
      textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
    },
    "selector.id": {
      color: "#fdfdfd",
      textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
    },
    "function": {
      color: "#fdfdfd",
      textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
    },
    "class-name": {
      color: "#fff5f6",
      textShadow: "0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"
    },
    constant: {
      color: "#f92aad",
      textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
    },
    symbol: {
      color: "#f92aad",
      textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
    },
    important: {
      color: "#f4eee4",
      textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575",
      fontWeight: "bold"
    },
    atrule: {
      color: "#f4eee4",
      textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
    },
    keyword: {
      color: "#f4eee4",
      textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
    },
    "selector.class": {
      color: "#f4eee4",
      textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
    },
    builtin: {
      color: "#f4eee4",
      textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
    },
    string: {
      color: "#f87c32"
    },
    "char": {
      color: "#f87c32"
    },
    "attr-value": {
      color: "#f87c32"
    },
    regex: {
      color: "#f87c32"
    },
    variable: {
      color: "#f87c32"
    },
    operator: {
      color: "#67cdcc"
    },
    entity: {
      color: "#67cdcc",
      cursor: "help"
    },
    url: {
      color: "#67cdcc"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    inserted: {
      color: "green"
    }
  };
}),
    dd = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      color: "#393A34",
      fontFamily: '"Consolas", "Bitstream Vera Sans Mono", "Courier New", Courier, monospace',
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      fontSize: ".9em",
      lineHeight: "1.2em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]': {
      color: "#393A34",
      fontFamily: '"Consolas", "Bitstream Vera Sans Mono", "Courier New", Courier, monospace',
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      fontSize: ".9em",
      lineHeight: "1.2em",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      border: "1px solid #dddddd",
      backgroundColor: "white"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    'pre[class*="language-"]::-moz-selection': {
      background: "#C1DEF1"
    },
    'pre[class*="language-"] ::-moz-selection': {
      background: "#C1DEF1"
    },
    'code[class*="language-"]::-moz-selection': {
      background: "#C1DEF1"
    },
    'code[class*="language-"] ::-moz-selection': {
      background: "#C1DEF1"
    },
    'pre[class*="language-"]::selection': {
      background: "#C1DEF1"
    },
    'pre[class*="language-"] ::selection': {
      background: "#C1DEF1"
    },
    'code[class*="language-"]::selection': {
      background: "#C1DEF1"
    },
    'code[class*="language-"] ::selection': {
      background: "#C1DEF1"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".2em",
      paddingTop: "1px",
      paddingBottom: "1px",
      background: "#f8f8f8",
      border: "1px solid #dddddd"
    },
    comment: {
      color: "#008000",
      fontStyle: "italic"
    },
    prolog: {
      color: "#008000",
      fontStyle: "italic"
    },
    doctype: {
      color: "#008000",
      fontStyle: "italic"
    },
    cdata: {
      color: "#008000",
      fontStyle: "italic"
    },
    namespace: {
      Opacity: ".7"
    },
    string: {
      color: "#A31515"
    },
    punctuation: {
      color: "#393A34"
    },
    operator: {
      color: "#393A34"
    },
    url: {
      color: "#36acaa"
    },
    symbol: {
      color: "#36acaa"
    },
    number: {
      color: "#36acaa"
    },
    "boolean": {
      color: "#36acaa"
    },
    variable: {
      color: "#36acaa"
    },
    constant: {
      color: "#36acaa"
    },
    inserted: {
      color: "#36acaa"
    },
    atrule: {
      color: "#0000ff"
    },
    keyword: {
      color: "#0000ff"
    },
    "attr-value": {
      color: "#0000ff"
    },
    ".language-autohotkey .token.selector": {
      color: "#0000ff"
    },
    ".language-json .token.boolean": {
      color: "#0000ff"
    },
    ".language-json .token.number": {
      color: "#0000ff"
    },
    'code[class*="language-css"]': {
      color: "#0000ff"
    },
    "function": {
      color: "#393A34"
    },
    deleted: {
      color: "#9a050f"
    },
    ".language-autohotkey .token.tag": {
      color: "#9a050f"
    },
    selector: {
      color: "#800000"
    },
    ".language-autohotkey .token.keyword": {
      color: "#00009f"
    },
    important: {
      fontWeight: "bold"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    "class-name": {
      color: "#2B91AF"
    },
    ".language-json .token.property": {
      color: "#2B91AF"
    },
    tag: {
      color: "#800000"
    },
    "attr-name": {
      color: "#ff0000"
    },
    property: {
      color: "#ff0000"
    },
    regex: {
      color: "#ff0000"
    },
    entity: {
      color: "#ff0000"
    },
    "directive.tag.tag": {
      background: "#ffff00",
      color: "#393A34"
    },
    ".line-numbers .line-numbers-rows": {
      borderRightColor: "#a5a5a5"
    },
    ".line-numbers-rows > span:before": {
      color: "#2B91AF"
    },
    ".line-highlight": {
      background: "linear-gradient(to right, rgba(193, 222, 241, 0.2) 70%, rgba(221, 222, 241, 0))"
    }
  };
}),
    fd = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'pre[class*="language-"]': {
      color: "#d4d4d4",
      fontSize: "13px",
      textShadow: "none",
      fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace',
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      padding: "1em",
      margin: ".5em 0",
      overflow: "auto",
      background: "#1e1e1e"
    },
    'code[class*="language-"]': {
      color: "#d4d4d4",
      fontSize: "13px",
      textShadow: "none",
      fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace',
      direction: "ltr",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none"
    },
    'pre[class*="language-"]::selection': {
      textShadow: "none",
      background: "#75a7ca"
    },
    'code[class*="language-"]::selection': {
      textShadow: "none",
      background: "#75a7ca"
    },
    'pre[class*="language-"] *::selection': {
      textShadow: "none",
      background: "#75a7ca"
    },
    'code[class*="language-"] *::selection': {
      textShadow: "none",
      background: "#75a7ca"
    },
    ':not(pre) > code[class*="language-"]': {
      padding: ".1em .3em",
      borderRadius: ".3em",
      color: "#db4c69",
      background: "#f9f2f4"
    },
    ".namespace": {
      Opacity: ".7"
    },
    "doctype.doctype-tag": {
      color: "#569CD6"
    },
    "doctype.name": {
      color: "#9cdcfe"
    },
    comment: {
      color: "#6a9955"
    },
    prolog: {
      color: "#6a9955"
    },
    punctuation: {
      color: "#d4d4d4"
    },
    ".language-html .language-css .token.punctuation": {
      color: "#d4d4d4"
    },
    ".language-html .language-javascript .token.punctuation": {
      color: "#d4d4d4"
    },
    property: {
      color: "#9cdcfe"
    },
    tag: {
      color: "#569cd6"
    },
    "boolean": {
      color: "#569cd6"
    },
    number: {
      color: "#b5cea8"
    },
    constant: {
      color: "#9cdcfe"
    },
    symbol: {
      color: "#b5cea8"
    },
    inserted: {
      color: "#b5cea8"
    },
    unit: {
      color: "#b5cea8"
    },
    selector: {
      color: "#d7ba7d"
    },
    "attr-name": {
      color: "#9cdcfe"
    },
    string: {
      color: "#ce9178"
    },
    "char": {
      color: "#ce9178"
    },
    builtin: {
      color: "#ce9178"
    },
    deleted: {
      color: "#ce9178"
    },
    ".language-css .token.string.url": {
      textDecoration: "underline"
    },
    operator: {
      color: "#d4d4d4"
    },
    entity: {
      color: "#569cd6"
    },
    "operator.arrow": {
      color: "#569CD6"
    },
    atrule: {
      color: "#ce9178"
    },
    "atrule.rule": {
      color: "#c586c0"
    },
    "atrule.url": {
      color: "#9cdcfe"
    },
    "atrule.url.function": {
      color: "#dcdcaa"
    },
    "atrule.url.punctuation": {
      color: "#d4d4d4"
    },
    keyword: {
      color: "#569CD6"
    },
    "keyword.module": {
      color: "#c586c0"
    },
    "keyword.control-flow": {
      color: "#c586c0"
    },
    "function": {
      color: "#dcdcaa"
    },
    "function.maybe-class-name": {
      color: "#dcdcaa"
    },
    regex: {
      color: "#d16969"
    },
    important: {
      color: "#569cd6"
    },
    italic: {
      fontStyle: "italic"
    },
    "class-name": {
      color: "#4ec9b0"
    },
    "maybe-class-name": {
      color: "#4ec9b0"
    },
    console: {
      color: "#9cdcfe"
    },
    parameter: {
      color: "#9cdcfe"
    },
    interpolation: {
      color: "#9cdcfe"
    },
    "punctuation.interpolation-punctuation": {
      color: "#569cd6"
    },
    variable: {
      color: "#9cdcfe"
    },
    "imports.maybe-class-name": {
      color: "#9cdcfe"
    },
    "exports.maybe-class-name": {
      color: "#9cdcfe"
    },
    escape: {
      color: "#d7ba7d"
    },
    "tag.punctuation": {
      color: "#808080"
    },
    cdata: {
      color: "#808080"
    },
    "attr-value": {
      color: "#ce9178"
    },
    "attr-value.punctuation": {
      color: "#ce9178"
    },
    "attr-value.punctuation.attr-equals": {
      color: "#d4d4d4"
    },
    namespace: {
      color: "#4ec9b0"
    },
    'pre[class*="language-javascript"]': {
      color: "#9cdcfe"
    },
    'code[class*="language-javascript"]': {
      color: "#9cdcfe"
    },
    'pre[class*="language-jsx"]': {
      color: "#9cdcfe"
    },
    'code[class*="language-jsx"]': {
      color: "#9cdcfe"
    },
    'pre[class*="language-typescript"]': {
      color: "#9cdcfe"
    },
    'code[class*="language-typescript"]': {
      color: "#9cdcfe"
    },
    'pre[class*="language-tsx"]': {
      color: "#9cdcfe"
    },
    'code[class*="language-tsx"]': {
      color: "#9cdcfe"
    },
    'pre[class*="language-css"]': {
      color: "#ce9178"
    },
    'code[class*="language-css"]': {
      color: "#ce9178"
    },
    'pre[class*="language-html"]': {
      color: "#d4d4d4"
    },
    'code[class*="language-html"]': {
      color: "#d4d4d4"
    },
    ".language-regex .token.anchor": {
      color: "#dcdcaa"
    },
    ".language-html .token.punctuation": {
      color: "#808080"
    },
    "pre[data-line]": {
      position: "relative"
    },
    'pre[class*="language-"] > code[class*="language-"]': {
      position: "relative",
      zIndex: "1"
    },
    ".line-highlight": {
      position: "absolute",
      left: "0",
      right: "0",
      padding: "inherit 0",
      marginTop: "1em",
      background: "#f7ebc6",
      boxShadow: "inset 5px 0 0 #f7d87c",
      zIndex: "0",
      pointerEvents: "none",
      lineHeight: "inherit",
      whiteSpace: "pre"
    }
  };
}),
    pd = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n["default"] = void 0;
  n["default"] = {
    'code[class*="language-"]': {
      MozTabSize: "2",
      OTabSize: "2",
      tabSize: "2",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      whiteSpace: "pre-wrap",
      wordWrap: "normal",
      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      fontSize: "14px",
      color: "#76d9e6",
      textShadow: "none"
    },
    'pre[class*="language-"]': {
      MozTabSize: "2",
      OTabSize: "2",
      tabSize: "2",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      whiteSpace: "pre-wrap",
      wordWrap: "normal",
      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      fontSize: "14px",
      color: "#76d9e6",
      textShadow: "none",
      background: "#2a2a2a",
      padding: "15px",
      borderRadius: "4px",
      border: "1px solid #e1e1e8",
      overflow: "auto",
      position: "relative"
    },
    'pre > code[class*="language-"]': {
      fontSize: "1em"
    },
    ':not(pre) > code[class*="language-"]': {
      background: "#2a2a2a",
      padding: "0.15em 0.2em 0.05em",
      borderRadius: ".3em",
      border: "0.13em solid #7a6652",
      boxShadow: "1px 1px 0.3em -0.1em #000 inset"
    },
    'pre[class*="language-"] code': {
      whiteSpace: "pre",
      display: "block"
    },
    namespace: {
      Opacity: ".7"
    },
    comment: {
      color: "#6f705e"
    },
    prolog: {
      color: "#6f705e"
    },
    doctype: {
      color: "#6f705e"
    },
    cdata: {
      color: "#6f705e"
    },
    operator: {
      color: "#a77afe"
    },
    "boolean": {
      color: "#a77afe"
    },
    number: {
      color: "#a77afe"
    },
    "attr-name": {
      color: "#e6d06c"
    },
    string: {
      color: "#e6d06c"
    },
    entity: {
      color: "#e6d06c",
      cursor: "help"
    },
    url: {
      color: "#e6d06c"
    },
    ".language-css .token.string": {
      color: "#e6d06c"
    },
    ".style .token.string": {
      color: "#e6d06c"
    },
    selector: {
      color: "#a6e22d"
    },
    inserted: {
      color: "#a6e22d"
    },
    atrule: {
      color: "#ef3b7d"
    },
    "attr-value": {
      color: "#ef3b7d"
    },
    keyword: {
      color: "#ef3b7d"
    },
    important: {
      color: "#ef3b7d",
      fontWeight: "bold"
    },
    deleted: {
      color: "#ef3b7d"
    },
    regex: {
      color: "#76d9e6"
    },
    statement: {
      color: "#76d9e6",
      fontWeight: "bold"
    },
    placeholder: {
      color: "#fff"
    },
    variable: {
      color: "#fff"
    },
    bold: {
      fontWeight: "bold"
    },
    punctuation: {
      color: "#bebec5"
    },
    italic: {
      fontStyle: "italic"
    },
    "code.language-markup": {
      color: "#f9f9f9"
    },
    "code.language-markup .token.tag": {
      color: "#ef3b7d"
    },
    "code.language-markup .token.attr-name": {
      color: "#a6e22d"
    },
    "code.language-markup .token.attr-value": {
      color: "#e6d06c"
    },
    "code.language-markup .token.style": {
      color: "#76d9e6"
    },
    "code.language-markup .token.script": {
      color: "#76d9e6"
    },
    "code.language-markup .token.script .token.keyword": {
      color: "#76d9e6"
    },
    'pre[class*="language-"][data-line]': {
      position: "relative",
      padding: "1em 0 1em 3em"
    },
    "pre[data-line] .line-highlight": {
      position: "absolute",
      left: "0",
      right: "0",
      padding: "0",
      marginTop: "1em",
      background: "rgba(255, 255, 255, 0.08)",
      pointerEvents: "none",
      lineHeight: "inherit",
      whiteSpace: "pre"
    },
    "pre[data-line] .line-highlight:before": {
      content: "attr(data-start)",
      position: "absolute",
      top: ".4em",
      left: ".6em",
      minWidth: "1em",
      padding: "0.2em 0.5em",
      backgroundColor: "rgba(255, 255, 255, 0.4)",
      color: "black",
      font: "bold 65%/1 sans-serif",
      height: "1em",
      lineHeight: "1em",
      textAlign: "center",
      borderRadius: "999px",
      textShadow: "none",
      boxShadow: "0 1px 1px rgba(255, 255, 255, 0.7)"
    },
    "pre[data-line] .line-highlight[data-end]:after": {
      content: "attr(data-end)",
      position: "absolute",
      top: "auto",
      left: ".6em",
      minWidth: "1em",
      padding: "0.2em 0.5em",
      backgroundColor: "rgba(255, 255, 255, 0.4)",
      color: "black",
      font: "bold 65%/1 sans-serif",
      height: "1em",
      lineHeight: "1em",
      textAlign: "center",
      borderRadius: "999px",
      textShadow: "none",
      boxShadow: "0 1px 1px rgba(255, 255, 255, 0.7)",
      bottom: ".4em"
    }
  };
}),
    gd = de(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.defineProperty(n, "coy", {
    enumerable: !0,
    get: function get() {
      return t["default"];
    }
  }), Object.defineProperty(n, "dark", {
    enumerable: !0,
    get: function get() {
      return o["default"];
    }
  }), Object.defineProperty(n, "funky", {
    enumerable: !0,
    get: function get() {
      return r["default"];
    }
  }), Object.defineProperty(n, "okaidia", {
    enumerable: !0,
    get: function get() {
      return a["default"];
    }
  }), Object.defineProperty(n, "solarizedlight", {
    enumerable: !0,
    get: function get() {
      return l["default"];
    }
  }), Object.defineProperty(n, "tomorrow", {
    enumerable: !0,
    get: function get() {
      return i["default"];
    }
  }), Object.defineProperty(n, "twilight", {
    enumerable: !0,
    get: function get() {
      return c["default"];
    }
  }), Object.defineProperty(n, "prism", {
    enumerable: !0,
    get: function get() {
      return s["default"];
    }
  }), Object.defineProperty(n, "a11yDark", {
    enumerable: !0,
    get: function get() {
      return u["default"];
    }
  }), Object.defineProperty(n, "atomDark", {
    enumerable: !0,
    get: function get() {
      return d["default"];
    }
  }), Object.defineProperty(n, "base16AteliersulphurpoolLight", {
    enumerable: !0,
    get: function get() {
      return f["default"];
    }
  }), Object.defineProperty(n, "cb", {
    enumerable: !0,
    get: function get() {
      return p["default"];
    }
  }), Object.defineProperty(n, "coldarkCold", {
    enumerable: !0,
    get: function get() {
      return g["default"];
    }
  }), Object.defineProperty(n, "coldarkDark", {
    enumerable: !0,
    get: function get() {
      return m["default"];
    }
  }), Object.defineProperty(n, "coyWithoutShadows", {
    enumerable: !0,
    get: function get() {
      return h["default"];
    }
  }), Object.defineProperty(n, "darcula", {
    enumerable: !0,
    get: function get() {
      return b["default"];
    }
  }), Object.defineProperty(n, "dracula", {
    enumerable: !0,
    get: function get() {
      return y["default"];
    }
  }), Object.defineProperty(n, "duotoneDark", {
    enumerable: !0,
    get: function get() {
      return k["default"];
    }
  }), Object.defineProperty(n, "duotoneEarth", {
    enumerable: !0,
    get: function get() {
      return v["default"];
    }
  }), Object.defineProperty(n, "duotoneForest", {
    enumerable: !0,
    get: function get() {
      return w["default"];
    }
  }), Object.defineProperty(n, "duotoneLight", {
    enumerable: !0,
    get: function get() {
      return x["default"];
    }
  }), Object.defineProperty(n, "duotoneSea", {
    enumerable: !0,
    get: function get() {
      return A["default"];
    }
  }), Object.defineProperty(n, "duotoneSpace", {
    enumerable: !0,
    get: function get() {
      return S["default"];
    }
  }), Object.defineProperty(n, "ghcolors", {
    enumerable: !0,
    get: function get() {
      return E["default"];
    }
  }), Object.defineProperty(n, "hopscotch", {
    enumerable: !0,
    get: function get() {
      return C["default"];
    }
  }), Object.defineProperty(n, "materialDark", {
    enumerable: !0,
    get: function get() {
      return z["default"];
    }
  }), Object.defineProperty(n, "materialLight", {
    enumerable: !0,
    get: function get() {
      return T["default"];
    }
  }), Object.defineProperty(n, "materialOceanic", {
    enumerable: !0,
    get: function get() {
      return M["default"];
    }
  }), Object.defineProperty(n, "nord", {
    enumerable: !0,
    get: function get() {
      return O["default"];
    }
  }), Object.defineProperty(n, "pojoaque", {
    enumerable: !0,
    get: function get() {
      return D["default"];
    }
  }), Object.defineProperty(n, "shadesOfPurple", {
    enumerable: !0,
    get: function get() {
      return F["default"];
    }
  }), Object.defineProperty(n, "synthwave84", {
    enumerable: !0,
    get: function get() {
      return P["default"];
    }
  }), Object.defineProperty(n, "vs", {
    enumerable: !0,
    get: function get() {
      return L["default"];
    }
  }), Object.defineProperty(n, "vscDarkPlus", {
    enumerable: !0,
    get: function get() {
      return B["default"];
    }
  }), Object.defineProperty(n, "xonokai", {
    enumerable: !0,
    get: function get() {
      return R["default"];
    }
  });
  var t = Fu(Pu),
      o = Fu(Lu),
      r = Fu(Bu),
      a = Fu(Ru),
      l = Fu(Hu),
      i = Fu(Nu),
      c = Fu(Iu),
      s = Fu(ju),
      u = Fu(Wu),
      d = Fu(qu),
      f = Fu(Uu),
      p = Fu(Vu),
      g = Fu(Ju),
      m = Fu(Ku),
      h = Fu(Qu),
      b = Fu(Yu),
      y = Fu(Gu),
      k = Fu(Xu),
      v = Fu(_u),
      w = Fu(Zu),
      x = Fu($u),
      A = Fu(ed),
      S = Fu(nd),
      E = Fu(td),
      C = Fu(od),
      z = Fu(rd),
      T = Fu(ad),
      M = Fu(ld),
      O = Fu(id),
      D = Fu(cd),
      F = Fu(sd),
      P = Fu(ud),
      L = Fu(dd),
      B = Fu(fd),
      R = Fu(pd);
}),
    md = function () {
  function e(e, n) {
    this._theme = e, this.options = n;
  }

  return Object.defineProperty(e.prototype, "theme", {
    get: function get() {
      var e,
          n = this;
      if (!(null === (e = this.options) || void 0 === e ? void 0 : e.themeOverrides)) return this._theme;
      var o = t({}, this._theme);
      return Object.keys(this.options.themeOverrides).forEach(function (e) {
        var r;
        o[e] = t(t({}, n._theme[e]), null === (r = n.options) || void 0 === r ? void 0 : r.themeOverrides[e]);
      }), o;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "lineHighlight", {
    get: function get() {
      var e;
      return (null === (e = this.options) || void 0 === e ? void 0 : e.lineHighlightColor) ? {
        background: this.options.lineHighlightColor,
        borderColor: this.options.lineHighlightColor,
        borderStyle: "solid",
        borderRadius: "0 2px 2px 0",
        borderWidth: "2.5px 4px 2.5px 0"
      } : {};
    },
    enumerable: !1,
    configurable: !0
  }), e;
}(),
    hd = new md(gd.okaidia, {
  lineHighlightColor: "rgb(58, 59, 64)",
  themeOverrides: {
    'code[class*="language-"]': {
      fontFamily: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit"
    }
  }
}),
    bd = new md(gd.prism, {
  lineHighlightColor: "rgb(200, 227, 252)",
  themeOverrides: {
    'code[class*="language-"]': {
      fontFamily: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      textShadow: void 0
    },
    operator: {
      background: void 0
    }
  }
}),
    yd = {
  background: Me,
  border: "1px solid " + Oe,
  fontFamily: "Monaco, Menlo, Consolas, Courier Prime, Courier, Courier New, monospace",
  fontSize: 13,
  padding: "1.8rem",
  textShadow: void 0
},
    kd = {
  "float": "left",
  fontFamily: "inherit",
  fontSize: "inherit",
  paddingRight: "2rem"
},
    vd = {
  opacity: .38
},
    wd = "[object GeneratorFunction]",
    xd = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    Ad = /^\w*$/,
    Sd = /^\./,
    Ed = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
    Cd = /\\(\\)?/g,
    zd = /^\[object .+?Constructor\]$/,
    Td = "object" == _typeof(fe) && fe && fe.Object === Object && fe,
    Md = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
    Od = Td || Md || Function("return this")();

var Dd,
    Fd = Array.prototype,
    Pd = Function.prototype,
    Ld = Object.prototype,
    Bd = Od["__core-js_shared__"],
    Rd = (Dd = /[^.]+$/.exec(Bd && Bd.keys && Bd.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Dd : "",
    Hd = Pd.toString,
    Nd = Ld.hasOwnProperty,
    Id = Ld.toString,
    jd = RegExp("^" + Hd.call(Nd).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
    Wd = Od.Symbol,
    qd = Fd.splice,
    Ud = ef(Od, "Map"),
    Vd = ef(Object, "create"),
    Jd = Wd ? Wd.prototype : void 0,
    Kd = Jd ? Jd.toString : void 0;

function Qd(e) {
  var n = -1,
      t = e ? e.length : 0;

  for (this.clear(); ++n < t;) {
    var o = e[n];
    this.set(o[0], o[1]);
  }
}

function Yd(e) {
  var n = -1,
      t = e ? e.length : 0;

  for (this.clear(); ++n < t;) {
    var o = e[n];
    this.set(o[0], o[1]);
  }
}

function Gd(e) {
  var n = -1,
      t = e ? e.length : 0;

  for (this.clear(); ++n < t;) {
    var o = e[n];
    this.set(o[0], o[1]);
  }
}

function Xd(e, n) {
  for (var t, o, r = e.length; r--;) {
    if ((t = e[r][0]) === (o = n) || t != t && o != o) return r;
  }

  return -1;
}

function _d(e, n) {
  for (var t, o = 0, r = (n = function (e, n) {
    if (rf(e)) return !1;

    var t = _typeof(e);

    if ("number" == t || "symbol" == t || "boolean" == t || null == e || lf(e)) return !0;
    return Ad.test(e) || !xd.test(e) || null != n && (e in Object(n));
  }(n, e) ? [n] : rf(t = n) ? t : nf(t)).length; null != e && o < r;) {
    e = e[tf(n[o++])];
  }

  return o && o == r ? e : void 0;
}

function Zd(e) {
  return !(!af(e) || (n = e, Rd && Rd in n)) && (function (e) {
    var n = af(e) ? Id.call(e) : "";
    return "[object Function]" == n || n == wd;
  }(e) || function (e) {
    var n = !1;
    if (null != e && "function" != typeof e.toString) try {
      n = !!(e + "");
    } catch (e) {}
    return n;
  }(e) ? jd : zd).test(function (e) {
    if (null != e) {
      try {
        return Hd.call(e);
      } catch (e) {}

      try {
        return e + "";
      } catch (e) {}
    }

    return "";
  }(e));
  var n;
}

function $d(e, n) {
  var t,
      o,
      r = e.__data__;
  return ("string" == (o = _typeof(t = n)) || "number" == o || "symbol" == o || "boolean" == o ? "__proto__" !== t : null === t) ? r["string" == typeof n ? "string" : "hash"] : r.map;
}

function ef(e, n) {
  var t = function (e, n) {
    return null == e ? void 0 : e[n];
  }(e, n);

  return Zd(t) ? t : void 0;
}

Qd.prototype.clear = function () {
  this.__data__ = Vd ? Vd(null) : {};
}, Qd.prototype["delete"] = function (e) {
  return this.has(e) && delete this.__data__[e];
}, Qd.prototype.get = function (e) {
  var n = this.__data__;

  if (Vd) {
    var t = n[e];
    return "__lodash_hash_undefined__" === t ? void 0 : t;
  }

  return Nd.call(n, e) ? n[e] : void 0;
}, Qd.prototype.has = function (e) {
  var n = this.__data__;
  return Vd ? void 0 !== n[e] : Nd.call(n, e);
}, Qd.prototype.set = function (e, n) {
  return this.__data__[e] = Vd && void 0 === n ? "__lodash_hash_undefined__" : n, this;
}, Yd.prototype.clear = function () {
  this.__data__ = [];
}, Yd.prototype["delete"] = function (e) {
  var n = this.__data__,
      t = Xd(n, e);
  return !(t < 0) && (t == n.length - 1 ? n.pop() : qd.call(n, t, 1), !0);
}, Yd.prototype.get = function (e) {
  var n = this.__data__,
      t = Xd(n, e);
  return t < 0 ? void 0 : n[t][1];
}, Yd.prototype.has = function (e) {
  return Xd(this.__data__, e) > -1;
}, Yd.prototype.set = function (e, n) {
  var t = this.__data__,
      o = Xd(t, e);
  return o < 0 ? t.push([e, n]) : t[o][1] = n, this;
}, Gd.prototype.clear = function () {
  this.__data__ = {
    hash: new Qd(),
    map: new (Ud || Yd)(),
    string: new Qd()
  };
}, Gd.prototype["delete"] = function (e) {
  return $d(this, e)["delete"](e);
}, Gd.prototype.get = function (e) {
  return $d(this, e).get(e);
}, Gd.prototype.has = function (e) {
  return $d(this, e).has(e);
}, Gd.prototype.set = function (e, n) {
  return $d(this, e).set(e, n), this;
};
var nf = of(function (e) {
  var n;
  e = null == (n = e) ? "" : function (e) {
    if ("string" == typeof e) return e;
    if (lf(e)) return Kd ? Kd.call(e) : "";
    var n = e + "";
    return "0" == n && 1 / e == -1 / 0 ? "-0" : n;
  }(n);
  var t = [];
  return Sd.test(e) && t.push(""), e.replace(Ed, function (e, n, o, r) {
    t.push(o ? r.replace(Cd, "$1") : n || e);
  }), t;
});

function tf(e) {
  if ("string" == typeof e || lf(e)) return e;
  var n = e + "";
  return "0" == n && 1 / e == -Infinity ? "-0" : n;
}

function of(e, n) {
  if ("function" != typeof e || n && "function" != typeof n) throw new TypeError("Expected a function");

  var t = function t() {
    var o = arguments,
        r = n ? n.apply(this, o) : o[0],
        a = t.cache;
    if (a.has(r)) return a.get(r);
    var l = e.apply(this, o);
    return t.cache = a.set(r, l), l;
  };

  return t.cache = new (of.Cache || Gd)(), t;
}

of.Cache = Gd;
var rf = Array.isArray;

function af(e) {
  var n = _typeof(e);

  return !!e && ("object" == n || "function" == n);
}

function lf(e) {
  return "symbol" == _typeof(e) || function (e) {
    return !!e && "object" == _typeof(e);
  }(e) && "[object Symbol]" == Id.call(e);
}

var cf,
    sf,
    uf,
    df,
    ff = function ff(e, n, t) {
  var o = null == e ? void 0 : _d(e, n);
  return void 0 === o ? t : o;
},
    pf = de(function (e, n) {
  !function (n, t, o) {
    e.exports = o(), e.exports["default"] = o();
  }(0, 0, function () {
    var e = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\"","”":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}'),
        n = JSON.parse('{"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"vi":{"Đ":"D","đ":"d"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"}}');

    function t(t, o) {
      if ("string" != typeof t) throw new Error("slugify: string argument expected");
      var r = n[(o = "string" == typeof o ? {
        replacement: o
      } : o || {}).locale] || {},
          a = void 0 === o.replacement ? "-" : o.replacement,
          l = t.normalize().split("").reduce(function (n, t) {
        return n + (r[t] || e[t] || t).replace(o.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
      }, "").trim().replace(new RegExp("[\\s" + a + "]+", "g"), a);
      return o.lower && (l = l.toLowerCase()), o.strict && (l = l.replace(new RegExp("[^a-zA-Z0-9" + a + "]", "g"), "").replace(new RegExp("[\\s" + a + "]+", "g"), a)), l;
    }

    return t.extend = function (n) {
      for (var t in n) {
        e[t] = n[t];
      }
    }, t;
  });
}),
    gf = "Tabs-module_tabs__3ZFTj",
    mf = "Tabs-module_content__WuKvE",
    hf = ["variant", "activeTabId"],
    bf = ["container", "default"],
    yf = f.createElement(Du, {
  type: "childDirectiveDependency",
  message: "Tabs directive must have at least one child tab directive declared"
}),
    kf = function kf(e) {
  var n = e.children,
      o = a(e, ["children"]),
      r = g(Pt),
      l = r.getTabsGroupActiveTab,
      i = r.setTabsGroupActiveTab,
      c = r.tabsGroupActiveTabs,
      s = p(function () {
    if (Array.isArray(n) && (null == n ? void 0 : n.length)) {
      var e = n.filter(function (e) {
        var n = e.props.directive;
        return n && n.type === Au.CONTAINER && n.name === Su.TAB;
      });
      if (e.length) return e.map(function (e, n) {
        var t = e.props,
            o = t.label,
            r = void 0 === o ? "Tab " + (n + 1) : o,
            a = t.id,
            l = void 0 === a ? "tab-" + (n + 1) : a,
            i = t.disabled,
            c = void 0 !== i && i,
            s = t.children;
        return {
          label: r,
          id: l,
          disabled: c,
          content: f.createElement("div", {
            className: mf
          }, s)
        };
      });
    }
  }, [n]),
      u = m(o.activeTabId || (null == s ? void 0 : s[0].id)),
      d = u[0],
      b = u[1],
      y = h(function (e) {
    var n = e.detail.activeTabId;
    i && o.groupId ? i(o.groupId, n) : b(n);
  }, [o]);
  return k(function () {
    if (s && l && o.groupId) {
      var e = l(o.groupId);
      e && s.find(function (n) {
        return n.id === e;
      }) || (e = s[0].id), b(e);
    }
  }, [s, o, c]), o.variant && !bf.includes(o.variant) && (o.variant = void 0), void 0 === s ? yf : f.createElement("div", {
    className: gf
  }, f.createElement(D, t({}, au(hf, o), {
    activeTabId: d,
    onChange: y,
    tabs: s
  })));
},
    vf = function vf(e, n) {
  if (!(null == e ? void 0 : e.length) || !n) return "";
  var t = e[0].position,
      o = e[e.length - 1].position;
  return t && o ? n.substring(t.start.offset, o.end.offset) : "";
},
    wf = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "alert", n;
  }

  return c(n, e), n;
}(zu),
    xf = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "asseturl", n;
  }

  return c(n, e), n;
}(zu),
    Af = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "button", n;
  }

  return c(n, e), n;
}(zu),
    Sf = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "children", n;
  }

  return c(n, e), n;
}(zu),
    Ef = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "pre", n;
  }

  return c(n, e), n.prototype.process = function (n, t) {
    e.prototype.process.call(this, n, t), this.appendNodeProperties(n, {
      value: vf(n.children, t.sourceContent)
    });
  }, n;
}(zu),
    Cf = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "code", n;
  }

  return c(n, e), n.prototype.process = function (n, t) {
    e.prototype.process.call(this, n, t), this.appendNodeProperties(n, {
      value: vf(n.children, t.sourceContent)
    });
  }, n;
}(zu),
    zf = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "expand", n;
  }

  return c(n, e), n;
}(zu),
    Tf = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "a", n;
  }

  return c(n, e), n.prototype.process = function (n, t) {
    e.prototype.process.call(this, n, t), this.appendNodeProperties(n, {
      href: encodeURI(n.attributes.href || "")
    });
  }, n;
}(zu),
    Mf = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "parameter", n;
  }

  return c(n, e), n;
}(zu),
    Of = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "tab", n;
  }

  return c(n, e), n;
}(zu),
    Df = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "tabs", n;
  }

  return c(n, e), n;
}(zu),
    Ff = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "video", n;
  }

  return c(n, e), n;
}(zu),
    Pf = ((cf = {})[Au.TEXT] = ((sf = {})[Su.ASSET_URL] = new xf(), sf[Su.BUTTON] = new Af(), sf[Su.CODE] = new Cf(), sf[Su.LINK] = new Tf(), sf[Su.PARAM] = new Mf(), sf), cf[Au.LEAF] = ((uf = {})[Su.ALERT] = new wf(), uf[Su.CHILDREN] = new Sf(), uf[Su.CODE] = new Ef(), uf[Su.EXPAND] = new zf(), uf[Su.VIDEO] = new Ff(), uf), cf[Au.CONTAINER] = ((df = {})[Su.ALERT] = new wf(), df[Su.CODE] = new Ef(), df[Su.EXPAND] = new zf(), df[Su.TABS] = new Df(), df[Su.TAB] = new Of(), df), cf),
    Lf = new (function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.hName = "error", n;
  }

  return c(n, e), n.prototype.process = function (n, t) {
    e.prototype.process.call(this, n, t);
    var o = n.position,
        r = this.getShortNodeType(n.type),
        a = this.getSupportedTypes(n),
        l = {
      type: "unknownDirective",
      message: (o ? "Line " + o.start.line + ": " : "") + "Unknown " + r + " directive “" + n.name + "”"
    };
    a.length && (l.type = "invalidDirectiveType", l.message = f.createElement(f.Fragment, null, o ? "Line " + o.start.line + ": " : "", "“", n.name, "” cannot be declared as a ", r, " directive. Please declare it as a", " ", s(a.map(this.getShortNodeType)), " directive")), this.appendNodeProperties(n, l);
  }, n.prototype.getSupportedTypes = function (e) {
    var n = [];
    return Object.keys(Pf).forEach(function (t) {
      Object.keys(Pf[t]).includes(e.name) && n.push(t);
    }), n;
  }, n.prototype.getShortNodeType = function (e) {
    return e.replace(/Directive$/i, "");
  }, n;
}(zu))(),
    Bf = function Bf() {
  var e = g(Bt),
      n = e.sourceContent,
      t = e.config;
  return h(function () {
    return function (e) {
      ll(e, [Au.TEXT, Au.LEAF, Au.CONTAINER], function (e) {
        var o,
            r = e.type,
            a = e.name,
            l = null === (o = Pf[r]) || void 0 === o ? void 0 : o[a];
        l || (l = Lf), l.process(e, {
          sourceContent: n,
          config: t
        });
      });
    };
  }, []);
},
    Rf = "clear_permissions_filter",
    Hf = function Hf(e) {
  var o = e.header,
      r = e.loading,
      a = e.error,
      l = e.permissions,
      i = e.onFilter,
      c = e.columnSorting,
      s = e.tablePreferences,
      u = e.storageKey,
      d = e.columnDefinitions,
      p = e.i18nStrings,
      g = m(1),
      h = g[0],
      b = g[1],
      y = m(0),
      v = y[0],
      w = y[1],
      x = m(0),
      A = x[0],
      S = x[1],
      E = m(""),
      C = E[0],
      T = E[1],
      M = m([]),
      O = M[0],
      D = M[1],
      F = m(c || {
    sortingColumn: {
      sortingField: ""
    }
  }),
      P = F[0],
      L = F[1],
      B = m(s || Se.defaultTablePreferences),
      R = B[0],
      H = B[1];
  return k(function () {
    J.setItem(K.tablePreferences, R, u);
  }, [R]), k(function () {
    b(1);
  }, [C]), k(function () {
    l && (h - 1) * R.pageSize > l.length && b(Math.ceil(O.length / R.pageSize));
  }, [R.pageSize]), k(function () {
    D(l ? i(C, P, l) : []);
  }, [C, l]), k(function () {
    w(Math.ceil(O.length / R.pageSize));
  }, [O, R.pageSize]), k(function () {
    S((h - 1) * R.pageSize);
  }, [R.pageSize, h]), k(function () {
    if (P.sortingColumn.sortingComparator && l) {
      var e = n([], O);
      Ee(e, P.sortingColumn.sortingComparator, P.isDescending), D(e), J.setItem(K.tableSortColumns, {
        isDescending: P.isDescending,
        sortingColumn: {
          sortingField: P.sortingColumn.sortingField
        }
      }, u);
    }
  }, [P]), f.createElement(ye, {
    header: o,
    sortingDescending: P.isDescending,
    sortingColumn: P.sortingColumn,
    onSortingChange: function onSortingChange(e) {
      var n = e.detail;
      return L(n);
    },
    columnDefinitions: d,
    items: O.slice(A, A + R.pageSize),
    loading: r,
    loadingText: Se.loadingText,
    filter: f.createElement(ke, {
      disabled: !l || r,
      onChange: function onChange(e) {
        var n = e.detail.filteringText;
        return T(n);
      },
      filteringText: C,
      filteringPlaceholder: Se.propertyFilteringI18nConstants.placeholder,
      countText: (null == C ? void 0 : C.trim()) && Ce(O.length, Se.textFilterCountTextI18nConstants),
      filteringAriaLabel: "Filter permissions"
    }),
    empty: a ? f.createElement(ep, {
      title: p.permissionRetrievalErrorMessage.title,
      description: p.permissionRetrievalErrorMessage.description
    }) : C ? f.createElement(ep, {
      title: "No matches",
      description: "We can not find a match.",
      actions: f.createElement(z, {
        "data-testid": Rf,
        onClick: function onClick() {
          return T("");
        }
      }, "Clear filter")
    }) : f.createElement(ep, {
      title: p.emptyPermissions.title,
      description: p.emptyPermissions.description
    }),
    pagination: f.createElement(be, {
      onChange: function onChange(e) {
        var n = e.detail.currentPageIndex;
        return b(n);
      },
      pagesCount: v,
      currentPageIndex: h,
      ariaLabels: Se.paginationAriaLabels,
      disabled: !l || r
    }),
    preferences: f.createElement(he, t({}, Se.collectionPreferencesI18nConstants, {
      preferences: R,
      pageSizePreference: Se.pageSizePreference,
      wrapLinesPreference: Se.wrapLinesPreference,
      onConfirm: function onConfirm(e) {
        var n = e.detail;
        return H(n);
      }
    })),
    wrapLines: R.wrapLines
  });
},
    Nf = function Nf() {
  return g(Wf);
},
    If = "manage-permissions",
    jf = "refresh-permissions",
    Wf = w({}),
    qf = function qf(e) {
  var n = e.id,
      t = e.infoComponent,
      o = e.setNotifications,
      r = e.i18nStrings,
      a = e.onRefetch,
      l = e.refetchIsLoading,
      i = e.refetchError,
      c = e.permissions,
      s = e.variant,
      u = e.columnDefinitions,
      d = e.onFilter,
      p = e.EditComponent,
      g = e.allPermissionsData,
      h = e.disableEdit,
      b = void 0 !== h && h,
      y = m(c),
      v = y[0],
      w = y[1],
      x = m(!1),
      A = x[0],
      S = x[1],
      E = re({
    setNotifications: o
  }),
      C = E.showNotification,
      T = E.clearNotification;
  k(function () {
    c && w(c);
  }, [c]), k(function () {
    return function () {
      T();
    };
  }, []);
  var O = f.createElement(H, {
    variant: "h2",
    actions: !A && f.createElement(M, {
      direction: "horizontal",
      size: "xs"
    }, f.createElement(z, {
      "data-testid": jf,
      onClick: function onClick() {
        w([]), a();
      },
      loading: l,
      iconName: "refresh",
      ariaLabel: "Refresh data"
    }), f.createElement(z, {
      "data-testid": If,
      iconName: "edit",
      disabled: b,
      onClick: function onClick() {
        T(), S(!0);
      }
    }, r.editCtaText)),
    counter: !A && v ? "(" + ((null == v ? void 0 : v.length) || 0) + ")" : void 0,
    info: t
  }, A ? r.tableTitle.edit : r.tableTitle.view),
      D = "workshops" === s ? "contentPermissionsTable" : "eventPermissionsTable";
  return A ? f.createElement(Wf.Provider, {
    value: {
      setEdit: S,
      showNotification: C,
      clearNotification: T
    }
  }, f.createElement(p, {
    onSuccess: a,
    id: n,
    header: O,
    allPermissionsData: g
  })) : f.createElement(Hf, {
    header: O,
    loading: l,
    error: i,
    permissions: v || [],
    storageKey: D,
    columnDefinitions: u,
    onFilter: d,
    i18nStrings: r,
    columnSorting: J.getItem(K.tableSortColumns, D),
    tablePreferences: J.getItem(K.tablePreferences, D)
  });
};

function Uf() {
  return Pe(function () {
    return import("./PreviewComponent.container-e5c1cb37.js");
  }, {
    retryFn: e.exponentialBackoff,
    interval: e.retryBackoff.interval
  });
}

var Vf,
    Jf = "Report a Workshop Studio bug",
    Kf = "This is for Workshop Studio bugs only. For content related issues, report the issue directly from the workshop detail view.",
    Qf = 'AWS Workshop Studio does not maintain the workshops that are published, as these are maintained by the workshop owner and the associated contributors. If you are attempting to report an issue with this workshop, please use the "Report a content issue" button on the workshop detail view. You can find the workshop detail view by finding the workshop in the Workshop Catalog and clicking "View Details."',
    Yf = 'If you are encountering an issue with Workshop Studio, please click "Report bug" below to report the issue and our team will investigate.',
    Gf = "Report bug",
    Xf = "Cancel",
    _f = function _f(n) {
  var t = n.isVisible,
      o = n.onModalClosed,
      r = n.onComplete,
      a = X().addCounterMetric,
      l = h(function () {
    window.open(e.ExternalLinks.reportBug, "_blank", "noopener,noreferrer"), a(e.CloudWatchMetric.REPORT_WORKSHOP_STUDIO_BUG), null == r || r();
  }, []),
      i = h(function () {
    u(), o();
  }, []),
      c = _({
    isVisible: t,
    onDismiss: o,
    modalHeader: Jf,
    actions: {
      primary: {
        text: Gf,
        onClick: l,
        iconAlign: "right",
        iconName: "external"
      },
      tertiary: {
        text: Xf,
        onClick: i
      }
    },
    content: f.createElement("section", null, f.createElement(M, {
      size: "l"
    }, f.createElement(O, {
      type: "warning"
    }, Kf), f.createElement(C, {
      variant: "p"
    }, Qf), f.createElement(C, {
      variant: "p"
    }, Yf)))
  }),
      s = c.modalComponent,
      u = c.hideModal;

  return s;
},
    Zf = function Zf(e) {
  var n = e.locale,
      t = void 0 === n ? "en-US" : n,
      o = e.metadata,
      r = void 0 === o ? {
    title: "",
    description: ""
  } : o,
      a = e.onChangeClientState,
      l = e.defaultTitle,
      i = void 0 === l ? "" : l,
      c = ae(window.location.href),
      s = c.origin,
      u = c.href,
      d = c.hostname,
      p = r.title,
      g = r.description;
  return k(function () {
    return function () {
      i && (document.title = i);
    };
  }, [i]), f.createElement(De, {
    htmlAttributes: {
      lang: t || "en-US"
    },
    onChangeClientState: a
  }, f.createElement("title", null, null == r ? void 0 : r.title), f.createElement("meta", {
    property: "og:type",
    content: "website"
  }), f.createElement("meta", {
    property: "og:url",
    content: u
  }), f.createElement("meta", {
    property: "og:title",
    content: p
  }), f.createElement("meta", {
    property: "og:description",
    content: g
  }), f.createElement("meta", {
    property: "og:image",
    content: uu.join(s, "logo192.png")
  }), f.createElement("meta", {
    name: "twitter:card",
    content: "summary"
  }), f.createElement("meta", {
    name: "twitter:domain",
    content: d
  }), f.createElement("meta", {
    name: "twitter:title",
    content: p
  }), f.createElement("meta", {
    name: "twitter:description",
    content: g
  }), f.createElement("meta", {
    name: "twitter:site",
    content: "@WorkshopStudio"
  }), f.createElement("meta", {
    name: "twitter:image",
    content: uu.join(s, "logo192.png")
  }), f.createElement("meta", {
    name: "twitter:url",
    content: u
  }), f.createElement("meta", {
    charSet: "utf-8"
  }));
},
    $f = function $f(e) {
  var n = e.children,
      t = e.defaultRedirectPath,
      o = void 0 === t ? "/" : t,
      r = e.onSignIn,
      a = e.onSignInFailure,
      l = le(),
      i = ie(),
      c = h(function (e) {
    switch (e.payload.event) {
      case "customOAuthState":
        e.payload.data && l.replace(e.payload.data);
        break;

      case "signIn":
        null == r || r();
        break;

      case "signIn_failure":
        null == a || a();
    }
  }, []);
  return k(function () {
    if (new URLSearchParams(i.search).get("state")) return Fe.listen("auth", c), function () {
      Fe.remove("auth", c);
    };
    l.replace(o);
  }, []), f.createElement(f.Fragment, null, n);
},
    ep = function ep(e) {
  return f.createElement("div", {
    "data-testid": "empty-message"
  }, f.createElement(C, {
    textAlign: "center"
  }, f.createElement(C, {
    color: "text-body-secondary",
    variant: "strong",
    "data-testid": "title"
  }, e.title), e.description && f.createElement(C, {
    color: "text-body-secondary",
    variant: "p",
    "data-testid": "description"
  }, e.description), e.actions && f.createElement(C, {
    margin: {
      top: "xs"
    },
    "data-testid": "actions"
  }, e.actions)));
},
    np = {
  error: {
    variant: "error",
    name: "status-negative"
  },
  warning: {
    variant: "warning",
    name: "status-warning"
  },
  success: {
    variant: "success",
    name: "status-positive"
  },
  info: {
    variant: "link",
    name: "status-info"
  },
  stopped: {
    variant: "subtle",
    name: "status-stopped"
  },
  pending: {
    variant: "subtle",
    name: "status-pending"
  },
  "in-progress": {
    variant: "subtle",
    name: "status-in-progress"
  },
  loading: {
    variant: "subtle",
    name: "status-stopped"
  }
},
    tp = {
  iconContainer: "StepIcon-module_iconContainer__2m1U6",
  "variant-default": "StepIcon-module_variant-default__20_bN",
  numberIcon: "StepIcon-module_numberIcon__1fYHM",
  "variant-subtle": "StepIcon-module_variant-subtle__1RHF6",
  "variant-info": "StepIcon-module_variant-info__3QCnV",
  "variant-success": "StepIcon-module_variant-success__RzI5w",
  "variant-error": "StepIcon-module_variant-error__14bkP",
  digits2: "StepIcon-module_digits2__IBuru"
},
    op = function op(e) {
  var n = e.status,
      o = e.index,
      r = void 0 === o ? 1 : o,
      a = e.variant,
      l = void 0 === a ? "subtle" : a;
  return n ? "loading" === n ? f.createElement(C, {
    color: "text-status-inactive"
  }, f.createElement(se, {
    size: "normal"
  })) : f.createElement(L, t({}, np[n] || np.stopped)) : f.createElement("div", {
    className: tp.iconContainer + " " + tp["variant-" + l] + " " + (r > 9 ? tp.digits2 : "")
  }, f.createElement("i", {
    className: tp.numberIcon
  }, f.createElement(C, {
    variant: "small"
  }, r)));
},
    rp = {
  error: "text-status-error",
  warning: "text-status-error",
  success: "text-status-success",
  info: "text-status-info",
  stopped: "text-status-inactive",
  pending: "text-status-inactive",
  "in-progress": "text-status-inactive",
  loading: "text-status-inactive"
};

!function (e) {
  e.STEP = "timeline__step", e.STEP_TITLE = "timeline__step-title";
}(Vf || (Vf = {}));

var ap = "TimelineStep-module_step__2EsH6",
    lp = "TimelineStep-module_label__2v4gW",
    ip = "TimelineStep-module_iconColumn__G0u0H",
    cp = "TimelineStep-module_contentColumn__2aGvU",
    sp = "TimelineStep-module_stepTitle__xnCvr",
    up = "TimelineStep-module_wrapTitle__2c6aB",
    dp = function dp(e) {
  var n = e.title,
      t = e.active,
      o = e.info,
      r = e.description,
      a = e.minWidth,
      l = e.status,
      i = e.index,
      c = e.wrapTitle,
      s = e.id,
      u = x(),
      d = l ? rp[l] : rp.stopped;
  return v(function () {
    var e = u.current;

    if (t && e) {
      var n = e.parentElement;
      if (!n) return;
      if (n.scrollWidth <= n.clientWidth && n.scrollHeight <= n.clientHeight) return;
      var o = void 0,
          r = void 0;
      n.scrollWidth > n.clientWidth && (o = e.offsetLeft - (e.clientWidth < n.clientWidth ? (n.clientWidth - e.clientWidth) / 2 : 0)), n.scrollHeight > n.clientHeight && (r = e.offsetTop - (e.clientHeight < n.clientHeight ? (n.clientHeight - e.clientHeight) / 2 : 0)), (o || r) && n.scrollTo({
        behavior: "smooth",
        left: o,
        top: r
      });
    }
  }, [t]), f.createElement("li", {
    className: ap + (t ? " _active" : ""),
    style: {
      minWidth: a
    },
    "data-testid": Vf.STEP,
    ref: u
  }, f.createElement("div", {
    "data-testid": s,
    className: lp
  }, f.createElement("div", {
    className: ip
  }, f.createElement(op, {
    status: l,
    index: i,
    variant: t ? "info" : void 0
  })), f.createElement("div", {
    className: cp
  }, f.createElement(C, {
    className: "step-title " + sp + " " + (c ? up : ""),
    color: t && "text-status-inactive" === d ? void 0 : d,
    "data-testid": Vf.STEP_TITLE
  }, o ? f.createElement(E, {
    triggerType: "text",
    header: o.header,
    content: o.content,
    size: o.size
  }, n) : n), r && f.createElement(C, {
    color: t ? "text-body-secondary" : "text-status-inactive",
    variant: "small"
  }, r))));
},
    fp = "Step",
    pp = {
  timeline: "Timeline-module_timeline__1jcX7",
  directionVertical: "Timeline-module_directionVertical__5Eqce",
  "align-start": "Timeline-module_align-start__1U7Gl",
  "align-center": "Timeline-module_align-center__uWuRK",
  "align-end": "Timeline-module_align-end__2YjDs",
  containStepWidth: "Timeline-module_containStepWidth__27n5c",
  contentPadding: "Timeline-module_contentPadding__3TTgW"
},
    gp = function gp(e) {
  var n = e.steps,
      t = e.activeStep,
      o = e.align,
      r = e.className,
      a = e.direction,
      l = void 0 === a ? "horizontal" : a,
      i = e.footer,
      c = e.header,
      s = e.stepMinWidth,
      u = e.stepWidth,
      d = e.style,
      g = e.variant,
      m = e.wrapTitles,
      h = p(function () {
    var e = [r, pp.timeline];
    return "container" === g && e.push(pp.contentPadding), "vertical" === l && e.push(pp.directionVertical), "contain" === u && e.push(pp.containStepWidth), o && e.push(pp["align-" + o]), e.join(" ");
  }, [o, r, l, u, g]),
      b = f.createElement("ol", {
    className: h,
    style: d
  }, n.map(function (e, n) {
    var o = e.id,
        r = e.i18nStrings,
        a = void 0 === r ? {} : r,
        l = e.status,
        i = e.info;
    n++;
    var c = a.title,
        u = void 0 === c ? fp + " " + n : c,
        d = a.description;
    return f.createElement(dp, {
      key: o,
      id: o,
      title: u,
      active: t === o,
      description: d,
      info: i,
      minWidth: s,
      status: l,
      index: n,
      wrapTitle: m
    });
  }));
  return "container" === g ? f.createElement(R, {
    footer: i,
    header: c,
    disableContentPaddings: !0
  }, b) : f.createElement(M, {
    direction: "vertical",
    size: "s"
  }, c || null, b, i || null);
};

export { gu as $, Ye as A, ru as B, ln as C, Zn as D, $n as E, dt as F, vd as G, hd as H, bd as I, Au as J, Su as K, At as L, Bt as M, ff as N, pf as O, qf as P, Cu as Q, _f as R, Zf as S, gp as T, ll as U, Mn as V, Bf as W, vu as X, kf as Y, Eu as Z, Lt as _, Ge as a, Xe as b, zn as c, sn as d, Hn as e, Xn as f, en as g, ot as h, Ct as i, Tt as j, Ft as k, Uf as l, $f as m, ep as n, lo as o, au as p, uu as q, su as r, pu as s, to as t, Nf as u, fu as v, mu as w, Du as x, yd as y, kd as z };
//# sourceMappingURL=Timeline-b3d7bc02.js.map
